(window.theme = window.theme || {}),
  (theme.bp = {}),
  (theme.bp.smallUp = 769),
  (theme.bp.small = theme.bp.smallUp - 1),
  (theme.config = {
    bpSmall: !1,
    hasSessionStorage: !0,
    hasLocalStorage: !0,
    mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
    mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
    youTubeReady: !1,
    vimeoReady: !1,
    vimeoLoading: !1,
    isTouch: !!(
      "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
    ),
    isIpad:
      /ipad/.test(window.navigator.userAgent.toLowerCase()) ||
      (window.navigator.platform === "MacIntel" &&
        window.navigator.maxTouchPoints > 1),
    stickyHeader: !1,
    recentlyViewed: [],
    rtl: document.documentElement.getAttribute("dir") == "rtl",
  }),
  (theme.recentlyViewed = { recent: {}, productInfo: {} }),
  theme.config.isIpad && (document.documentElement.className += " js-ipad"),
  console &&
    console.log &&
    console.log(
      "Impulse theme (" +
        theme.settings.themeVersion +
        ") by ARCH\u039ETYPE | Learn more at https://archetypethemes.co"
    ),
  (window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expFactor = 4),
  (function (e) {
    var e = (jQuery = e);
    (theme.utils = {
      defaultTo: function (a, t) {
        return a == null || a !== a ? t : a;
      },
    }),
      (theme.a11y = {
        trapFocus: function (a) {
          var t = {
              focusin: a.namespace ? "focusin." + a.namespace : "focusin",
              focusout: a.namespace ? "focusout." + a.namespace : "focusout",
              keydown: a.namespace
                ? "keydown." + a.namespace
                : "keydown.handleFocus",
            },
            n = a.$container.find(
              e(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
              ).filter(":visible")
            ),
            i = n[0],
            o = n[n.length - 1];
          a.$elementToFocus || (a.$elementToFocus = a.$container);
          function l(d) {
            d.keyCode === 9 &&
              (d.target === o && !d.shiftKey && (d.preventDefault(), i.focus()),
              d.target === i && d.shiftKey && (d.preventDefault(), o.focus()));
          }
          a.$container.attr("tabindex", "-1"),
            a.$elementToFocus.focus(),
            e(document).off("focusin"),
            e(document).on(t.focusout, function () {
              e(document).off(t.keydown);
            }),
            e(document).on(t.focusin, function (d) {
              (d.target !== o && d.target !== i) ||
                e(document).on(t.keydown, function (m) {
                  l(m);
                });
            });
        },
        removeTrapFocus: function (a) {
          var t = a.namespace ? "focusin." + a.namespace : "focusin";
          a.$container &&
            a.$container.length &&
            a.$container.removeAttr("tabindex"),
            e(document).off(t);
        },
        lockMobileScrolling: function (a, t) {
          if (t) var n = t;
          else var n = e(document.documentElement).add("body");
          n.on("touchmove" + a, function () {
            return !1;
          });
        },
        unlockMobileScrolling: function (a, t) {
          if (t) var n = t;
          else var n = e(document.documentElement).add("body");
          n.off(a);
        },
      }),
      (theme.Sections = function () {
        (this.constructors = {}),
          (this.instances = []),
          e(document)
            .on("shopify:section:load", this._onSectionLoad.bind(this))
            .on("shopify:section:unload", this._onSectionUnload.bind(this))
            .on("shopify:section:select", this._onSelect.bind(this))
            .on("shopify:section:deselect", this._onDeselect.bind(this))
            .on("shopify:block:select", this._onBlockSelect.bind(this))
            .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
      }),
      (theme.Sections.prototype = e.extend({}, theme.Sections.prototype, {
        createInstance: function (a, t, n) {
          var i = e(a),
            o = i.attr("data-section-id"),
            l = i.attr("data-section-type");
          if (((t = t || this.constructors[l]), typeof t != "undefined")) {
            if (n) {
              var d = this._findInstance(o);
              if (d) return;
            }
            var m = e.extend(new t(a), { id: o, type: l, container: a });
            this.instances.push(m);
          }
        },
        _onSectionLoad: function (a, t, n) {
          AOS && AOS.refreshHard();
          var i = t || e("[data-section-id]", a.target)[0];
          if (!!i) {
            this.createInstance(i);
            var o = t ? n : this._findInstance(a.detail.sectionId);
            t || this._loadSubSections(),
              o && typeof o.onLoad == "function" && o.onLoad(a);
          }
        },
        _loadSubSections: function () {
          AOS && AOS.refreshHard(),
            e("[data-subsection]").each(
              function (a, t) {
                this._onSectionLoad(null, t, e(t).data("section-id"));
              }.bind(this)
            );
        },
        _onSectionUnload: function (a) {
          var t = this._removeInstance(a.detail.sectionId);
          t && typeof t.onUnload == "function" && t.onUnload(a);
        },
        _onSelect: function (a) {
          var t = this._findInstance(a.detail.sectionId);
          t && typeof t.onSelect == "function" && t.onSelect(a);
        },
        _onDeselect: function (a) {
          var t = this._findInstance(a.detail.sectionId);
          t && typeof t.onDeselect == "function" && t.onDeselect(a);
        },
        _onBlockSelect: function (a) {
          var t = this._findInstance(a.detail.sectionId);
          t && typeof t.onBlockSelect == "function" && t.onBlockSelect(a);
        },
        _onBlockDeselect: function (a) {
          var t = this._findInstance(a.detail.sectionId);
          t && typeof t.onBlockDeselect == "function" && t.onBlockDeselect(a);
        },
        _findInstance: function (a) {
          for (var t = 0; t < this.instances.length; t++)
            if (this.instances[t].id === a) return this.instances[t];
        },
        _removeInstance: function (a) {
          for (var t = this.instances.length, n; t--; )
            if (this.instances[t].id === a) {
              (n = this.instances[t]), this.instances.splice(t, 1);
              break;
            }
          return n;
        },
        register: function (a, t, n) {
          var i = !1;
          this.constructors[a] = t;
          var o = e("[data-section-type=" + a + "]");
          n && (o = e("[data-section-type=" + a + "]", n)),
            o.each(
              function (l, d) {
                this.createInstance(d, t, n);
              }.bind(this)
            );
        },
      })),
      (theme.Currency = (function () {
        var a = "${{amount}}";
        function t(i, o) {
          o || (o = theme.settings.moneyFormat),
            typeof i == "string" && (i = i.replace(".", ""));
          var l = "",
            d = /\{\{\s*(\w+)\s*\}\}/,
            m = o || a;
          function f(u, h, g, b) {
            if (
              ((h = theme.utils.defaultTo(h, 2)),
              (g = theme.utils.defaultTo(g, ",")),
              (b = theme.utils.defaultTo(b, ".")),
              isNaN(u) || u == null)
            )
              return 0;
            u = (u / 100).toFixed(h);
            var w = u.split("."),
              k = w[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + g),
              x = w[1] ? b + w[1] : "";
            return k + x;
          }
          switch (m.match(d)[1]) {
            case "amount":
              l = f(i, 2);
              break;
            case "amount_no_decimals":
              l = f(i, 0);
              break;
            case "amount_with_comma_separator":
              l = f(i, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              l = f(i, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              l = f(i, 0, " ");
              break;
          }
          return m.replace(d, l);
        }
        function n(i) {
          if (
            !!i &&
            !(
              !i.unit_price_measurement ||
              !i.unit_price_measurement.reference_value
            )
          )
            return i.unit_price_measurement.reference_value === 1
              ? i.unit_price_measurement.reference_unit
              : i.unit_price_measurement.reference_value +
                  i.unit_price_measurement.reference_unit;
        }
        return { formatMoney: t, getBaseUnit: n };
      })()),
      (theme.Images = (function () {
        function a(o) {
          if (!o) return "620x";
          var l = o.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return l !== null ? l[1] : null;
        }
        function t(o, l) {
          if (!o || l == null) return o;
          if (l === "master") return this.removeProtocol(o);
          var d = o.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (d != null) {
            var m = o.split(d[0]),
              f = d[0];
            return this.removeProtocol(m[0] + "_" + l + f);
          }
          return null;
        }
        function n(o) {
          return o.replace(/http(s)?:/, "");
        }
        function i(o) {
          var l;
          return o !== null && (l = o.replace(/(\.[^.]*)$/, "_{width}x$1")), l;
        }
        return {
          imageSize: a,
          getSizedImageUrl: t,
          removeProtocol: n,
          lazyloadImagePath: i,
        };
      })()),
      (theme.Variants = (function () {
        function a(t) {
          (this.$container = t.$container),
            (this.variants = t.variants),
            (this.singleOptionSelector = t.singleOptionSelector),
            (this.originalSelectorId = t.originalSelectorId),
            (this.enableHistoryState = t.enableHistoryState),
            (this.currentVariant = this._getVariantFromOptions()),
            e(this.singleOptionSelector, this.$container).on(
              "change",
              this._onSelectChange.bind(this)
            );
        }
        return (
          (a.prototype = e.extend({}, a.prototype, {
            _getCurrentOptions: function () {
              var t = e.map(
                e(this.singleOptionSelector, this.$container),
                function (n) {
                  var i = e(n),
                    o = i.attr("type"),
                    l = {};
                  return o === "radio" || o === "checkbox"
                    ? i[0].checked
                      ? ((l.value = i.val()), (l.index = i.data("index")), l)
                      : !1
                    : ((l.value = i.val()), (l.index = i.data("index")), l);
                }
              );
              return (t = this._compact(t)), t;
            },
            _getVariantFromOptions: function () {
              var t = this._getCurrentOptions(),
                n = this.variants,
                i = !1;
              return (
                n.forEach(function (o) {
                  var l = !0,
                    d = o.options;
                  t.forEach(function (m) {
                    l && (l = o[m.index] === m.value);
                  }),
                    l && (i = o);
                }),
                i || null
              );
            },
            _onSelectChange: function () {
              var t = this._getVariantFromOptions();
              this.$container.trigger({ type: "variantChange", variant: t }),
                document.dispatchEvent(
                  new CustomEvent("variant:change", { detail: { variant: t } })
                ),
                !!t &&
                  (this._updateMasterSelect(t),
                  this._updateImages(t),
                  this._updatePrice(t),
                  this._updateUnitPrice(t),
                  this._updateSKU(t),
                  (this.currentVariant = t),
                  this.enableHistoryState && this._updateHistoryState(t));
            },
            _updateImages: function (t) {
              var n = t.featured_image || {},
                i = this.currentVariant.featured_image || {};
              !t.featured_image ||
                n.src === i.src ||
                this.$container.trigger({
                  type: "variantImageChange",
                  variant: t,
                });
            },
            _updatePrice: function (t) {
              (t.price === this.currentVariant.price &&
                t.compare_at_price === this.currentVariant.compare_at_price) ||
                this.$container.trigger({
                  type: "variantPriceChange",
                  variant: t,
                });
            },
            _updateUnitPrice: function (t) {
              t.unit_price !== this.currentVariant.unit_price &&
                this.$container.trigger({
                  type: "variantUnitPriceChange",
                  variant: t,
                });
            },
            _updateSKU: function (t) {
              t.sku !== this.currentVariant.sku &&
                this.$container.trigger({
                  type: "variantSKUChange",
                  variant: t,
                });
            },
            _updateHistoryState: function (t) {
              if (!(!history.replaceState || !t)) {
                var n =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                  "?variant=" +
                  t.id;
                window.history.replaceState({ path: n }, "", n);
              }
            },
            _updateMasterSelect: function (t) {
              e(this.originalSelectorId, this.$container).val(t.id);
            },
            _compact: function (t) {
              for (
                var n = -1, i = t == null ? 0 : t.length, o = 0, l = [];
                ++n < i;

              ) {
                var d = t[n];
                d && (l[o++] = d);
              }
              return l;
            },
          })),
          a
        );
      })()),
      (theme.rte = {
        init: function () {
          theme.rte.wrapTable(), theme.rte.wrapVideo(), theme.rte.imageLinks();
        },
        wrapTable: function () {
          e(".rte table").wrap('<div class="table-wrapper"></div>');
        },
        wrapVideo: function () {
          var a = e(
              '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
            ),
            t = a.add("iframe#admin_bar_iframe");
          a.each(function () {
            e(this).parents(".video-wrapper").length ||
              e(this).wrap('<div class="video-wrapper"></div>');
          }),
            t.each(function () {
              this.src = this.src;
            });
        },
        imageLinks: function () {
          e(".rte a img").parent().addClass("rte__image");
        },
      }),
      (theme.LibraryLoader = (function () {
        var a = { link: "link", script: "script" },
          t = { requested: "requested", loaded: "loaded" },
          n = "https://cdn.shopify.com/shopifycloud/",
          i = {
            youtubeSdk: {
              tagId: "youtube-sdk",
              src: "https://www.youtube.com/iframe_api",
              type: a.script,
            },
            shopifyXr: {
              tagId: "shopify-model-viewer-xr",
              src: n + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
              type: a.script,
            },
            modelViewerUi: {
              tagId: "shopify-model-viewer-ui",
              src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
              type: a.script,
            },
            modelViewerUiStyles: {
              tagId: "shopify-model-viewer-ui-styles",
              src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              type: a.link,
            },
          };
        function o(m, f) {
          var u = i[m];
          if (!!u && u.status !== t.requested) {
            if (((f = f || function () {}), u.status === t.loaded)) {
              f();
              return;
            }
            u.status = t.requested;
            var h;
            switch (u.type) {
              case a.script:
                h = l(u, f);
                break;
              case a.link:
                h = d(u, f);
                break;
            }
            (h.id = u.tagId), (u.element = h);
            var g = document.getElementsByTagName(u.type)[0];
            g.parentNode.insertBefore(h, g);
          }
        }
        function l(m, f) {
          var u = document.createElement("script");
          return (
            (u.src = m.src),
            u.addEventListener("load", function () {
              (m.status = t.loaded), f();
            }),
            u
          );
        }
        function d(m, f) {
          var u = document.createElement("link");
          return (
            (u.href = m.src),
            (u.rel = "stylesheet"),
            (u.type = "text/css"),
            u.addEventListener("load", function () {
              (m.status = t.loaded), f();
            }),
            u
          );
        }
        return { load: o };
      })()),
      (theme.Modals = (function () {
        function a(t, n, i) {
          var o = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + n,
            openClass: "modal--is-active",
            closingClass: "modal--is-closing",
            bodyOpenClass: "modal-open",
            bodyOpenSolidClass: "modal-open--solid",
            bodyClosingClass: "modal-closing",
            closeOffContentClick: !0,
          };
          if (((this.id = t), (this.$modal = e("#" + t)), !this.$modal.length))
            return !1;
          (this.nodes = {
            $parent: e("html").add("body"),
            $modalContent: this.$modal.find(".modal__inner"),
          }),
            (this.config = e.extend(o, i)),
            (this.modalIsOpen = !1),
            (this.$focusOnOpen = this.config.focusOnOpen
              ? e(this.config.focusOnOpen)
              : this.$modal),
            (this.isSolid = this.config.solid),
            this.init();
        }
        return (
          (a.prototype.init = function () {
            var t = e(this.config.open);
            t.attr("aria-expanded", "false"),
              e(this.config.open).on("click", this.open.bind(this)),
              this.$modal
                .find(this.config.close)
                .on("click", this.close.bind(this)),
              e("body").on(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (a.prototype.open = function (t) {
            var n = !1;
            this.modalIsOpen ||
              (t ? t.preventDefault() : (n = !0),
              t &&
                t.stopPropagation &&
                (t.stopPropagation(),
                (this.$activeSource = e(t.currentTarget).attr(
                  "aria-expanded",
                  "true"
                ))),
              this.modalIsOpen && !n && this.close(),
              this.$modal.prepareTransition().addClass(this.config.openClass),
              this.nodes.$parent.addClass(this.config.bodyOpenClass),
              this.isSolid &&
                this.nodes.$parent.addClass(this.config.bodyOpenSolidClass),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({
                $container: this.$modal,
                $elementToFocus: this.$focusOnOpen,
                namespace: "modal_focus",
              }),
              e("body")
                .trigger("productModalOpen")
                .trigger("modalOpen." + this.id),
              this.bindEvents());
          }),
          (a.prototype.close = function () {
            !this.modalIsOpen ||
              (e(document.activeElement).trigger("blur"),
              this.$modal
                .prepareTransition()
                .removeClass(this.config.openClass)
                .addClass(this.config.closingClass),
              this.nodes.$parent.removeClass(this.config.bodyOpenClass),
              this.nodes.$parent.addClass(this.config.bodyClosingClass),
              window.setTimeout(
                function () {
                  this.nodes.$parent.removeClass(this.config.bodyClosingClass),
                    this.$modal.removeClass(this.config.closingClass),
                    this.$activeSource &&
                      this.$activeSource.attr("aria-expanded") &&
                      this.$activeSource.attr("aria-expanded", "false").focus();
                }.bind(this),
                550
              ),
              this.isSolid &&
                this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass),
              (this.modalIsOpen = !1),
              theme.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: "modal_focus",
              }),
              e("body").trigger("modalClose." + this.id),
              this.unbindEvents());
          }),
          (a.prototype.bindEvents = function () {
            this.nodes.$parent.on(
              "keyup.modal",
              function (t) {
                t.keyCode === 27 && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                (this.$modal.on("click.modal", this.close.bind(this)),
                this.nodes.$modalContent.on("click.modal", function (t) {
                  t.stopImmediatePropagation();
                }));
          }),
          (a.prototype.unbindEvents = function () {
            this.nodes.$parent.off(".modal"),
              this.config.closeOffContentClick &&
                (this.$modal.off(".modal"),
                this.nodes.$modalContent.off(".modal"));
          }),
          a
        );
      })()),
      (theme.Drawers = (function () {
        function a(t, n, i) {
          if (
            ((this.config = {
              id: t,
              close: ".js-drawer-close",
              open: ".js-drawer-open-" + n,
              openClass: "js-drawer-open",
              closingClass: "js-drawer-closing",
              activeDrawer: "drawer--is-open",
              namespace: ".drawer-" + n,
            }),
            (this.$nodes = {
              parent: e(document.documentElement).add("body"),
              page: e("#MainContent"),
            }),
            (this.$drawer = e("#" + t)),
            !this.$drawer.length)
          )
            return !1;
          (this.isOpen = !1), (this.ignoreScrollLock = i), this.init();
        }
        return (
          (a.prototype = e.extend({}, a.prototype, {
            init: function () {
              var t = e(this.config.open);
              t.attr("aria-expanded", "false"),
                t.on("click", this.open.bind(this)),
                this.$drawer
                  .find(this.config.close)
                  .on("click", this.close.bind(this)),
                e("body").on(
                  "productModalOpen",
                  function () {
                    this.close();
                  }.bind(this)
                );
            },
            open: function (t, n) {
              if ((t && t.preventDefault(), !this.isOpen)) {
                if (t && t.stopPropagation)
                  t.stopPropagation(),
                    (this.$activeSource = e(t.currentTarget).attr(
                      "aria-expanded",
                      "true"
                    ));
                else if (n) {
                  var i = e(n);
                  this.$activeSource = i.attr("aria-expanded", "true");
                }
                this.$drawer
                  .prepareTransition()
                  .addClass(this.config.activeDrawer),
                  this.$nodes.parent.addClass(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus",
                  }),
                  e("body")
                    .trigger("drawerOpen")
                    .trigger("drawerOpen." + this.config.id),
                  this.bindEvents();
              }
            },
            close: function () {
              !this.isOpen ||
                (e(document.activeElement).trigger("blur"),
                this.$drawer
                  .prepareTransition()
                  .removeClass(this.config.activeDrawer),
                this.$nodes.parent.removeClass(this.config.openClass),
                this.$nodes.parent.addClass(this.config.closingClass),
                window.setTimeout(
                  function () {
                    this.$nodes.parent.removeClass(this.config.closingClass),
                      this.$activeSource &&
                        this.$activeSource.attr("aria-expanded") &&
                        this.$activeSource
                          .attr("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                (this.isOpen = !1),
                theme.a11y.removeTrapFocus({
                  $container: this.$drawer,
                  namespace: "drawer_focus",
                }),
                this.unbindEvents());
            },
            bindEvents: function () {
              this.ignoreScrollLock ||
                theme.a11y.lockMobileScrolling(
                  this.config.namespace,
                  this.$nodes.page
                ),
                this.$nodes.page.on(
                  "click" + this.config.namespace,
                  function (t) {
                    var n = e(t.target),
                      i = this.elementInsideDrawer(n);
                    if (!i) return this.close(), !1;
                  }.bind(this)
                ),
                this.$nodes.parent.on(
                  "keyup" + this.config.namespace,
                  function (t) {
                    t.keyCode === 27 && this.close();
                  }.bind(this)
                );
            },
            unbindEvents: function () {
              this.ignoreScrollLock ||
                theme.a11y.unlockMobileScrolling(
                  this.config.namespace,
                  this.$nodes.page
                ),
                this.$nodes.parent.off(this.config.namespace),
                this.$nodes.page.off(this.config.namespace);
            },
            elementInsideDrawer: function (t) {
              return this.$drawer.find(t).length;
            },
          })),
          a
        );
      })()),
      (theme.cart = {
        getCart: function () {
          return e.getJSON(theme.routes.cart);
        },
        changeItem: function (a, t) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartChange,
            data: "quantity=" + t + "&id=" + a,
            dataType: "json",
          });
        },
        addItemFromForm: function (a) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartAdd,
            data: a,
            dataType: "json",
          });
        },
        _updateCart: function (a) {
          return e.ajax(a).then(
            function (t) {
              return t;
            }.bind(this)
          );
        },
        updateNote: function (a) {
          var t = {
            type: "POST",
            url: "/cart/update.js",
            data: "note=" + theme.cart.attributeToString(a),
            dataType: "json",
            success: function (n) {},
            error: function (n, i) {},
          };
          e.ajax(t);
        },
        attributeToString: function (a) {
          return (
            typeof a != "string" && ((a += ""), a === "undefined" && (a = "")),
            a.trim()
          );
        },
      }),
      e(function () {
        e("body").on("click", ".cart__checkout", function () {
          e(this).addClass("btn--loading");
        }),
          e("body").on("change", 'textarea[name="note"]', function () {
            var a = e(this).val();
            theme.cart.updateNote(a);
          }),
          e("body").on("click", ".cart__checkout--ajax", function (a) {
            if (!e("#CartAgree").is(":checked"))
              return (
                alert(theme.strings.cartTermsConfirmation),
                e(this).removeClass("btn--loading"),
                !1
              );
          }),
          e("body").on("click", ".cart__checkout--page", function (a) {
            if (!e("#CartPageAgree").is(":checked"))
              return (
                alert(theme.strings.cartTermsConfirmation),
                e(this).removeClass("btn--loading"),
                !1
              );
          });
      }),
      (theme.QtySelector = (function () {
        var a = {
          input: ".js-qty__num",
          plus: ".js-qty__adjust--plus",
          minus: ".js-qty__adjust--minus",
        };
        function t(n, i) {
          (this.$wrapper = n),
            (this.$input = n.find(a.input)),
            (this.$plus = n.find(a.plus)),
            (this.$minus = n.find(a.minus)),
            (this.minValue = this.$input.attr("min") || 1);
          var o = { namespace: null, key: this.$input.data("id") };
          (this.options = e.extend(o, i)), this.initEventListeners();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            initEventListeners: function () {
              this.$plus.on(
                "click",
                function () {
                  var n = this.validateQty(this.$input.val());
                  this.addQty(n);
                }.bind(this)
              ),
                this.$minus.on(
                  "click",
                  function () {
                    var n = this.validateQty(this.$input.val());
                    this.subtractQty(n);
                  }.bind(this)
                ),
                this.$input.on(
                  "change",
                  function () {
                    var n = this.validateQty(this.$input.val());
                    this.changeQty(n);
                  }.bind(this)
                );
            },
            addQty: function (n) {
              var i = n + 1;
              this.changeQty(i);
            },
            subtractQty: function (n) {
              var i = n - 1;
              i <= this.minValue && (i = this.minValue), this.changeQty(i);
            },
            changeQty: function (n) {
              this.$input.val(n),
                e("body").trigger("qty" + this.options.namespace, [
                  this.options.key,
                  n,
                ]);
            },
            validateQty: function (n) {
              return (
                (parseFloat(n) == parseInt(n) && !isNaN(n)) || (n = 1),
                parseInt(n)
              );
            },
          })),
          t
        );
      })()),
      (theme.CartDrawer = (function () {
        var a = { namespace: ".ajaxcart" },
          t = {
            drawer: "#CartDrawer",
            container: "#CartContainer",
            template: "#CartTemplate",
            cartBubble: ".cart-link__bubble",
          };
        function n() {
          (this.status = { loaded: !1, loading: !1 }),
            (this.drawer = new theme.Drawers("CartDrawer", "cart"));
          var i = e(t.template).html();
          (this.template = Handlebars.compile(i)),
            theme.cart.getCart().then(this.buildCart.bind(this)),
            document.addEventListener(
              "cart:build",
              function () {
                theme.cart.getCart().then(this.buildCart.bind(this));
              }.bind(this)
            ),
            this.initEventListeners();
        }
        return (
          (n.prototype = e.extend({}, n.prototype, {
            initEventListeners: function () {
              e("body").on(
                "updateCart" + a.namespace,
                this.initQtySelectors.bind(this)
              ),
                e("body").on(
                  "updateCart" + a.namespace,
                  this.updateCartNotification.bind(this)
                ),
                e("body").on(
                  "added.ajaxProduct",
                  function (i, o) {
                    theme.cart.getCart().then(
                      function (l) {
                        this.buildCart(l, !0, o);
                      }.bind(this)
                    );
                  }.bind(this)
                );
            },
            buildCart: function (i, o, l) {
              if ((this.loading(!0), this.emptyCart(), i.item_count === 0))
                e(t.container).append(
                  '<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' +
                    theme.strings.cartEmpty +
                    "</p></div>"
                );
              else {
                var d = [],
                  m = {},
                  f = {},
                  u = 1;
                e.each(i.items, function (b, w) {
                  var k;
                  w.image !== null
                    ? (k = w.image.replace(/(\.[^.]*)$/, "_180x$1"))
                    : (k =
                        "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"),
                    w.properties !== null &&
                      e.each(w.properties, function (c, r) {
                        (c.charAt(0) === "_" || !r) && delete w.properties[c];
                      });
                  var x = 0;
                  if (w.line_level_discount_allocations.length !== 0)
                    for (var s in w.line_level_discount_allocations)
                      (x = w.line_level_discount_allocations[s].amount),
                        (w.line_level_discount_allocations[s].formattedAmount =
                          theme.Currency.formatMoney(
                            x,
                            theme.settings.moneyFormat
                          ));
                  (u += 2),
                    (m = {
                      key: w.key,
                      url: w.url,
                      img: k,
                      animationRow: u,
                      name: w.product_title,
                      variation: w.variant_title,
                      properties: w.properties,
                      itemQty: w.quantity,
                      price: theme.Currency.formatMoney(
                        w.price,
                        theme.settings.moneyFormat
                      ),
                      unitPrice: theme.Currency.formatMoney(
                        w.unit_price,
                        theme.settings.moneyFormat
                      ),
                      unitBase: theme.Currency.getBaseUnit(w),
                      discountedPrice: theme.Currency.formatMoney(
                        w.price - w.total_discount / w.quantity,
                        theme.settings.moneyFormat
                      ),
                      discounts: w.line_level_discount_allocations,
                      discountsApplied:
                        w.line_level_discount_allocations.length !== 0,
                      vendor: w.vendor,
                    }),
                    d.push(m);
                }),
                  (u += 2);
                var h = 0;
                if (i.cart_level_discount_applications.length !== 0)
                  for (var g in i.cart_level_discount_applications)
                    (h =
                      i.cart_level_discount_applications[g]
                        .total_allocated_amount),
                      (i.cart_level_discount_applications[g].formattedAmount =
                        theme.Currency.formatMoney(
                          h,
                          theme.settings.moneyFormat
                        ));
                (f = {
                  items: d,
                  note: i.note,
                  lastAnimationRow: u,
                  cartDiscounts: i.cart_level_discount_applications,
                  cartDiscountsApplied:
                    i.cart_level_discount_applications.length !== 0,
                  totalPrice: theme.Currency.formatMoney(
                    i.total_price,
                    theme.settings.moneyFormat
                  ),
                }),
                  e(t.container).append(this.template(f));
              }
              e("span.ajaxcart__product-meta").html(function () {
                return e(this).html().replace("--", "<br/> ");
              }),
                e("span.ajaxcart__product-meta").html(function () {
                  return e(this).html().replaceAll("|", "<br/> ");
                }),
                (this.status.loaded = !0),
                this.loading(!1),
                e("body").trigger("updateCart" + a.namespace, i),
                Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize(),
                o === !0 && this.drawer.open(!1, l),
                document.dispatchEvent(
                  new CustomEvent("cart:updated", { detail: { cart: i } })
                );
            },
            initQtySelectors: function () {
              e(t.container)
                .find(".js-qty__wrapper")
                .each(
                  function (i, o) {
                    var l = new theme.QtySelector(e(o), {
                      namespace: ".cart-drawer",
                    });
                  }.bind(this)
                ),
                e("body").on("qty.cart-drawer", this.updateItem.bind(this));
            },
            updateItem: function (i, o, l) {
              this.status.loading ||
                (this.loading(!0),
                theme.cart
                  .changeItem(o, l)
                  .then(
                    function (d) {
                      this.updateSuccess(d);
                    }.bind(this)
                  )
                  .catch(
                    function (d) {
                      this.updateError(d);
                    }.bind(this)
                  )
                  .always(
                    function () {
                      this.loading(!1);
                    }.bind(this)
                  ));
            },
            loading: function (i) {
              (this.status.loading = i),
                i
                  ? e(t.container).addClass("is-loading")
                  : e(t.container).removeClass("is-loading");
            },
            emptyCart: function () {
              e(t.container).empty();
            },
            updateSuccess: function (i) {
              this.buildCart(i);
            },
            updateError: function (i) {
              i.responseJSON && i.responseJSON.description;
            },
            updateCartNotification: function (i, o) {
              o.items.length > 0
                ? e(t.cartBubble).addClass("cart-link__bubble--visible")
                : e(t.cartBubble).removeClass("cart-link__bubble--visible");
            },
          })),
          n
        );
      })()),
      (theme.AjaxProduct = (function () {
        var a = { loading: !1 };
        function t(n) {
          (this.$form = n),
            (this.$addToCart = this.$form.find(".add-to-cart")),
            this.$form.length &&
              this.$form.on("submit", this.addItemFromForm.bind(this));
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            addItemFromForm: function (n, i) {
              if ((n.preventDefault(), !a.loading)) {
                this.$addToCart.addClass("btn--loading"), (a.loading = !0);
                var o = this.$form.serialize();
                theme.cart
                  .addItemFromForm(o)
                  .then(
                    function (l) {
                      this.success(l);
                    }.bind(this)
                  )
                  .catch(
                    function (l) {
                      this.error(l);
                    }.bind(this)
                  )
                  .always(
                    function () {
                      (a.loading = !1),
                        this.$addToCart.removeClass("btn--loading");
                    }.bind(this)
                  );
              }
            },
            success: function (n) {
              this.$form.find(".errors").remove(),
                e("body").trigger("added.ajaxProduct", this.$addToCart),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: { product: n },
                  })
                );
            },
            error: function (n) {
              this.$form.find(".errors").remove(),
                n.responseJSON &&
                  n.responseJSON.description &&
                  (this.$form.prepend(
                    '<div class="errors text-center">' +
                      n.responseJSON.description +
                      "</div>"
                  ),
                  document.dispatchEvent(
                    new CustomEvent("ajaxProduct:error", {
                      detail: { errorMessage: n.responseJSON.description },
                    })
                  ));
            },
          })),
          t
        );
      })()),
      (theme.collapsibles = (function () {
        var a = {
            trigger: ".collapsible-trigger",
            module: ".collapsible-content",
            moduleInner: ".collapsible-content__inner",
          },
          t = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height",
          },
          n = ".collapsible",
          i = !1;
        function o() {
          e(a.trigger).each(function () {
            var d = e(this),
              m = d.hasClass(t.open);
            d.attr("aria-expanded", m);
          }),
            e("body, .modal__inner")
              .off(n)
              .on("click" + n, a.trigger, function () {
                if (!i) {
                  i = !0;
                  var d = e(this),
                    m = d.hasClass(t.open),
                    f = d.attr("aria-controls"),
                    u = e("#" + f),
                    h = u.find(a.moduleInner).outerHeight(),
                    g = d.hasClass(t.autoHeight);
                  m &&
                    g &&
                    setTimeout(function () {
                      (h = 0), l(u, h, m, g);
                    }, 0),
                    m && !g && (h = 0),
                    d.attr("aria-expanded", !m).toggleClass(t.open, !m),
                    l(u, h, m, g);
                }
              });
        }
        function l(d, m, f, u) {
          if (
            (d
              .removeClass(t.hide)
              .prepareTransition()
              .css("height", m)
              .toggleClass(t.open, !f),
            !f && u)
          ) {
            var h = d;
            window.setTimeout(function () {
              h.css("height", "auto"), (i = !1);
            }, 350);
          } else i = !1;
        }
        return { init: o };
      })()),
      (theme.headerNav = (function () {
        var a = e(document.documentElement).add("body"),
          t = e("#MainContent"),
          n = {
            wrapper: ".header-wrapper",
            siteHeader: ".site-header",
            searchBtn: ".js-search-header",
            closeSearch: ".js-search-header-close",
            searchContainer: ".site-header__search-container",
            logoContainer: ".site-header__logo",
            logo: ".site-header__logo img",
            navigation: ".site-navigation",
            megamenu: ".megamenu",
            navContainerWithLogo: ".header-item--logo",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
          },
          i = {
            hasDropdownClass: "site-nav--has-dropdown",
            hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
            dropdownActive: "is-focused",
            overlaidBodyClass: "overlaid-header",
            stickyBodyClass: "sticky-header",
          },
          o = {
            namespace: ".siteNav",
            wrapperOverlayed: !1,
            overlayedClass: "is-light",
            stickyEnabledClass: "header-wrapper--sticky",
            stickyEnabled: !1,
            stickyActive: !1,
            stickyInitialized: !1,
            forceStopSticky: !1,
            stickyClass: "site-header--stuck",
            openTransitionClass: "site-header--opening",
            lastScroll: 0,
          },
          l,
          d,
          m,
          f,
          u,
          h;
        function g() {
          (l = e(window)),
            (d = e(n.navContainerWithLogo)),
            (m = e(n.logoContainer)),
            (f = e(n.navigation)),
            (u = e(n.wrapper)),
            (h = e(n.siteHeader)),
            (o.wrapperOverlayed = theme.settings.overlayHeader =
              u.hasClass(o.overlayedClass)),
            (o.stickyEnabled = h.data("sticky")),
            o.stickyEnabled &&
              (c(), l.on("resize" + o.namespace, e.debounce(150, c))),
            o.wrapperOverlayed && e("body").addClass(i.overlaidBodyClass),
            s(),
            w();
        }
        function b() {
          e(window).off(o.namespace),
            e(n.searchBtn).off(o.namespace),
            e(n.closeSearch).off(o.namespace),
            a.off(o.namespace),
            e(n.navLinks).off(o.namespace),
            e(n.navDropdownLinks).off(o.namespace);
        }
        function w() {
          e(n.searchBtn).on("click" + o.namespace, function (_) {
            _.preventDefault(), k();
          }),
            e(n.closeSearch).on("click" + o.namespace, function () {
              x();
            });
        }
        function k() {
          e(n.searchContainer).addClass("is-active"),
            a.addClass("js-drawer-open--search"),
            theme.a11y.trapFocus({
              $container: e(n.searchContainer),
              namespace: "header_search",
              $elementToFocus: e(n.searchContainer).find("input"),
            }),
            theme.config.bpSmall &&
              o.stickyEnabled &&
              o.lastScroll < 300 &&
              window.scrollTo(0, 0),
            theme.a11y.lockMobileScrolling(o.namespace),
            t.on("click" + o.namespace, function () {
              return x(), !1;
            }),
            a.on("keyup" + o.namespace, function (_) {
              _.keyCode === 27 && x();
            });
        }
        function x() {
          e(document.activeElement).trigger("blur"),
            a.removeClass("js-drawer-open--search").off(o.namespace),
            e(n.searchContainer).removeClass("is-active"),
            theme.a11y.removeTrapFocus({
              $container: e(n.searchContainer),
              namespace: "header_search",
            }),
            theme.a11y.unlockMobileScrolling(o.namespace),
            t.off("click" + o.namespace),
            a.off("keyup" + o.namespace);
        }
        function s() {
          var _ = !1,
            C = !1,
            I = !1;
          theme.config.isTouch &&
            (e(n.navLinksWithDropdown).on(
              "touchend" + o.namespace,
              function (L) {
                var M = e(this),
                  E = M.parent();
                E.hasClass(i.dropdownActive)
                  ? window.location.replace(M.attr("href"))
                  : (L.preventDefault(), T(), D(M));
              }
            ),
            e(n.navDropdownLinks).on("touchend" + o.namespace, function (L) {
              var M = e(this),
                E = M.parent();
              E.hasClass(i.hasSubDropdownClass)
                ? E.hasClass(i.dropdownActive)
                  ? window.location.replace(M.attr("href"))
                  : (L.preventDefault(), A(), V(M))
                : window.location.replace(M.attr("href"));
            }),
            e("body").on("touchend" + o.namespace, function () {
              F(), A();
            }),
            e(n.megamenu).on("touchend" + o.namespace, function (L) {
              L.stopImmediatePropagation();
            })),
            e(n.navLinks).on("focusin mouseover" + o.namespace, function () {
              _ && F(), C && A(), D(e(this));
            }),
            e(n.navLinks).on("mouseleave" + o.namespace, function () {
              F(), A();
            }),
            e(n.navDropdownLinks).on("focusin" + o.namespace, function () {
              C && A(), V(e(this), !0);
            });
          function D(L) {
            var M = L.parent();
            if (
              (M.hasClass(i.hasDropdownClass) &&
                (M.addClass(i.dropdownActive), (_ = !0)),
              !theme.config.isTouch && !I)
            ) {
              var E = theme.config.isTouch ? "touchend" : "click";
              (I = !0),
                e("body").on(E + o.namespace, function () {
                  T(), e("body").off(o.namespace), (I = !1);
                });
            }
          }
          function V(L, M) {
            var E = L.parent();
            (E.hasClass(i.hasSubDropdownClass) || M) &&
              (E.addClass(i.dropdownActive), (C = !0));
          }
          function T() {
            F(), A();
          }
          function F() {
            e(n.navItems).removeClass(i.dropdownActive);
          }
          function A() {
            e(n.navDropdownLinks).parent().removeClass(i.dropdownActive);
          }
        }
        function c() {
          (theme.config.stickyHeader = v()),
            theme.config.stickyHeader
              ? ((o.forceStopSticky = !1), r())
              : (o.forceStopSticky = !0);
        }
        function r() {
          o.stickyInitialized ||
            (a.addClass(i.stickyBodyClass),
            h.wrap('<div class="site-header-sticky"></div>'),
            p(),
            setTimeout(function () {
              p();
            }, 200),
            l.on("resize" + o.namespace, e.debounce(50, p)),
            l.on("scroll" + o.namespace, e.throttle(15, y))),
            (o.stickyInitialized = !0);
        }
        function v() {
          var _ = 0;
          return (
            e(n.megamenu).each(function () {
              var C = e(this).outerHeight();
              C > _ && (_ = C);
            }),
            !(window.innerHeight < _ + 120)
          );
        }
        function p() {
          var _ = h.outerHeight(!0),
            C = e(".site-header-sticky").css("height", _);
          e(".grid__item--sidebar").length &&
            e(".grid__item--sidebar").css("top", _ + 10);
        }
        function y() {
          if (!o.forceStopSticky) {
            var _ = l.scrollTop(),
              C = 150;
            if (_ > C) {
              if (o.stickyActive) return;
              (o.stickyActive = !0),
                h.addClass(o.stickyClass),
                o.wrapperOverlayed && u.removeClass(o.overlayedClass),
                setTimeout(function () {
                  h.addClass(o.openTransitionClass);
                }, 100);
            } else {
              if (!o.stickyActive) return;
              (o.stickyActive = !1),
                h.removeClass(o.openTransitionClass).removeClass(o.stickyClass),
                o.wrapperOverlayed && u.addClass(o.overlayedClass);
            }
            o.lastScroll = _;
          }
        }
        function S() {
          e(n.wrapper)
            .removeClass(o.stickyEnabledClass)
            .removeClass(o.overlayedClass),
            e("body").removeClass(i.overlaidBodyClass),
            (o.wrapperOverlayed = !1);
        }
        return { init: g, disableOverlayHeader: S, unload: b };
      })()),
      (theme.Slideshow = (function () {
        this.$slideshow = null;
        var a = {
          next: "is-next",
          init: "is-init",
          animateOut: "animate-out",
          wrapper: "slideshow-wrapper",
          slideshow: "slideshow",
          allSlides: "slick-slide",
          currentSlide: "slick-current",
          pauseButton: "slideshow__pause",
          isPaused: "is-paused",
        };
        function t(n, i) {
          (this.$slideshow = e(n)),
            (this.$wrapper = this.$slideshow.closest("." + a.wrapper)),
            (this.$pause = this.$wrapper.find("." + a.pauseButton)),
            (this.settings = {
              accessibility: !0,
              arrows: !!i.arrows,
              dots: !!i.dots,
              fade: !!i.fade,
              speed: i.speed ? i.speed : 500,
              draggable: !0,
              touchThreshold: 5,
              pauseOnHover: !1,
              rtl: theme.config.rtl,
              autoplay: !!i.autoplay,
              autoplaySpeed: this.$slideshow.data("speed"),
            }),
            this.$slideshow.off("beforeChange"),
            this.$slideshow.off("afterSlideChange"),
            this.$slideshow.on("init", this.init.bind(this)),
            this.$slideshow.on(
              "beforeChange",
              this.beforeSlideChange.bind(this)
            ),
            this.$slideshow.on("afterChange", this.afterSlideChange.bind(this)),
            this.$slideshow.slick(this.settings),
            this.$pause.on("click", this._togglePause.bind(this));
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function (n, i) {
              (this.$slideshowList = i.$list),
                (this.$slickDots = i.$dots),
                (this.$allSlides = i.$slides),
                (this.slideCount = i.slideCount),
                this.$slideshow.addClass(a.init),
                this._a11y(),
                this._clonedLazyloading();
            },
            beforeSlideChange: function (n, i, o, l) {
              var d = i.$slider,
                m = d.find("." + a.currentSlide).addClass(a.animateOut);
            },
            afterSlideChange: function (n, i, o) {
              var l = i.$slider,
                d = l.find("." + a.allSlides).removeClass(a.animateOut);
            },
            destroy: function () {
              this.$slideshow.slick("unslick");
            },
            _play: function () {
              this.$slideshow.slick("slickPause"),
                e(a.pauseButton).addClass("is-paused");
            },
            _pause: function () {
              this.$slideshow.slick("slickPlay"),
                e(a.pauseButton).removeClass("is-paused");
            },
            _togglePause: function () {
              var n = this._getSlideshowId(this.$pause);
              this.$pause.hasClass(a.isPaused)
                ? (this.$pause.removeClass(a.isPaused), e(n).slick("slickPlay"))
                : (this.$pause.addClass(a.isPaused), e(n).slick("slickPause"));
            },
            _getSlideshowId: function (n) {
              return "#Slideshow-" + n.data("id");
            },
            _activeSlide: function () {
              return this.$slideshow.find(".slick-active");
            },
            _currentSlide: function () {
              return this.$slideshow.find(".slick-current");
            },
            _nextSlide: function (n) {
              return this.$slideshow.find(
                '.slideshow__slide[data-slick-index="' + n + '"]'
              );
            },
            _a11y: function () {
              var n = this.$slideshowList,
                i = this.settings.autoplay;
              !n ||
                (n.removeAttr("aria-live"),
                e(a.wrapper).on(
                  "focusin",
                  function (o) {
                    !e(a.wrapper).has(o.target).length ||
                      (n.attr("aria-live", "polite"), i && this._pause());
                  }.bind(this)
                ),
                e(a.wrapper).on(
                  "focusout",
                  function (o) {
                    !e(a.wrapper).has(o.target).length ||
                      (n.removeAttr("aria-live"), i && this._play());
                  }.bind(this)
                ));
            },
            _clonedLazyloading: function () {
              var n = this.$slideshow;
              n.find(".slick-slide").each(
                function (i, o) {
                  var l = e(o);
                  if (l.hasClass("slick-cloned")) {
                    var d = l.data("id"),
                      m = l
                        .find(".hero__image")
                        .removeClass("lazyloading")
                        .addClass("lazyloaded");
                    setTimeout(function () {
                      var f = n
                        .find(
                          ".slideshow__slide--" +
                            d +
                            ":not(.slick-cloned) .hero__image"
                        )
                        .attr("style");
                      f && m.attr("style", f);
                    }, this.settings.autoplaySpeed / 1.5);
                  }
                }.bind(this)
              );
            },
          })),
          t
        );
      })()),
      (theme.announcementBar = (function () {
        var a = 0,
          t = !1,
          n = {
            accessibility: !0,
            arrows: !1,
            dots: !1,
            autoplay: !0,
            autoplaySpeed: 5e3,
            touchThreshold: 20,
            rtl: theme.config.rtl,
            slidesToShow: 1,
          },
          i;
        function o() {
          if (((i = e("#AnnouncementSlider")), !!i.length)) {
            (a = i.data("block-count")), (t = i.data("compact-style"));
            var h = e.extend({}, n, {
                slidesToShow: t ? 1 : a,
                slidesToScroll: 1,
              }),
              g = e.extend({}, n, { slidesToShow: 1 });
            theme.config.bpSmall ? l(i, g) : l(i, h),
              e("body").on(
                "matchSmall",
                function () {
                  l(i, g);
                }.bind(this)
              ),
              e("body").on(
                "matchLarge",
                function () {
                  l(i, h);
                }.bind(this)
              );
          }
        }
        function l(h, g) {
          d(h) && h.slick("unslick"), h.slick(g);
        }
        function d(h) {
          return h.length && h.hasClass("slick-initialized");
        }
        function m(h) {
          var g = e("#AnnouncementSlide-" + h);
          i.length && i.slick("slickPause"),
            g.length && i.slick("slickGoTo", g.data("index"));
        }
        function f(h) {
          i.length && d(i) && i.slick("slickPlay");
        }
        function u() {
          d(i) && i.slick("unslick");
        }
        return { init: o, onBlockSelect: m, onBlockDeselect: f, unload: u };
      })()),
      (theme.predictiveSearch = (function () {
        var a = "",
          t = !1,
          n,
          i = ".predictive",
          o = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: ".predictive-results",
            searchButton: "[data-predictive-search-button]",
            resultDiv: "#PredictiveResults",
            resultTemplate: "#PredictiveTemplate",
          },
          l = { isActive: "predicitive-active" },
          d = { up_arrow: 38, down_arrow: 40, tab: 9 };
        function m() {
          if (document.getElementById("shopify-features")) {
            var p = JSON.parse(
              document.getElementById("shopify-features").innerHTML
            );
            if (!p.predictiveSearch) return;
          }
          e(o.form).attr("autocomplete", "off"),
            e(o.form).on("submit" + i, h),
            e(o.input, o.form).on("keyup" + i, g),
            e(o.searchButton, o.wrapper).on("click" + i, u);
          var y = e(o.resultTemplate).html();
          resultTemplate = Handlebars.compile(y);
        }
        function f() {
          e(o.wrapper).addClass("hide"), clearTimeout(n);
        }
        function u() {
          e(o.form).trigger("submit");
        }
        function h(p) {
          var y = e(this);
          p.preventDefault ? p.preventDefault() : (p.returnValue = !1);
          var S = y.serializeArray().reduce(function (C, I) {
            return (C[I.name] = I.value), C;
          }, {});
          S.q && (S.q += "*");
          var _ = e.param(S);
          return (window.location.href = "/search?" + _), !1;
        }
        function g(p) {
          if (p.keyCode === d.up_arrow) {
            return;
          }
          if (p.keyCode === d.down_arrow) {
            return;
          }
          p.keyCode !== d.tab && b();
        }
        function b() {
          var p = e(o.input, o.form).val();
          if (p === "") {
            f();
            return;
          }
          var y = r(p);
          clearTimeout(n),
            (n = setTimeout(
              function () {
                w(y);
              }.bind(this),
              500
            ));
        }
        function w(p) {
          t ||
            (a !== p &&
              ((a = p),
              (t = !0),
              jQuery
                .getJSON("/search/suggest.json", {
                  q: p,
                  resources: {
                    type: theme.settings.predictiveSearchType,
                    limit: 4,
                    options: {
                      unavailable_products: "last",
                      fields: "title,product_type,variants.title,vendor",
                    },
                  },
                })
                .done(function (y) {
                  t = !1;
                  var S = {},
                    _ = 0;
                  e(o.wrapper).removeClass("hide");
                  for (
                    var C = Object.entries(y.resources.results),
                      I = C.length - 1;
                    I >= 0;
                    I--
                  ) {
                    var D = C[I],
                      V = D[0],
                      T = D[1];
                    switch (((_ += T.length), V)) {
                      case "products":
                        S[V] = k(T);
                        break;
                      case "collections":
                        S[V] = x(T);
                        break;
                      default:
                        S[V] = s(T);
                        break;
                    }
                  }
                  _ === 0 && f(),
                    e(o.resultDiv).empty().append(resultTemplate(S));
                })));
        }
        function k(p) {
          for (var y = [], S = p.length - 1; S >= 0; S--) {
            var _ = p[S],
              C = {
                title: _.title,
                url: _.url,
                image: theme.Images.lazyloadImagePath(_.image),
                vendor: _.vendor,
                price: theme.Currency.formatMoney(_.price),
                compare_price_max: theme.Currency.formatMoney(
                  _.compare_at_price_max
                ),
                on_sale: parseInt(_.compare_at_price_max) > parseInt(_.price),
                custom_label: c(_.tags),
              };
            y.push(C);
          }
          return y;
        }
        function x(p) {
          for (var y = [], S = p.length - 1; S >= 0; S--) {
            var _ = p[S],
              C = { title: _.title, url: _.url };
            y.push(C);
          }
          return y;
        }
        function s(p) {
          for (var y = p.length - 1; y >= 0; y--)
            if (!!p[y].image) {
              var S = theme.Images.lazyloadImagePath(p[y].image);
              p[y].image = S;
            }
          return p;
        }
        function c(p) {
          if (!p.length) return !1;
          for (var y = p.length - 1; y >= 0; y--)
            if (p[y].indexOf("_label_") !== -1)
              return p[y].replace("_label_", "");
          return !1;
        }
        function r(p) {
          return typeof p != "string"
            ? null
            : p.trim().replace(/\ /g, "-").toLowerCase();
        }
        function v(p, y) {}
        return { init: m };
      })()),
      (theme.initQuickShop = function () {
        var a = [],
          t = e(".quick-product__btn");
        t.each(function () {
          var n = e(this).data("product-id"),
            i = "QuickShopModal-" + n,
            o = "quick-modal-" + n;
          if (a.indexOf(n) > -1) {
            e('.modal--quick-shop[data-product-id="' + n + '"]').each(function (
              l
            ) {
              l > 0 && e(this).remove();
            });
            return;
          }
          new theme.Modals(i, o), a.push(n);
        });
      }),
      (theme.videoModal = function () {
        var a = null,
          t = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              autoplay: 1,
              branding: 0,
              cc_load_policy: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
            events: { onReady: u },
          },
          n = "VideoHolder",
          i = !1,
          o = {
            videoHolder: "#" + n,
            youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
            mp4Trigger: ".product-video-trigger--mp4",
            mp4Player: ".product-video-mp4-sound",
          };
        if (!e(o.youtube).length && !e(o.mp4Trigger).length) return;
        var l = new theme.Modals("VideoModal", "video-modal", {
          closeOffContentClick: !0,
          solid: !0,
        });
        e(o.youtube).on("click", d),
          e(o.mp4Trigger).on("click", m),
          e("body").on("modalClose.VideoModal", function () {
            a && i === "youtube"
              ? setTimeout(function () {
                  a.destroy();
                }, 500)
              : g();
          });
        function d(b) {
          g(),
            b.preventDefault(),
            theme.LibraryLoader.load("youtubeSdk"),
            theme.config.youTubeReady
              ? f(b)
              : e("body").on("youTubeReady", function () {
                  f(b);
                });
        }
        function m(b) {
          g();
          var w = e(b.currentTarget),
            k = w.next(o.mp4Player);
          k.clone().removeClass("hide").appendTo(o.videoHolder),
            l.open(b),
            e(o.videoHolder).find("video")[0].play(),
            (i = "mp4");
        }
        function f(b) {
          var w = e(b.currentTarget),
            k = h(w.attr("href")),
            x = e.extend({}, t, { videoId: k });
          (x.playerVars.playsinline = theme.config.bpSmall ? 0 : 1),
            (a = new YT.Player(n, x)),
            l.open(b),
            (i = "youtube");
        }
        function u(b) {
          b.target.playVideo();
        }
        function h(b) {
          var w =
              /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
            k = b.match(w);
          return k && k[7].length == 11 ? k[7] : !1;
        }
        function g() {
          e(o.videoHolder).empty();
        }
      }),
      (theme.RecentlyViewed = (function () {
        var a = {
            template: "#RecentlyViewedProduct",
            outputContainer: "#RecentlyViewed-",
          },
          t = !1;
        function n(i) {
          var o = (this.$container = e(i)),
            l = (this.sectionId = o.attr("data-section-id"));
          (this.namespace = ".recently-viewed" + l),
            !!e(a.template).length &&
              (this.checkVisibility(),
              e(window).on(
                "scroll" + this.namespace,
                e.throttle(200, this.checkVisibility.bind(this))
              ));
        }
        return (
          (n.prototype = e.extend({}, n.prototype, {
            init: function () {
              if (
                !t &&
                ((t = !0), !e.isEmptyObject(theme.recentlyViewed.recent))
              ) {
                (this.outputContainer = e(a.outputContainer + this.sectionId)),
                  (this.handle = this.$container.attr("data-product-handle"));
                var i = [];
                for (handle in theme.recentlyViewed.recent)
                  handle !== "undefined" && i.push(this.getProductInfo(handle));
                Promise.all(i).then(
                  function (o) {
                    this.setupOutput(o), this.captureProductDetails(o);
                  }.bind(this),
                  function (o) {
                    console.warn(
                      "Theme | recently viewed products failed to load"
                    );
                  }
                );
              }
            },
            checkVisibility: function () {
              theme.isElementVisible(this.$container, 600) &&
                (this.init(), e(window).off("scroll" + this.namespace));
            },
            getProductInfo: function (i) {
              return new Promise(function (o, l) {
                theme.recentlyViewed.productInfo.hasOwnProperty(i)
                  ? o(theme.recentlyViewed.productInfo[i])
                  : jQuery.getJSON("/products/" + i + ".js", function (d) {
                      o(d);
                    });
              });
            },
            setupOutput: function (i) {
              var o = [],
                l = {},
                d = this.$container.attr("data-recent-count"),
                m = 0;
              for (key in i) {
                var f = i[key];
                if (
                  f.handle !== this.handle &&
                  typeof f.handle != "undefined"
                ) {
                  m++,
                    (f.url_formatted = theme.recentlyViewed.recent[f.handle]
                      ? theme.recentlyViewed.recent[f.handle].url
                      : f.url),
                    (f.image_responsive_url =
                      theme.recentlyViewed.recent[f.handle].featuredImage),
                    (f.image_aspect_ratio =
                      theme.recentlyViewed.recent[f.handle].aspectRatio),
                    (f.on_sale = f.compare_at_price > f.price),
                    (f.sold_out = !f.available),
                    (f.price_formatted = theme.Currency.formatMoney(
                      f.price,
                      theme.settings.moneyFormat
                    )),
                    (f.compare_at_price_formatted = theme.Currency.formatMoney(
                      f.compare_at_price,
                      theme.settings.moneyFormat
                    )),
                    (f.price_min_formatted = theme.Currency.formatMoney(
                      f.price_min,
                      theme.settings.moneyFormat
                    )),
                    (f.money_saved = theme.Currency.formatMoney(
                      f.compare_at_price - f.price,
                      theme.settings.moneyFormat
                    ));
                  var u = f.variants[0];
                  if (u && u.unit_price) {
                    var h = "";
                    u.unit_price_measurement &&
                      (u.unit_price_measurement.reference_value != 1 &&
                        (h += u.unit_price_measurement.reference_value + " "),
                      (h += u.unit_price_measurement.reference_unit)),
                      (f.unit_price = theme.Currency.formatMoney(u.unit_price)),
                      h != "" && (f.unit_price += "/" + h);
                  }
                  o.unshift(f);
                }
              }
              if (
                ((l = {
                  items: o.slice(0, d),
                  grid_item_width: this.$container.attr("data-grid-item-class"),
                }),
                o.length !== 0)
              ) {
                var g = e(a.template).html(),
                  b = Handlebars.compile(g);
                this.outputContainer.append(b(l)), AOS && AOS.refreshHard();
              }
            },
            captureProductDetails: function (i) {
              for (var o = 0; o < i.length; o++) {
                var l = i[o];
                theme.recentlyViewed.productInfo[l.handle] = l;
              }
              theme.config.hasSessionStorage &&
                sessionStorage.setItem(
                  "recent-products",
                  JSON.stringify(theme.recentlyViewed.productInfo)
                );
            },
            onUnload: function () {
              (t = !1), e("window").off(this.namespace);
            },
          })),
          n
        );
      })()),
      (theme.parallaxSections = {}),
      (theme.Parallax = (function () {
        var a = 7;
        function t(n, i) {
          (this.$container = e(n)),
            (this.namespace = i.namespace),
            !!this.$container.length &&
              (i.desktopOnly
                ? this.desktopInit()
                : this.init(this.$container, i));
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function (n) {
              var i = (this.$window = e(window)),
                o = this.$container.offset().top;
              i.on(
                "scroll" + this.namespace,
                function (l) {
                  var d = i.scrollTop(),
                    m = (o - d) / a;
                  this.$container.css({
                    transform: "translate3d(0, " + m + "px, 0)",
                  });
                }.bind(this)
              ),
                i.on(
                  "resize" + this.namespace,
                  e.debounce(
                    350,
                    function () {
                      if ((i.off(this.namespace), n && !theme.config.bpSmall)) {
                        this.init(!0);
                        return;
                      }
                      this.init();
                    }.bind(this)
                  )
                );
            },
            desktopInit: function () {
              theme.config.bpSmall || this.init(!0),
                e("body").on(
                  "matchSmall",
                  function () {
                    this.destroy();
                  }.bind(this)
                ),
                e("body").on(
                  "matchLarge",
                  function () {
                    this.init(!0);
                  }.bind(this)
                );
            },
            destroy: function () {
              this.$container.removeAttr("style"),
                this.$window.off(this.namespace);
            },
          })),
          t
        );
      })()),
      (theme.Disclosure = (function () {
        var a = {
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]",
          },
          t = { listVisible: "disclosure-list--visible" };
        function n(i) {
          (this.$container = i),
            (this.cache = {}),
            this._cacheSelectors(),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut();
        }
        return (
          (n.prototype = e.extend({}, n.prototype, {
            _cacheSelectors: function () {
              this.cache = {
                $disclosureList: this.$container.find(a.disclosureList),
                $disclosureToggle: this.$container.find(a.disclosureToggle),
                $disclosureInput: this.$container.find(a.disclosureInput),
                $disclosureOptions: this.$container.find(a.disclosureOptions),
              };
            },
            _connectToggle: function () {
              this.cache.$disclosureToggle.on(
                "click",
                function (i) {
                  var o = e(i.currentTarget).attr("aria-expanded") === "true";
                  e(i.currentTarget).attr("aria-expanded", !o),
                    this.cache.$disclosureList.toggleClass(t.listVisible);
                }.bind(this)
              );
            },
            _connectOptions: function () {
              this.cache.$disclosureOptions.on(
                "click",
                function (i) {
                  i.preventDefault(),
                    this._submitForm(e(i.currentTarget).data("value"));
                }.bind(this)
              );
            },
            _onFocusOut: function () {
              this.cache.$disclosureToggle.on(
                "focusout",
                function (i) {
                  var o = this.$container.has(i.relatedTarget).length === 0;
                  o && this._hideList();
                }.bind(this)
              ),
                this.cache.$disclosureList.on(
                  "focusout",
                  function (i) {
                    var o = e(i.currentTarget).has(i.relatedTarget).length > 0,
                      l = this.cache.$disclosureList.hasClass(t.listVisible);
                    l && !o && this._hideList();
                  }.bind(this)
                ),
                this.$container.on(
                  "keyup",
                  function (i) {
                    i.which === 27 &&
                      (this._hideList(), this.cache.$disclosureToggle.focus());
                  }.bind(this)
                ),
                e("body").on(
                  "click",
                  function (i) {
                    var o = this.$container.has(i.target).length > 0,
                      l = this.cache.$disclosureList.hasClass(t.listVisible);
                    l && !o && this._hideList();
                  }.bind(this)
                );
            },
            _submitForm: function (i) {
              e("body").addClass("unloading"),
                this.cache.$disclosureInput.val(i),
                this.$container.parents("form").submit();
            },
            _hideList: function () {
              this.cache.$disclosureList.removeClass(t.listVisible),
                this.cache.$disclosureToggle.attr("aria-expanded", !1);
            },
            unload: function () {
              this.cache.$disclosureOptions.off(),
                this.cache.$disclosureToggle.off(),
                this.cache.$disclosureList.off(),
                this.$container.off();
            },
          })),
          n
        );
      })()),
      (theme.ProductMedia = (function () {
        var a = {},
          t = {},
          n = {},
          i = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]",
          };
        function o(u, h) {
          (a[h] = { loaded: !1 }),
            u.each(function (g) {
              var b = e(this),
                w = b.data("media-id"),
                k = e(b.find("model-viewer")[0]),
                x = k.data("model-id");
              if (g === 0) {
                var s = b.closest(i.mediaGroup).find(i.xrButton);
                n[h] = { $element: s, defaultId: x };
              }
              t[w] = { modelId: x, sectionId: h, $container: b, $element: k };
            }),
            window.Shopify.loadFeatures([
              { name: "shopify-xr", version: "1.0", onLoad: l },
              { name: "model-viewer-ui", version: "1.0", onLoad: d },
            ]),
            theme.LibraryLoader.load("modelViewerUiStyles");
        }
        function l(u) {
          if (!u) {
            if (!window.ShopifyXR) {
              document.addEventListener("shopify_xr_initialized", function () {
                l();
              });
              return;
            }
            for (var h in a)
              if (a.hasOwnProperty(h)) {
                var g = a[h];
                if (g.loaded) continue;
                var b = e("#ModelJson-" + h);
                window.ShopifyXR.addModels(JSON.parse(b.html())),
                  (g.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          }
        }
        function d(u) {
          if (!u) {
            for (var h in t)
              if (t.hasOwnProperty(h)) {
                var g = t[h];
                !g.modelViewerUi &&
                  Shopify &&
                  (g.modelViewerUi = new Shopify.ModelViewerUI(g.$element)),
                  m(g);
              }
          }
        }
        function m(u) {
          var h = n[u.sectionId];
          u.$container.on("mediaVisible", function () {
            h.$element.attr("data-shopify-model3d-id", u.modelId),
              !theme.config.isTouch && u.modelViewerUi.play();
          }),
            u.$container
              .on("mediaHidden", function () {
                h.$element.attr("data-shopify-model3d-id", h.defaultId),
                  u.modelViewerUi.pause();
              })
              .on("xrLaunch", function () {
                u.modelViewerUi.pause();
              });
        }
        function f(u) {
          for (var h in t)
            if (t.hasOwnProperty(h)) {
              var g = t[h];
              g.sectionId === u && delete t[h];
            }
          delete a[u];
        }
        return { init: o, removeSectionModels: f };
      })()),
      (theme.collectionTemplate = (function () {
        var a = !1,
          t = {
            collectionGrid: ".collection-grid__wrapper",
            sidebar: "#CollectionSidebar",
            activeTagList: ".tag-list--active-tags",
            tags: ".tag-list a",
            filters: ".collection-filter",
          },
          n = { combineTags: e(t.sidebar).data("combine-tags") },
          i = { activeTag: "tag--active", removeTagParent: "tag--remove" };
        function o() {
          e(window).on("popstate", function (h) {
            h && f(location.href);
          }),
            theme.config.stickyHeader &&
              (m(), e(window).on("resize", e.debounce(150, m))),
            l();
        }
        function l() {
          e("body").on("click", t.tags, function (h) {
            var g = e(this);
            if (
              (theme.FilterDrawer && theme.FilterDrawer.close(),
              !g.hasClass("no-ajax") && (h.preventDefault(), !a))
            ) {
              a = !0;
              var g = e(h.currentTarget),
                b = g.parent(),
                w = g.attr("href");
              n.combineTags
                ? b.hasClass(i.activeTag)
                  ? b.removeClass(i.activeTag)
                  : (b.addClass(i.activeTag),
                    g.parent("li").hasClass(i.removeTagParent)
                      ? e(this).parent().remove()
                      : e(t.activeTagList).append(
                          '<li class="tag tag--remove"><a class="btn btn--small">' +
                            g.text() +
                            "</a></li>"
                        ))
                : (e(t.tags).parent().removeClass(i.activeTag),
                  b.addClass(i.activeTag)),
                d(!0),
                history.pushState({}, "", w),
                e(t.collectionGrid).addClass("unload"),
                f(w);
            }
          });
        }
        function d(h) {
          var g;
          if (
            (theme.config.bpSmall
              ? (g = e("[data-scroll-to]").offset().top - 60)
              : (g = e("#CollectionAjaxResult").offset().top + 1),
            theme.config.stickyHeader)
          ) {
            var b = e(".site-header").outerHeight(!0);
            g = g - b;
          }
          h
            ? e("html, body").animate({ scrollTop: g }, 300)
            : e("html, body").scrollTop(g);
        }
        function m() {
          var h = e(".site-header").outerHeight(!0);
          e(t.filters).css("top", h + 10);
        }
        function f(h) {
          (h = h.indexOf("?") === -1 ? h + "?view=ajax" : h + "&view=ajax"),
            e("#CollectionAjaxResult").load(
              h + " #CollectionAjaxContent",
              function () {
                (a = !1),
                  theme.reinitSection("collection-template"),
                  theme.collectionTemplate.reinit();
              }.bind(this)
            );
        }
        function u() {
          (n.combineTags = e(t.sidebar).data("combine-tags")),
            d(!1),
            theme.reinitProductGridItem(),
            e("body").trigger("resize");
        }
        return { init: o, reinit: u };
      })()),
      (theme.customerTemplates = (function () {
        function a() {
          e("#RecoverPassword").on("click", function (l) {
            l.preventDefault(), t();
          }),
            e("#HideRecoverPasswordLink").on("click", function (l) {
              l.preventDefault(), t();
            });
        }
        function t() {
          e("#RecoverPasswordForm").toggleClass("hide"),
            e("#CustomerLoginForm").toggleClass("hide");
        }
        function n() {
          var l = e(".reset-password-success");
          !l.length || e("#ResetSuccess").removeClass("hide");
        }
        function i() {
          var l = e("#AddressNewForm"),
            d = e(".js-address-form");
          !l.length ||
            !d.length ||
            (Shopify &&
              e(".js-address-country").each(function () {
                var m = e(this),
                  f = m.data("country-id"),
                  u = m.data("province-id"),
                  h = m.data("province-container-id");
                Shopify &&
                  new Shopify.CountryProvinceSelector(f, u, { hideElement: h });
              }),
            e(".address-new-toggle").on("click", function () {
              l.toggleClass("hide");
            }),
            e(".address-edit-toggle").on("click", function () {
              var m = e(this).data("form-id");
              e("#EditAddress_" + m).toggleClass("hide");
            }),
            e(".address-delete").on("click", function () {
              var m = e(this),
                f = m.data("form-id"),
                u = m.data("confirm-message");
              confirm(u || "Are you sure you wish to delete this address?") &&
                Shopify &&
                Shopify.postLink("/account/addresses/" + f, {
                  parameters: { _method: "delete" },
                });
            }));
        }
        function o() {
          var l = window.location.hash;
          l === "#recover" && t();
        }
        return {
          init: function () {
            o(), a(), n(), i();
          },
        };
      })()),
      (theme.Product = (function () {
        var a = {
            onSale: "on-sale",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible",
          },
          t = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            currentSlide: ".slick-current",
            startingSlide: ".starting-slide",
          },
          n,
          i = {},
          o = [],
          l = {
            height: "480",
            width: "850",
            playerVars: {
              autohide: 0,
              autoplay: 0,
              branding: 0,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
          };
        function d(s, c) {
          var r = e("#" + c),
            v = r.attr("id");
          o[v] = s.target;
          var p = o[v];
          b(r),
            i[v].style === "muted" ? o[v].mute() : w(r),
            (r.closest(t.startingSlide).length ||
              r.data("image-count") === 1) &&
              i[v].style === "muted" &&
              (o[v].playVideo(), m(v));
        }
        function m(s) {
          f(s), e(window).on("scroll." + s, { id: s }, e.throttle(150, f));
        }
        function f(s) {
          var c;
          if (typeof s == "string") c = s;
          else {
            if (!s.data) return;
            c = s.data.id;
          }
          if (theme.isElementVisible(e("#" + c))) {
            if (i[c] && i[c].style === "unmuted") return;
            u(c);
          } else h(c);
        }
        function u(s) {
          o[s] && typeof o[s].playVideo == "function" && o[s].playVideo();
        }
        function h(s) {
          o[s] && typeof o[s].pauseVideo == "function" && o[s].pauseVideo();
        }
        function g(s, c) {
          var r = e("#" + c),
            v = r.attr("id"),
            p = o[v];
          switch (s.data) {
            case -1:
              i[v].attemptedToPlay && (w(r), k(r));
              break;
            case 0:
              i[v] && i[v].loop && p.playVideo();
              break;
            case 1:
              w(r);
              break;
            case 3:
              i[v].attemptedToPlay = !0;
              break;
          }
        }
        function b(s) {
          s.closest(t.videoParent).addClass(a.loading);
        }
        function w(s) {
          s.closest(t.videoParent).removeClass(a.loading).addClass(a.loaded);
        }
        function k(s) {
          s.closest(t.videoParent).addClass(a.interactable);
        }
        function x(s) {
          var c = (this.$container = e(s)),
            r = (this.sectionId = c.attr("data-section-id"));
          (this.inModal = c.closest(".modal").length),
            this.$modal,
            (this.settings = {
              enableHistoryState: c.data("enable-history-state") || !1,
              namespace: ".product-" + r,
              inventory: c.data("inventory") || !1,
              incomingInventory: c.data("incoming-inventory") || !1,
              modalInit: !1,
              slickMainInitialized: !1,
              slickThumbInitialized: !1,
              thumbArrows: !1,
              thumbVertical: !1,
              hasImages: !0,
              hasMultipleImages: !1,
              has3d: !1,
              imageSize: "620x",
              videoLooping: c.data("video-looping"),
            }),
            this.inModal &&
              ((this.settings.enableHistoryState = !1),
              (this.settings.namespace = ".product-" + r + "-modal"),
              (this.$modal = e("#QuickShopModal-" + r))),
            (this.selectors = {
              variantsJson: "VariantsJson-" + r,
              currentVariantJson: "CurrentVariantJson-" + r,
              video: "ProductVideo-" + r,
              media: "[data-product-media-type-model]",
              closeMedia: ".product-single__close-media",
              photoThumbs: ".product__thumb-" + r,
              thumbSlider: "#ProductThumbs-" + r,
              mainSlider: "#ProductPhotos-" + r,
              imageContainer: "[data-product-images]",
              productImageMain: ".product-image-main--" + r,
              dotsContainer: ".product__photo-dots--" + r,
              priceWrapper: ".product__price-wrap-" + r,
              price: "#ProductPrice-" + r,
              comparePrice: "#ComparePrice-" + r,
              savePrice: "#SavePrice-" + r,
              priceA11y: "#PriceA11y-" + r,
              comparePriceA11y: "#ComparePriceA11y-" + r,
              unitWrapper: ".product__unit-price-wrapper--" + r,
              unitPrice: ".product__unit-price--" + r,
              unitPriceBaseUnit: ".product__unit-base--" + r,
              sku: "#Sku-" + r,
              inventory: "#ProductInventory-" + r,
              incomingInventory: "#ProductIncomingInventory-" + r,
              addToCart: "#AddToCart-" + r,
              addToCartText: "#AddToCartText-" + r,
              originalSelectorId: "#ProductSelect-" + r,
              singleOptionSelector: ".variant__input-" + r,
              variantColorSwatch: ".variant__input--color-swatch-" + r,
              modalFormHolder: "#ProductFormHolder-" + r,
              formContainer: "#AddToCartForm-" + r,
              availabilityContainer: "StoreAvailabilityHolder-" + r,
            }),
            (this.$mainSlider = e(this.selectors.mainSlider)),
            (this.$thumbSlider = e(this.selectors.thumbSlider)),
            (this.$firstProductImage = this.$mainSlider.find("img").first()),
            this.$firstProductImage.length || (this.settings.hasImages = !1),
            this.init();
        }
        return (
          (x.prototype = e.extend({}, x.prototype, {
            init: function () {
              this.inModal &&
                (this.$container.addClass(a.isModal),
                e("body")
                  .off("modalOpen.QuickShopModal-" + this.sectionId)
                  .off("modalClose.QuickShopModal-" + this.sectionId),
                e("body").on(
                  "modalOpen.QuickShopModal-" + this.sectionId,
                  this.openModalProduct.bind(this)
                ),
                e("body").on(
                  "modalClose.QuickShopModal-" + this.sectionId,
                  this.closeModalProduct.bind(this)
                )),
                this.inModal ||
                  (this.stringOverrides(),
                  this.formSetup(),
                  this.productSetup(),
                  this.checkIfVideos(),
                  this.createImageCarousels(),
                  this.customMediaListners(),
                  this.addIdToRecentlyViewed());
            },
            formSetup: function () {
              theme.settings.dynamicVariantsEnable &&
                (this.$variantSelectors = e(this.selectors.formContainer).find(
                  this.selectors.singleOptionSelector
                )),
                this.initQtySelector(),
                this.initAjaxProductForm(),
                this.availabilitySetup(),
                this.initVariants();
            },
            availabilitySetup: function () {
              var s = document.getElementById(
                this.selectors.availabilityContainer
              );
              s && (this.storeAvailability = new theme.StoreAvailability(s));
            },
            productSetup: function () {
              this.setImageSizes(),
                this.initImageSwitch(),
                this.initImageZoom(),
                this.initModelViewerLibraries(),
                this.initShopifyXrLaunch();
            },
            addIdToRecentlyViewed: function () {
              var s = this.$container.attr("data-product-handle"),
                c = this.$container.attr("data-product-url"),
                r = this.$container.attr("data-aspect-ratio"),
                v = this.$container.attr("data-img-url");
              theme.recentlyViewed.recent.hasOwnProperty(s) &&
                delete theme.recentlyViewed.recent[s],
                (theme.recentlyViewed.recent[s] = {
                  url: c,
                  aspectRatio: r,
                  featuredImage: v,
                }),
                theme.config.hasLocalStorage &&
                  window.localStorage.setItem(
                    "theme-recent",
                    JSON.stringify(theme.recentlyViewed.recent)
                  );
            },
            stringOverrides: function () {
              (theme.productStrings = theme.productStrings || {}),
                e.extend(theme.strings, theme.productStrings);
            },
            initVariants: function () {
              if (!!document.getElementById(this.selectors.variantsJson)) {
                this.variantsObject = JSON.parse(
                  document.getElementById(this.selectors.variantsJson).innerHTML
                );
                var s = {
                  $container: this.$container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: this.selectors.singleOptionSelector,
                  originalSelectorId: this.selectors.originalSelectorId,
                  variants: this.variantsObject,
                };
                e(this.selectors.variantColorSwatch).length &&
                  e(this.selectors.variantColorSwatch).on(
                    "change",
                    function (c) {
                      var r = e(c.currentTarget),
                        v = r.data("color-name"),
                        p = r.data("color-index");
                      this.updateColorName(v, p);
                    }.bind(this)
                  ),
                  (this.variants = new theme.Variants(s)),
                  this.storeAvailability &&
                    (this.storeAvailability.updateContent(
                      this.variants.currentVariant.id
                    ),
                    this.$container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateAvailability.bind(this)
                    )),
                  this.$container
                    .on(
                      "variantChange" + this.settings.namespace,
                      this.updateCartButton.bind(this)
                    )
                    .on(
                      "variantImageChange" + this.settings.namespace,
                      this.updateVariantImage.bind(this)
                    )
                    .on(
                      "variantPriceChange" + this.settings.namespace,
                      this.updatePrice.bind(this)
                    )
                    .on(
                      "variantUnitPriceChange" + this.settings.namespace,
                      this.updateUnitPrice.bind(this)
                    ),
                  e(this.selectors.sku).length &&
                    this.$container.on(
                      "variantSKUChange" + this.settings.namespace,
                      this.updateSku.bind(this)
                    ),
                  (this.settings.inventory ||
                    this.settings.incomingInventory) &&
                    this.$container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateInventory.bind(this)
                    ),
                  theme.settings.dynamicVariantsEnable &&
                    document.getElementById(
                      this.selectors.currentVariantJson
                    ) &&
                    ((this.currentVariantObject = JSON.parse(
                      document.getElementById(this.selectors.currentVariantJson)
                        .innerHTML
                    )),
                    this.$variantSelectors.on(
                      "change" + this.settings.namespace,
                      this.updateVariantAvailability.bind(this)
                    ),
                    this.setCurrentVariantAvailability(
                      this.currentVariantObject,
                      !0
                    ));
              }
            },
            initQtySelector: function () {
              this.$container.find(".js-qty__wrapper").each(function () {
                new theme.QtySelector(e(this), { namespace: ".product" });
              });
            },
            initAjaxProductForm: function () {
              theme.settings.cartType === "drawer" &&
                new theme.AjaxProduct(e(this.selectors.formContainer));
            },
            setCurrentVariantAvailability: function (s) {
              var c = { option1: [], option2: [], option3: [] };
              this.disableVariantGroup(
                e(this.selectors.formContainer).find(".variant-input-wrap")
              );
              var r = this.variantsObject.filter(function (I) {
                  if (s.id === I.id) return !1;
                  if (
                    (s.option2 === I.option2 && s.option3 === I.option3) ||
                    (s.option1 === I.option1 && s.option3 === I.option3) ||
                    (s.option1 === I.option1 && s.option2 === I.option2)
                  )
                    return !0;
                }),
                v = { variant: s };
              r = Object.assign({}, v, r);
              for (var p in r)
                if (r.hasOwnProperty(p)) {
                  var y = r[p],
                    S = y.option1,
                    _ = y.option2,
                    C = y.option3;
                  S && c.option1.indexOf(S) === -1 && c.option1.push(S),
                    _ && c.option2.indexOf(_) === -1 && c.option2.push(_),
                    C && c.option3.indexOf(C) === -1 && c.option3.push(C);
                }
              c.option1.length &&
                this.enableVariantOptionByValue(c.option1, "option1"),
                c.option2.length &&
                  this.enableVariantOptionByValue(c.option2, "option2"),
                c.option3.length &&
                  this.enableVariantOptionByValue(c.option3, "option3");
            },
            updateVariantAvailability: function (s, c, r) {
              if (c && r)
                var v = c,
                  p = r;
              else
                var y = e(s.currentTarget),
                  v = y.val() ? y.val() : s.currentTarget.value,
                  p = y.data("index");
              var S = this.variantsObject.filter(function (_) {
                return _[p] === v;
              });
              e(this.selectors.formContainer)
                .find(".variant-input-wrap")
                .each(
                  function (_, C) {
                    var I = e(C),
                      D = I.data("index");
                    if (D !== p) {
                      this.disableVariantGroup(I);
                      for (var V = 0; V < S.length; V++)
                        this.enableVariantOption(I, S[V][D]);
                    }
                  }.bind(this)
                );
            },
            disableVariantGroup: function (s) {
              theme.settings.dynamicVariantType === "dropdown"
                ? s.find("option").prop("disabled", !0)
                : (s.find("input").prop("disabled", !0),
                  s.find("label").toggleClass("disabled", !0));
            },
            enableVariantOptionByValue: function (s, c) {
              for (
                var r = e(this.selectors.formContainer).find(
                    '.variant-input-wrap[data-index="' + c + '"]'
                  ),
                  v = 0;
                v < s.length;
                v++
              )
                this.enableVariantOption(r, s[v]);
            },
            enableVariantOption: function (s, c) {
              if (
                ((c = c.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")),
                theme.settings.dynamicVariantType === "dropdown")
              )
                s.find('option[value="' + c + '"]').prop("disabled", !1);
              else {
                var r = s.find('.variant-input[data-value="' + c + '"]');
                r.find("input").prop("disabled", !1),
                  r.find("label").toggleClass("disabled", !1);
              }
            },
            updateColorName: function (s, c) {
              e("#VariantColorLabel-" + this.sectionId + "-" + c).text(s);
            },
            updateCartButton: function (s) {
              var c = s.variant;
              if (c)
                if (c.available) {
                  e(this.selectors.addToCart)
                    .removeClass(a.disabled)
                    .prop("disabled", !1);
                  var r = e(this.selectors.addToCartText).data("default-text");
                  e(this.selectors.addToCartText).html(r);
                } else
                  e(this.selectors.addToCart)
                    .addClass(a.disabled)
                    .prop("disabled", !0),
                    e(this.selectors.addToCartText).html(theme.strings.soldOut);
              else
                e(this.selectors.addToCart)
                  .addClass(a.disabled)
                  .prop("disabled", !0),
                  e(this.selectors.addToCartText).html(
                    theme.strings.unavailable
                  );
            },
            updatePrice: function (s) {
              var c = s.variant;
              if (c)
                if (
                  (e(this.selectors.price)
                    .html(
                      theme.Currency.formatMoney(
                        c.price,
                        theme.settings.moneyFormat
                      )
                    )
                    .show(),
                  c.compare_at_price > c.price)
                ) {
                  e(this.selectors.comparePrice).html(
                    theme.Currency.formatMoney(
                      c.compare_at_price,
                      theme.settings.moneyFormat
                    )
                  ),
                    e(this.selectors.priceWrapper).removeClass("hide"),
                    e(this.selectors.price).addClass(a.onSale),
                    e(this.selectors.comparePriceA11y).attr(
                      "aria-hidden",
                      "false"
                    ),
                    e(this.selectors.priceA11y).attr("aria-hidden", "false");
                  var r = c.compare_at_price - c.price;
                  theme.settings.saveType == "percent"
                    ? (r = Math.round((r * 100) / c.compare_at_price) + "%")
                    : (r = theme.Currency.formatMoney(
                        r,
                        theme.settings.moneyFormat
                      )),
                    e(this.selectors.savePrice)
                      .removeClass("hide")
                      .html(
                        theme.strings.savePrice.replace("[saved_amount]", r)
                      );
                } else
                  e(this.selectors.priceWrapper).addClass("hide"),
                    e(this.selectors.price).removeClass(a.onSale),
                    e(this.selectors.comparePriceA11y).attr(
                      "aria-hidden",
                      "true"
                    ),
                    e(this.selectors.priceA11y).attr("aria-hidden", "true"),
                    e(this.selectors.savePrice).addClass("hide");
            },
            updateUnitPrice: function (s) {
              var c = s.variant;
              c && c.unit_price
                ? (e(this.selectors.unitPrice).html(
                    theme.Currency.formatMoney(
                      c.unit_price,
                      theme.settings.moneyFormat
                    )
                  ),
                  e(this.selectors.unitPriceBaseUnit).text(
                    theme.Currency.getBaseUnit(c)
                  ),
                  e(this.selectors.unitWrapper)
                    .removeClass("hide")
                    .removeClass(a.visuallyHide))
                : e(this.selectors.unitWrapper).addClass(a.visuallyHide);
            },
            updateSku: function (s) {
              var c = s.variant,
                r = "";
              c && (c.sku && (r = c.sku), e(this.selectors.sku).html(r));
            },
            updateInventory: function (s) {
              var c = s.variant;
              if (
                !c ||
                !c.inventory_management ||
                c.inventory_policy === "continue"
              ) {
                this.toggleInventoryQuantity(!1),
                  this.toggleIncomingInventory(!1);
                return;
              }
              if (
                c.inventory_management === "shopify" &&
                window.inventories &&
                window.inventories[this.sectionId]
              ) {
                variantInventoryObject =
                  window.inventories[this.sectionId][c.id];
                var r = variantInventoryObject.quantity,
                  v = !0,
                  p = !1;
                (r <= 0 || r > theme.settings.inventoryThreshold) && (v = !1),
                  this.toggleInventoryQuantity(v, r),
                  !v && variantInventoryObject.incoming && (p = !0),
                  this.toggleIncomingInventory(
                    p,
                    c.available,
                    variantInventoryObject.next_incoming_date
                  );
              }
            },
            updateAvailability: function (s) {
              var c = s.variant;
              !c || this.storeAvailability.updateContent(c.id);
            },
            toggleInventoryQuantity: function (s, c) {
              this.settings.inventory || (s = !1),
                s
                  ? e(this.selectors.inventory)
                      .removeClass("hide")
                      .text(theme.strings.stockLabel.replace("[count]", c))
                  : e(this.selectors.inventory).addClass("hide");
            },
            toggleIncomingInventory: function (s, c, r) {
              if ((this.settings.incomingInventory || (s = !1), s)) {
                var v = c
                  ? theme.strings.willNotShipUntil.replace("[date]", r)
                  : theme.strings.willBeInStockAfter.replace("[date]", r);
                r || (v = theme.strings.waitingForStock),
                  e(this.selectors.incomingInventory)
                    .removeClass("hide")
                    .text(v);
              } else e(this.selectors.incomingInventory).addClass("hide");
            },
            checkIfVideos: function () {
              var s = this.$mainSlider.find(t.productVideo);
              if (!s.length) return !1;
              var c = [];
              return (
                s.each(function () {
                  var r = e(this).data("video-type");
                  c.indexOf(r) < 0 && c.push(r);
                }),
                c.indexOf("youtube") > -1 &&
                  (theme.config.youTubeReady
                    ? this.loadYoutubeVideos(s)
                    : (theme.LibraryLoader.load("youtubeSdk"),
                      e("body").on(
                        "youTubeReady" + this.settings.namespace,
                        function () {
                          this.loadYoutubeVideos(s);
                        }.bind(this)
                      ))),
                c.indexOf("mp4") > -1 && this.loadMp4Videos(s),
                c
              );
            },
            loadMp4Videos: function (s) {
              s.each(function () {
                var c = e(this);
                if (c.data("video-type") == "mp4") {
                  var r = c.attr("id"),
                    v = c.data("video-id");
                  i[r] = {
                    type: "mp4",
                    divId: r,
                    style: c.data("video-style"),
                  };
                }
              });
            },
            loadYoutubeVideos: function (s) {
              s.each(function () {
                var v = e(this);
                if (v.data("video-type") == "youtube") {
                  var p = v.attr("id"),
                    y = v.data("youtube-id");
                  i[p] = {
                    type: "youtube",
                    id: p,
                    videoId: y,
                    style: v.data("video-style"),
                    loop: v.data("video-loop"),
                    attemptedToPlay: !1,
                    events: {
                      onReady: function (S) {
                        d(S, p);
                      },
                      onStateChange: function (S) {
                        g(S, p);
                      },
                    },
                  };
                }
              });
              for (var c in i)
                if (i[c].type === "youtube" && i.hasOwnProperty(c)) {
                  var r = e.extend({}, l, i[c]);
                  r.style === "muted" ||
                    ((r.playerVars.controls = 1), (r.playerVars.autoplay = 0)),
                    (o[c] = new YT.Player(c, r));
                }
              n = !0;
            },
            initVideo: function (s) {
              var c = s.data("video-type"),
                r = s.attr("id");
              c === "mp4" && i[r].style === "muted" && this.playMp4Video(r),
                c === "youtube" &&
                  n &&
                  i[r].style === "muted" &&
                  this.requestToPlayYoutubeVideo(r),
                this.inModal && this.resizeSlides();
            },
            stopVideo: function (s, c) {
              s || (this.stopYoutubeVideo(), this.stopMp4Video()),
                c === "youtube" && this.stopYoutubeVideo(s),
                c === "mp4" && this.stopMp4Video(s);
            },
            getVideoType: function (s) {
              return s.data("video-type");
            },
            getVideoId: function (s) {
              return s.attr("id");
            },
            requestToPlayYoutubeVideo: function (s, c) {
              if (!!theme.config.youTubeReady) {
                var r = e("#" + s);
                if ((b(r), typeof o[s].playVideo != "function")) {
                  setTimeout(
                    function () {
                      this.playYoutubeVideo(s, c);
                    }.bind(this),
                    1e3
                  );
                  return;
                }
                this.playYoutubeVideo(s, c);
              }
            },
            playYoutubeVideo: function (s, c) {
              var r = e("#" + s);
              w(r),
                typeof o[s].playVideo == "function" && o[s].playVideo(),
                c || m(s);
            },
            stopYoutubeVideo: function (s) {
              if (!!theme.config.youTubeReady)
                if (s && o[s])
                  typeof o[s].pauseVideo == "function" && o[s].pauseVideo(),
                    e(window).off("scroll." + s);
                else
                  for (key in o) {
                    var c = this.$container.find("#" + key);
                    c.length &&
                      typeof o[key].pauseVideo == "function" &&
                      (o[key].pauseVideo(), e(window).off("scroll." + key));
                  }
            },
            playMp4Video: function (s) {
              var c = e("#" + s);
              w(c);
              var r = c[0].play();
              r !== void 0 &&
                r
                  .then(function () {})
                  .catch(function (v) {
                    c[0].setAttribute("controls", ""),
                      c
                        .closest(t.videoParent)
                        .attr("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (s) {
              if (s) e("#" + s)[0].pause();
              else
                for (var c in i) {
                  var r = this.$container.find("#" + c);
                  if (r.length && i[c].type === "mp4") {
                    var v = e("#" + i[c].divId)[0];
                    v && typeof v.pause == "function" && v.pause();
                  }
                }
            },
            initImageZoom: function () {
              var s = e(this.selectors.imageContainer, this.$container),
                c = new theme.Photoswipe(s[0], this.sectionId);
            },
            setImageSizes: function () {
              if (!!this.settings.hasImages) {
                var s = this.$firstProductImage[0].currentSrc;
                s && (this.settings.imageSize = theme.Images.imageSize(s));
              }
            },
            updateVariantImage: function (s) {
              var c = s.variant,
                r = theme.Images.getSizedImageUrl(
                  c.featured_media.preview_image.src,
                  this.settings.imageSize
                ),
                v = e('.product__thumb[data-id="' + c.featured_media.id + '"]'),
                p = this._slideIndex(v.closest(".product__thumb-item"));
              typeof p != "undefined" && this.$mainSlider.slick("slickGoTo", p);
            },
            initImageSwitch: function () {
              !e(this.selectors.photoThumbs).length ||
                e(this.selectors.photoThumbs)
                  .on("click", function (s) {
                    s.preventDefault();
                  })
                  .on(
                    "focus",
                    function (s) {
                      if (!!this.settings.slickThumbInitialized) {
                        var c = e(s.currentTarget).data("index");
                        c !== void 0 && this.$thumbSlider.slick("slickGoTo", c);
                      }
                    }.bind(this)
                  )
                  .on(
                    "keydown",
                    function (s) {
                      s.keyCode === 13 &&
                        this.$container.find(t.currentSlide).focus();
                    }.bind(this)
                  );
            },
            createImageCarousels: function () {
              if (
                !this.$thumbSlider.length ||
                e(this.selectors.photoThumbs).length < 2
              ) {
                var s = e(this.selectors.productImageMain).find(t.productVideo);
                s.length && this.initVideo(s);
                return;
              }
              (this.settings.hasMultipleImages = !0),
                (this.settings.has3d = this.$container.find(
                  this.selectors.media
                ).length);
              var c = this.$mainSlider.find(".starting-slide"),
                r = this._slideIndex(c);
              this.$mainSlider.off("init"),
                this.$mainSlider.off("beforeChange"),
                this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                this.$mainSlider.on(
                  "beforeChange",
                  this.beforeSlideChange.bind(this)
                ),
                this.$thumbSlider.on("init", this.thumbSlideInit.bind(this)),
                (this.mainSliderArgs = {
                  infinite: !this.settings.has3d,
                  arrows: !1,
                  dots: !0,
                  adaptiveHeight: !0,
                  rtl: theme.config.rtl,
                  initialSlide: r,
                  appendDots: this.selectors.dotsContainer,
                }),
                (this.thumbSliderArgs = {
                  accessibility: !1,
                  rtl: theme.config.rtl,
                  initialSlide: r,
                });
              var v = this.setSliderArgs();
              this.initSliders(v),
                e("body").on(
                  "matchSmall matchLarge",
                  function () {
                    var p = this.setSliderArgs();
                    this.initSliders(p);
                  }.bind(this)
                ),
                AOS && AOS.refresh();
            },
            initSliders: function (s) {
              this.destroyImageCarousels(),
                this.$mainSlider.slick(s.main),
                theme.config.bpSmall || this.$thumbSlider.slick(s.thumbs),
                (this.settings.slickMainInitialized = !0);
            },
            setSliderArgs: function () {
              var s = {},
                c = (this.settings.thumbVertical =
                  this.$thumbSlider.data("position") === "beside"),
                r = (this.settings.thumbArrows =
                  this.$thumbSlider.data("arrows")),
                v = c && r ? 1 : c ? 3 : 5;
              return (
                theme.config.bpSmall
                  ? ((s.main = this.mainSliderArgs),
                    (s.thumbs = this.thumbSliderArgs))
                  : ((s.main = e.extend({}, this.mainSliderArgs, {
                      asNavFor: this.selectors.thumbSlider,
                      adaptiveHeight: !c,
                      dots: !1,
                      infinite: !1,
                      fade: !0,
                    })),
                    (s.thumbs = e.extend({}, this.thumbSliderArgs, {
                      asNavFor: this.selectors.mainSlider,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: r,
                      dots: !1,
                      vertical: c,
                      verticalSwiping: c,
                      focusOnSelect: !0,
                      infinite: !1,
                      customHeightMatching: r ? !1 : c,
                      customSlideAdvancement: !0,
                    }))),
                s
              );
            },
            destroyImageCarousels: function () {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("unslick"),
                (this.settings.slickMainInitialized = !1)),
                this.$thumbSlider &&
                  this.settings.slickThumbInitialized &&
                  (this.$thumbSlider.slick("unslick"),
                  (this.settings.slickThumbInitialized = !1)),
                (this.settings.slickMainInitialized = !1),
                (this.settings.slickThumbInitialized = !1);
            },
            mainSlideInit: function (s, c) {
              var r = c.$slider,
                v = r.find(t.currentSlide),
                p = v.find(t.productVideo);
              !p.length || this.initVideo(p);
            },
            thumbSlideInit: function (s, c) {
              (this.settings.slickThumbInitialized = !0),
                this.settings.thumbArrows &&
                  this.$thumbSlider.on(
                    "setPosition",
                    this.thumbSlideArrowVisibility.bind(this)
                  );
            },
            thumbSlideArrowVisibility: function (s, c) {
              var r = c.$slider,
                v = r.find(".slick-arrow"),
                p = !1;
              if (this.settings.thumbVertical) {
                var y = r.find(".slick-track").height();
                y >= r.height() && (p = !0);
              } else {
                var S = r.find(".slick-track").width();
                S >= r.width() && (p = !0);
              }
              p ? v.removeClass("hide") : v.addClass("hide");
            },
            beforeSlideChange: function (s, c, r, v) {
              var p = c.$slider,
                y = p.find(t.currentSlide),
                S = y.find(".product__video"),
                _ = p.find('.slick-slide[data-slick-index="' + v + '"]'),
                C = _.find(".product__video");
              if (r !== v && S.length) {
                var I = this.getVideoType(S),
                  D = this.getVideoId(S);
                D && this.stopVideo(D, I);
              }
              if (C.length) {
                var V = this.getVideoType(C),
                  T = this.getVideoId(C);
                T &&
                  V === "youtube" &&
                  (n
                    ? i[T] &&
                      i[T].style === "muted" &&
                      this.requestToPlayYoutubeVideo(T, !0)
                    : e("body").on(
                        "youTubeReady" + this.settings.namespace,
                        function () {
                          i[T] &&
                            i[T].style === "muted" &&
                            this.requestToPlayYoutubeVideo(T, !0);
                        }.bind(this)
                      )),
                  T &&
                    i[T] &&
                    i[T].style === "muted" &&
                    V === "mp4" &&
                    this.playMp4Video(T),
                  T && i[T] && i[T].style != "muted" && w(e("#" + T));
              }
              var F = y.find(this.selectors.media);
              F.length && F.trigger("mediaHidden");
              var A = _.find(this.selectors.media);
              A.length &&
                (A.trigger("mediaVisible"),
                _.find(".shopify-model-viewer-ui__button").attr("tabindex", 0),
                _.find(".product-single__close-media").attr("tabindex", 0));
            },
            resizeSlides: function () {
              !this.settings.hasMultipleImages ||
                (e(window).trigger("resize.slick"),
                setTimeout(
                  function () {
                    this.$mainSlider &&
                      this.settings.slickMainInitialized &&
                      this.$mainSlider.slick("setPosition"),
                      this.$thumbSlider &&
                        this.settings.slickThumbInitialized &&
                        this.$thumbSlider.slick("setPosition");
                  }.bind(this),
                  500
                ));
            },
            _slideIndex: function (s) {
              return s.data("index");
            },
            openModalProduct: function () {
              var s = !1;
              if (this.settings.modalInit) s = !0;
              else {
                var c = e(this.selectors.modalFormHolder),
                  r = c.data("url"),
                  v = c.data("template");
                v || (r = r + "?view=ajax"),
                  c.load(
                    r + " #AddToCartForm-" + this.sectionId,
                    function () {
                      c.addClass("is-active"),
                        this.formSetup(),
                        Shopify &&
                          Shopify.PaymentButton &&
                          Shopify.PaymentButton.init();
                    }.bind(this)
                  ),
                  this.productSetup(),
                  this.loadModalContent(),
                  this.createImageCarousels(),
                  this.customMediaListners(),
                  (this.settings.modalInit = !0),
                  document.dispatchEvent(
                    new CustomEvent("quickview:loaded", {
                      detail: { productId: this.sectionId },
                    })
                  );
              }
              this.resizeSlides(),
                document.dispatchEvent(
                  new CustomEvent("quickview:open", {
                    detail: { initialized: s, productId: this.sectionId },
                  })
                ),
                this.addIdToRecentlyViewed();
            },
            closeModalProduct: function () {
              this.stopVideo(),
                e("body").off(this.settings.namespace),
                e(window).off(this.settings.namespace);
            },
            loadModalContent: function () {
              var s = this.checkIfVideos();
              s &&
                s.indexOf("mp4") > -1 &&
                this.$modal
                  .find('.product__video[data-video-type="mp4"]')
                  .find(".product__video-src")
                  .each(
                    function (c, r) {
                      var v = e(r),
                        p = v.attr("src"),
                        y = v.attr("type"),
                        S = document.createElement("source");
                      (S.src = p), (S.type = y), v.after(S);
                    }.bind(this)
                  );
            },
            initModelViewerLibraries: function () {
              var s = e(this.selectors.media, this.$container);
              s.length < 1 || theme.ProductMedia.init(s, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              var s = this;
              e(document).on("shopify_xr_launch", function () {
                var c = e(
                  s.selectors.productMediaWrapper + ":not(." + a.hidden + ")",
                  s.$container
                );
                c.trigger("xrLaunch");
              });
            },
            customMediaListners: function () {
              e("body").on(
                "click",
                this.selectors.closeMedia,
                function () {
                  this.$mainSlider
                    .find(t.currentSlide)
                    .find(this.selectors.media)
                    .trigger("mediaHidden");
                }.bind(this)
              ),
                this.$container
                  .find("model-viewer")
                  .on(
                    "shopify_model_viewer_ui_toggle_play",
                    function (s) {
                      this.mediaLoaded(s);
                    }.bind(this)
                  )
                  .on(
                    "shopify_model_viewer_ui_toggle_pause",
                    function (s) {
                      this.mediaUnloaded(s);
                    }.bind(this)
                  );
            },
            mediaLoaded: function (s) {
              this.$container
                .find(this.selectors.closeMedia)
                .removeClass("hide"),
                this.toggleSliderSwiping(!1);
            },
            mediaUnloaded: function (s) {
              this.$container.find(this.selectors.closeMedia).addClass("hide"),
                this.toggleSliderSwiping(!0);
            },
            toggleSliderSwiping: function (s) {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("slickSetOption", "swipe", s),
                this.$mainSlider.slick("slickSetOption", "draggable", s),
                this.$mainSlider.slick("slickSetOption", "touchMove", s),
                this.$mainSlider.slick("slickSetOption", "accessibility", s));
            },
            onUnload: function () {
              this.$container.off(this.settings.namespace),
                e("body").off(this.settings.namespace),
                this.destroyImageCarousels(),
                theme.ProductMedia.removeSectionModels(this.sectionId);
            },
          })),
          x
        );
      })()),
      (theme.Recommendations = (function () {
        function a(t) {
          var n = (this.$container = e(t)),
            i = (this.sectionId = n.attr("data-section-id"));
          (this.url = n.data("url")),
            (this.selectors = {
              recommendations: "#Recommendations-" + i,
              placeholder: ".product-recommendations-placeholder",
              sectionClass: " .product-recommendations",
              productResults: ".grid-product",
            }),
            this.init();
        }
        return (
          (a.prototype = e.extend({}, a.prototype, {
            init: function () {
              var t = e(this.selectors.recommendations);
              if (!(!t.length || t.data("enable") === !1)) {
                var n = t.find(this.selectors.placeholder),
                  i = t.data("product-id"),
                  o = t.data("limit"),
                  l =
                    this.url +
                    "?section_id=product-recommendations&limit=" +
                    o +
                    "&product_id=" +
                    i;
                n.load(
                  l + this.selectors.sectionClass,
                  function (d) {
                    theme.reinitProductGridItem(t),
                      this.updateVariantInventory(t),
                      e(d)
                        .find(this.selectors.sectionClass)
                        .find(this.selectors.productResults).length === 0 &&
                        t.addClass("hide");
                  }.bind(this)
                );
              }
            },
            updateVariantInventory: function (t) {
              (window.inventories = window.inventories || {}),
                t.find(".js-product-inventory-data").each(function () {
                  var n = e(this),
                    i = n.data("section-id");
                  (window.inventories[i] = {}),
                    e(".js-variant-inventory-data", n).each(function () {
                      var o = e(this);
                      window.inventories[i][o.data("id")] = {
                        quantity: o.data("quantity"),
                        incoming: o.data("incoming"),
                        next_incoming_date: o.data("date"),
                      };
                    });
                });
            },
          })),
          a
        );
      })()),
      (theme.StoreAvailability = (function () {
        var a = {
          drawerOpenBtn: ".js-drawer-open-availability",
          productTitle: "[data-availability-product-title]",
        };
        function t(n) {
          (this.container = n),
            (this.baseUrl = n.dataset.baseUrl),
            (this.productTitle = n.dataset.productName);
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            updateContent: function (n) {
              var i =
                this.baseUrl +
                "/variants/" +
                n +
                "/?section_id=store-availability";
              this.container.innerHTML = "";
              var o = this;
              fetch(i)
                .then(function (l) {
                  return l.text();
                })
                .then(function (l) {
                  l.trim() !== "" &&
                    ((o.container.innerHTML = l),
                    (o.container.innerHTML =
                      o.container.firstElementChild.innerHTML),
                    !!o.container.querySelector(a.drawerOpenBtn) &&
                      ((o.drawer = new theme.Drawers(
                        "StoreAvailabilityDrawer",
                        "availability"
                      )),
                      (o.container.querySelector(a.productTitle).textContent =
                        o.productTitle)));
                });
            },
          })),
          t
        );
      })()),
      (theme.CollectionHeader = (function () {
        var a = {
          hero: ".collection-hero",
          parallaxContainer: ".parallax-container",
        };
        function t(n) {
          var i = e(n);
          this.namespace = ".collection-header";
          var o = (this.$heroContainer = i.find(a.hero));
          if (o.length) {
            if ((this.checkIfNeedReload(), i.data("parallax"))) {
              var l = i.find(a.parallaxContainer),
                d = { namespace: this.namespace };
              theme.parallaxSections[this.namespace] = new theme.Parallax(l, d);
            }
          } else theme.headerNav.disableOverlayHeader();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            checkIfNeedReload: function () {
              if (!!Shopify.designMode && !!theme.settings.overlayHeader) {
                var n = e(".header-wrapper");
                !n.hasClass("is-light") &&
                  !e(".header-wrapper").hasClass("header-wrapper--sticky") &&
                  location.reload();
              }
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] &&
                (theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]);
            },
          })),
          t
        );
      })()),
      (theme.CollectionSidebar = (function () {
        var a = !1;
        function t(n) {
          (this.$container = e(n)), this.init();
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              this.onUnload(),
                (a = this.$container.data("style") === "drawer"),
                (theme.FilterDrawer = new theme.Drawers(
                  "FilterDrawer",
                  "collection-filters",
                  !0
                ));
            },
            forceReload: function () {
              this.init();
            },
            onSelect: function () {
              if (theme.FilterDrawer) {
                if (!a) {
                  theme.FilterDrawer.close();
                  return;
                }
                (a || theme.config.bpSmall) && theme.FilterDrawer.open();
              }
            },
            onDeselect: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
            onUnload: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
          })),
          t
        );
      })()),
      (theme.Collection = (function () {
        var a = {
            colorSwatchImage: ".grid-product__color-image",
            colorSwatch: ".color-swatch--with-image",
            sortSelect: "#SortBy",
          },
          t = { sortBy: "data-default-sortby" };
        function n(i) {
          (this.container = i),
            (this.sectionId = e(i).attr("data-section-id")),
            (this.namespace = ".collection-" + this.sectionId),
            this.init();
        }
        return (
          (n.prototype = e.extend({}, n.prototype, {
            init: function () {
              this.$container = e(this.container);
              var i = (this.sectionId =
                this.$container.attr("data-section-id"));
              (this.namespace = ".collection-" + i),
                (this.$sortSelect = e(a.sortSelect)),
                this.$sortSelect.on("change", this.onSortChange.bind(this)),
                (this.defaultSort = this.getDefaultSortValue()),
                this.initParams(),
                this.colorSwatchHovering(),
                theme.reinitSection("collection-sidebar");
            },
            initParams: function () {
              if (((this.queryParams = {}), location.search.length))
                for (
                  var i, o = location.search.substr(1).split("&"), l = 0;
                  l < o.length;
                  l++
                )
                  (i = o[l].split("=")),
                    i.length > 1 &&
                      (this.queryParams[decodeURIComponent(i[0])] =
                        decodeURIComponent(i[1]));
            },
            getSortValue: function () {
              return this.$sortSelect.val() || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.$sortSelect.attr(t.sortBy);
            },
            onSortChange: function () {
              (this.queryParams.sort_by = this.getSortValue()),
                this.queryParams.page && delete this.queryParams.page,
                (window.location.search = e.param(this.queryParams));
            },
            colorSwatchHovering: function () {
              var i = e(a.colorSwatchImage);
              !i.length ||
                e(a.colorSwatch).on({
                  mouseenter: function (o) {
                    $el = e(o.currentTarget);
                    var l = $el.data("variant-id"),
                      d = $el.data("variant-image");
                    e(".grid-product__color-image--" + l)
                      .css("background-image", "url(" + d + ")")
                      .addClass("is-active");
                  },
                  mouseleave: function (o) {
                    $el = e(o.currentTarget);
                    var l = $el.data("variant-id");
                    e(".grid-product__color-image--" + l).removeClass(
                      "is-active"
                    );
                  },
                });
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              e(window).off(this.namespace),
                this.$container.off(this.namespace),
                e(a.colorSwatch).off(this.namespace);
            },
          })),
          n
        );
      })()),
      (theme.HeaderSection = (function () {
        var a = {
            drawer: "#NavDrawer",
            mobileSubNavToggle: ".mobile-nav__toggle-btn",
            hasSublist: ".mobile-nav__has-sublist",
            disclosureLocale: "[data-disclosure-locale]",
            disclosureCurrency: "[data-disclosure-currency]",
          },
          t = { navExpanded: "mobile-nav--expanded" };
        function n(i) {
          var o = (this.$container = e(i)),
            l = (this.sectionId = o.attr("data-section-id"));
          theme.reinitSection("slideshow-section"),
            this.initDrawers(),
            theme.headerNav.init(),
            theme.announcementBar.init(),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.$localeDisclosure.length &&
              (this.localeDisclosure = new theme.Disclosure(
                this.cache.$localeDisclosure
              )),
            this.cache.$currencyDisclosure.length &&
              (this.currencyDisclosure = new theme.Disclosure(
                this.cache.$currencyDisclosure
              )),
            Shopify.designMode &&
              setTimeout(function () {
                e("body").trigger("resize");
              }, 500);
        }
        return (
          (n.prototype = e.extend({}, n.prototype, {
            cacheSelectors: function () {
              this.cache = {
                $localeDisclosure: this.$container.find(a.disclosureLocale),
                $currencyDisclosure: this.$container.find(a.disclosureCurrency),
              };
            },
            initDrawers: function () {
              (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                theme.settings.cartType === "drawer" && new theme.CartDrawer(),
                this.drawerMenuButtons();
            },
            drawerMenuButtons: function () {
              e(a.drawer)
                .find(".js-drawer-close")
                .on("click", function (o) {
                  o.preventDefault(), theme.NavDrawer.close();
                });
              var i = e(a.mobileSubNavToggle);
              i.attr("aria-expanded", "false"),
                i.each(function (o, l) {
                  var d = e(l);
                  d.attr("aria-controls", d.attr("data-aria-controls"));
                }),
                i.on("click", function () {
                  var o = e(this),
                    l = o.attr("aria-expanded"),
                    d = !1;
                  l === "true"
                    ? o.attr("aria-expanded", "false")
                    : (o.attr("aria-expanded", "true"), (d = !0)),
                    o.closest(a.hasSublist).toggleClass(t.navExpanded, d);
                });
            },
            onBlockSelect: function (i) {
              theme.announcementBar.onBlockSelect(i.detail.blockId);
            },
            onDeselect: function () {
              theme.announcementBar.onBlockDeselect();
            },
            onUnload: function () {
              theme.NavDrawer.close(),
                theme.headerNav.unload(),
                theme.announcementBar.unload(),
                this.cache.$localeDisclosure.length &&
                  this.localeDisclosure.unload(),
                this.cache.$currencyDisclosure.length &&
                  this.currencyDisclosure.unload();
            },
          })),
          n
        );
      })()),
      (theme.FooterSection = (function () {
        var a = {
          disclosureLocale: "[data-disclosure-locale]",
          disclosureCurrency: "[data-disclosure-currency]",
        };
        function t(n) {
          var i = (this.$container = e(n));
          (this.cache = {}),
            this.cacheSelectors(),
            this.cache.$localeDisclosure.length &&
              (this.localeDisclosure = new theme.Disclosure(
                this.cache.$localeDisclosure
              )),
            this.cache.$currencyDisclosure.length &&
              (this.currencyDisclosure = new theme.Disclosure(
                this.cache.$currencyDisclosure
              ));
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            cacheSelectors: function () {
              this.cache = {
                $localeDisclosure: this.$container.find(a.disclosureLocale),
                $currencyDisclosure: this.$container.find(a.disclosureCurrency),
              };
            },
            onUnload: function () {
              this.cache.$localeDisclosure.length &&
                this.localeDisclosure.unload(),
                this.cache.$currencyDisclosure.length &&
                  this.currencyDisclosure.unload();
            },
          })),
          t
        );
      })()),
      (theme.FeaturedContentSection = (function () {
        function a() {
          e(".rte").find("a:not(:has(img))").addClass("text-link");
        }
        return a;
      })()),
      (theme.slideshows = {}),
      (theme.SlideshowSection = (function () {
        var a = { parallaxContainer: ".parallax-container" };
        function t(n) {
          var i = (this.$container = e(n)),
            o = i.parent(),
            l = i.attr("data-section-id"),
            d = (this.slideshow = "#Slideshow-" + l);
          this.namespace = "." + l;
          var m = e(n).find(".hero");
          if (
            (m.length && theme.loadImageSection(m),
            this.init(),
            i.data("parallax"))
          ) {
            var f = { namespace: this.namespace };
            theme.parallaxSections[this.namespace] = new theme.Parallax(
              i.find(a.parallaxContainer),
              f
            );
          }
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              this.onUnload();
              var n = e(this.slideshow),
                i = {
                  autoplay: n.data("autoplay"),
                  arrows: n.data("arrows"),
                  dots: n.data("dots"),
                  fade: !0,
                  speed: 500,
                };
              theme.slideshows[this.slideshow] = new theme.Slideshow(
                this.slideshow,
                i
              );
            },
            forceReload: function () {
              this.init();
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] &&
                (theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]),
                theme.slideshows[this.slideshow] &&
                  (theme.slideshows[this.slideshow].destroy(),
                  delete theme.slideshows[this.slideshow]);
            },
            onSelect: function () {
              e(this.slideshow).slick("slickPause");
            },
            onDeselect: function () {
              e(this.slideshow).slick("slickPlay");
            },
            onBlockSelect: function (n) {
              var i = e(this.slideshow),
                o = e(
                  ".slideshow__slide--" +
                    n.detail.blockId +
                    ":not(.slick-cloned)"
                ),
                l = o.data("slick-index");
              i.slick("slickGoTo", l).slick("slickPause");
            },
            onBlockDeselect: function () {
              e(this.slideshow).slick("slickPlay");
            },
          })),
          t
        );
      })()),
      (theme.VideoSection = (function () {
        var a,
          t = [],
          n = [],
          i = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              branding: 0,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
          },
          o = !1,
          l = { byline: !1, title: !1, portrait: !1, loop: !0 },
          d = {
            videoParent: ".video-parent-section",
            promoContainer: ".promo-grid__container",
          },
          m = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          };
        function f(r) {
          var v = (this.$container = e(r)),
            p = (this.sectionId = v.attr("data-section-id")),
            y = (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId);
          this.namespace = "." + y;
          var S = (this.vimeoPlayerId = "Vimeo-" + this.sectionId),
            _ = (this.$vimeoTrigger = e("#VimeoTrigger-" + this.sectionId)),
            C = "Mp4Video-" + this.sectionId,
            I = e("#" + y),
            D = e("#" + S),
            V = e("#" + C);
          (this.vimeoPlayer = []),
            I.length &&
              ((this.youtubeVideoId = I.data("video-id")),
              this.initYoutubeVideo()),
            D.length &&
              ((this.vimeoVideoId = D.data("video-id")), this.initVimeoVideo()),
            V.length &&
              (s(V),
              u(C)
                .then(function () {})
                .catch(function (T) {
                  V.attr("controls", ""), c(V);
                }));
        }
        function u(r) {
          return document.querySelector("#" + r).play();
        }
        function h(r, v) {
          var p = e("#" + v),
            y = p.attr("id");
          n[y] = r.target;
          var S = n[y];
          x(p),
            n[y].mute(),
            p.attr("tabindex", "-1"),
            g(y),
            e(window).on("scroll." + y, { id: y }, e.throttle(150, g));
        }
        function g(r) {
          var v;
          typeof r == "string" ? (v = r) : (v = r.data ? r.data.id : !1),
            v && (theme.isElementVisible(e("#" + v)) ? b(v) : w(v));
        }
        function b(r) {
          n[r] && typeof n[r].playVideo == "function" && n[r].playVideo();
        }
        function w(r) {
          n[r] && typeof n[r].pauseVideo == "function" && n[r].pauseVideo();
        }
        function k(r, v) {
          var p = e("#" + v),
            y = p.attr("id"),
            S = n[y];
          switch (r.data) {
            case -1:
              t[y].attemptedToPlay && (s(p), c(p));
              break;
            case 0:
              S.playVideo();
              break;
            case 1:
              s(p);
              break;
            case 3:
              t[y].attemptedToPlay = !0;
              break;
          }
        }
        function x(r) {
          r.closest(d.videoParent).addClass(m.loading);
        }
        function s(r) {
          r.closest(d.videoParent).removeClass(m.loading).addClass(m.loaded);
        }
        function c(r) {
          r.closest(d.videoParent).addClass(m.interactable),
            r.closest(d.promoContainer).addClass(m.interactable);
        }
        return (
          (f.prototype = e.extend({}, f.prototype, {
            initYoutubeVideo: function () {
              (t[this.youtubePlayerId] = {
                id: this.youtubePlayerId,
                videoId: this.youtubeVideoId,
                type: "youtube",
                attemptedToPlay: !1,
                events: {
                  onReady: function (r) {
                    h(r, this.youtubePlayerId);
                  }.bind(this),
                  onStateChange: function (r) {
                    k(r, this.youtubePlayerId);
                  }.bind(this),
                },
              }),
                a
                  ? this.loadYoutubeVideo()
                  : (theme.LibraryLoader.load("youtubeSdk"),
                    e("body").on(
                      "youTubeReady" + this.namespace,
                      this.loadYoutubeVideo.bind(this)
                    ));
            },
            loadYoutubeVideo: function () {
              var r = e.extend({}, i, t[this.youtubePlayerId]);
              (r.playerVars.controls = 0),
                (n[this.youtubePlayerId] = new YT.Player(
                  this.youtubePlayerId,
                  r
                )),
                (a = !0);
            },
            initVimeoVideo: function () {
              t[this.vimeoPlayerId] = {
                divId: this.vimeoPlayerId,
                id: this.vimeoVideoId,
                type: "vimeo",
              };
              var r = e("#" + this.vimeoPlayerId);
              x(r),
                this.$vimeoTrigger.on(
                  "click",
                  +this.namespace,
                  function (v) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                  }.bind(this)
                ),
                o
                  ? this.loadVimeoVideo()
                  : (window.loadVimeo(),
                    e("body").on(
                      "vimeoReady" + this.namespace,
                      this.loadVimeoVideo.bind(this)
                    ));
            },
            loadVimeoVideo: function () {
              var r = e.extend({}, l, t[this.vimeoPlayerId]);
              if (
                ((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(
                  t[this.vimeoPlayerId].divId,
                  r
                )),
                (o = !0),
                !theme.config.bpSmall)
              )
                this.requestToPlayVimeoVideo(this.vimeoPlayerId);
              else {
                var v = e("#" + this.vimeoPlayerId);
                s(v);
              }
            },
            requestToPlayVimeoVideo: function (r) {
              if (!o) {
                e("body").on(
                  "vimeoReady" + this.namespace,
                  function () {
                    this.playVimeoVideo(r);
                  }.bind(this)
                );
                return;
              }
              this.playVimeoVideo(r);
            },
            playVimeoVideo: function (r) {
              this.vimeoPlayer[r].play(), this.vimeoPlayer[r].setVolume(0);
              var v = e("#" + r);
              s(v);
            },
            onUnload: function (r) {
              var v = r.target.id.replace("shopify-section-", ""),
                p = "YouTubeVideo-" + v;
              n[p].destroy(),
                e(window).off("scroll" + this.namespace),
                e("body").off("vimeoReady" + this.namespace);
            },
          })),
          f
        );
      })()),
      (theme.BackgroundImage = (function () {
        var a = { parallaxContainer: ".parallax-container" };
        function t(n) {
          var i = e(n),
            o = i.attr("data-section-id");
          if (((this.namespace = "." + o), !!i.length && i.data("parallax"))) {
            var l = i.find(a.parallaxContainer),
              d = { namespace: this.namespace, desktopOnly: !0 };
            theme.parallaxSections[this.namespace] = new theme.Parallax(l, d);
          }
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            onUnload: function (n) {
              theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace];
            },
          })),
          t
        );
      })()),
      (theme.Testimonials = (function () {
        var a = 0,
          t = {
            accessibility: !0,
            arrows: !1,
            dots: !0,
            autoplay: !1,
            touchThreshold: 20,
            rtl: theme.config.rtl,
            slidesToShow: 3,
            slidesToScroll: 3,
          };
        function n(i) {
          var o = (this.$container = e(i)),
            l = o.attr("data-section-id"),
            d = (this.wrapper = ".testimonials-wrapper"),
            m = (this.slider = "#Testimonials-" + l),
            f = e(m);
          this.sliderActive = !1;
          var u = e.extend({}, t, {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: !0,
          });
          (a = f.data("count")),
            a < t.slidesToShow &&
              ((t.slidesToShow = a), (t.slidesToScroll = a)),
            f.on("init", this.a11y.bind(this)),
            theme.config.bpSmall ? this.init(f, u) : this.init(f, t),
            e("body").on(
              "matchSmall",
              function () {
                this.init(f, u);
              }.bind(this)
            ),
            e("body").on(
              "matchLarge",
              function () {
                this.init(f, t);
              }.bind(this)
            );
        }
        return (
          (n.prototype = e.extend({}, n.prototype, {
            onUnload: function () {
              e(this.slider, this.wrapper).slick("unslick");
            },
            onBlockSelect: function (i) {
              var o = e(
                  ".testimonials-slide--" +
                    i.detail.blockId +
                    ":not(.slick-cloned)"
                ),
                l = o.data("slick-index");
              e(this.slider, this.wrapper).slick("slickGoTo", l);
            },
            init: function (i, o) {
              this.sliderActive &&
                (i.slick("unslick"), (this.sliderActive = !1)),
                i.slick(o),
                (this.sliderActive = !0),
                AOS && AOS.refresh();
            },
            a11y: function (i, o) {
              var l = o.$list,
                d = e(this.wrapper, this.$container);
              l.removeAttr("aria-live"),
                d.on("focusin", function (m) {
                  d.has(m.target).length && l.attr("aria-live", "polite");
                }),
                d.on("focusout", function (m) {
                  d.has(m.target).length && l.removeAttr("aria-live");
                });
            },
          })),
          n
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function a(t) {
          var n = (this.$container = e(t)),
            i = n.attr("data-section-id");
          if (
            ((this.cookieName = "newsletter-" + i),
            !!n.length && window.location.pathname !== "/challenge")
          ) {
            if (
              ((this.data = {
                secondsBeforeShow: n.data("delay-seconds"),
                daysBeforeReappear: n.data("delay-days"),
                cookie: Cookies.get(this.cookieName),
                testMode: n.data("test-mode"),
              }),
              (this.modal = new theme.Modals(
                "NewsletterPopup-" + i,
                "newsletter-popup-modal"
              )),
              (n.find(".errors").length || n.find(".note--success").length) &&
                this.modal.open(),
              n.find(".note--success").length)
            ) {
              this.closePopup(!0);
              return;
            }
            e("body").on(
              "modalClose." + n.attr("id"),
              this.closePopup.bind(this)
            ),
              (!this.data.cookie || this.data.testMode) &&
                this.initPopupDelay();
          }
        }
        return (
          (a.prototype = e.extend({}, a.prototype, {
            initPopupDelay: function () {
              setTimeout(
                function () {
                  this.modal.open();
                }.bind(this),
                this.data.secondsBeforeShow * 1e3
              );
            },
            closePopup: function (t) {
              if (this.data.testMode) {
                Cookies.remove(this.cookieName, { path: "/" });
                return;
              }
              var n = t ? 200 : this.data.daysBeforeReappear;
              Cookies.set(this.cookieName, "opened", { path: "/", expires: n });
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
            onUnload: function () {},
          })),
          a
        );
      })()),
      (theme.Maps = (function () {
        var a = { zoom: 14 },
          t = null,
          n = [],
          i = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError,
          },
          o = {
            section: '[data-section-type="map"]',
            map: "[data-map]",
            mapOverlay: "[data-map-overlay]",
          },
          l = {
            mapError: "map-section--load-error",
            errorMsg: "map-section__error errors text-center",
          };
        window.gm_authFailure = function () {
          !Shopify.designMode ||
            (e(o.section).addClass(l.mapError),
            e(o.map).remove(),
            e(o.mapOverlay).after(
              '<div class="' +
                l.errorMsg +
                '">' +
                theme.strings.authError +
                "</div>"
            ));
        };
        function d(u) {
          (this.$container = e(u)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.namespace = ".map-" + this.sectionId),
            (this.$map = this.$container.find(o.map)),
            (this.key = this.$map.data("api-key")),
            !!this.key &&
              (this.checkVisibility(),
              e(window).on(
                "scroll" + this.namespace,
                e.throttle(50, this.checkVisibility.bind(this))
              ));
        }
        function m() {
          e.each(n, function (u, h) {
            h.createMap();
          });
        }
        function f(u) {
          var h = e.Deferred(),
            g = new google.maps.Geocoder(),
            b = u.data("address-setting");
          return (
            g.geocode({ address: b }, function (w, k) {
              k !== google.maps.GeocoderStatus.OK && h.reject(k), h.resolve(w);
            }),
            h
          );
        }
        return (
          (d.prototype = e.extend({}, d.prototype, {
            prepMapApi: function () {
              t === "loaded"
                ? this.createMap()
                : (n.push(this),
                  t !== "loading" &&
                    ((t = "loading"),
                    (typeof window.google == "undefined" ||
                      typeof window.google.maps == "undefined") &&
                      e
                        .getScript(
                          "https://maps.googleapis.com/maps/api/js?key=" +
                            this.key
                        )
                        .then(function () {
                          (t = "loaded"), m();
                        })));
            },
            createMap: function () {
              var u = this.$map;
              return f(u)
                .then(
                  function (h) {
                    var g = {
                        zoom: a.zoom,
                        backgroundColor: "none",
                        center: h[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0,
                      },
                      b = (this.map = new google.maps.Map(u[0], g)),
                      w = (this.center = b.getCenter()),
                      k = new google.maps.Marker({
                        map: b,
                        position: b.getCenter(),
                      });
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      e.debounce(250, function () {
                        google.maps.event.trigger(b, "resize"),
                          b.setCenter(w),
                          u.removeAttr("style");
                      })
                    );
                  }.bind(this)
                )
                .fail(function () {
                  var h;
                  switch (status) {
                    case "ZERO_RESULTS":
                      h = i.addressNoResults;
                      break;
                    case "OVER_QUERY_LIMIT":
                      h = i.addressQueryLimit;
                      break;
                    case "REQUEST_DENIED":
                      h = i.authError;
                      break;
                    default:
                      h = i.addressError;
                      break;
                  }
                  Shopify.designMode &&
                    u
                      .parent()
                      .addClass(l.mapError)
                      .html('<div class="' + l.errorMsg + '">' + h + "</div>");
                });
            },
            checkVisibility: function () {
              theme.isElementVisible(this.$container, 600) &&
                (this.prepMapApi(), e(window).off(this.namespace));
            },
            onUnload: function () {
              this.$map.length !== 0 &&
                google.maps.event.clearListeners(this.map, "resize");
            },
          })),
          d
        );
      })()),
      (theme.Blog = (function () {
        function a(t) {
          this.tagFilters();
        }
        return (
          (a.prototype = e.extend({}, a.prototype, {
            tagFilters: function () {
              var t = e("#BlogTagFilter");
              !t.length ||
                t.on("change", function () {
                  location.href = e(this).val();
                });
            },
            onUnload: function () {},
          })),
          a
        );
      })()),
      (theme.Photoswipe = (function () {
        var a = {
          trigger: ".js-photoswipe__zoom",
          images: ".photoswipe__image",
          activeImage: ".slick-active .photoswipe__image",
        };
        function t(n, i) {
          (this.$container = e(n)),
            (this.sectionId = i),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.$images,
            (this.inSlideshow = !1),
            this.$container.attr("data-zoom") !== "false" &&
              (this.$container.attr("data-has-slideshow") === "true" &&
                (this.inSlideshow = !0),
              this.init());
        }
        return (
          (t.prototype = e.extend({}, t.prototype, {
            init: function () {
              var n = this.$container.find(a.trigger);
              this.$images = this.$container.find(a.images);
              var i = [];
              n.on(
                "click" + this.namespace,
                function (o) {
                  if (((i = this.getImageData()), this.inSlideshow))
                    var l = this.$container.find(a.activeImage).data("index");
                  else var l = e(o.currentTarget).data("index");
                  this.initGallery(i, l);
                }.bind(this)
              );
            },
            getImageData: function () {
              var n = !1,
                i = [],
                o = {};
              return (
                this.$images.each(function () {
                  var l = !0,
                    d = e(this).prop("currentSrc") || e(this).prop("src"),
                    m = {
                      msrc: d,
                      src: e(this).data("photoswipe-src"),
                      w: e(this).data("photoswipe-width"),
                      h: e(this).data("photoswipe-height"),
                      el: e(this)[0],
                      initialZoomLevel: 0.5,
                    };
                  i.push(m);
                }),
                i
              );
            },
            initGallery: function (n, i) {
              var o = document.querySelectorAll(".pswp")[0],
                l = {
                  allowPanToNext: !1,
                  captionEl: !1,
                  closeOnScroll: !1,
                  counterEl: !1,
                  history: !1,
                  index: i - 1,
                  pinchToClose: !1,
                  preloaderEl: !1,
                  scaleMode: "zoom",
                  shareEl: !1,
                  tapToToggleControls: !1,
                  getThumbBoundsFn: function (d) {
                    var m =
                        window.pageYOffset ||
                        document.documentElement.scrollTop,
                      f = n[d].el,
                      u = f.getBoundingClientRect();
                    return { x: u.left, y: u.top + m, w: u.width };
                  },
                };
              (this.gallery = new PhotoSwipe(o, PhotoSwipeUI_Default, n, l)),
                this.gallery.init(),
                this.gallery.listen("afterChange", this.afterChange.bind(this));
            },
            afterChange: function () {
              if (this.inSlideshow) {
                var n = e("#ProductPhotos-" + this.sectionId);
                if (n.hasClass("slick-initialized")) {
                  var i = this.gallery.getCurrentIndex();
                  n.slick("slickGoTo", i), console.log(i);
                }
              }
            },
          })),
          t
        );
      })()),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0), e("body").trigger("youTubeReady");
      }),
      (window.loadVimeo = function () {
        if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
          theme.config.vimeoLoading = !0;
          var a = document.createElement("script");
          a.src = "https://player.vimeo.com/api/player.js";
          var t = document.getElementsByTagName("script")[0];
          t.parentNode.insertBefore(a, t),
            O()
              .then(function () {
                (theme.config.vimeoReady = !0),
                  (theme.config.vimeoLoading = !1),
                  e("body").trigger("vimeoReady");
              })
              .fail(function () {});
        }
      });
    function O() {
      var a = e.Deferred(),
        t,
        n;
      return (
        (t = setInterval(function () {
          !Vimeo || (clearInterval(t), clearTimeout(n), a.resolve());
        }, 500)),
        (n = setTimeout(function () {
          clearInterval(t), a.reject();
        }, 4e3)),
        a
      );
    }
    (theme.init = function () {
      theme.setGlobals(),
        theme.collapsibles.init(),
        theme.rte.init(),
        AOS.init({
          easing: "ease-out-quad",
          once: !0,
          offset: 60,
          disableMutationObserver: !0,
        }),
        e(document.documentElement).on("keyup.tab", function (a) {
          a.keyCode === 9 &&
            (e(document.documentElement).addClass("tab-outline"),
            e(document.documentElement).off("keyup.tab"));
        }),
        e(".footer__newsletter-input").on("keyup", function () {
          e(this).addClass("footer__newsletter-input--active");
        });
    }),
      (theme.initSecondary = function () {
        theme.initQuickShop(),
          theme.settings.predictiveSearch && theme.predictiveSearch.init(),
          theme.collectionTemplate.init(),
          theme.customerTemplates.init(),
          theme.videoModal(),
          document.dispatchEvent(new CustomEvent("page:loaded"));
      }),
      (theme.setGlobals = function () {
        (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
          (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
          theme.config.hasLocalStorage &&
            ((theme.recentlyViewed.localStorage =
              window.localStorage.getItem("theme-recent")),
            theme.recentlyViewed.localStorage &&
              (theme.recentlyViewed.recent = JSON.parse(
                theme.recentlyViewed.localStorage
              ))),
          (theme.recentlyViewed.productInfo =
            theme.config.hasSessionStorage && sessionStorage["recent-products"]
              ? JSON.parse(sessionStorage["recent-products"])
              : {}),
          theme.config.isTouch && e("body").addClass("supports-touch"),
          enquire.register(theme.config.mediaQuerySmall, {
            match: function () {
              (theme.config.bpSmall = !0), e("body").trigger("matchSmall");
            },
            unmatch: function () {
              (theme.config.bpSmall = !1), e("body").trigger("unmatchSmall");
            },
          }),
          enquire.register(theme.config.mediaQuerySmallUp, {
            match: function () {
              e("body").trigger("matchLarge");
            },
            unmatch: function () {
              e("body").trigger("unmatchLarge");
            },
          });
      }),
      (theme.loadImageSection = function (a) {
        function t() {
          a.removeClass("loading loading--delayed").addClass("loaded");
        }
        function n() {
          return a.find(".lazyloaded").length;
        }
        if (a.find("svg").length) {
          t();
          return;
        }
        if (n() > 0) {
          t();
          return;
        }
        var i = setInterval(function () {
          n() > 0 && (clearInterval(i), t());
        }, 80);
      }),
      (theme.isStorageSupported = function (a) {
        if (window.self !== window.top) return !1;
        var t = "test",
          n;
        a === "session" && (n = window.sessionStorage),
          a === "local" && (n = window.localStorage);
        try {
          return n.setItem(t, "1"), n.removeItem(t), !0;
        } catch (i) {
          return !1;
        }
      }),
      (theme.isElementVisible = function (a, t) {
        var n = a[0].getBoundingClientRect(),
          i = window.innerHeight || document.documentElement.clientHeight;
        return (
          (t = t || 0),
          n.bottom >= 0 &&
            n.right >= 0 &&
            n.top <= i + t &&
            n.left <=
              (window.innerWidth || document.documentElement.clientWidth)
        );
      }),
      (theme.reinitSection = function (a) {
        for (var t = 0; t < sections.instances.length; t++) {
          var n = sections.instances[t];
          n.type === a && typeof n.forceReload == "function" && n.forceReload();
        }
      }),
      (theme.reinitProductGridItem = function (a) {
        AOS && AOS.refreshHard(),
          theme.initQuickShop(),
          window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
          sections.register("product-template", theme.Product, a),
          theme.collapsibles.init();
      }),
      (window.onpageshow = function (a) {
        a.persisted && e("body").removeClass("unloading");
      }),
      e(document).ready(function () {
        theme.init(),
          (window.sections = new theme.Sections()),
          sections.register("header-section", theme.HeaderSection),
          sections.register("slideshow-section", theme.SlideshowSection),
          sections.register("video-section", theme.VideoSection),
          sections.register("background-image", theme.BackgroundImage),
          sections.register("recently-viewed", theme.RecentlyViewed),
          sections.register("product", theme.Product),
          sections.register("product-recommendations", theme.Recommendations),
          sections.register("store-availability", theme.StoreAvailability),
          sections.register("product-template", theme.Product),
          sections.register("collection-header", theme.CollectionHeader),
          sections.register("collection-sidebar", theme.CollectionSidebar),
          sections.register("collection-template", theme.Collection),
          sections.register(
            "featured-content-section",
            theme.FeaturedContentSection
          ),
          sections.register("testimonials", theme.Testimonials),
          sections.register("newsletter-popup", theme.NewsletterPopup),
          sections.register("map", theme.Maps),
          sections.register("blog", theme.Blog),
          sections.register("photoswipe", theme.Photoswipe),
          sections.register("footer-section", theme.FooterSection),
          theme.initSecondary();
      });
  })(theme.jQuery),
  $(document).on(
    "change",
    ".main_product_bundle-data .product_option .form_with_button-wrapp form .product-swatch .swatch .swatch-element input.main-swacth-color",
    function (P) {
      var e = $(this).attr("data-url");
      var data_image = $(this).attr("data-image");
      console.log(data_image);
      jQuery.ajax({
        type: "GET",
        url: e,
        dataType: "html",
        success: function (O) {
          $(".product-single__sticky").html(
            $(O).find(".product-single__sticky").html()
          ),
            $(".product_image_popup").html(
              $(O).find(".product_image_popup").html()
            ),
            $(".products-main-slider").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1,
              fade: !1,
              asNavFor: ".product-thumbnail-silder",
            }),
            $(".product-thumbnail-silder").slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              asNavFor: ".products-main-slider",
              dots: !1,
              vertical: !0,
              centerMode: !1,
              verticalSwiping: !0,
              focusOnSelect: !0,
            }),
            $(".product-slider-image").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !0,
              prevArrow: $(".prev"),
              nextArrow: $(".next"),
              responsive: [{ breakpoint: 769, settings: { swipe: !1 } }],
            });
          var data_index = $(
            ".updated_hugger.product-thumbnail-silder .product__thumb-item .image-wrap img[src='" +
              data_image +
              "']"
          )
            .parents(".product__thumb-item")
            .trigger("click");
        },
      });
    }
  ),
  $(".product-slider-image").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !0,
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    responsive: [{ breakpoint: 769, settings: { swipe: !1 } }],
  }),
  $(document).on(
    "click",
    ".product__main-photos .products-main-slider .main_product_images img",
    function (P) {
      P.preventDefault();
      var e = $(this)
        .parents(".products-main-slider .main_product_images")
        .data("slick-index");
      console.log(e), $(".product-slider-image").slick("slickGoTo", e);
    }
  ),
  $(document).on(
    "click",
    ".product__main-photos .products-main-slider button",
    function (P) {
      P.preventDefault();
      var e = $(this)
        .parents(".products-main-slider .main_product_images")
        .data("slick-index");
      console.log(e), $(".product-slider-image").slick("slickGoTo", e);
    }
  ),
  $(document).on(
    "click",
    ".product__main-photos .main_product-media-data .main_product_images img",
    function (P) {
      P.preventDefault();
      var e = $(this)
        .parents(".main_product-media-data .main_product_images")
        .data("slick-index");
      console.log(e), $(".product-slider-image").slick("slickGoTo", e);
    }
  ),
  $(document).on(
    "click",
    ".product__main-photos .main_product-media-data button",
    function (P) {
      P.preventDefault();
      var e = $(this)
        .parents(".main_product-media-data .main_product_images")
        .data("slick-index");
      console.log(e), $(".product-slider-image").slick("slickGoTo", e);
    }
  ),
  $(document).on("click", "button.popup_cross_btn", function () {
    $(".product_image_popup").hide();
  }),
  $(window).width() > 767 &&
    ($(document).on(
      "click",
      ".product__main-photos .products-main-slider .main_product_images img",
      function () {
        $(".product_image_popup").show();
      }
    ),
    $(document).on(
      "click",
      ".product__main-photos .main_product-media-data .main_product_images img",
      function () {
        $(".product_image_popup").show();
      }
    )),
  $(document).on(
    "click",
    ".product__main-photos .products-main-slider button",
    function () {
      $(".product_image_popup").show();
    }
  ),
  $(document).on(
    "click",
    ".product__main-photos .main_product-media-data button",
    function () {
      $(".product_image_popup").show();
    }
  ),
  $(document).on(
    "click",
    ".product_image_popup .popup_data .main_product_images .product-image-main img",
    function () {
      $(this)
        .parents(
          ".product_image_popup .popup_data .main_product_images .product-image-main"
        )
        .toggleClass("zoom-in-popup");
    }
  ),
  $(".product-slider-image").on("afterChange", function (P, e, O, a) {
    $(
      ".product_image_popup .popup_data .main_product_images .product-image-main"
    ).removeClass("zoom-in-popup");
  }),
  $(document).ready(function () {
    if (window.location.href.indexOf("?variant") > -1) {
      var P = $(".new_variant_input")
          .children("input[name=Color]:checked")
          .val(),
        e = P.toLowerCase().replace(/ /g, "-");
      $(".cstm_imgs").hasClass("a_" + e) && $(".a_" + e).trigger("click");
    }
    $(".collection_under_description span.readmore-btn").click(function () {
      $(this).hide();
      $(".collection_under_description span.read_more-content").show();
      $(".collection_under_description span.readless-btn").show();
    });
    $(".collection_under_description span.readless-btn").click(function () {
      $(this).hide();
      $(".collection_under_description span.read_more-content").hide();
      $(".collection_under_description span.readmore-btn").show();
    });
  });
//# sourceMappingURL=/s/files/1/0508/9155/5015/t/35/assets/theme.js.map?v=1638855833

/*
Impulse by Archetype Themes (https://archetypethemes.co)

Plugins:
jQuery                  3.5.1
Enqurie                 2.1.2
Slick Slider            1.6.0 with customizations by Archetype
Handlebars JS           4.7.2
Prepare Transition      1.0.0
JavaScript Cookie       2.2.0
AOS                     2.3.4
Photoswipe              4.1.3
Photoswipe UI           4.1.2 with customizations by Archetype

Lazysizes for image loading:
core                    4.0.2
respimg                 4.0.1
rias                    4.0.1
bgset                   4.0.1
object-fit              4.1.2
parent-fit              4.1.2
*/
/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */ !(function (
  e,
  t
) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
  "use strict";
  function n(e, t, n) {
    var i,
      o,
      r = (n = n || pe).createElement("script");
    if (((r.text = e), t))
      for (i in de)
        (o = t[i] || (t.getAttribute && t.getAttribute(i))) &&
          r.setAttribute(i, o);
    n.head.appendChild(r).parentNode.removeChild(r);
  }
  function i(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? ie[oe.call(e)] || "object"
      : typeof e;
  }
  function o(e) {
    var t = !!e && "length" in e && e.length,
      n = i(e);
    return (
      !ce(e) &&
      !ue(e) &&
      ("array" === n ||
        0 === t ||
        ("number" == typeof t && 0 < t && t - 1 in e))
    );
  }
  function r(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  function s(e, t, n) {
    return ce(t)
      ? he.grep(e, function (e, i) {
          return !!t.call(e, i, e) !== n;
        })
      : t.nodeType
      ? he.grep(e, function (e) {
          return (e === t) !== n;
        })
      : "string" != typeof t
      ? he.grep(e, function (e) {
          return -1 < ne.call(t, e) !== n;
        })
      : he.filter(t, e, n);
  }
  function a(e, t) {
    for (; (e = e[t]) && 1 !== e.nodeType; );
    return e;
  }
  function l(e) {
    return e;
  }
  function c(e) {
    throw e;
  }
  function u(e, t, n, i) {
    var o;
    try {
      e && ce((o = e.promise))
        ? o.call(e).done(t).fail(n)
        : e && ce((o = e.then))
        ? o.call(e, t, n)
        : t.apply(void 0, [e].slice(i));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  function p() {
    pe.removeEventListener("DOMContentLoaded", p),
      e.removeEventListener("load", p),
      he.ready();
  }
  function d(e, t) {
    return t.toUpperCase();
  }
  function f(e) {
    return e.replace(Pe, "ms-").replace(_e, d);
  }
  function h() {
    this.expando = he.expando + h.uid++;
  }
  function m(e, t, n) {
    var i, o;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((i = "data-" + t.replace(Ne, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(i)))
      ) {
        try {
          n =
            "true" === (o = n) ||
            ("false" !== o &&
              ("null" === o
                ? null
                : o === +o + ""
                ? +o
                : Le.test(o)
                ? JSON.parse(o)
                : o));
        } catch (e) {}
        Ie.set(e, t, n);
      } else n = void 0;
    return n;
  }
  function v(e, t, n, i) {
    var o,
      r,
      s = 20,
      a = i
        ? function () {
            return i.cur();
          }
        : function () {
            return he.css(e, t, "");
          },
      l = a(),
      c = (n && n[3]) || (he.cssNumber[t] ? "" : "px"),
      u =
        e.nodeType &&
        (he.cssNumber[t] || ("px" !== c && +l)) &&
        Me.exec(he.css(e, t));
    if (u && u[3] !== c) {
      for (l /= 2, c = c || u[3], u = +l || 1; s--; )
        he.style(e, t, u + c),
          (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0),
          (u /= r);
      (u *= 2), he.style(e, t, u + c), (n = n || []);
    }
    return (
      n &&
        ((u = +u || +l || 0),
        (o = n[1] ? u + (n[1] + 1) * n[2] : +n[2]),
        i && ((i.unit = c), (i.start = u), (i.end = o))),
      o
    );
  }
  function g(e, t) {
    for (var n, i, o, r, s, a, l, c = [], u = 0, p = e.length; u < p; u++)
      (i = e[u]).style &&
        ((n = i.style.display),
        t
          ? ("none" === n &&
              ((c[u] = $e.get(i, "display") || null),
              c[u] || (i.style.display = "")),
            "" === i.style.display &&
              Fe(i) &&
              (c[u] =
                ((l = s = r = void 0),
                (s = (o = i).ownerDocument),
                (a = o.nodeName),
                (l = qe[a]) ||
                  ((r = s.body.appendChild(s.createElement(a))),
                  (l = he.css(r, "display")),
                  r.parentNode.removeChild(r),
                  "none" === l && (l = "block"),
                  (qe[a] = l)))))
          : "none" !== n && ((c[u] = "none"), $e.set(i, "display", n)));
    for (u = 0; u < p; u++) null != c[u] && (e[u].style.display = c[u]);
    return e;
  }
  function y(e, t) {
    var n;
    return (
      (n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && r(e, t)) ? he.merge([e], n) : n
    );
  }
  function b(e, t) {
    for (var n = 0, i = e.length; n < i; n++)
      $e.set(e[n], "globalEval", !t || $e.get(t[n], "globalEval"));
  }
  function w(e, t, n, o, r) {
    for (
      var s,
        a,
        l,
        c,
        u,
        p,
        d = t.createDocumentFragment(),
        f = [],
        h = 0,
        m = e.length;
      h < m;
      h++
    )
      if ((s = e[h]) || 0 === s)
        if ("object" === i(s)) he.merge(f, s.nodeType ? [s] : s);
        else if (Xe.test(s)) {
          for (
            a = a || d.appendChild(t.createElement("div")),
              l = (Ve.exec(s) || ["", ""])[1].toLowerCase(),
              c = Ke[l] || Ke._default,
              a.innerHTML = c[1] + he.htmlPrefilter(s) + c[2],
              p = c[0];
            p--;

          )
            a = a.lastChild;
          he.merge(f, a.childNodes), ((a = d.firstChild).textContent = "");
        } else f.push(t.createTextNode(s));
    for (d.textContent = "", h = 0; (s = f[h++]); )
      if (o && -1 < he.inArray(s, o)) r && r.push(s);
      else if (((u = He(s)), (a = y(d.appendChild(s), "script")), u && b(a), n))
        for (p = 0; (s = a[p++]); ) Ze.test(s.type || "") && n.push(s);
    return d;
  }
  function x() {
    return !0;
  }
  function k() {
    return !1;
  }
  function S(e, t) {
    return (
      (e ===
        (function () {
          try {
            return pe.activeElement;
          } catch (e) {}
        })()) ==
      ("focus" === t)
    );
  }
  function C(e, t, n, i, o, r) {
    var s, a;
    if ("object" == typeof t) {
      for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), t))
        C(e, a, n, i, t[a], r);
      return e;
    }
    if (
      (null == i && null == o
        ? ((o = n), (i = n = void 0))
        : null == o &&
          ("string" == typeof n
            ? ((o = i), (i = void 0))
            : ((o = i), (i = n), (n = void 0))),
      !1 === o)
    )
      o = k;
    else if (!o) return e;
    return (
      1 === r &&
        ((s = o),
        ((o = function (e) {
          return he().off(e), s.apply(this, arguments);
        }).guid = s.guid || (s.guid = he.guid++))),
      e.each(function () {
        he.event.add(this, t, o, i, n);
      })
    );
  }
  function T(e, t, n) {
    n
      ? ($e.set(e, t, !1),
        he.event.add(e, t, {
          namespace: !1,
          handler: function (e) {
            var i,
              o,
              r = $e.get(this, t);
            if (1 & e.isTrigger && this[t]) {
              if (r.length)
                (he.event.special[t] || {}).delegateType && e.stopPropagation();
              else if (
                ((r = Q.call(arguments)),
                $e.set(this, t, r),
                (i = n(this, t)),
                this[t](),
                r !== (o = $e.get(this, t)) || i
                  ? $e.set(this, t, !1)
                  : (o = {}),
                r !== o)
              )
                return (
                  e.stopImmediatePropagation(), e.preventDefault(), o.value
                );
            } else
              r.length &&
                ($e.set(this, t, {
                  value: he.event.trigger(
                    he.extend(r[0], he.Event.prototype),
                    r.slice(1),
                    this
                  ),
                }),
                e.stopImmediatePropagation());
          },
        }))
      : void 0 === $e.get(e, t) && he.event.add(e, t, x);
  }
  function E(e, t) {
    return (
      (r(e, "table") &&
        r(11 !== t.nodeType ? t : t.firstChild, "tr") &&
        he(e).children("tbody")[0]) ||
      e
    );
  }
  function A(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function P(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function _(e, t) {
    var n, i, o, r, s, a;
    if (1 === t.nodeType) {
      if ($e.hasData(e) && (a = $e.get(e).events))
        for (o in ($e.remove(t, "handle events"), a))
          for (n = 0, i = a[o].length; n < i; n++) he.event.add(t, o, a[o][n]);
      Ie.hasData(e) &&
        ((r = Ie.access(e)), (s = he.extend({}, r)), Ie.set(t, s));
    }
  }
  function O(e, t, i, o) {
    t = ee(t);
    var r,
      s,
      a,
      l,
      c,
      u,
      p = 0,
      d = e.length,
      f = d - 1,
      h = t[0],
      m = ce(h);
    if (m || (1 < d && "string" == typeof h && !le.checkClone && et.test(h)))
      return e.each(function (n) {
        var r = e.eq(n);
        m && (t[0] = h.call(this, n, r.html())), O(r, t, i, o);
      });
    if (
      d &&
      ((s = (r = w(t, e[0].ownerDocument, !1, e, o)).firstChild),
      1 === r.childNodes.length && (r = s),
      s || o)
    ) {
      for (l = (a = he.map(y(r, "script"), A)).length; p < d; p++)
        (c = r),
          p !== f &&
            ((c = he.clone(c, !0, !0)), l && he.merge(a, y(c, "script"))),
          i.call(e[p], c, p);
      if (l)
        for (u = a[a.length - 1].ownerDocument, he.map(a, P), p = 0; p < l; p++)
          (c = a[p]),
            Ze.test(c.type || "") &&
              !$e.access(c, "globalEval") &&
              he.contains(u, c) &&
              (c.src && "module" !== (c.type || "").toLowerCase()
                ? he._evalUrl &&
                  !c.noModule &&
                  he._evalUrl(
                    c.src,
                    { nonce: c.nonce || c.getAttribute("nonce") },
                    u
                  )
                : n(c.textContent.replace(tt, ""), c, u));
    }
    return e;
  }
  function $(e, t, n) {
    for (var i, o = t ? he.filter(t, e) : e, r = 0; null != (i = o[r]); r++)
      n || 1 !== i.nodeType || he.cleanData(y(i)),
        i.parentNode &&
          (n && He(i) && b(y(i, "script")), i.parentNode.removeChild(i));
    return e;
  }
  function I(e, t, n) {
    var i,
      o,
      r,
      s,
      a = e.style;
    return (
      (n = n || it(e)) &&
        ("" !== (s = n.getPropertyValue(t) || n[t]) ||
          He(e) ||
          (s = he.style(e, t)),
        !le.pixelBoxStyles() &&
          nt.test(s) &&
          rt.test(t) &&
          ((i = a.width),
          (o = a.minWidth),
          (r = a.maxWidth),
          (a.minWidth = a.maxWidth = a.width = s),
          (s = n.width),
          (a.width = i),
          (a.minWidth = o),
          (a.maxWidth = r))),
      void 0 !== s ? s + "" : s
    );
  }
  function L(e, t) {
    return {
      get: function () {
        return e()
          ? void delete this.get
          : (this.get = t).apply(this, arguments);
      },
    };
  }
  function N(e) {
    var t = he.cssProps[e] || lt[e];
    return (
      t ||
      (e in at
        ? e
        : (lt[e] =
            (function (e) {
              for (
                var t = e[0].toUpperCase() + e.slice(1), n = st.length;
                n--;

              )
                if ((e = st[n] + t) in at) return e;
            })(e) || e))
    );
  }
  function D(e, t, n) {
    var i = Me.exec(t);
    return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
  }
  function M(e, t, n, i, o, r) {
    var s = "width" === t ? 1 : 0,
      a = 0,
      l = 0;
    if (n === (i ? "border" : "content")) return 0;
    for (; s < 4; s += 2)
      "margin" === n && (l += he.css(e, n + ze[s], !0, o)),
        i
          ? ("content" === n && (l -= he.css(e, "padding" + ze[s], !0, o)),
            "margin" !== n &&
              (l -= he.css(e, "border" + ze[s] + "Width", !0, o)))
          : ((l += he.css(e, "padding" + ze[s], !0, o)),
            "padding" !== n
              ? (l += he.css(e, "border" + ze[s] + "Width", !0, o))
              : (a += he.css(e, "border" + ze[s] + "Width", !0, o)));
    return (
      !i &&
        0 <= r &&
        (l +=
          Math.max(
            0,
            Math.ceil(
              e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5
            )
          ) || 0),
      l
    );
  }
  function z(e, t, n) {
    var i = it(e),
      o =
        (!le.boxSizingReliable() || n) &&
        "border-box" === he.css(e, "boxSizing", !1, i),
      s = o,
      a = I(e, t, i),
      l = "offset" + t[0].toUpperCase() + t.slice(1);
    if (nt.test(a)) {
      if (!n) return a;
      a = "auto";
    }
    return (
      ((!le.boxSizingReliable() && o) ||
        (!le.reliableTrDimensions() && r(e, "tr")) ||
        "auto" === a ||
        (!parseFloat(a) && "inline" === he.css(e, "display", !1, i))) &&
        e.getClientRects().length &&
        ((o = "border-box" === he.css(e, "boxSizing", !1, i)),
        (s = l in e) && (a = e[l])),
      (a = parseFloat(a) || 0) +
        M(e, t, n || (o ? "border" : "content"), s, i, a) +
        "px"
    );
  }
  function j(e, t, n, i, o) {
    return new j.prototype.init(e, t, n, i, o);
  }
  function H() {
    ht &&
      (!1 === pe.hidden && e.requestAnimationFrame
        ? e.requestAnimationFrame(H)
        : e.setTimeout(H, he.fx.interval),
      he.fx.tick());
  }
  function R() {
    return (
      e.setTimeout(function () {
        ft = void 0;
      }),
      (ft = Date.now())
    );
  }
  function F(e, t) {
    var n,
      i = 0,
      o = { height: e };
    for (t = t ? 1 : 0; i < 4; i += 2 - t)
      o["margin" + (n = ze[i])] = o["padding" + n] = e;
    return t && (o.opacity = o.width = e), o;
  }
  function q(e, t, n) {
    for (
      var i,
        o = (B.tweeners[t] || []).concat(B.tweeners["*"]),
        r = 0,
        s = o.length;
      r < s;
      r++
    )
      if ((i = o[r].call(n, t, e))) return i;
  }
  function B(e, t, n) {
    var i,
      o,
      r = 0,
      s = B.prefilters.length,
      a = he.Deferred().always(function () {
        delete l.elem;
      }),
      l = function () {
        if (o) return !1;
        for (
          var t = ft || R(),
            n = Math.max(0, c.startTime + c.duration - t),
            i = 1 - (n / c.duration || 0),
            r = 0,
            s = c.tweens.length;
          r < s;
          r++
        )
          c.tweens[r].run(i);
        return (
          a.notifyWith(e, [c, i, n]),
          i < 1 && s
            ? n
            : (s || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1)
        );
      },
      c = a.promise({
        elem: e,
        props: he.extend({}, t),
        opts: he.extend(
          !0,
          { specialEasing: {}, easing: he.easing._default },
          n
        ),
        originalProperties: t,
        originalOptions: n,
        startTime: ft || R(),
        duration: n.duration,
        tweens: [],
        createTween: function (t, n) {
          var i = he.Tween(
            e,
            c.opts,
            t,
            n,
            c.opts.specialEasing[t] || c.opts.easing
          );
          return c.tweens.push(i), i;
        },
        stop: function (t) {
          var n = 0,
            i = t ? c.tweens.length : 0;
          if (o) return this;
          for (o = !0; n < i; n++) c.tweens[n].run(1);
          return (
            t
              ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t]))
              : a.rejectWith(e, [c, t]),
            this
          );
        },
      }),
      u = c.props;
    for (
      !(function (e, t) {
        var n, i, o, r, s;
        for (n in e)
          if (
            ((o = t[(i = f(n))]),
            (r = e[n]),
            Array.isArray(r) && ((o = r[1]), (r = e[n] = r[0])),
            n !== i && ((e[i] = r), delete e[n]),
            (s = he.cssHooks[i]) && ("expand" in s))
          )
            for (n in ((r = s.expand(r)), delete e[i], r))
              (n in e) || ((e[n] = r[n]), (t[n] = o));
          else t[i] = o;
      })(u, c.opts.specialEasing);
      r < s;
      r++
    )
      if ((i = B.prefilters[r].call(c, e, u, c.opts)))
        return (
          ce(i.stop) &&
            (he._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
          i
        );
    return (
      he.map(u, q, c),
      ce(c.opts.start) && c.opts.start.call(e, c),
      c
        .progress(c.opts.progress)
        .done(c.opts.done, c.opts.complete)
        .fail(c.opts.fail)
        .always(c.opts.always),
      he.fx.timer(he.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
      c
    );
  }
  function W(e) {
    return (e.match(Ce) || []).join(" ");
  }
  function U(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function V(e) {
    return Array.isArray(e) ? e : ("string" == typeof e && e.match(Ce)) || [];
  }
  function Z(e, t, n, o) {
    var r;
    if (Array.isArray(t))
      he.each(t, function (t, i) {
        n || _t.test(e)
          ? o(e, i)
          : Z(
              e + "[" + ("object" == typeof i && null != i ? t : "") + "]",
              i,
              n,
              o
            );
      });
    else if (n || "object" !== i(t)) o(e, t);
    else for (r in t) Z(e + "[" + r + "]", t[r], n, o);
  }
  function K(e) {
    return function (t, n) {
      "string" != typeof t && ((n = t), (t = "*"));
      var i,
        o = 0,
        r = t.toLowerCase().match(Ce) || [];
      if (ce(n))
        for (; (i = r[o++]); )
          "+" === i[0]
            ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
            : (e[i] = e[i] || []).push(n);
    };
  }
  function X(e, t, n, i) {
    function o(a) {
      var l;
      return (
        (r[a] = !0),
        he.each(e[a] || [], function (e, a) {
          var c = a(t, n, i);
          return "string" != typeof c || s || r[c]
            ? s
              ? !(l = c)
              : void 0
            : (t.dataTypes.unshift(c), o(c), !1);
        }),
        l
      );
    }
    var r = {},
      s = e === Rt;
    return o(t.dataTypes[0]) || (!r["*"] && o("*"));
  }
  function Y(e, t) {
    var n,
      i,
      o = he.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
    return i && he.extend(!0, e, i), e;
  }
  var G = [],
    J = Object.getPrototypeOf,
    Q = G.slice,
    ee = G.flat
      ? function (e) {
          return G.flat.call(e);
        }
      : function (e) {
          return G.concat.apply([], e);
        },
    te = G.push,
    ne = G.indexOf,
    ie = {},
    oe = ie.toString,
    re = ie.hasOwnProperty,
    se = re.toString,
    ae = se.call(Object),
    le = {},
    ce = function (e) {
      return "function" == typeof e && "number" != typeof e.nodeType;
    },
    ue = function (e) {
      return null != e && e === e.window;
    },
    pe = e.document,
    de = { type: !0, src: !0, nonce: !0, noModule: !0 },
    fe = "3.5.1",
    he = function (e, t) {
      return new he.fn.init(e, t);
    };
  (he.fn = he.prototype =
    {
      jquery: fe,
      constructor: he,
      length: 0,
      toArray: function () {
        return Q.call(this);
      },
      get: function (e) {
        return null == e
          ? Q.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        var t = he.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return he.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          he.map(this, function (t, n) {
            return e.call(t, n, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(Q.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          he.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          he.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= n && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: te,
      sort: G.sort,
      splice: G.splice,
    }),
    (he.extend = he.fn.extend =
      function () {
        var e,
          t,
          n,
          i,
          o,
          r,
          s = arguments[0] || {},
          a = 1,
          l = arguments.length,
          c = !1;
        for (
          "boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++),
            "object" == typeof s || ce(s) || (s = {}),
            a === l && ((s = this), a--);
          a < l;
          a++
        )
          if (null != (e = arguments[a]))
            for (t in e)
              (i = e[t]),
                "__proto__" !== t &&
                  s !== i &&
                  (c && i && (he.isPlainObject(i) || (o = Array.isArray(i)))
                    ? ((n = s[t]),
                      (r =
                        o && !Array.isArray(n)
                          ? []
                          : o || he.isPlainObject(n)
                          ? n
                          : {}),
                      (o = !1),
                      (s[t] = he.extend(c, r, i)))
                    : void 0 !== i && (s[t] = i));
        return s;
      }),
    he.extend({
      expando: "jQuery" + (fe + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return !(
          !e ||
          "[object Object]" !== oe.call(e) ||
          ((t = J(e)) &&
            ("function" !=
              typeof (n = re.call(t, "constructor") && t.constructor) ||
              se.call(n) !== ae))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, i) {
        n(e, { nonce: t && t.nonce }, i);
      },
      each: function (e, t) {
        var n,
          i = 0;
        if (o(e))
          for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
        else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
        return e;
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e &&
            (o(Object(e))
              ? he.merge(n, "string" == typeof e ? [e] : e)
              : te.call(n, e)),
          n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : ne.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
        return (e.length = o), e;
      },
      grep: function (e, t, n) {
        for (var i = [], o = 0, r = e.length, s = !n; o < r; o++)
          !t(e[o], o) !== s && i.push(e[o]);
        return i;
      },
      map: function (e, t, n) {
        var i,
          r,
          s = 0,
          a = [];
        if (o(e))
          for (i = e.length; s < i; s++)
            null != (r = t(e[s], s, n)) && a.push(r);
        else for (s in e) null != (r = t(e[s], s, n)) && a.push(r);
        return ee(a);
      },
      guid: 1,
      support: le,
    }),
    "function" == typeof Symbol &&
      (he.fn[Symbol.iterator] = G[Symbol.iterator]),
    he.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        ie["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var me = (function (e) {
    function t(e, t, n, i) {
      var o,
        r,
        s,
        a,
        l,
        c,
        u,
        d = t && t.ownerDocument,
        h = t ? t.nodeType : 9;
      if (
        ((n = n || []),
        "string" != typeof e || !e || (1 !== h && 9 !== h && 11 !== h))
      )
        return n;
      if (!i && (O(t), (t = t || $), L)) {
        if (11 !== h && (l = ge.exec(e)))
          if ((o = l[1])) {
            if (9 === h) {
              if (!(s = t.getElementById(o))) return n;
              if (s.id === o) return n.push(s), n;
            } else if (d && (s = d.getElementById(o)) && z(t, s) && s.id === o)
              return n.push(s), n;
          } else {
            if (l[2]) return G.apply(n, t.getElementsByTagName(e)), n;
            if (
              (o = l[3]) &&
              w.getElementsByClassName &&
              t.getElementsByClassName
            )
              return G.apply(n, t.getElementsByClassName(o)), n;
          }
        if (
          w.qsa &&
          !U[e + " "] &&
          (!N || !N.test(e)) &&
          (1 !== h || "object" !== t.nodeName.toLowerCase())
        ) {
          if (((u = e), (d = t), 1 === h && (ce.test(e) || le.test(e)))) {
            for (
              ((d = (ye.test(e) && p(t.parentNode)) || t) === t && w.scope) ||
                ((a = t.getAttribute("id"))
                  ? (a = a.replace(xe, ke))
                  : t.setAttribute("id", (a = j))),
                r = (c = C(e)).length;
              r--;

            )
              c[r] = (a ? "#" + a : ":scope") + " " + f(c[r]);
            u = c.join(",");
          }
          try {
            return G.apply(n, d.querySelectorAll(u)), n;
          } catch (t) {
            U(e, !0);
          } finally {
            a === j && t.removeAttribute("id");
          }
        }
      }
      return E(e.replace(se, "$1"), t, n, i);
    }
    function n() {
      var e = [];
      return function t(n, i) {
        return (
          e.push(n + " ") > x.cacheLength && delete t[e.shift()],
          (t[n + " "] = i)
        );
      };
    }
    function i(e) {
      return (e[j] = !0), e;
    }
    function o(e) {
      var t = $.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function r(e, t) {
      for (var n = e.split("|"), i = n.length; i--; ) x.attrHandle[n[i]] = t;
    }
    function s(e, t) {
      var n = t && e,
        i =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (i) return i;
      if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function a(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function l(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();
        return ("input" === n || "button" === n) && t.type === e;
      };
    }
    function c(e) {
      return function (t) {
        return "form" in t
          ? t.parentNode && !1 === t.disabled
            ? "label" in t
              ? "label" in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (t.isDisabled !== !e && Ce(t) === e)
            : t.disabled === e
          : "label" in t && t.disabled === e;
      };
    }
    function u(e) {
      return i(function (t) {
        return (
          (t = +t),
          i(function (n, i) {
            for (var o, r = e([], n.length, t), s = r.length; s--; )
              n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
          })
        );
      });
    }
    function p(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }
    function d() {}
    function f(e) {
      for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
      return i;
    }
    function h(e, t, n) {
      var i = t.dir,
        o = t.next,
        r = o || i,
        s = n && "parentNode" === r,
        a = F++;
      return t.first
        ? function (t, n, o) {
            for (; (t = t[i]); ) if (1 === t.nodeType || s) return e(t, n, o);
            return !1;
          }
        : function (t, n, l) {
            var c,
              u,
              p,
              d = [R, a];
            if (l) {
              for (; (t = t[i]); )
                if ((1 === t.nodeType || s) && e(t, n, l)) return !0;
            } else
              for (; (t = t[i]); )
                if (1 === t.nodeType || s)
                  if (
                    ((u =
                      (p = t[j] || (t[j] = {}))[t.uniqueID] ||
                      (p[t.uniqueID] = {})),
                    o && o === t.nodeName.toLowerCase())
                  )
                    t = t[i] || t;
                  else {
                    if ((c = u[r]) && c[0] === R && c[1] === a)
                      return (d[2] = c[2]);
                    if (((u[r] = d)[2] = e(t, n, l))) return !0;
                  }
            return !1;
          };
    }
    function m(e) {
      return 1 < e.length
        ? function (t, n, i) {
            for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
            return !0;
          }
        : e[0];
    }
    function v(e, t, n, i, o) {
      for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++)
        (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), c && t.push(a)));
      return s;
    }
    function g(e, n, o, r, s, a) {
      return (
        r && !r[j] && (r = g(r)),
        s && !s[j] && (s = g(s, a)),
        i(function (i, a, l, c) {
          var u,
            p,
            d,
            f = [],
            h = [],
            m = a.length,
            g =
              i ||
              (function (e, n, i) {
                for (var o = 0, r = n.length; o < r; o++) t(e, n[o], i);
                return i;
              })(n || "*", l.nodeType ? [l] : l, []),
            y = !e || (!i && n) ? g : v(g, f, e, l, c),
            b = o ? (s || (i ? e : m || r) ? [] : a) : y;
          if ((o && o(y, b, l, c), r))
            for (u = v(b, h), r(u, [], l, c), p = u.length; p--; )
              (d = u[p]) && (b[h[p]] = !(y[h[p]] = d));
          if (i) {
            if (s || e) {
              if (s) {
                for (u = [], p = b.length; p--; )
                  (d = b[p]) && u.push((y[p] = d));
                s(null, (b = []), u, c);
              }
              for (p = b.length; p--; )
                (d = b[p]) &&
                  -1 < (u = s ? Q(i, d) : f[p]) &&
                  (i[u] = !(a[u] = d));
            }
          } else (b = v(b === a ? b.splice(m, b.length) : b)), s ? s(null, a, b, c) : G.apply(a, b);
        })
      );
    }
    function y(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          r = x.relative[e[0].type],
          s = r || x.relative[" "],
          a = r ? 1 : 0,
          l = h(
            function (e) {
              return e === t;
            },
            s,
            !0
          ),
          c = h(
            function (e) {
              return -1 < Q(t, e);
            },
            s,
            !0
          ),
          u = [
            function (e, n, i) {
              var o =
                (!r && (i || n !== A)) ||
                ((t = n).nodeType ? l(e, n, i) : c(e, n, i));
              return (t = null), o;
            },
          ];
        a < o;
        a++
      )
        if ((n = x.relative[e[a].type])) u = [h(m(u), n)];
        else {
          if ((n = x.filter[e[a].type].apply(null, e[a].matches))[j]) {
            for (i = ++a; i < o && !x.relative[e[i].type]; i++);
            return g(
              1 < a && m(u),
              1 < a &&
                f(
                  e
                    .slice(0, a - 1)
                    .concat({ value: " " === e[a - 2].type ? "*" : "" })
                ).replace(se, "$1"),
              n,
              a < i && y(e.slice(a, i)),
              i < o && y((e = e.slice(i))),
              i < o && f(e)
            );
          }
          u.push(n);
        }
      return m(u);
    }
    var b,
      w,
      x,
      k,
      S,
      C,
      T,
      E,
      A,
      P,
      _,
      O,
      $,
      I,
      L,
      N,
      D,
      M,
      z,
      j = "sizzle" + 1 * new Date(),
      H = e.document,
      R = 0,
      F = 0,
      q = n(),
      B = n(),
      W = n(),
      U = n(),
      V = function (e, t) {
        return e === t && (_ = !0), 0;
      },
      Z = {}.hasOwnProperty,
      K = [],
      X = K.pop,
      Y = K.push,
      G = K.push,
      J = K.slice,
      Q = function (e, t) {
        for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
        return -1;
      },
      ee =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      te = "[\\x20\\t\\r\\n\\f]",
      ne =
        "(?:\\\\[\\da-fA-F]{1,6}" +
        te +
        "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      ie =
        "\\[" +
        te +
        "*(" +
        ne +
        ")(?:" +
        te +
        "*([*^$|!~]?=)" +
        te +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        ne +
        "))|)" +
        te +
        "*\\]",
      oe =
        ":(" +
        ne +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        ie +
        ")*)|.*)\\)|)",
      re = new RegExp(te + "+", "g"),
      se = new RegExp(
        "^" + te + "+|((?:^|[^\\\\])(?:\\\\.)*)" + te + "+$",
        "g"
      ),
      ae = new RegExp("^" + te + "*," + te + "*"),
      le = new RegExp("^" + te + "*([>+~]|" + te + ")" + te + "*"),
      ce = new RegExp(te + "|>"),
      ue = new RegExp(oe),
      pe = new RegExp("^" + ne + "$"),
      de = {
        ID: new RegExp("^#(" + ne + ")"),
        CLASS: new RegExp("^\\.(" + ne + ")"),
        TAG: new RegExp("^(" + ne + "|[*])"),
        ATTR: new RegExp("^" + ie),
        PSEUDO: new RegExp("^" + oe),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            te +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            te +
            "*(?:([+-]|)" +
            te +
            "*(\\d+)|))" +
            te +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + ee + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            te +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            te +
            "*((?:-\\d)?\\d*)" +
            te +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      fe = /HTML$/i,
      he = /^(?:input|select|textarea|button)$/i,
      me = /^h\d$/i,
      ve = /^[^{]+\{\s*\[native \w/,
      ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      ye = /[+~]/,
      be = new RegExp(
        "\\\\[\\da-fA-F]{1,6}" + te + "?|\\\\([^\\r\\n\\f])",
        "g"
      ),
      we = function (e, t) {
        var n = "0x" + e.slice(1) - 65536;
        return (
          t ||
          (n < 0
            ? String.fromCharCode(n + 65536)
            : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
        );
      },
      xe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ke = function (e, t) {
        return t
          ? "\0" === e
            ? "�"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      Se = function () {
        O();
      },
      Ce = h(
        function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      G.apply((K = J.call(H.childNodes)), H.childNodes),
        K[H.childNodes.length].nodeType;
    } catch (e) {
      G = {
        apply: K.length
          ? function (e, t) {
              Y.apply(e, J.call(t));
            }
          : function (e, t) {
              for (var n = e.length, i = 0; (e[n++] = t[i++]); );
              e.length = n - 1;
            },
      };
    }
    for (b in ((w = t.support = {}),
    (S = t.isXML =
      function (e) {
        var t = e.namespaceURI,
          n = (e.ownerDocument || e).documentElement;
        return !fe.test(t || (n && n.nodeName) || "HTML");
      }),
    (O = t.setDocument =
      function (e) {
        var t,
          n,
          i = e ? e.ownerDocument || e : H;
        return (
          i != $ &&
            9 === i.nodeType &&
            i.documentElement &&
            ((I = ($ = i).documentElement),
            (L = !S($)),
            H != $ &&
              (n = $.defaultView) &&
              n.top !== n &&
              (n.addEventListener
                ? n.addEventListener("unload", Se, !1)
                : n.attachEvent && n.attachEvent("onunload", Se)),
            (w.scope = o(function (e) {
              return (
                I.appendChild(e).appendChild($.createElement("div")),
                "undefined" != typeof e.querySelectorAll &&
                  !e.querySelectorAll(":scope fieldset div").length
              );
            })),
            (w.attributes = o(function (e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (w.getElementsByTagName = o(function (e) {
              return (
                e.appendChild($.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (w.getElementsByClassName = ve.test($.getElementsByClassName)),
            (w.getById = o(function (e) {
              return (
                (I.appendChild(e).id = j),
                !$.getElementsByName || !$.getElementsByName(j).length
              );
            })),
            w.getById
              ? ((x.filter.ID = function (e) {
                  var t = e.replace(be, we);
                  return function (e) {
                    return e.getAttribute("id") === t;
                  };
                }),
                (x.find.ID = function (e, t) {
                  if ("undefined" != typeof t.getElementById && L) {
                    var n = t.getElementById(e);
                    return n ? [n] : [];
                  }
                }))
              : ((x.filter.ID = function (e) {
                  var t = e.replace(be, we);
                  return function (e) {
                    var n =
                      "undefined" != typeof e.getAttributeNode &&
                      e.getAttributeNode("id");
                    return n && n.value === t;
                  };
                }),
                (x.find.ID = function (e, t) {
                  if ("undefined" != typeof t.getElementById && L) {
                    var n,
                      i,
                      o,
                      r = t.getElementById(e);
                    if (r) {
                      if ((n = r.getAttributeNode("id")) && n.value === e)
                        return [r];
                      for (o = t.getElementsByName(e), i = 0; (r = o[i++]); )
                        if ((n = r.getAttributeNode("id")) && n.value === e)
                          return [r];
                    }
                    return [];
                  }
                })),
            (x.find.TAG = w.getElementsByTagName
              ? function (e, t) {
                  return "undefined" != typeof t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : w.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var n,
                    i = [],
                    o = 0,
                    r = t.getElementsByTagName(e);
                  if ("*" === e) {
                    for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                    return i;
                  }
                  return r;
                }),
            (x.find.CLASS =
              w.getElementsByClassName &&
              function (e, t) {
                if ("undefined" != typeof t.getElementsByClassName && L)
                  return t.getElementsByClassName(e);
              }),
            (D = []),
            (N = []),
            (w.qsa = ve.test($.querySelectorAll)) &&
              (o(function (e) {
                var t;
                (I.appendChild(e).innerHTML =
                  "<a id='" +
                  j +
                  "'></a><select id='" +
                  j +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    N.push("[*^$]=" + te + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    N.push("\\[" + te + "*(?:value|" + ee + ")"),
                  e.querySelectorAll("[id~=" + j + "-]").length || N.push("~="),
                  (t = $.createElement("input")).setAttribute("name", ""),
                  e.appendChild(t),
                  e.querySelectorAll("[name='']").length ||
                    N.push(
                      "\\[" + te + "*name" + te + "*=" + te + "*(?:''|\"\")"
                    ),
                  e.querySelectorAll(":checked").length || N.push(":checked"),
                  e.querySelectorAll("a#" + j + "+*").length ||
                    N.push(".#.+[+~]"),
                  e.querySelectorAll("\\\f"),
                  N.push("[\\r\\n\\f]");
              }),
              o(function (e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = $.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    N.push("name" + te + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length &&
                    N.push(":enabled", ":disabled"),
                  (I.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(":disabled").length &&
                    N.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  N.push(",.*:");
              })),
            (w.matchesSelector = ve.test(
              (M =
                I.matches ||
                I.webkitMatchesSelector ||
                I.mozMatchesSelector ||
                I.oMatchesSelector ||
                I.msMatchesSelector)
            )) &&
              o(function (e) {
                (w.disconnectedMatch = M.call(e, "*")),
                  M.call(e, "[s!='']:x"),
                  D.push("!=", oe);
              }),
            (N = N.length && new RegExp(N.join("|"))),
            (D = D.length && new RegExp(D.join("|"))),
            (t = ve.test(I.compareDocumentPosition)),
            (z =
              t || ve.test(I.contains)
                ? function (e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                      i = t && t.parentNode;
                    return (
                      e === i ||
                      !(
                        !i ||
                        1 !== i.nodeType ||
                        !(n.contains
                          ? n.contains(i)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(i))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                    return !1;
                  }),
            (V = t
              ? function (e, t) {
                  if (e === t) return (_ = !0), 0;
                  var n =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    n ||
                    (1 &
                      (n =
                        (e.ownerDocument || e) == (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!w.sortDetached && t.compareDocumentPosition(e) === n)
                      ? e == $ || (e.ownerDocument == H && z(H, e))
                        ? -1
                        : t == $ || (t.ownerDocument == H && z(H, t))
                        ? 1
                        : P
                        ? Q(P, e) - Q(P, t)
                        : 0
                      : 4 & n
                      ? -1
                      : 1)
                  );
                }
              : function (e, t) {
                  if (e === t) return (_ = !0), 0;
                  var n,
                    i = 0,
                    o = e.parentNode,
                    r = t.parentNode,
                    a = [e],
                    l = [t];
                  if (!o || !r)
                    return e == $
                      ? -1
                      : t == $
                      ? 1
                      : o
                      ? -1
                      : r
                      ? 1
                      : P
                      ? Q(P, e) - Q(P, t)
                      : 0;
                  if (o === r) return s(e, t);
                  for (n = e; (n = n.parentNode); ) a.unshift(n);
                  for (n = t; (n = n.parentNode); ) l.unshift(n);
                  for (; a[i] === l[i]; ) i++;
                  return i ? s(a[i], l[i]) : a[i] == H ? -1 : l[i] == H ? 1 : 0;
                })),
          $
        );
      }),
    (t.matches = function (e, n) {
      return t(e, null, null, n);
    }),
    (t.matchesSelector = function (e, n) {
      if (
        (O(e),
        w.matchesSelector &&
          L &&
          !U[n + " "] &&
          (!D || !D.test(n)) &&
          (!N || !N.test(n)))
      )
        try {
          var i = M.call(e, n);
          if (
            i ||
            w.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return i;
        } catch (e) {
          U(n, !0);
        }
      return 0 < t(n, $, null, [e]).length;
    }),
    (t.contains = function (e, t) {
      return (e.ownerDocument || e) != $ && O(e), z(e, t);
    }),
    (t.attr = function (e, t) {
      (e.ownerDocument || e) != $ && O(e);
      var n = x.attrHandle[t.toLowerCase()],
        i = n && Z.call(x.attrHandle, t.toLowerCase()) ? n(e, t, !L) : void 0;
      return void 0 !== i
        ? i
        : w.attributes || !L
        ? e.getAttribute(t)
        : (i = e.getAttributeNode(t)) && i.specified
        ? i.value
        : null;
    }),
    (t.escape = function (e) {
      return (e + "").replace(xe, ke);
    }),
    (t.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }),
    (t.uniqueSort = function (e) {
      var t,
        n = [],
        i = 0,
        o = 0;
      if (
        ((_ = !w.detectDuplicates),
        (P = !w.sortStable && e.slice(0)),
        e.sort(V),
        _)
      ) {
        for (; (t = e[o++]); ) t === e[o] && (i = n.push(o));
        for (; i--; ) e.splice(n[i], 1);
      }
      return (P = null), e;
    }),
    (k = t.getText =
      function (e) {
        var t,
          n = "",
          i = 0,
          o = e.nodeType;
        if (o) {
          if (1 === o || 9 === o || 11 === o) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) n += k(e);
          } else if (3 === o || 4 === o) return e.nodeValue;
        } else for (; (t = e[i++]); ) n += k(t);
        return n;
      }),
    ((x = t.selectors =
      {
        cacheLength: 50,
        createPseudo: i,
        match: de,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(be, we)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(be, we)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || t.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && t.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              n = !e[6] && e[2];
            return de.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : n &&
                    ue.test(n) &&
                    (t = C(n, !0)) &&
                    (t = n.indexOf(")", n.length - t) - n.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(be, we).toLowerCase();
            return "*" === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = q[e + " "];
            return (
              t ||
              ((t = new RegExp("(^|" + te + ")" + e + "(" + te + "|$)")) &&
                q(e, function (e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      ("undefined" != typeof e.getAttribute &&
                        e.getAttribute("class")) ||
                      ""
                  );
                }))
            );
          },
          ATTR: function (e, n, i) {
            return function (o) {
              var r = t.attr(o, e);
              return null == r
                ? "!=" === n
                : !n ||
                    ((r += ""),
                    "=" === n
                      ? r === i
                      : "!=" === n
                      ? r !== i
                      : "^=" === n
                      ? i && 0 === r.indexOf(i)
                      : "*=" === n
                      ? i && -1 < r.indexOf(i)
                      : "$=" === n
                      ? i && r.slice(-i.length) === i
                      : "~=" === n
                      ? -1 < (" " + r.replace(re, " ") + " ").indexOf(i)
                      : "|=" === n &&
                        (r === i || r.slice(0, i.length + 1) === i + "-"));
            };
          },
          CHILD: function (e, t, n, i, o) {
            var r = "nth" !== e.slice(0, 3),
              s = "last" !== e.slice(-4),
              a = "of-type" === t;
            return 1 === i && 0 === o
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (t, n, l) {
                  var c,
                    u,
                    p,
                    d,
                    f,
                    h,
                    m = r !== s ? "nextSibling" : "previousSibling",
                    v = t.parentNode,
                    g = a && t.nodeName.toLowerCase(),
                    y = !l && !a,
                    b = !1;
                  if (v) {
                    if (r) {
                      for (; m; ) {
                        for (d = t; (d = d[m]); )
                          if (
                            a
                              ? d.nodeName.toLowerCase() === g
                              : 1 === d.nodeType
                          )
                            return !1;
                        h = m = "only" === e && !h && "nextSibling";
                      }
                      return !0;
                    }
                    if (((h = [s ? v.firstChild : v.lastChild]), s && y)) {
                      for (
                        b =
                          (f =
                            (c =
                              (u =
                                (p = (d = v)[j] || (d[j] = {}))[d.uniqueID] ||
                                (p[d.uniqueID] = {}))[e] || [])[0] === R &&
                            c[1]) && c[2],
                          d = f && v.childNodes[f];
                        (d = (++f && d && d[m]) || (b = f = 0) || h.pop());

                      )
                        if (1 === d.nodeType && ++b && d === t) {
                          u[e] = [R, f, b];
                          break;
                        }
                    } else if (
                      (y &&
                        (b = f =
                          (c =
                            (u =
                              (p = (d = t)[j] || (d[j] = {}))[d.uniqueID] ||
                              (p[d.uniqueID] = {}))[e] || [])[0] === R && c[1]),
                      !1 === b)
                    )
                      for (
                        ;
                        (d = (++f && d && d[m]) || (b = f = 0) || h.pop()) &&
                        ((a
                          ? d.nodeName.toLowerCase() !== g
                          : 1 !== d.nodeType) ||
                          !++b ||
                          (y &&
                            ((u =
                              (p = d[j] || (d[j] = {}))[d.uniqueID] ||
                              (p[d.uniqueID] = {}))[e] = [R, b]),
                          d !== t));

                      );
                    return (b -= o) === i || (b % i == 0 && 0 <= b / i);
                  }
                };
          },
          PSEUDO: function (e, n) {
            var o,
              r =
                x.pseudos[e] ||
                x.setFilters[e.toLowerCase()] ||
                t.error("unsupported pseudo: " + e);
            return r[j]
              ? r(n)
              : 1 < r.length
              ? ((o = [e, e, "", n]),
                x.setFilters.hasOwnProperty(e.toLowerCase())
                  ? i(function (e, t) {
                      for (var i, o = r(e, n), s = o.length; s--; )
                        e[(i = Q(e, o[s]))] = !(t[i] = o[s]);
                    })
                  : function (e) {
                      return r(e, 0, o);
                    })
              : r;
          },
        },
        pseudos: {
          not: i(function (e) {
            var t = [],
              n = [],
              o = T(e.replace(se, "$1"));
            return o[j]
              ? i(function (e, t, n, i) {
                  for (var r, s = o(e, null, i, []), a = e.length; a--; )
                    (r = s[a]) && (e[a] = !(t[a] = r));
                })
              : function (e, i, r) {
                  return (t[0] = e), o(t, null, r, n), (t[0] = null), !n.pop();
                };
          }),
          has: i(function (e) {
            return function (n) {
              return 0 < t(e, n).length;
            };
          }),
          contains: i(function (e) {
            return (
              (e = e.replace(be, we)),
              function (t) {
                return -1 < (t.textContent || k(t)).indexOf(e);
              }
            );
          }),
          lang: i(function (e) {
            return (
              pe.test(e || "") || t.error("unsupported lang: " + e),
              (e = e.replace(be, we).toLowerCase()),
              function (t) {
                var n;
                do
                  if (
                    (n = L
                      ? t.lang
                      : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                  )
                    return (
                      (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                    );
                while ((t = t.parentNode) && 1 === t.nodeType);
                return !1;
              }
            );
          }),
          target: function (t) {
            var n = e.location && e.location.hash;
            return n && n.slice(1) === t.id;
          },
          root: function (e) {
            return e === I;
          },
          focus: function (e) {
            return (
              e === $.activeElement &&
              (!$.hasFocus || $.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: c(!1),
          disabled: c(!0),
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !x.pseudos.empty(e);
          },
          header: function (e) {
            return me.test(e.nodeName);
          },
          input: function (e) {
            return he.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function (e) {
            var t;
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (t = e.getAttribute("type")) ||
                "text" === t.toLowerCase())
            );
          },
          first: u(function () {
            return [0];
          }),
          last: u(function (e, t) {
            return [t - 1];
          }),
          eq: u(function (e, t, n) {
            return [n < 0 ? n + t : n];
          }),
          even: u(function (e, t) {
            for (var n = 0; n < t; n += 2) e.push(n);
            return e;
          }),
          odd: u(function (e, t) {
            for (var n = 1; n < t; n += 2) e.push(n);
            return e;
          }),
          lt: u(function (e, t, n) {
            for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i; ) e.push(i);
            return e;
          }),
          gt: u(function (e, t, n) {
            for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
            return e;
          }),
        },
      }).pseudos.nth = x.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      x.pseudos[b] = a(b);
    for (b in { submit: !0, reset: !0 }) x.pseudos[b] = l(b);
    return (
      (d.prototype = x.filters = x.pseudos),
      (x.setFilters = new d()),
      (C = t.tokenize =
        function (e, n) {
          var i,
            o,
            r,
            s,
            a,
            l,
            c,
            u = B[e + " "];
          if (u) return n ? 0 : u.slice(0);
          for (a = e, l = [], c = x.preFilter; a; ) {
            for (s in ((i && !(o = ae.exec(a))) ||
              (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
            (i = !1),
            (o = le.exec(a)) &&
              ((i = o.shift()),
              r.push({ value: i, type: o[0].replace(se, " ") }),
              (a = a.slice(i.length))),
            x.filter))
              !(o = de[s].exec(a)) ||
                (c[s] && !(o = c[s](o))) ||
                ((i = o.shift()),
                r.push({ value: i, type: s, matches: o }),
                (a = a.slice(i.length)));
            if (!i) break;
          }
          return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
        }),
      (T = t.compile =
        function (e, n) {
          var o,
            r,
            s,
            a,
            l,
            c,
            u = [],
            p = [],
            d = W[e + " "];
          if (!d) {
            for (n || (n = C(e)), o = n.length; o--; )
              (d = y(n[o]))[j] ? u.push(d) : p.push(d);
            (d = W(
              e,
              ((r = p),
              (a = 0 < (s = u).length),
              (l = 0 < r.length),
              (c = function (e, n, i, o, c) {
                var u,
                  p,
                  d,
                  f = 0,
                  h = "0",
                  m = e && [],
                  g = [],
                  y = A,
                  b = e || (l && x.find.TAG("*", c)),
                  w = (R += null == y ? 1 : Math.random() || 0.1),
                  k = b.length;
                for (
                  c && (A = n == $ || n || c);
                  h !== k && null != (u = b[h]);
                  h++
                ) {
                  if (l && u) {
                    for (
                      p = 0, n || u.ownerDocument == $ || (O(u), (i = !L));
                      (d = r[p++]);

                    )
                      if (d(u, n || $, i)) {
                        o.push(u);
                        break;
                      }
                    c && (R = w);
                  }
                  a && ((u = !d && u) && f--, e && m.push(u));
                }
                if (((f += h), a && h !== f)) {
                  for (p = 0; (d = s[p++]); ) d(m, g, n, i);
                  if (e) {
                    if (0 < f) for (; h--; ) m[h] || g[h] || (g[h] = X.call(o));
                    g = v(g);
                  }
                  G.apply(o, g),
                    c &&
                      !e &&
                      0 < g.length &&
                      1 < f + s.length &&
                      t.uniqueSort(o);
                }
                return c && ((R = w), (A = y)), m;
              }),
              a ? i(c) : c)
            )).selector = e;
          }
          return d;
        }),
      (E = t.select =
        function (e, t, n, i) {
          var o,
            r,
            s,
            a,
            l,
            c = "function" == typeof e && e,
            u = !i && C((e = c.selector || e));
          if (((n = n || []), 1 === u.length)) {
            if (
              2 < (r = u[0] = u[0].slice(0)).length &&
              "ID" === (s = r[0]).type &&
              9 === t.nodeType &&
              L &&
              x.relative[r[1].type]
            ) {
              if (!(t = (x.find.ID(s.matches[0].replace(be, we), t) || [])[0]))
                return n;
              c && (t = t.parentNode), (e = e.slice(r.shift().value.length));
            }
            for (
              o = de.needsContext.test(e) ? 0 : r.length;
              o-- && ((s = r[o]), !x.relative[(a = s.type)]);

            )
              if (
                (l = x.find[a]) &&
                (i = l(
                  s.matches[0].replace(be, we),
                  (ye.test(r[0].type) && p(t.parentNode)) || t
                ))
              ) {
                if ((r.splice(o, 1), !(e = i.length && f(r))))
                  return G.apply(n, i), n;
                break;
              }
          }
          return (
            (c || T(e, u))(
              i,
              t,
              !L,
              n,
              !t || (ye.test(e) && p(t.parentNode)) || t
            ),
            n
          );
        }),
      (w.sortStable = j.split("").sort(V).join("") === j),
      (w.detectDuplicates = !!_),
      O(),
      (w.sortDetached = o(function (e) {
        return 1 & e.compareDocumentPosition($.createElement("fieldset"));
      })),
      o(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        r("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (w.attributes &&
        o(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        r("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      o(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        r(ee, function (e, t, n) {
          var i;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (i = e.getAttributeNode(t)) && i.specified
              ? i.value
              : null;
        }),
      t
    );
  })(e);
  (he.find = me),
    (he.expr = me.selectors),
    (he.expr[":"] = he.expr.pseudos),
    (he.uniqueSort = he.unique = me.uniqueSort),
    (he.text = me.getText),
    (he.isXMLDoc = me.isXML),
    (he.contains = me.contains),
    (he.escapeSelector = me.escape);
  var ve = function (e, t, n) {
      for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
        if (1 === e.nodeType) {
          if (o && he(e).is(n)) break;
          i.push(e);
        }
      return i;
    },
    ge = function (e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    ye = he.expr.match.needsContext,
    be = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  (he.filter = function (e, t, n) {
    var i = t[0];
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === i.nodeType
        ? he.find.matchesSelector(i, e)
          ? [i]
          : []
        : he.find.matches(
            e,
            he.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    he.fn.extend({
      find: function (e) {
        var t,
          n,
          i = this.length,
          o = this;
        if ("string" != typeof e)
          return this.pushStack(
            he(e).filter(function () {
              for (t = 0; t < i; t++) if (he.contains(o[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < i; t++) he.find(e, o[t], n);
        return 1 < i ? he.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(s(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(s(this, e || [], !0));
      },
      is: function (e) {
        return !!s(
          this,
          "string" == typeof e && ye.test(e) ? he(e) : e || [],
          !1
        ).length;
      },
    });
  var we,
    xe = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((he.fn.init = function (e, t, n) {
    var i, o;
    if (!e) return this;
    if (((n = n || we), "string" == typeof e)) {
      if (
        !(i =
          "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
            ? [null, e, null]
            : xe.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (i[1]) {
        if (
          ((t = t instanceof he ? t[0] : t),
          he.merge(
            this,
            he.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : pe, !0)
          ),
          be.test(i[1]) && he.isPlainObject(t))
        )
          for (i in t) ce(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        return this;
      }
      return (
        (o = pe.getElementById(i[2])) && ((this[0] = o), (this.length = 1)),
        this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : ce(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(he)
      : he.makeArray(e, this);
  }).prototype = he.fn),
    (we = he(pe));
  var ke = /^(?:parents|prev(?:Until|All))/,
    Se = { children: !0, contents: !0, next: !0, prev: !0 };
  he.fn.extend({
    has: function (e) {
      var t = he(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (he.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        i = 0,
        o = this.length,
        r = [],
        s = "string" != typeof e && he(e);
      if (!ye.test(e))
        for (; i < o; i++)
          for (n = this[i]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (s
                ? -1 < s.index(n)
                : 1 === n.nodeType && he.find.matchesSelector(n, e))
            ) {
              r.push(n);
              break;
            }
      return this.pushStack(1 < r.length ? he.uniqueSort(r) : r);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? ne.call(he(e), this[0])
          : ne.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(he.uniqueSort(he.merge(this.get(), he(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    he.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return ve(e, "parentNode");
        },
        parentsUntil: function (e, t, n) {
          return ve(e, "parentNode", n);
        },
        next: function (e) {
          return a(e, "nextSibling");
        },
        prev: function (e) {
          return a(e, "previousSibling");
        },
        nextAll: function (e) {
          return ve(e, "nextSibling");
        },
        prevAll: function (e) {
          return ve(e, "previousSibling");
        },
        nextUntil: function (e, t, n) {
          return ve(e, "nextSibling", n);
        },
        prevUntil: function (e, t, n) {
          return ve(e, "previousSibling", n);
        },
        siblings: function (e) {
          return ge((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return ge(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && J(e.contentDocument)
            ? e.contentDocument
            : (r(e, "template") && (e = e.content || e),
              he.merge([], e.childNodes));
        },
      },
      function (e, t) {
        he.fn[e] = function (n, i) {
          var o = he.map(this, t, n);
          return (
            "Until" !== e.slice(-5) && (i = n),
            i && "string" == typeof i && (o = he.filter(i, o)),
            1 < this.length &&
              (Se[e] || he.uniqueSort(o), ke.test(e) && o.reverse()),
            this.pushStack(o)
          );
        };
      }
    );
  var Ce = /[^\x20\t\r\n\f]+/g;
  (he.Callbacks = function (e) {
    var t, n;
    e =
      "string" == typeof e
        ? ((t = e),
          (n = {}),
          he.each(t.match(Ce) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : he.extend({}, e);
    var o,
      r,
      s,
      a,
      l = [],
      c = [],
      u = -1,
      p = function () {
        for (a = a || e.once, s = o = !0; c.length; u = -1)
          for (r = c.shift(); ++u < l.length; )
            !1 === l[u].apply(r[0], r[1]) &&
              e.stopOnFalse &&
              ((u = l.length), (r = !1));
        e.memory || (r = !1), (o = !1), a && (l = r ? [] : "");
      },
      d = {
        add: function () {
          return (
            l &&
              (r && !o && ((u = l.length - 1), c.push(r)),
              (function t(n) {
                he.each(n, function (n, o) {
                  ce(o)
                    ? (e.unique && d.has(o)) || l.push(o)
                    : o && o.length && "string" !== i(o) && t(o);
                });
              })(arguments),
              r && !o && p()),
            this
          );
        },
        remove: function () {
          return (
            he.each(arguments, function (e, t) {
              for (var n; -1 < (n = he.inArray(t, l, n)); )
                l.splice(n, 1), n <= u && u--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < he.inArray(e, l) : 0 < l.length;
        },
        empty: function () {
          return l && (l = []), this;
        },
        disable: function () {
          return (a = c = []), (l = r = ""), this;
        },
        disabled: function () {
          return !l;
        },
        lock: function () {
          return (a = c = []), r || o || (l = r = ""), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return (
            a ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              c.push(t),
              o || p()),
            this
          );
        },
        fire: function () {
          return d.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!s;
        },
      };
    return d;
  }),
    he.extend({
      Deferred: function (t) {
        var n = [
            [
              "notify",
              "progress",
              he.Callbacks("memory"),
              he.Callbacks("memory"),
              2,
            ],
            [
              "resolve",
              "done",
              he.Callbacks("once memory"),
              he.Callbacks("once memory"),
              0,
              "resolved",
            ],
            [
              "reject",
              "fail",
              he.Callbacks("once memory"),
              he.Callbacks("once memory"),
              1,
              "rejected",
            ],
          ],
          i = "pending",
          o = {
            state: function () {
              return i;
            },
            always: function () {
              return r.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return o.then(null, e);
            },
            pipe: function () {
              var e = arguments;
              return he
                .Deferred(function (t) {
                  he.each(n, function (n, i) {
                    var o = ce(e[i[4]]) && e[i[4]];
                    r[i[1]](function () {
                      var e = o && o.apply(this, arguments);
                      e && ce(e.promise)
                        ? e
                            .promise()
                            .progress(t.notify)
                            .done(t.resolve)
                            .fail(t.reject)
                        : t[i[0] + "With"](this, o ? [e] : arguments);
                    });
                  }),
                    (e = null);
                })
                .promise();
            },
            then: function (t, i, o) {
              function r(t, n, i, o) {
                return function () {
                  var a = this,
                    u = arguments,
                    p = function () {
                      var e, p;
                      if (!(t < s)) {
                        if ((e = i.apply(a, u)) === n.promise())
                          throw new TypeError("Thenable self-resolution");
                        (p =
                          e &&
                          ("object" == typeof e || "function" == typeof e) &&
                          e.then),
                          ce(p)
                            ? o
                              ? p.call(e, r(s, n, l, o), r(s, n, c, o))
                              : (s++,
                                p.call(
                                  e,
                                  r(s, n, l, o),
                                  r(s, n, c, o),
                                  r(s, n, l, n.notifyWith)
                                ))
                            : (i !== l && ((a = void 0), (u = [e])),
                              (o || n.resolveWith)(a, u));
                      }
                    },
                    d = o
                      ? p
                      : function () {
                          try {
                            p();
                          } catch (e) {
                            he.Deferred.exceptionHook &&
                              he.Deferred.exceptionHook(e, d.stackTrace),
                              s <= t + 1 &&
                                (i !== c && ((a = void 0), (u = [e])),
                                n.rejectWith(a, u));
                          }
                        };
                  t
                    ? d()
                    : (he.Deferred.getStackHook &&
                        (d.stackTrace = he.Deferred.getStackHook()),
                      e.setTimeout(d));
                };
              }
              var s = 0;
              return he
                .Deferred(function (e) {
                  n[0][3].add(r(0, e, ce(o) ? o : l, e.notifyWith)),
                    n[1][3].add(r(0, e, ce(t) ? t : l)),
                    n[2][3].add(r(0, e, ce(i) ? i : c));
                })
                .promise();
            },
            promise: function (e) {
              return null != e ? he.extend(e, o) : o;
            },
          },
          r = {};
        return (
          he.each(n, function (e, t) {
            var s = t[2],
              a = t[5];
            (o[t[1]] = s.add),
              a &&
                s.add(
                  function () {
                    i = a;
                  },
                  n[3 - e][2].disable,
                  n[3 - e][3].disable,
                  n[0][2].lock,
                  n[0][3].lock
                ),
              s.add(t[3].fire),
              (r[t[0]] = function () {
                return (
                  r[t[0] + "With"](this === r ? void 0 : this, arguments), this
                );
              }),
              (r[t[0] + "With"] = s.fireWith);
          }),
          o.promise(r),
          t && t.call(r, r),
          r
        );
      },
      when: function (e) {
        var t = arguments.length,
          n = t,
          i = Array(n),
          o = Q.call(arguments),
          r = he.Deferred(),
          s = function (e) {
            return function (n) {
              (i[e] = this),
                (o[e] = 1 < arguments.length ? Q.call(arguments) : n),
                --t || r.resolveWith(i, o);
            };
          };
        if (
          t <= 1 &&
          (u(e, r.done(s(n)).resolve, r.reject, !t),
          "pending" === r.state() || ce(o[n] && o[n].then))
        )
          return r.then();
        for (; n--; ) u(o[n], s(n), r.reject);
        return r.promise();
      },
    });
  var Te = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (he.Deferred.exceptionHook = function (t, n) {
    e.console &&
      e.console.warn &&
      t &&
      Te.test(t.name) &&
      e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
  }),
    (he.readyException = function (t) {
      e.setTimeout(function () {
        throw t;
      });
    });
  var Ee = he.Deferred();
  (he.fn.ready = function (e) {
    return (
      Ee.then(e).catch(function (e) {
        he.readyException(e);
      }),
      this
    );
  }),
    he.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --he.readyWait : he.isReady) ||
          ((he.isReady = !0) !== e && 0 < --he.readyWait) ||
          Ee.resolveWith(pe, [he]);
      },
    }),
    (he.ready.then = Ee.then),
    "complete" === pe.readyState ||
    ("loading" !== pe.readyState && !pe.documentElement.doScroll)
      ? e.setTimeout(he.ready)
      : (pe.addEventListener("DOMContentLoaded", p),
        e.addEventListener("load", p));
  var Ae = function (e, t, n, o, r, s, a) {
      var l = 0,
        c = e.length,
        u = null == n;
      if ("object" === i(n))
        for (l in ((r = !0), n)) Ae(e, t, l, n[l], !0, s, a);
      else if (
        void 0 !== o &&
        ((r = !0),
        ce(o) || (a = !0),
        u &&
          (a
            ? (t.call(e, o), (t = null))
            : ((u = t),
              (t = function (e, t, n) {
                return u.call(he(e), n);
              }))),
        t)
      )
        for (; l < c; l++) t(e[l], n, a ? o : o.call(e[l], l, t(e[l], n)));
      return r ? e : u ? t.call(e) : c ? t(e[0], n) : s;
    },
    Pe = /^-ms-/,
    _e = /-([a-z])/g,
    Oe = function (e) {
      return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
  (h.uid = 1),
    (h.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Oe(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var i,
          o = this.cache(e);
        if ("string" == typeof t) o[f(t)] = n;
        else for (i in t) o[f(i)] = t[i];
        return o;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][f(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          i = e[this.expando];
        if (void 0 !== i) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(f)
              : (t = f(t)) in i
              ? [t]
              : t.match(Ce) || []).length;
            for (; n--; ) delete i[t[n]];
          }
          (void 0 === t || he.isEmptyObject(i)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !he.isEmptyObject(t);
      },
    });
  var $e = new h(),
    Ie = new h(),
    Le = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    Ne = /[A-Z]/g;
  he.extend({
    hasData: function (e) {
      return Ie.hasData(e) || $e.hasData(e);
    },
    data: function (e, t, n) {
      return Ie.access(e, t, n);
    },
    removeData: function (e, t) {
      Ie.remove(e, t);
    },
    _data: function (e, t, n) {
      return $e.access(e, t, n);
    },
    _removeData: function (e, t) {
      $e.remove(e, t);
    },
  }),
    he.fn.extend({
      data: function (e, t) {
        var n,
          i,
          o,
          r = this[0],
          s = r && r.attributes;
        if (void 0 === e) {
          if (
            this.length &&
            ((o = Ie.get(r)), 1 === r.nodeType && !$e.get(r, "hasDataAttrs"))
          ) {
            for (n = s.length; n--; )
              s[n] &&
                0 === (i = s[n].name).indexOf("data-") &&
                ((i = f(i.slice(5))), m(r, i, o[i]));
            $e.set(r, "hasDataAttrs", !0);
          }
          return o;
        }
        return "object" == typeof e
          ? this.each(function () {
              Ie.set(this, e);
            })
          : Ae(
              this,
              function (t) {
                var n;
                return r && void 0 === t
                  ? void 0 !== (n = Ie.get(r, e))
                    ? n
                    : void 0 !== (n = m(r, e))
                    ? n
                    : void 0
                  : void this.each(function () {
                      Ie.set(this, e, t);
                    });
              },
              null,
              t,
              1 < arguments.length,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          Ie.remove(this, e);
        });
      },
    }),
    he.extend({
      queue: function (e, t, n) {
        var i;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (i = $e.get(e, t)),
            n &&
              (!i || Array.isArray(n)
                ? (i = $e.access(e, t, he.makeArray(n)))
                : i.push(n)),
            i || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = he.queue(e, t),
          i = n.length,
          o = n.shift(),
          r = he._queueHooks(e, t);
        "inprogress" === o && ((o = n.shift()), i--),
          o &&
            ("fx" === t && n.unshift("inprogress"),
            delete r.stop,
            o.call(
              e,
              function () {
                he.dequeue(e, t);
              },
              r
            )),
          !i && r && r.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks";
        return (
          $e.get(e, n) ||
          $e.access(e, n, {
            empty: he.Callbacks("once memory").add(function () {
              $e.remove(e, [t + "queue", n]);
            }),
          })
        );
      },
    }),
    he.fn.extend({
      queue: function (e, t) {
        var n = 2;
        return (
          "string" != typeof e && ((t = e), (e = "fx"), n--),
          arguments.length < n
            ? he.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var n = he.queue(this, e, t);
                he._queueHooks(this, e),
                  "fx" === e && "inprogress" !== n[0] && he.dequeue(this, e);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          he.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        var n,
          i = 1,
          o = he.Deferred(),
          r = this,
          s = this.length,
          a = function () {
            --i || o.resolveWith(r, [r]);
          };
        for (
          "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
          s--;

        )
          (n = $e.get(r[s], e + "queueHooks")) &&
            n.empty &&
            (i++, n.empty.add(a));
        return a(), o.promise(t);
      },
    });
  var De = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    Me = new RegExp("^(?:([+-])=|)(" + De + ")([a-z%]*)$", "i"),
    ze = ["Top", "Right", "Bottom", "Left"],
    je = pe.documentElement,
    He = function (e) {
      return he.contains(e.ownerDocument, e);
    },
    Re = { composed: !0 };
  je.getRootNode &&
    (He = function (e) {
      return (
        he.contains(e.ownerDocument, e) || e.getRootNode(Re) === e.ownerDocument
      );
    });
  var Fe = function (e, t) {
      return (
        "none" === (e = t || e).style.display ||
        ("" === e.style.display && He(e) && "none" === he.css(e, "display"))
      );
    },
    qe = {};
  he.fn.extend({
    show: function () {
      return g(this, !0);
    },
    hide: function () {
      return g(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            Fe(this) ? he(this).show() : he(this).hide();
          });
    },
  });
  var Be,
    We,
    Ue = /^(?:checkbox|radio)$/i,
    Ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    Ze = /^$|^module$|\/(?:java|ecma)script/i;
  (Be = pe.createDocumentFragment().appendChild(pe.createElement("div"))),
    (We = pe.createElement("input")).setAttribute("type", "radio"),
    We.setAttribute("checked", "checked"),
    We.setAttribute("name", "t"),
    Be.appendChild(We),
    (le.checkClone = Be.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (Be.innerHTML = "<textarea>x</textarea>"),
    (le.noCloneChecked = !!Be.cloneNode(!0).lastChild.defaultValue),
    (Be.innerHTML = "<option></option>"),
    (le.option = !!Be.lastChild);
  var Ke = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""],
  };
  (Ke.tbody = Ke.tfoot = Ke.colgroup = Ke.caption = Ke.thead),
    (Ke.th = Ke.td),
    le.option ||
      (Ke.optgroup = Ke.option =
        [1, "<select multiple='multiple'>", "</select>"]);
  var Xe = /<|&#?\w+;/,
    Ye = /^key/,
    Ge = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Je = /^([^.]*)(?:\.(.+)|)/;
  (he.event = {
    global: {},
    add: function (e, t, n, i, o) {
      var r,
        s,
        a,
        l,
        c,
        u,
        p,
        d,
        f,
        h,
        m,
        v = $e.get(e);
      if (Oe(e))
        for (
          n.handler && ((n = (r = n).handler), (o = r.selector)),
            o && he.find.matchesSelector(je, o),
            n.guid || (n.guid = he.guid++),
            (l = v.events) || (l = v.events = Object.create(null)),
            (s = v.handle) ||
              (s = v.handle =
                function (t) {
                  return "undefined" != typeof he &&
                    he.event.triggered !== t.type
                    ? he.event.dispatch.apply(e, arguments)
                    : void 0;
                }),
            c = (t = (t || "").match(Ce) || [""]).length;
          c--;

        )
          (f = m = (a = Je.exec(t[c]) || [])[1]),
            (h = (a[2] || "").split(".").sort()),
            f &&
              ((p = he.event.special[f] || {}),
              (f = (o ? p.delegateType : p.bindType) || f),
              (p = he.event.special[f] || {}),
              (u = he.extend(
                {
                  type: f,
                  origType: m,
                  data: i,
                  handler: n,
                  guid: n.guid,
                  selector: o,
                  needsContext: o && he.expr.match.needsContext.test(o),
                  namespace: h.join("."),
                },
                r
              )),
              (d = l[f]) ||
                (((d = l[f] = []).delegateCount = 0),
                (p.setup && !1 !== p.setup.call(e, i, h, s)) ||
                  (e.addEventListener && e.addEventListener(f, s))),
              p.add &&
                (p.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)),
              o ? d.splice(d.delegateCount++, 0, u) : d.push(u),
              (he.event.global[f] = !0));
    },
    remove: function (e, t, n, i, o) {
      var r,
        s,
        a,
        l,
        c,
        u,
        p,
        d,
        f,
        h,
        m,
        v = $e.hasData(e) && $e.get(e);
      if (v && (l = v.events)) {
        for (c = (t = (t || "").match(Ce) || [""]).length; c--; )
          if (
            ((f = m = (a = Je.exec(t[c]) || [])[1]),
            (h = (a[2] || "").split(".").sort()),
            f)
          ) {
            for (
              p = he.event.special[f] || {},
                d = l[(f = (i ? p.delegateType : p.bindType) || f)] || [],
                a =
                  a[2] &&
                  new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                s = r = d.length;
              r--;

            )
              (u = d[r]),
                (!o && m !== u.origType) ||
                  (n && n.guid !== u.guid) ||
                  (a && !a.test(u.namespace)) ||
                  (i && i !== u.selector && ("**" !== i || !u.selector)) ||
                  (d.splice(r, 1),
                  u.selector && d.delegateCount--,
                  p.remove && p.remove.call(e, u));
            s &&
              !d.length &&
              ((p.teardown && !1 !== p.teardown.call(e, h, v.handle)) ||
                he.removeEvent(e, f, v.handle),
              delete l[f]);
          } else for (f in l) he.event.remove(e, f + t[c], n, i, !0);
        he.isEmptyObject(l) && $e.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t,
        n,
        i,
        o,
        r,
        s,
        a = new Array(arguments.length),
        l = he.event.fix(e),
        c = ($e.get(this, "events") || Object.create(null))[l.type] || [],
        u = he.event.special[l.type] || {};
      for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
      if (
        ((l.delegateTarget = this),
        !u.preDispatch || !1 !== u.preDispatch.call(this, l))
      ) {
        for (
          s = he.event.handlers.call(this, l, c), t = 0;
          (o = s[t++]) && !l.isPropagationStopped();

        )
          for (
            l.currentTarget = o.elem, n = 0;
            (r = o.handlers[n++]) && !l.isImmediatePropagationStopped();

          )
            (l.rnamespace &&
              !1 !== r.namespace &&
              !l.rnamespace.test(r.namespace)) ||
              ((l.handleObj = r),
              (l.data = r.data),
              void 0 !==
                (i = (
                  (he.event.special[r.origType] || {}).handle || r.handler
                ).apply(o.elem, a)) &&
                !1 === (l.result = i) &&
                (l.preventDefault(), l.stopPropagation()));
        return u.postDispatch && u.postDispatch.call(this, l), l.result;
      }
    },
    handlers: function (e, t) {
      var n,
        i,
        o,
        r,
        s,
        a = [],
        l = t.delegateCount,
        c = e.target;
      if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
        for (; c !== this; c = c.parentNode || this)
          if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
            for (r = [], s = {}, n = 0; n < l; n++)
              void 0 === s[(o = (i = t[n]).selector + " ")] &&
                (s[o] = i.needsContext
                  ? -1 < he(o, this).index(c)
                  : he.find(o, this, null, [c]).length),
                s[o] && r.push(i);
            r.length && a.push({ elem: c, handlers: r });
          }
      return (
        (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a
      );
    },
    addProp: function (e, t) {
      Object.defineProperty(he.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: ce(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function (t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t,
          });
        },
      });
    },
    fix: function (e) {
      return e[he.expando] ? e : new he.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      click: {
        setup: function (e) {
          var t = this || e;
          return (
            Ue.test(t.type) && t.click && r(t, "input") && T(t, "click", x), !1
          );
        },
        trigger: function (e) {
          var t = this || e;
          return (
            Ue.test(t.type) && t.click && r(t, "input") && T(t, "click"), !0
          );
        },
        _default: function (e) {
          var t = e.target;
          return (
            (Ue.test(t.type) &&
              t.click &&
              r(t, "input") &&
              $e.get(t, "click")) ||
            r(t, "a")
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (he.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (he.Event = function (e, t) {
      return this instanceof he.Event
        ? (e && e.type
            ? ((this.originalEvent = e),
              (this.type = e.type),
              (this.isDefaultPrevented =
                e.defaultPrevented ||
                (void 0 === e.defaultPrevented && !1 === e.returnValue)
                  ? x
                  : k),
              (this.target =
                e.target && 3 === e.target.nodeType
                  ? e.target.parentNode
                  : e.target),
              (this.currentTarget = e.currentTarget),
              (this.relatedTarget = e.relatedTarget))
            : (this.type = e),
          t && he.extend(this, t),
          (this.timeStamp = (e && e.timeStamp) || Date.now()),
          (this[he.expando] = !0),
          void 0)
        : new he.Event(e, t);
    }),
    (he.Event.prototype = {
      constructor: he.Event,
      isDefaultPrevented: k,
      isPropagationStopped: k,
      isImmediatePropagationStopped: k,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = x),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = x),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = x),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    he.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && Ye.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && Ge.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      he.event.addProp
    ),
    he.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
      he.event.special[e] = {
        setup: function () {
          return T(this, e, S), !1;
        },
        trigger: function () {
          return T(this, e), !0;
        },
        delegateType: t,
      };
    }),
    he.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, t) {
        he.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var n,
              i = e.relatedTarget,
              o = e.handleObj;
            return (
              (i && (i === this || he.contains(this, i))) ||
                ((e.type = o.origType),
                (n = o.handler.apply(this, arguments)),
                (e.type = t)),
              n
            );
          },
        };
      }
    ),
    he.fn.extend({
      on: function (e, t, n, i) {
        return C(this, e, t, n, i);
      },
      one: function (e, t, n, i) {
        return C(this, e, t, n, i, 1);
      },
      off: function (e, t, n) {
        var i, o;
        if (e && e.preventDefault && e.handleObj)
          return (
            (i = e.handleObj),
            he(e.delegateTarget).off(
              i.namespace ? i.origType + "." + i.namespace : i.origType,
              i.selector,
              i.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (o in e) this.off(o, t, e[o]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = k),
          this.each(function () {
            he.event.remove(this, e, n, t);
          })
        );
      },
    });
  var Qe = /<script|<style|<link/i,
    et = /checked\s*(?:[^=]|=\s*.checked.)/i,
    tt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  he.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, n) {
      var i,
        o,
        r,
        s,
        a,
        l,
        c,
        u = e.cloneNode(!0),
        p = He(e);
      if (
        !(
          le.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          he.isXMLDoc(e)
        )
      )
        for (s = y(u), i = 0, o = (r = y(e)).length; i < o; i++)
          (a = r[i]),
            (l = s[i]),
            "input" === (c = l.nodeName.toLowerCase()) && Ue.test(a.type)
              ? (l.checked = a.checked)
              : ("input" !== c && "textarea" !== c) ||
                (l.defaultValue = a.defaultValue);
      if (t)
        if (n)
          for (r = r || y(e), s = s || y(u), i = 0, o = r.length; i < o; i++)
            _(r[i], s[i]);
        else _(e, u);
      return 0 < (s = y(u, "script")).length && b(s, !p && y(e, "script")), u;
    },
    cleanData: function (e) {
      for (var t, n, i, o = he.event.special, r = 0; void 0 !== (n = e[r]); r++)
        if (Oe(n)) {
          if ((t = n[$e.expando])) {
            if (t.events)
              for (i in t.events)
                o[i] ? he.event.remove(n, i) : he.removeEvent(n, i, t.handle);
            n[$e.expando] = void 0;
          }
          n[Ie.expando] && (n[Ie.expando] = void 0);
        }
    },
  }),
    he.fn.extend({
      detach: function (e) {
        return $(this, e, !0);
      },
      remove: function (e) {
        return $(this, e);
      },
      text: function (e) {
        return Ae(
          this,
          function (e) {
            return void 0 === e
              ? he.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return O(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            E(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return O(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = E(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return O(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return O(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (he.cleanData(y(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return he.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return Ae(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              i = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !Qe.test(e) &&
              !Ke[(Ve.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = he.htmlPrefilter(e);
              try {
                for (; n < i; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (he.cleanData(y(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var e = [];
        return O(
          this,
          arguments,
          function (t) {
            var n = this.parentNode;
            he.inArray(this, e) < 0 &&
              (he.cleanData(y(this)), n && n.replaceChild(t, this));
          },
          e
        );
      },
    }),
    he.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, t) {
        he.fn[e] = function (e) {
          for (var n, i = [], o = he(e), r = o.length - 1, s = 0; s <= r; s++)
            (n = s === r ? this : this.clone(!0)),
              he(o[s])[t](n),
              te.apply(i, n.get());
          return this.pushStack(i);
        };
      }
    );
  var nt = new RegExp("^(" + De + ")(?!px)[a-z%]+$", "i"),
    it = function (t) {
      var n = t.ownerDocument.defaultView;
      return (n && n.opener) || (n = e), n.getComputedStyle(t);
    },
    ot = function (e, t, n) {
      var i,
        o,
        r = {};
      for (o in t) (r[o] = e.style[o]), (e.style[o] = t[o]);
      for (o in ((i = n.call(e)), t)) e.style[o] = r[o];
      return i;
    },
    rt = new RegExp(ze.join("|"), "i");
  !(function () {
    function t() {
      if (u) {
        (c.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (u.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          je.appendChild(c).appendChild(u);
        var t = e.getComputedStyle(u);
        (i = "1%" !== t.top),
          (l = 12 === n(t.marginLeft)),
          (u.style.right = "60%"),
          (s = 36 === n(t.right)),
          (o = 36 === n(t.width)),
          (u.style.position = "absolute"),
          (r = 12 === n(u.offsetWidth / 3)),
          je.removeChild(c),
          (u = null);
      }
    }
    function n(e) {
      return Math.round(parseFloat(e));
    }
    var i,
      o,
      r,
      s,
      a,
      l,
      c = pe.createElement("div"),
      u = pe.createElement("div");
    u.style &&
      ((u.style.backgroundClip = "content-box"),
      (u.cloneNode(!0).style.backgroundClip = ""),
      (le.clearCloneStyle = "content-box" === u.style.backgroundClip),
      he.extend(le, {
        boxSizingReliable: function () {
          return t(), o;
        },
        pixelBoxStyles: function () {
          return t(), s;
        },
        pixelPosition: function () {
          return t(), i;
        },
        reliableMarginLeft: function () {
          return t(), l;
        },
        scrollboxSize: function () {
          return t(), r;
        },
        reliableTrDimensions: function () {
          var t, n, i, o;
          return (
            null == a &&
              ((t = pe.createElement("table")),
              (n = pe.createElement("tr")),
              (i = pe.createElement("div")),
              (t.style.cssText = "position:absolute;left:-11111px"),
              (n.style.height = "1px"),
              (i.style.height = "9px"),
              je.appendChild(t).appendChild(n).appendChild(i),
              (o = e.getComputedStyle(n)),
              (a = 3 < parseInt(o.height)),
              je.removeChild(t)),
            a
          );
        },
      }));
  })();
  var st = ["Webkit", "Moz", "ms"],
    at = pe.createElement("div").style,
    lt = {},
    ct = /^(none|table(?!-c[ea]).+)/,
    ut = /^--/,
    pt = { position: "absolute", visibility: "hidden", display: "block" },
    dt = { letterSpacing: "0", fontWeight: "400" };
  he.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = I(e, "opacity");
            return "" === n ? "1" : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, n, i) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var o,
          r,
          s,
          a = f(t),
          l = ut.test(t),
          c = e.style;
        if (
          (l || (t = N(a)),
          (s = he.cssHooks[t] || he.cssHooks[a]),
          void 0 === n)
        )
          return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : c[t];
        "string" == (r = typeof n) &&
          (o = Me.exec(n)) &&
          o[1] &&
          ((n = v(e, t, o)), (r = "number")),
          null != n &&
            n == n &&
            ("number" !== r ||
              l ||
              (n += (o && o[3]) || (he.cssNumber[a] ? "" : "px")),
            le.clearCloneStyle ||
              "" !== n ||
              0 !== t.indexOf("background") ||
              (c[t] = "inherit"),
            (s && "set" in s && void 0 === (n = s.set(e, n, i))) ||
              (l ? c.setProperty(t, n) : (c[t] = n)));
      }
    },
    css: function (e, t, n, i) {
      var o,
        r,
        s,
        a = f(t);
      return (
        ut.test(t) || (t = N(a)),
        (s = he.cssHooks[t] || he.cssHooks[a]) &&
          "get" in s &&
          (o = s.get(e, !0, n)),
        void 0 === o && (o = I(e, t, i)),
        "normal" === o && t in dt && (o = dt[t]),
        "" === n || n
          ? ((r = parseFloat(o)), !0 === n || isFinite(r) ? r || 0 : o)
          : o
      );
    },
  }),
    he.each(["height", "width"], function (e, t) {
      he.cssHooks[t] = {
        get: function (e, n, i) {
          if (n)
            return !ct.test(he.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? z(e, t, i)
              : ot(e, pt, function () {
                  return z(e, t, i);
                });
        },
        set: function (e, n, i) {
          var o,
            r = it(e),
            s = !le.scrollboxSize() && "absolute" === r.position,
            a = (s || i) && "border-box" === he.css(e, "boxSizing", !1, r),
            l = i ? M(e, t, i, a, r) : 0;
          return (
            a &&
              s &&
              (l -= Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(r[t]) -
                  M(e, t, "border", !1, r) -
                  0.5
              )),
            l &&
              (o = Me.exec(n)) &&
              "px" !== (o[3] || "px") &&
              ((e.style[t] = n), (n = he.css(e, t))),
            D(0, n, l)
          );
        },
      };
    }),
    (he.cssHooks.marginLeft = L(le.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(I(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              ot(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    he.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
      (he.cssHooks[e + t] = {
        expand: function (n) {
          for (
            var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n];
            i < 4;
            i++
          )
            o[e + ze[i] + t] = r[i] || r[i - 2] || r[0];
          return o;
        },
      }),
        "margin" !== e && (he.cssHooks[e + t].set = D);
    }),
    he.fn.extend({
      css: function (e, t) {
        return Ae(
          this,
          function (e, t, n) {
            var i,
              o,
              r = {},
              s = 0;
            if (Array.isArray(t)) {
              for (i = it(e), o = t.length; s < o; s++)
                r[t[s]] = he.css(e, t[s], !1, i);
              return r;
            }
            return void 0 !== n ? he.style(e, t, n) : he.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((he.Tween = j).prototype = {
      constructor: j,
      init: function (e, t, n, i, o, r) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = o || he.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = i),
          (this.unit = r || (he.cssNumber[n] ? "" : "px"));
      },
      cur: function () {
        var e = j.propHooks[this.prop];
        return e && e.get ? e.get(this) : j.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = j.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                he.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : j.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = j.prototype),
    ((j.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = he.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          he.fx.step[e.prop]
            ? he.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (!he.cssHooks[e.prop] && null == e.elem.style[N(e.prop)])
            ? (e.elem[e.prop] = e.now)
            : he.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = j.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (he.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (he.fx = j.prototype.init),
    (he.fx.step = {});
  var ft,
    ht,
    mt,
    vt,
    gt = /^(?:toggle|show|hide)$/,
    yt = /queueHooks$/;
  (he.Animation = he.extend(B, {
    tweeners: {
      "*": [
        function (e, t) {
          var n = this.createTween(e, t);
          return v(n.elem, e, Me.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      ce(e) ? ((t = e), (e = ["*"])) : (e = e.match(Ce));
      for (var n, i = 0, o = e.length; i < o; i++)
        (n = e[i]),
          (B.tweeners[n] = B.tweeners[n] || []),
          B.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var i,
          o,
          r,
          s,
          a,
          l,
          c,
          u,
          p = "width" in t || "height" in t,
          d = this,
          f = {},
          h = e.style,
          m = e.nodeType && Fe(e),
          v = $e.get(e, "fxshow");
        for (i in (n.queue ||
          (null == (s = he._queueHooks(e, "fx")).unqueued &&
            ((s.unqueued = 0),
            (a = s.empty.fire),
            (s.empty.fire = function () {
              s.unqueued || a();
            })),
          s.unqueued++,
          d.always(function () {
            d.always(function () {
              s.unqueued--, he.queue(e, "fx").length || s.empty.fire();
            });
          })),
        t))
          if (((o = t[i]), gt.test(o))) {
            if (
              (delete t[i],
              (r = r || "toggle" === o),
              o === (m ? "hide" : "show"))
            ) {
              if ("show" !== o || !v || void 0 === v[i]) continue;
              m = !0;
            }
            f[i] = (v && v[i]) || he.style(e, i);
          }
        if ((l = !he.isEmptyObject(t)) || !he.isEmptyObject(f))
          for (i in (p &&
            1 === e.nodeType &&
            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
            null == (c = v && v.display) && (c = $e.get(e, "display")),
            "none" === (u = he.css(e, "display")) &&
              (c
                ? (u = c)
                : (g([e], !0),
                  (c = e.style.display || c),
                  (u = he.css(e, "display")),
                  g([e]))),
            ("inline" === u || ("inline-block" === u && null != c)) &&
              "none" === he.css(e, "float") &&
              (l ||
                (d.done(function () {
                  h.display = c;
                }),
                null == c && ((u = h.display), (c = "none" === u ? "" : u))),
              (h.display = "inline-block"))),
          n.overflow &&
            ((h.overflow = "hidden"),
            d.always(function () {
              (h.overflow = n.overflow[0]),
                (h.overflowX = n.overflow[1]),
                (h.overflowY = n.overflow[2]);
            })),
          (l = !1),
          f))
            l ||
              (v
                ? "hidden" in v && (m = v.hidden)
                : (v = $e.access(e, "fxshow", { display: c })),
              r && (v.hidden = !m),
              m && g([e], !0),
              d.done(function () {
                for (i in (m || g([e]), $e.remove(e, "fxshow"), f))
                  he.style(e, i, f[i]);
              })),
              (l = q(m ? v[i] : 0, i, d)),
              i in v ||
                ((v[i] = l.start), m && ((l.end = l.start), (l.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? B.prefilters.unshift(e) : B.prefilters.push(e);
    },
  })),
    (he.speed = function (e, t, n) {
      var i =
        e && "object" == typeof e
          ? he.extend({}, e)
          : {
              complete: n || (!n && t) || (ce(e) && e),
              duration: e,
              easing: (n && t) || (t && !ce(t) && t),
            };
      return (
        he.fx.off
          ? (i.duration = 0)
          : "number" != typeof i.duration &&
            (i.duration in he.fx.speeds
              ? (i.duration = he.fx.speeds[i.duration])
              : (i.duration = he.fx.speeds._default)),
        (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
        (i.old = i.complete),
        (i.complete = function () {
          ce(i.old) && i.old.call(this), i.queue && he.dequeue(this, i.queue);
        }),
        i
      );
    }),
    he.fn.extend({
      fadeTo: function (e, t, n, i) {
        return this.filter(Fe)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, i);
      },
      animate: function (e, t, n, i) {
        var o = he.isEmptyObject(e),
          r = he.speed(t, n, i),
          s = function () {
            var t = B(this, he.extend({}, e), r);
            (o || $e.get(this, "finish")) && t.stop(!0);
          };
        return (
          (s.finish = s),
          o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
        );
      },
      stop: function (e, t, n) {
        var i = function (e) {
          var t = e.stop;
          delete e.stop, t(n);
        };
        return (
          "string" != typeof e && ((n = t), (t = e), (e = void 0)),
          t && this.queue(e || "fx", []),
          this.each(function () {
            var t = !0,
              o = null != e && e + "queueHooks",
              r = he.timers,
              s = $e.get(this);
            if (o) s[o] && s[o].stop && i(s[o]);
            else for (o in s) s[o] && s[o].stop && yt.test(o) && i(s[o]);
            for (o = r.length; o--; )
              r[o].elem !== this ||
                (null != e && r[o].queue !== e) ||
                (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
            (!t && n) || he.dequeue(this, e);
          })
        );
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || "fx"),
          this.each(function () {
            var t,
              n = $e.get(this),
              i = n[e + "queue"],
              o = n[e + "queueHooks"],
              r = he.timers,
              s = i ? i.length : 0;
            for (
              n.finish = !0,
                he.queue(this, e, []),
                o && o.stop && o.stop.call(this, !0),
                t = r.length;
              t--;

            )
              r[t].elem === this &&
                r[t].queue === e &&
                (r[t].anim.stop(!0), r.splice(t, 1));
            for (t = 0; t < s; t++)
              i[t] && i[t].finish && i[t].finish.call(this);
            delete n.finish;
          })
        );
      },
    }),
    he.each(["toggle", "show", "hide"], function (e, t) {
      var n = he.fn[t];
      he.fn[t] = function (e, i, o) {
        return null == e || "boolean" == typeof e
          ? n.apply(this, arguments)
          : this.animate(F(t, !0), e, i, o);
      };
    }),
    he.each(
      {
        slideDown: F("show"),
        slideUp: F("hide"),
        slideToggle: F("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, t) {
        he.fn[e] = function (e, n, i) {
          return this.animate(t, e, n, i);
        };
      }
    ),
    (he.timers = []),
    (he.fx.tick = function () {
      var e,
        t = 0,
        n = he.timers;
      for (ft = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || he.fx.stop(), (ft = void 0);
    }),
    (he.fx.timer = function (e) {
      he.timers.push(e), he.fx.start();
    }),
    (he.fx.interval = 13),
    (he.fx.start = function () {
      ht || ((ht = !0), H());
    }),
    (he.fx.stop = function () {
      ht = null;
    }),
    (he.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (he.fn.delay = function (t, n) {
      return (
        (t = (he.fx && he.fx.speeds[t]) || t),
        (n = n || "fx"),
        this.queue(n, function (n, i) {
          var o = e.setTimeout(n, t);
          i.stop = function () {
            e.clearTimeout(o);
          };
        })
      );
    }),
    (mt = pe.createElement("input")),
    (vt = pe.createElement("select").appendChild(pe.createElement("option"))),
    (mt.type = "checkbox"),
    (le.checkOn = "" !== mt.value),
    (le.optSelected = vt.selected),
    ((mt = pe.createElement("input")).value = "t"),
    (mt.type = "radio"),
    (le.radioValue = "t" === mt.value);
  var bt,
    wt = he.expr.attrHandle;
  he.fn.extend({
    attr: function (e, t) {
      return Ae(this, he.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        he.removeAttr(this, e);
      });
    },
  }),
    he.extend({
      attr: function (e, t, n) {
        var i,
          o,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return "undefined" == typeof e.getAttribute
            ? he.prop(e, t, n)
            : ((1 === r && he.isXMLDoc(e)) ||
                (o =
                  he.attrHooks[t.toLowerCase()] ||
                  (he.expr.match.bool.test(t) ? bt : void 0)),
              void 0 !== n
                ? null === n
                  ? void he.removeAttr(e, t)
                  : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                  ? i
                  : (e.setAttribute(t, n + ""), n)
                : o && "get" in o && null !== (i = o.get(e, t))
                ? i
                : null == (i = he.find.attr(e, t))
                ? void 0
                : i);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!le.radioValue && "radio" === t && r(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          i = 0,
          o = t && t.match(Ce);
        if (o && 1 === e.nodeType) for (; (n = o[i++]); ) e.removeAttribute(n);
      },
    }),
    (bt = {
      set: function (e, t, n) {
        return !1 === t ? he.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    he.each(he.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = wt[t] || he.find.attr;
      wt[t] = function (e, t, i) {
        var o,
          r,
          s = t.toLowerCase();
        return (
          i ||
            ((r = wt[s]),
            (wt[s] = o),
            (o = null != n(e, t, i) ? s : null),
            (wt[s] = r)),
          o
        );
      };
    });
  var xt = /^(?:input|select|textarea|button)$/i,
    kt = /^(?:a|area)$/i;
  he.fn.extend({
    prop: function (e, t) {
      return Ae(this, he.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[he.propFix[e] || e];
      });
    },
  }),
    he.extend({
      prop: function (e, t, n) {
        var i,
          o,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return (
            (1 === r && he.isXMLDoc(e)) ||
              ((t = he.propFix[t] || t), (o = he.propHooks[t])),
            void 0 !== n
              ? o && "set" in o && void 0 !== (i = o.set(e, n, t))
                ? i
                : (e[t] = n)
              : o && "get" in o && null !== (i = o.get(e, t))
              ? i
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = he.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : xt.test(e.nodeName) || (kt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    le.optSelected ||
      (he.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    he.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        he.propFix[this.toLowerCase()] = this;
      }
    ),
    he.fn.extend({
      addClass: function (e) {
        var t,
          n,
          i,
          o,
          r,
          s,
          a,
          l = 0;
        if (ce(e))
          return this.each(function (t) {
            he(this).addClass(e.call(this, t, U(this)));
          });
        if ((t = V(e)).length)
          for (; (n = this[l++]); )
            if (((o = U(n)), (i = 1 === n.nodeType && " " + W(o) + " "))) {
              for (s = 0; (r = t[s++]); )
                i.indexOf(" " + r + " ") < 0 && (i += r + " ");
              o !== (a = W(i)) && n.setAttribute("class", a);
            }
        return this;
      },
      removeClass: function (e) {
        var t,
          n,
          i,
          o,
          r,
          s,
          a,
          l = 0;
        if (ce(e))
          return this.each(function (t) {
            he(this).removeClass(e.call(this, t, U(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ((t = V(e)).length)
          for (; (n = this[l++]); )
            if (((o = U(n)), (i = 1 === n.nodeType && " " + W(o) + " "))) {
              for (s = 0; (r = t[s++]); )
                for (; -1 < i.indexOf(" " + r + " "); )
                  i = i.replace(" " + r + " ", " ");
              o !== (a = W(i)) && n.setAttribute("class", a);
            }
        return this;
      },
      toggleClass: function (e, t) {
        var n = typeof e,
          i = "string" === n || Array.isArray(e);
        return "boolean" == typeof t && i
          ? t
            ? this.addClass(e)
            : this.removeClass(e)
          : ce(e)
          ? this.each(function (n) {
              he(this).toggleClass(e.call(this, n, U(this), t), t);
            })
          : this.each(function () {
              var t, o, r, s;
              if (i)
                for (o = 0, r = he(this), s = V(e); (t = s[o++]); )
                  r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
              else
                (void 0 !== e && "boolean" !== n) ||
                  ((t = U(this)) && $e.set(this, "__className__", t),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      t || !1 === e ? "" : $e.get(this, "__className__") || ""
                    ));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          i = 0;
        for (t = " " + e + " "; (n = this[i++]); )
          if (1 === n.nodeType && -1 < (" " + W(U(n)) + " ").indexOf(t))
            return !0;
        return !1;
      },
    });
  var St = /\r/g;
  he.fn.extend({
    val: function (e) {
      var t,
        n,
        i,
        o = this[0];
      return arguments.length
        ? ((i = ce(e)),
          this.each(function (n) {
            var o;
            1 === this.nodeType &&
              (null == (o = i ? e.call(this, n, he(this).val()) : e)
                ? (o = "")
                : "number" == typeof o
                ? (o += "")
                : Array.isArray(o) &&
                  (o = he.map(o, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((t =
                he.valHooks[this.type] ||
                he.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in t &&
                void 0 !== t.set(this, o, "value")) ||
                (this.value = o));
          }))
        : o
        ? (t = he.valHooks[o.type] || he.valHooks[o.nodeName.toLowerCase()]) &&
          "get" in t &&
          void 0 !== (n = t.get(o, "value"))
          ? n
          : "string" == typeof (n = o.value)
          ? n.replace(St, "")
          : null == n
          ? ""
          : n
        : void 0;
    },
  }),
    he.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = he.find.attr(e, "value");
            return null != t ? t : W(he.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              n,
              i,
              o = e.options,
              s = e.selectedIndex,
              a = "select-one" === e.type,
              l = a ? null : [],
              c = a ? s + 1 : o.length;
            for (i = s < 0 ? c : a ? s : 0; i < c; i++)
              if (
                ((n = o[i]).selected || i === s) &&
                !n.disabled &&
                (!n.parentNode.disabled || !r(n.parentNode, "optgroup"))
              ) {
                if (((t = he(n).val()), a)) return t;
                l.push(t);
              }
            return l;
          },
          set: function (e, t) {
            for (
              var n, i, o = e.options, r = he.makeArray(t), s = o.length;
              s--;

            )
              ((i = o[s]).selected =
                -1 < he.inArray(he.valHooks.option.get(i), r)) && (n = !0);
            return n || (e.selectedIndex = -1), r;
          },
        },
      },
    }),
    he.each(["radio", "checkbox"], function () {
      (he.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < he.inArray(he(e).val(), t));
        },
      }),
        le.checkOn ||
          (he.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (le.focusin = "onfocusin" in e);
  var Ct = /^(?:focusinfocus|focusoutblur)$/,
    Tt = function (e) {
      e.stopPropagation();
    };
  he.extend(he.event, {
    trigger: function (t, n, i, o) {
      var r,
        s,
        a,
        l,
        c,
        u,
        p,
        d,
        f = [i || pe],
        h = re.call(t, "type") ? t.type : t,
        m = re.call(t, "namespace") ? t.namespace.split(".") : [];
      if (
        ((s = d = a = i = i || pe),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !Ct.test(h + he.event.triggered) &&
          (-1 < h.indexOf(".") && ((h = (m = h.split(".")).shift()), m.sort()),
          (c = h.indexOf(":") < 0 && "on" + h),
          ((t = t[he.expando]
            ? t
            : new he.Event(h, "object" == typeof t && t)).isTrigger = o
            ? 2
            : 3),
          (t.namespace = m.join(".")),
          (t.rnamespace = t.namespace
            ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : he.makeArray(n, [t])),
          (p = he.event.special[h] || {}),
          o || !p.trigger || !1 !== p.trigger.apply(i, n)))
      ) {
        if (!o && !p.noBubble && !ue(i)) {
          for (
            l = p.delegateType || h, Ct.test(l + h) || (s = s.parentNode);
            s;
            s = s.parentNode
          )
            f.push(s), (a = s);
          a === (i.ownerDocument || pe) &&
            f.push(a.defaultView || a.parentWindow || e);
        }
        for (r = 0; (s = f[r++]) && !t.isPropagationStopped(); )
          (d = s),
            (t.type = 1 < r ? l : p.bindType || h),
            (u =
              ($e.get(s, "events") || Object.create(null))[t.type] &&
              $e.get(s, "handle")) && u.apply(s, n),
            (u = c && s[c]) &&
              u.apply &&
              Oe(s) &&
              ((t.result = u.apply(s, n)),
              !1 === t.result && t.preventDefault());
        return (
          (t.type = h),
          o ||
            t.isDefaultPrevented() ||
            (p._default && !1 !== p._default.apply(f.pop(), n)) ||
            !Oe(i) ||
            (c &&
              ce(i[h]) &&
              !ue(i) &&
              ((a = i[c]) && (i[c] = null),
              (he.event.triggered = h),
              t.isPropagationStopped() && d.addEventListener(h, Tt),
              i[h](),
              t.isPropagationStopped() && d.removeEventListener(h, Tt),
              (he.event.triggered = void 0),
              a && (i[c] = a))),
          t.result
        );
      }
    },
    simulate: function (e, t, n) {
      var i = he.extend(new he.Event(), n, { type: e, isSimulated: !0 });
      he.event.trigger(i, null, t);
    },
  }),
    he.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          he.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return he.event.trigger(e, t, n, !0);
      },
    }),
    le.focusin ||
      he.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        var n = function (e) {
          he.event.simulate(t, e.target, he.event.fix(e));
        };
        he.event.special[t] = {
          setup: function () {
            var i = this.ownerDocument || this.document || this,
              o = $e.access(i, t);
            o || i.addEventListener(e, n, !0), $e.access(i, t, (o || 0) + 1);
          },
          teardown: function () {
            var i = this.ownerDocument || this.document || this,
              o = $e.access(i, t) - 1;
            o
              ? $e.access(i, t, o)
              : (i.removeEventListener(e, n, !0), $e.remove(i, t));
          },
        };
      });
  var Et = e.location,
    At = { guid: Date.now() },
    Pt = /\?/;
  he.parseXML = function (t) {
    var n;
    if (!t || "string" != typeof t) return null;
    try {
      n = new e.DOMParser().parseFromString(t, "text/xml");
    } catch (e) {
      n = void 0;
    }
    return (
      (n && !n.getElementsByTagName("parsererror").length) ||
        he.error("Invalid XML: " + t),
      n
    );
  };
  var _t = /\[\]$/,
    Ot = /\r?\n/g,
    $t = /^(?:submit|button|image|reset|file)$/i,
    It = /^(?:input|select|textarea|keygen)/i;
  (he.param = function (e, t) {
    var n,
      i = [],
      o = function (e, t) {
        var n = ce(t) ? t() : t;
        i[i.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
      };
    if (null == e) return "";
    if (Array.isArray(e) || (e.jquery && !he.isPlainObject(e)))
      he.each(e, function () {
        o(this.name, this.value);
      });
    else for (n in e) Z(n, e[n], t, o);
    return i.join("&");
  }),
    he.fn.extend({
      serialize: function () {
        return he.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = he.prop(this, "elements");
          return e ? he.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !he(this).is(":disabled") &&
              It.test(this.nodeName) &&
              !$t.test(e) &&
              (this.checked || !Ue.test(e))
            );
          })
          .map(function (e, t) {
            var n = he(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? he.map(n, function (e) {
                  return { name: t.name, value: e.replace(Ot, "\r\n") };
                })
              : { name: t.name, value: n.replace(Ot, "\r\n") };
          })
          .get();
      },
    });
  var Lt = /%20/g,
    Nt = /#.*$/,
    Dt = /([?&])_=[^&]*/,
    Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    zt = /^(?:GET|HEAD)$/,
    jt = /^\/\//,
    Ht = {},
    Rt = {},
    Ft = "*/".concat("*"),
    qt = pe.createElement("a");
  (qt.href = Et.href),
    he.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Et.href,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            Et.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Ft,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": he.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? Y(Y(e, he.ajaxSettings), t) : Y(he.ajaxSettings, e);
      },
      ajaxPrefilter: K(Ht),
      ajaxTransport: K(Rt),
      ajax: function (t, n) {
        function i(t, n, i, a) {
          var c,
            d,
            f,
            w,
            x,
            k = n;
          u ||
            ((u = !0),
            l && e.clearTimeout(l),
            (o = void 0),
            (s = a || ""),
            (S.readyState = 0 < t ? 4 : 0),
            (c = (200 <= t && t < 300) || 304 === t),
            i &&
              (w = (function (e, t, n) {
                for (
                  var i, o, r, s, a = e.contents, l = e.dataTypes;
                  "*" === l[0];

                )
                  l.shift(),
                    void 0 === i &&
                      (i = e.mimeType || t.getResponseHeader("Content-Type"));
                if (i)
                  for (o in a)
                    if (a[o] && a[o].test(i)) {
                      l.unshift(o);
                      break;
                    }
                if (l[0] in n) r = l[0];
                else {
                  for (o in n) {
                    if (!l[0] || e.converters[o + " " + l[0]]) {
                      r = o;
                      break;
                    }
                    s || (s = o);
                  }
                  r = r || s;
                }
                if (r) return r !== l[0] && l.unshift(r), n[r];
              })(h, S, i)),
            !c &&
              -1 < he.inArray("script", h.dataTypes) &&
              (h.converters["text script"] = function () {}),
            (w = (function (e, t, n, i) {
              var o,
                r,
                s,
                a,
                l,
                c = {},
                u = e.dataTypes.slice();
              if (u[1])
                for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
              for (r = u.shift(); r; )
                if (
                  (e.responseFields[r] && (n[e.responseFields[r]] = t),
                  !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (l = r),
                  (r = u.shift()))
                )
                  if ("*" === r) r = l;
                  else if ("*" !== l && l !== r) {
                    if (!(s = c[l + " " + r] || c["* " + r]))
                      for (o in c)
                        if (
                          (a = o.split(" "))[1] === r &&
                          (s = c[l + " " + a[0]] || c["* " + a[0]])
                        ) {
                          !0 === s
                            ? (s = c[o])
                            : !0 !== c[o] && ((r = a[0]), u.unshift(a[1]));
                          break;
                        }
                    if (!0 !== s)
                      if (s && e.throws) t = s(t);
                      else
                        try {
                          t = s(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: s
                              ? e
                              : "No conversion from " + l + " to " + r,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(h, w, S, c)),
            c
              ? (h.ifModified &&
                  ((x = S.getResponseHeader("Last-Modified")) &&
                    (he.lastModified[r] = x),
                  (x = S.getResponseHeader("etag")) && (he.etag[r] = x)),
                204 === t || "HEAD" === h.type
                  ? (k = "nocontent")
                  : 304 === t
                  ? (k = "notmodified")
                  : ((k = w.state), (d = w.data), (c = !(f = w.error))))
              : ((f = k), (!t && k) || ((k = "error"), t < 0 && (t = 0))),
            (S.status = t),
            (S.statusText = (n || k) + ""),
            c ? g.resolveWith(m, [d, k, S]) : g.rejectWith(m, [S, k, f]),
            S.statusCode(b),
            (b = void 0),
            p && v.trigger(c ? "ajaxSuccess" : "ajaxError", [S, h, c ? d : f]),
            y.fireWith(m, [S, k]),
            p &&
              (v.trigger("ajaxComplete", [S, h]),
              --he.active || he.event.trigger("ajaxStop")));
        }
        "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
        var o,
          r,
          s,
          a,
          l,
          c,
          u,
          p,
          d,
          f,
          h = he.ajaxSetup({}, n),
          m = h.context || h,
          v = h.context && (m.nodeType || m.jquery) ? he(m) : he.event,
          g = he.Deferred(),
          y = he.Callbacks("once memory"),
          b = h.statusCode || {},
          w = {},
          x = {},
          k = "canceled",
          S = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (u) {
                if (!a)
                  for (a = {}; (t = Mt.exec(s)); )
                    a[t[1].toLowerCase() + " "] = (
                      a[t[1].toLowerCase() + " "] || []
                    ).concat(t[2]);
                t = a[e.toLowerCase() + " "];
              }
              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function () {
              return u ? s : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == u &&
                  ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e),
                  (w[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == u && (h.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (u) S.always(e[S.status]);
                else for (t in e) b[t] = [b[t], e[t]];
              return this;
            },
            abort: function (e) {
              var t = e || k;
              return o && o.abort(t), i(0, t), this;
            },
          };
        if (
          (g.promise(S),
          (h.url = ((t || h.url || Et.href) + "").replace(
            jt,
            Et.protocol + "//"
          )),
          (h.type = n.method || n.type || h.method || h.type),
          (h.dataTypes = (h.dataType || "*").toLowerCase().match(Ce) || [""]),
          null == h.crossDomain)
        ) {
          c = pe.createElement("a");
          try {
            (c.href = h.url),
              (c.href = c.href),
              (h.crossDomain =
                qt.protocol + "//" + qt.host != c.protocol + "//" + c.host);
          } catch (e) {
            h.crossDomain = !0;
          }
        }
        if (
          (h.data &&
            h.processData &&
            "string" != typeof h.data &&
            (h.data = he.param(h.data, h.traditional)),
          X(Ht, h, n, S),
          u)
        )
          return S;
        for (d in ((p = he.event && h.global) &&
          0 == he.active++ &&
          he.event.trigger("ajaxStart"),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !zt.test(h.type)),
        (r = h.url.replace(Nt, "")),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 ===
              (h.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (h.data = h.data.replace(Lt, "+"))
          : ((f = h.url.slice(r.length)),
            h.data &&
              (h.processData || "string" == typeof h.data) &&
              ((r += (Pt.test(r) ? "&" : "?") + h.data), delete h.data),
            !1 === h.cache &&
              ((r = r.replace(Dt, "$1")),
              (f = (Pt.test(r) ? "&" : "?") + "_=" + At.guid++ + f)),
            (h.url = r + f)),
        h.ifModified &&
          (he.lastModified[r] &&
            S.setRequestHeader("If-Modified-Since", he.lastModified[r]),
          he.etag[r] && S.setRequestHeader("If-None-Match", he.etag[r])),
        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) &&
          S.setRequestHeader("Content-Type", h.contentType),
        S.setRequestHeader(
          "Accept",
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] +
                ("*" !== h.dataTypes[0] ? ", " + Ft + "; q=0.01" : "")
            : h.accepts["*"]
        ),
        h.headers))
          S.setRequestHeader(d, h.headers[d]);
        if (h.beforeSend && (!1 === h.beforeSend.call(m, S, h) || u))
          return S.abort();
        if (
          ((k = "abort"),
          y.add(h.complete),
          S.done(h.success),
          S.fail(h.error),
          (o = X(Rt, h, n, S)))
        ) {
          if (((S.readyState = 1), p && v.trigger("ajaxSend", [S, h]), u))
            return S;
          h.async &&
            0 < h.timeout &&
            (l = e.setTimeout(function () {
              S.abort("timeout");
            }, h.timeout));
          try {
            (u = !1), o.send(w, i);
          } catch (e) {
            if (u) throw e;
            i(-1, e);
          }
        } else i(-1, "No Transport");
        return S;
      },
      getJSON: function (e, t, n) {
        return he.get(e, t, n, "json");
      },
      getScript: function (e, t) {
        return he.get(e, void 0, t, "script");
      },
    }),
    he.each(["get", "post"], function (e, t) {
      he[t] = function (e, n, i, o) {
        return (
          ce(n) && ((o = o || i), (i = n), (n = void 0)),
          he.ajax(
            he.extend(
              { url: e, type: t, dataType: o, data: n, success: i },
              he.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    he.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers)
        "content-type" === t.toLowerCase() &&
          (e.contentType = e.headers[t] || "");
    }),
    (he._evalUrl = function (e, t, n) {
      return he.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: { "text script": function () {} },
        dataFilter: function (e) {
          he.globalEval(e, t, n);
        },
      });
    }),
    he.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (ce(e) && (e = e.call(this[0])),
            (t = he(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                for (var e = this; e.firstElementChild; )
                  e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (e) {
        return ce(e)
          ? this.each(function (t) {
              he(this).wrapInner(e.call(this, t));
            })
          : this.each(function () {
              var t = he(this),
                n = t.contents();
              n.length ? n.wrapAll(e) : t.append(e);
            });
      },
      wrap: function (e) {
        var t = ce(e);
        return this.each(function (n) {
          he(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              he(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (he.expr.pseudos.hidden = function (e) {
      return !he.expr.pseudos.visible(e);
    }),
    (he.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (he.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    });
  var Bt = { 0: 200, 1223: 204 },
    Wt = he.ajaxSettings.xhr();
  (le.cors = !!Wt && "withCredentials" in Wt),
    (le.ajax = Wt = !!Wt),
    he.ajaxTransport(function (t) {
      var n, i;
      if (le.cors || (Wt && !t.crossDomain))
        return {
          send: function (o, r) {
            var s,
              a = t.xhr();
            if (
              (a.open(t.type, t.url, t.async, t.username, t.password),
              t.xhrFields)
            )
              for (s in t.xhrFields) a[s] = t.xhrFields[s];
            for (s in (t.mimeType &&
              a.overrideMimeType &&
              a.overrideMimeType(t.mimeType),
            t.crossDomain ||
              o["X-Requested-With"] ||
              (o["X-Requested-With"] = "XMLHttpRequest"),
            o))
              a.setRequestHeader(s, o[s]);
            (n = function (e) {
              return function () {
                n &&
                  ((n =
                    i =
                    a.onload =
                    a.onerror =
                    a.onabort =
                    a.ontimeout =
                    a.onreadystatechange =
                      null),
                  "abort" === e
                    ? a.abort()
                    : "error" === e
                    ? "number" != typeof a.status
                      ? r(0, "error")
                      : r(a.status, a.statusText)
                    : r(
                        Bt[a.status] || a.status,
                        a.statusText,
                        "text" !== (a.responseType || "text") ||
                          "string" != typeof a.responseText
                          ? { binary: a.response }
                          : { text: a.responseText },
                        a.getAllResponseHeaders()
                      ));
              };
            }),
              (a.onload = n()),
              (i = a.onerror = a.ontimeout = n("error")),
              void 0 !== a.onabort
                ? (a.onabort = i)
                : (a.onreadystatechange = function () {
                    4 === a.readyState &&
                      e.setTimeout(function () {
                        n && i();
                      });
                  }),
              (n = n("abort"));
            try {
              a.send((t.hasContent && t.data) || null);
            } catch (e) {
              if (n) throw e;
            }
          },
          abort: function () {
            n && n();
          },
        };
    }),
    he.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    he.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return he.globalEval(e), e;
        },
      },
    }),
    he.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    he.ajaxTransport("script", function (e) {
      var t, n;
      if (e.crossDomain || e.scriptAttrs)
        return {
          send: function (i, o) {
            (t = he("<script>")
              .attr(e.scriptAttrs || {})
              .prop({ charset: e.scriptCharset, src: e.url })
              .on(
                "load error",
                (n = function (e) {
                  t.remove(),
                    (n = null),
                    e && o("error" === e.type ? 404 : 200, e.type);
                })
              )),
              pe.head.appendChild(t[0]);
          },
          abort: function () {
            n && n();
          },
        };
    });
  var Ut,
    Vt = [],
    Zt = /(=)\?(?=&|$)|\?\?/;
  he.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = Vt.pop() || he.expando + "_" + At.guid++;
      return (this[e] = !0), e;
    },
  }),
    he.ajaxPrefilter("json jsonp", function (t, n, i) {
      var o,
        r,
        s,
        a =
          !1 !== t.jsonp &&
          (Zt.test(t.url)
            ? "url"
            : "string" == typeof t.data &&
              0 ===
                (t.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Zt.test(t.data) &&
              "data");
      if (a || "jsonp" === t.dataTypes[0])
        return (
          (o = t.jsonpCallback =
            ce(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
          a
            ? (t[a] = t[a].replace(Zt, "$1" + o))
            : !1 !== t.jsonp &&
              (t.url += (Pt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
          (t.converters["script json"] = function () {
            return s || he.error(o + " was not called"), s[0];
          }),
          (t.dataTypes[0] = "json"),
          (r = e[o]),
          (e[o] = function () {
            s = arguments;
          }),
          i.always(function () {
            void 0 === r ? he(e).removeProp(o) : (e[o] = r),
              t[o] && ((t.jsonpCallback = n.jsonpCallback), Vt.push(o)),
              s && ce(r) && r(s[0]),
              (s = r = void 0);
          }),
          "script"
        );
    }),
    (le.createHTMLDocument =
      (((Ut = pe.implementation.createHTMLDocument("").body).innerHTML =
        "<form></form><form></form>"),
      2 === Ut.childNodes.length)),
    (he.parseHTML = function (e, t, n) {
      return "string" != typeof e
        ? []
        : ("boolean" == typeof t && ((n = t), (t = !1)),
          t ||
            (le.createHTMLDocument
              ? (((i = (t =
                  pe.implementation.createHTMLDocument("")).createElement(
                  "base"
                )).href = pe.location.href),
                t.head.appendChild(i))
              : (t = pe)),
          (r = !n && []),
          (o = be.exec(e))
            ? [t.createElement(o[1])]
            : ((o = w([e], t, r)),
              r && r.length && he(r).remove(),
              he.merge([], o.childNodes)));
      var i, o, r;
    }),
    (he.fn.load = function (e, t, n) {
      var i,
        o,
        r,
        s = this,
        a = e.indexOf(" ");
      return (
        -1 < a && ((i = W(e.slice(a))), (e = e.slice(0, a))),
        ce(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (o = "POST"),
        0 < s.length &&
          he
            .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
            .done(function (e) {
              (r = arguments),
                s.html(i ? he("<div>").append(he.parseHTML(e)).find(i) : e);
            })
            .always(
              n &&
                function (e, t) {
                  s.each(function () {
                    n.apply(this, r || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (he.expr.pseudos.animated = function (e) {
      return he.grep(he.timers, function (t) {
        return e === t.elem;
      }).length;
    }),
    (he.offset = {
      setOffset: function (e, t, n) {
        var i,
          o,
          r,
          s,
          a,
          l,
          c = he.css(e, "position"),
          u = he(e),
          p = {};
        "static" === c && (e.style.position = "relative"),
          (a = u.offset()),
          (r = he.css(e, "top")),
          (l = he.css(e, "left")),
          ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto")
            ? ((s = (i = u.position()).top), (o = i.left))
            : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
          ce(t) && (t = t.call(e, n, he.extend({}, a))),
          null != t.top && (p.top = t.top - a.top + s),
          null != t.left && (p.left = t.left - a.left + o),
          "using" in t
            ? t.using.call(e, p)
            : ("number" == typeof p.top && (p.top += "px"),
              "number" == typeof p.left && (p.left += "px"),
              u.css(p));
      },
    }),
    he.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                he.offset.setOffset(this, e, t);
              });
        var t,
          n,
          i = this[0];
        return i
          ? i.getClientRects().length
            ? ((t = i.getBoundingClientRect()),
              (n = i.ownerDocument.defaultView),
              { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            i = this[0],
            o = { top: 0, left: 0 };
          if ("fixed" === he.css(i, "position")) t = i.getBoundingClientRect();
          else {
            for (
              t = this.offset(),
                n = i.ownerDocument,
                e = i.offsetParent || n.documentElement;
              e &&
              (e === n.body || e === n.documentElement) &&
              "static" === he.css(e, "position");

            )
              e = e.parentNode;
            e &&
              e !== i &&
              1 === e.nodeType &&
              (((o = he(e).offset()).top += he.css(e, "borderTopWidth", !0)),
              (o.left += he.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - o.top - he.css(i, "marginTop", !0),
            left: t.left - o.left - he.css(i, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (
            var e = this.offsetParent;
            e && "static" === he.css(e, "position");

          )
            e = e.offsetParent;
          return e || je;
        });
      },
    }),
    he.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (e, t) {
        var n = "pageYOffset" === t;
        he.fn[e] = function (i) {
          return Ae(
            this,
            function (e, i, o) {
              var r;
              return (
                ue(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView),
                void 0 === o
                  ? r
                    ? r[t]
                    : e[i]
                  : void (r
                      ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset)
                      : (e[i] = o))
              );
            },
            e,
            i,
            arguments.length
          );
        };
      }
    ),
    he.each(["top", "left"], function (e, t) {
      he.cssHooks[t] = L(le.pixelPosition, function (e, n) {
        if (n)
          return (n = I(e, t)), nt.test(n) ? he(e).position()[t] + "px" : n;
      });
    }),
    he.each({ Height: "height", Width: "width" }, function (e, t) {
      he.each(
        { padding: "inner" + e, content: t, "": "outer" + e },
        function (n, i) {
          he.fn[i] = function (o, r) {
            var s = arguments.length && (n || "boolean" != typeof o),
              a = n || (!0 === o || !0 === r ? "margin" : "border");
            return Ae(
              this,
              function (t, n, o) {
                var r;
                return ue(t)
                  ? 0 === i.indexOf("outer")
                    ? t["inner" + e]
                    : t.document.documentElement["client" + e]
                  : 9 === t.nodeType
                  ? ((r = t.documentElement),
                    Math.max(
                      t.body["scroll" + e],
                      r["scroll" + e],
                      t.body["offset" + e],
                      r["offset" + e],
                      r["client" + e]
                    ))
                  : void 0 === o
                  ? he.css(t, n, a)
                  : he.style(t, n, o, a);
              },
              t,
              s ? o : void 0,
              s
            );
          };
        }
      );
    }),
    he.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        he.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    he.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, i) {
        return this.on(t, e, n, i);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", n);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    he.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, t) {
        he.fn[t] = function (e, n) {
          return 0 < arguments.length
            ? this.on(t, null, e, n)
            : this.trigger(t);
        };
      }
    );
  var Kt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (he.proxy = function (e, t) {
    var n, i, o;
    if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), ce(e)))
      return (
        (i = Q.call(arguments, 2)),
        ((o = function () {
          return e.apply(t || this, i.concat(Q.call(arguments)));
        }).guid = e.guid =
          e.guid || he.guid++),
        o
      );
  }),
    (he.holdReady = function (e) {
      e ? he.readyWait++ : he.ready(!0);
    }),
    (he.isArray = Array.isArray),
    (he.parseJSON = JSON.parse),
    (he.nodeName = r),
    (he.isFunction = ce),
    (he.isWindow = ue),
    (he.camelCase = f),
    (he.type = i),
    (he.now = Date.now),
    (he.isNumeric = function (e) {
      var t = he.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    (he.trim = function (e) {
      return null == e ? "" : (e + "").replace(Kt, "");
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return he;
      });
  var Xt = e.jQuery,
    Yt = e.$;
  return (
    (he.noConflict = function (t) {
      return (
        e.$ === he && (e.$ = Yt), t && e.jQuery === he && (e.jQuery = Xt), he
      );
    }),
    "undefined" == typeof t && (e.jQuery = e.$ = he),
    he
  );
}),
  (window.theme = window.theme || {}),
  (theme.jQuery =
    jQuery) /*! enquire.js v2.1.2 - http://wicky.nillia.ms/enquire.js */,
  !(function (e, t, n) {
    var i = window.matchMedia;
    "undefined" != typeof module && module.exports
      ? (module.exports = n(i))
      : "function" == typeof define && define.amd
      ? define(function () {
          return (t[e] = n(i));
        })
      : (t[e] = n(i));
  })("enquire", this, function (e) {
    "use strict";
    function t(e, t) {
      var n,
        i = 0,
        o = e.length;
      for (i; o > i && ((n = t(e[i], i)), n !== !1); i++);
    }
    function n(e) {
      return "[object Array]" === Object.prototype.toString.apply(e);
    }
    function i(e) {
      return "function" == typeof e;
    }
    function o(e) {
      (this.options = e), !e.deferSetup && this.setup();
    }
    function r(t, n) {
      (this.query = t),
        (this.isUnconditional = n),
        (this.handlers = []),
        (this.mql = e(t));
      var i = this;
      (this.listener = function (e) {
        (i.mql = e), i.assess();
      }),
        this.mql.addListener(this.listener);
    }
    function s() {
      if (!e)
        throw new Error(
          "matchMedia not present, legacy browsers require a polyfill"
        );
      (this.queries = {}), (this.browserIsIncapable = !e("only all").matches);
    }
    return (
      (o.prototype = {
        setup: function () {
          this.options.setup && this.options.setup(), (this.initialised = !0);
        },
        on: function () {
          !this.initialised && this.setup(),
            this.options.match && this.options.match();
        },
        off: function () {
          this.options.unmatch && this.options.unmatch();
        },
        destroy: function () {
          this.options.destroy ? this.options.destroy() : this.off();
        },
        equals: function (e) {
          return this.options === e || this.options.match === e;
        },
      }),
      (r.prototype = {
        addHandler: function (e) {
          var t = new o(e);
          this.handlers.push(t), this.matches() && t.on();
        },
        removeHandler: function (e) {
          var n = this.handlers;
          t(n, function (t, i) {
            return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0;
          });
        },
        matches: function () {
          return this.mql.matches || this.isUnconditional;
        },
        clear: function () {
          t(this.handlers, function (e) {
            e.destroy();
          }),
            this.mql.removeListener(this.listener),
            (this.handlers.length = 0);
        },
        assess: function () {
          var e = this.matches() ? "on" : "off";
          t(this.handlers, function (t) {
            t[e]();
          });
        },
      }),
      (s.prototype = {
        register: function (e, o, s) {
          var a = this.queries,
            l = s && this.browserIsIncapable;
          return (
            a[e] || (a[e] = new r(e, l)),
            i(o) && (o = { match: o }),
            n(o) || (o = [o]),
            t(o, function (t) {
              i(t) && (t = { match: t }), a[e].addHandler(t);
            }),
            this
          );
        },
        unregister: function (e, t) {
          var n = this.queries[e];
          return (
            n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])),
            this
          );
        },
      }),
      new s()
    );
  }),
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (e) {
    "use strict";
    var t = window.Slick || {};
    (t = (function () {
      function t(t, i) {
        var o,
          r = this,
          s = document.querySelector('[data-id="nextArrowTemplate"]').outerHTML,
          a = document.querySelector('[data-id="prevArrowTemplate"]').outerHTML;
        (r.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: e(t),
          appendDots: e(t),
          arrows: !0,
          asNavFor: null,
          prevArrow: a,
          nextArrow: s,
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (t, n) {
            return e(
              '<button type="button" data-role="none" role="button" tabindex="0" />'
            ).text(n + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          infinite: !0,
          initialSlide: 0,
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
          customHeightMatching: !1,
          customSlideAdvancement: !1,
        }),
          (r.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          e.extend(r, r.initials),
          (r.activeBreakpoint = null),
          (r.animType = null),
          (r.animProp = null),
          (r.breakpoints = []),
          (r.breakpointSettings = []),
          (r.cssTransitions = !1),
          (r.focussed = !1),
          (r.interrupted = !1),
          (r.hidden = "hidden"),
          (r.paused = !0),
          (r.positionProp = null),
          (r.respondTo = null),
          (r.rowCount = 1),
          (r.shouldClick = !0),
          (r.$slider = e(t)),
          (r.$slidesCache = null),
          (r.transformType = null),
          (r.transitionType = null),
          (r.visibilityChange = "visibilitychange"),
          (r.windowWidth = 0),
          (r.windowTimer = null),
          (o = e(t).data("slick") || {}),
          (r.options = e.extend({}, r.defaults, i, o)),
          (r.currentSlide = r.options.initialSlide),
          (r.originalSettings = r.options),
          "undefined" != typeof document.mozHidden
            ? ((r.hidden = "mozHidden"),
              (r.visibilityChange = "mozvisibilitychange"))
            : "undefined" != typeof document.webkitHidden &&
              ((r.hidden = "webkitHidden"),
              (r.visibilityChange = "webkitvisibilitychange")),
          (r.autoPlay = e.proxy(r.autoPlay, r)),
          (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
          (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
          (r.changeSlide = e.proxy(r.changeSlide, r)),
          (r.clickHandler = e.proxy(r.clickHandler, r)),
          (r.selectHandler = e.proxy(r.selectHandler, r)),
          (r.setPosition = e.proxy(r.setPosition, r)),
          (r.swipeHandler = e.proxy(r.swipeHandler, r)),
          (r.dragHandler = e.proxy(r.dragHandler, r)),
          (r.keyHandler = e.proxy(r.keyHandler, r)),
          (r.instanceUid = n++),
          (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          r.registerBreakpoints(),
          r.init(!0);
      }
      var n = 0;
      return t;
    })()),
      (t.prototype.activateADA = function () {
        var e = this;
        e.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (t.prototype.addSlide = t.prototype.slickAdd =
        function (t, n, i) {
          var o = this;
          if ("boolean" == typeof n) (i = n), (n = null);
          else if (n < 0 || n >= o.slideCount) return !1;
          o.unload(),
            "number" == typeof n
              ? 0 === n && 0 === o.$slides.length
                ? e(t).appendTo(o.$slideTrack)
                : i
                ? e(t).insertBefore(o.$slides.eq(n))
                : e(t).insertAfter(o.$slides.eq(n))
              : i === !0
              ? e(t).prependTo(o.$slideTrack)
              : e(t).appendTo(o.$slideTrack),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            o.$slides.each(function (t, n) {
              e(n).attr("data-slick-index", t);
            }),
            (o.$slidesCache = o.$slides),
            o.reinit();
        }),
      (t.prototype.animateHeight = function () {
        var e = this;
        if (
          1 === e.options.slidesToShow &&
          e.options.adaptiveHeight === !0 &&
          e.options.vertical === !1
        ) {
          var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
          e.$list.animate({ height: t }, e.options.speed);
        }
      }),
      (t.prototype.animateSlide = function (t, n) {
        var i = {},
          o = this;
        o.animateHeight(),
          o.options.rtl === !0 && o.options.vertical === !1 && (t = -t),
          o.transformsEnabled === !1
            ? o.options.vertical === !1
              ? o.$slideTrack.animate(
                  { left: t },
                  o.options.speed,
                  o.options.easing,
                  n
                )
              : o.$slideTrack.animate(
                  { top: t },
                  o.options.speed,
                  o.options.easing,
                  n
                )
            : o.cssTransitions === !1
            ? (o.options.rtl === !0 && (o.currentLeft = -o.currentLeft),
              e({ animStart: o.currentLeft }).animate(
                { animStart: t },
                {
                  duration: o.options.speed,
                  easing: o.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      o.options.vertical === !1
                        ? ((i[o.animType] = "translate(" + e + "px, 0px)"),
                          o.$slideTrack.css(i))
                        : ((i[o.animType] = "translate(0px," + e + "px)"),
                          o.$slideTrack.css(i));
                  },
                  complete: function () {
                    n && n.call();
                  },
                }
              ))
            : (o.applyTransition(),
              (t = Math.ceil(t)),
              o.options.vertical === !1
                ? (i[o.animType] = "translate3d(" + t + "px, 0px, 0px)")
                : (i[o.animType] = "translate3d(0px," + t + "px, 0px)"),
              o.$slideTrack.css(i),
              n &&
                setTimeout(function () {
                  o.disableTransition(), n.call();
                }, o.options.speed));
      }),
      (t.prototype.getNavTarget = function () {
        var t = this,
          n = t.options.asNavFor;
        return n && null !== n && (n = e(n).not(t.$slider)), n;
      }),
      (t.prototype.asNavFor = function (t) {
        var n = this,
          i = n.getNavTarget();
        null !== i &&
          "object" == typeof i &&
          i.each(function () {
            var n = e(this).slick("getSlick");
            n.unslicked || n.slideHandler(t, !0);
          });
      }),
      (t.prototype.applyTransition = function (e) {
        var t = this,
          n = {};
        t.options.fade === !1
          ? (n[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (n[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
      }),
      (t.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (t.prototype.autoPlayClear = function () {
        var e = this;
        e.autoPlayTimer && clearInterval(e.autoPlayTimer);
      }),
      (t.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused ||
          e.interrupted ||
          e.focussed ||
          (e.options.infinite === !1 &&
            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
              ? (e.direction = 0)
              : 0 === e.direction &&
                ((t = e.currentSlide - e.options.slidesToScroll),
                e.currentSlide - 1 === 0 && (e.direction = 1))),
          e.slideHandler(t));
      }),
      (t.prototype.buildArrows = function () {
        var t = this;
        t.options.arrows === !0 &&
          ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
          (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
          t.slideCount > t.options.slidesToShow
            ? (t.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.htmlExpr.test(t.options.prevArrow) &&
                t.$prevArrow.prependTo(t.options.appendArrows),
              t.htmlExpr.test(t.options.nextArrow) &&
                t.$nextArrow.appendTo(t.options.appendArrows),
              t.options.infinite !== !0 &&
                t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : t.$prevArrow
                .add(t.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (t.prototype.buildDots = function () {
        var t,
          n,
          i = this;
        if (i.options.dots === !0 && i.slideCount > i.options.slidesToShow) {
          for (
            i.$slider.addClass("slick-dotted"),
              n = e("<ul />").addClass(i.options.dotsClass),
              t = 0;
            t <= i.getDotCount();
            t += 1
          )
            n.append(
              e("<li />").append(i.options.customPaging.call(this, i, t))
            );
          (i.$dots = n.appendTo(i.options.appendDots)),
            i.$dots
              .find("li")
              .first()
              .addClass("slick-active")
              .attr("aria-hidden", "false");
        }
      }),
      (t.prototype.buildOut = function () {
        var t = this;
        (t.$slides = t.$slider
          .children(t.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.$slides.each(function (t, n) {
            e(n)
              .attr("data-slick-index", t)
              .data("originalStyling", e(n).attr("style") || "");
          }),
          t.$slider.addClass("slick-slider"),
          (t.$slideTrack =
            0 === t.slideCount
              ? e('<div class="slick-track"/>').appendTo(t.$slider)
              : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (t.$list = t.$slideTrack
            .wrap('<div aria-live="polite" class="slick-list"/>')
            .parent()),
          t.$slideTrack.css("opacity", 0),
          (t.options.centerMode !== !0 && t.options.swipeToSlide !== !0) ||
            (t.options.slidesToScroll = 1),
          t.setupInfinite(),
          t.buildArrows(),
          t.buildDots(),
          t.updateDots(),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.options.draggable === !0 && t.$list.addClass("draggable");
      }),
      (t.prototype.buildRows = function () {
        var e,
          t,
          n,
          i,
          o,
          r,
          s,
          a = this;
        if (
          ((i = document.createDocumentFragment()),
          (r = a.$slider.children()),
          a.options.rows > 1)
        ) {
          for (
            s = a.options.slidesPerRow * a.options.rows,
              o = Math.ceil(r.length / s),
              e = 0;
            e < o;
            e++
          ) {
            var l = document.createElement("div");
            for (t = 0; t < a.options.rows; t++) {
              var c = document.createElement("div");
              for (n = 0; n < a.options.slidesPerRow; n++) {
                var u = e * s + (t * a.options.slidesPerRow + n);
                r.get(u) && c.appendChild(r.get(u));
              }
              l.appendChild(c);
            }
            i.appendChild(l);
          }
          a.$slider.empty().append(i),
            a.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (t.prototype.checkResponsive = function (t, n) {
        var i,
          o,
          r,
          s = this,
          a = !1,
          l = s.$slider.width(),
          c = window.innerWidth || e(window).width();
        if (
          ("window" === s.respondTo
            ? (r = c)
            : "slider" === s.respondTo
            ? (r = l)
            : "min" === s.respondTo && (r = Math.min(c, l)),
          s.options.responsive &&
            s.options.responsive.length &&
            null !== s.options.responsive)
        ) {
          o = null;
          for (i in s.breakpoints)
            s.breakpoints.hasOwnProperty(i) &&
              (s.originalSettings.mobileFirst === !1
                ? r < s.breakpoints[i] && (o = s.breakpoints[i])
                : r > s.breakpoints[i] && (o = s.breakpoints[i]));
          null !== o
            ? null !== s.activeBreakpoint
              ? (o !== s.activeBreakpoint || n) &&
                ((s.activeBreakpoint = o),
                "unslick" === s.breakpointSettings[o]
                  ? s.unslick(o)
                  : ((s.options = e.extend(
                      {},
                      s.originalSettings,
                      s.breakpointSettings[o]
                    )),
                    t === !0 && (s.currentSlide = s.options.initialSlide),
                    s.refresh(t)),
                (a = o))
              : ((s.activeBreakpoint = o),
                "unslick" === s.breakpointSettings[o]
                  ? s.unslick(o)
                  : ((s.options = e.extend(
                      {},
                      s.originalSettings,
                      s.breakpointSettings[o]
                    )),
                    t === !0 && (s.currentSlide = s.options.initialSlide),
                    s.refresh(t)),
                (a = o))
            : null !== s.activeBreakpoint &&
              ((s.activeBreakpoint = null),
              (s.options = s.originalSettings),
              t === !0 && (s.currentSlide = s.options.initialSlide),
              s.refresh(t),
              (a = o)),
            t || a === !1 || s.$slider.trigger("breakpoint", [s, a]);
        }
      }),
      (t.prototype.changeSlide = function (t, n) {
        var i,
          o,
          r,
          s = this,
          a = e(t.currentTarget);
        switch (
          (a.is("a") && t.preventDefault(),
          a.is("li") || (a = a.closest("li")),
          (r = s.slideCount % s.options.slidesToScroll !== 0),
          (i = r
            ? 0
            : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
          t.data.message)
        ) {
          case "previous":
            (o =
              0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i),
              s.slideCount > s.options.slidesToShow &&
                s.slideHandler(s.currentSlide - o, !1, n);
            break;
          case "next":
            (o = 0 === i ? s.options.slidesToScroll : i),
              s.slideCount > s.options.slidesToShow &&
                s.slideHandler(s.currentSlide + o, !1, n);
            break;
          case "index":
            var l =
              0 === t.data.index
                ? 0
                : t.data.index || a.index() * s.options.slidesToScroll;
            s.slideHandler(s.checkNavigable(l), !1, n),
              a.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (t.prototype.checkNavigable = function (e) {
        var t,
          n,
          i = this;
        if (((t = i.getNavigableIndexes()), (n = 0), e > t[t.length - 1]))
          e = t[t.length - 1];
        else
          for (var o in t) {
            if (e < t[o]) {
              e = n;
              break;
            }
            n = t[o];
          }
        return e;
      }),
      (t.prototype.cleanUpEvents = function () {
        var t = this;
        t.options.dots &&
          null !== t.$dots &&
          e("li", t.$dots)
            .off("click.slick", t.changeSlide)
            .off("mouseenter.slick", e.proxy(t.interrupt, t, !0))
            .off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
          t.$slider.off("focus.slick blur.slick"),
          t.options.arrows === !0 &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
            t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
          t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
          t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
          t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
          t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
          t.$list.off("click.slick", t.clickHandler),
          e(document).off(t.visibilityChange, t.visibility),
          t.cleanUpSlideEvents(),
          t.options.accessibility === !0 &&
            t.$list.off("keydown.slick", t.keyHandler),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().off("click.slick", t.selectHandler),
          e(window).off(
            "orientationchange.slick.slick-" + t.instanceUid,
            t.orientationChange
          ),
          e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
          e("[draggable!=true]", t.$slideTrack).off(
            "dragstart",
            t.preventDefault
          ),
          e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.cleanUpSlideEvents = function () {
        var t = this;
        t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.cleanUpRows = function () {
        var e,
          t = this;
        t.options.rows > 1 &&
          ((e = t.$slides.children().children()),
          e.removeAttr("style"),
          t.$slider.empty().append(e));
      }),
      (t.prototype.clickHandler = function (e) {
        var t = this;
        t.shouldClick === !1 &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (t.prototype.destroy = function (t) {
        var n = this;
        n.autoPlayClear(),
          (n.touchObject = {}),
          n.cleanUpEvents(),
          e(".slick-cloned", n.$slider).detach(),
          n.$dots && n.$dots.remove(),
          n.$prevArrow &&
            n.$prevArrow.length &&
            (n.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
          n.$nextArrow &&
            n.$nextArrow.length &&
            (n.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
          n.$slides &&
            (n.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                e(this).attr("style", e(this).data("originalStyling"));
              }),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.detach(),
            n.$list.detach(),
            n.$slider.append(n.$slides)),
          n.cleanUpRows(),
          n.$slider.removeClass("slick-slider"),
          n.$slider.removeClass("slick-initialized"),
          n.$slider.removeClass("slick-dotted"),
          (n.unslicked = !0),
          t || n.$slider.trigger("destroy", [n]);
      }),
      (t.prototype.disableTransition = function (e) {
        var t = this,
          n = {};
        (n[t.transitionType] = ""),
          t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
      }),
      (t.prototype.fadeSlide = function (e, t) {
        var n = this;
        n.cssTransitions === !1
          ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }),
            n.$slides.eq(e).animate({ opacity: 1 }, 0, n.options.easing, t))
          : (n.applyTransition(e),
            n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
            t &&
              setTimeout(function () {
                n.disableTransition(e), t.call();
              }, n.options.speed));
      }),
      (t.prototype.fadeSlideOut = function (e) {
        var t = this;
        t.cssTransitions === !1
          ? t.$slides
              .eq(e)
              .animate(
                { opacity: 1, zIndex: t.options.zIndex - 2 },
                t.options.speed,
                t.options.easing
              )
          : (t.applyTransition(e),
            t.$slides.eq(e).css({ opacity: 1, zIndex: t.options.zIndex - 2 }));
      }),
      (t.prototype.filterSlides = t.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (t.prototype.focusHandler = function () {
        var t = this;
        t.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (n) {
            n.stopImmediatePropagation();
            var i = e(this);
            setTimeout(function () {
              t.options.pauseOnFocus &&
                ((t.focussed = i.is(":focus")), t.autoPlay());
            }, 0);
          });
      }),
      (t.prototype.getCurrent = t.prototype.slickCurrentSlide =
        function () {
          var e = this;
          return e.currentSlide;
        }),
      (t.prototype.getDotCount = function () {
        var e = this,
          t = 0,
          n = 0,
          i = 0;
        if (e.options.infinite === !0)
          for (; t < e.slideCount; )
            ++i,
              (t = n + e.options.slidesToScroll),
              (n +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else if (e.options.centerMode === !0) i = e.slideCount;
        else if (e.options.asNavFor)
          for (; t < e.slideCount; )
            ++i,
              (t = n + e.options.slidesToScroll),
              (n +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else
          i =
            1 +
            Math.ceil(
              (e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll
            );
        return i - 1;
      }),
      (t.prototype.getLeft = function (e) {
        var t,
          n,
          i,
          o = this,
          r = 0;
        return (
          (o.slideOffset = 0),
          (n = o.$slides.first().outerHeight(!0)),
          o.options.infinite === !0
            ? (o.slideCount > o.options.slidesToShow &&
                ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1),
                (r = n * o.options.slidesToShow * -1)),
              o.slideCount % o.options.slidesToScroll !== 0 &&
                e + o.options.slidesToScroll > o.slideCount &&
                o.slideCount > o.options.slidesToShow &&
                (e > o.slideCount
                  ? ((o.slideOffset =
                      (o.options.slidesToShow - (e - o.slideCount)) *
                      o.slideWidth *
                      -1),
                    (r =
                      (o.options.slidesToShow - (e - o.slideCount)) * n * -1))
                  : ((o.slideOffset =
                      (o.slideCount % o.options.slidesToScroll) *
                      o.slideWidth *
                      -1),
                    (r = (o.slideCount % o.options.slidesToScroll) * n * -1))))
            : e + o.options.slidesToShow > o.slideCount &&
              ((o.slideOffset =
                (e + o.options.slidesToShow - o.slideCount) * o.slideWidth),
              (r = (e + o.options.slidesToShow - o.slideCount) * n)),
          o.slideCount <= o.options.slidesToShow &&
            ((o.slideOffset = 0), (r = 0)),
          o.options.centerMode === !0 && o.options.infinite === !0
            ? (o.slideOffset +=
                o.slideWidth * Math.floor(o.options.slidesToShow / 2) -
                o.slideWidth)
            : o.options.centerMode === !0 &&
              ((o.slideOffset = 0),
              (o.slideOffset +=
                o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
          (t =
            o.options.vertical === !1
              ? e * o.slideWidth * -1 + o.slideOffset
              : e * n * -1 + r),
          o.options.variableWidth === !0 &&
            ((i =
              o.slideCount <= o.options.slidesToShow ||
              o.options.infinite === !1
                ? o.$slideTrack.children(".slick-slide").eq(e)
                : o.$slideTrack
                    .children(".slick-slide")
                    .eq(e + o.options.slidesToShow)),
            (t =
              o.options.rtl === !0
                ? i[0]
                  ? (o.$slideTrack.width() - i[0].offsetLeft - i.width()) * -1
                  : 0
                : i[0]
                ? i[0].offsetLeft * -1
                : 0),
            o.options.centerMode === !0 &&
              ((i =
                o.slideCount <= o.options.slidesToShow ||
                o.options.infinite === !1
                  ? o.$slideTrack.children(".slick-slide").eq(e)
                  : o.$slideTrack
                      .children(".slick-slide")
                      .eq(e + o.options.slidesToShow + 1)),
              (t =
                o.options.rtl === !0
                  ? i[0]
                    ? (o.$slideTrack.width() - i[0].offsetLeft - i.width()) * -1
                    : 0
                  : i[0]
                  ? i[0].offsetLeft * -1
                  : 0),
              (t += (o.$list.width() - i.outerWidth()) / 2))),
          t
        );
      }),
      (t.prototype.getOption = t.prototype.slickGetOption =
        function (e) {
          var t = this;
          return t.options[e];
        }),
      (t.prototype.getNavigableIndexes = function () {
        var e,
          t = this,
          n = 0,
          i = 0,
          o = [];
        for (
          t.options.infinite === !1
            ? (e = t.slideCount)
            : ((n = t.options.slidesToScroll * -1),
              (i = t.options.slidesToScroll * -1),
              (e = 2 * t.slideCount));
          n < e;

        )
          o.push(n),
            (n = i + t.options.slidesToScroll),
            (i +=
              t.options.slidesToScroll <= t.options.slidesToShow
                ? t.options.slidesToScroll
                : t.options.slidesToShow);
        return o;
      }),
      (t.prototype.getSlick = function () {
        return this;
      }),
      (t.prototype.getSlideCount = function () {
        var t,
          n,
          i,
          o = this;
        return (
          (i =
            o.options.centerMode === !0
              ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
              : 0),
          o.options.swipeToSlide === !0
            ? (o.$slideTrack.find(".slick-slide").each(function (t, r) {
                if (r.offsetLeft - i + e(r).outerWidth() / 2 > o.swipeLeft * -1)
                  return (n = r), !1;
              }),
              (t =
                Math.abs(e(n).attr("data-slick-index") - o.currentSlide) || 1))
            : o.options.slidesToScroll
        );
      }),
      (t.prototype.goTo = t.prototype.slickGoTo =
        function (e, t) {
          var n = this;
          n.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
        }),
      (t.prototype.init = function (t) {
        var n = this;
        if (
          (e(n.$slider).hasClass("slick-initialized") ||
            (e(n.$slider).addClass("slick-initialized"),
            n.buildRows(),
            n.buildOut(),
            n.setProps(),
            n.startLoad(),
            n.loadSlider(),
            n.initializeEvents(),
            n.updateArrows(),
            n.updateDots(),
            n.checkResponsive(!0),
            n.focusHandler()),
          t && n.$slider.trigger("init", [n]),
          n.options.accessibility === !0 && n.initADA(),
          n.options.autoplay && ((n.paused = !1), n.autoPlay()),
          n.options.customSlideAdvancement)
        ) {
          var i = n.options.initialSlide ? n.options.initialSlide : 0;
          n.changeSlide({ data: { message: "index", index: parseInt(i) } });
        }
      }),
      (t.prototype.initADA = function () {
        var t = this;
        t.$slides
          .add(t.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (t) {
            e(this).attr({ role: "option" });
          }),
          null !== t.$dots &&
            t.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (n) {
                e(this).attr({
                  role: "presentation",
                  "aria-selected": "false",
                  "aria-controls": "navigation" + t.instanceUid + n,
                  id: "slick-slide" + t.instanceUid + n,
                });
              })
              .first()
              .attr("aria-selected", "true")
              .end()
              .find("button")
              .attr("role", "button")
              .end()
              .closest("div")
              .attr("role", "toolbar"),
          t.activateADA();
      }),
      (t.prototype.initArrowEvents = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide));
      }),
      (t.prototype.initDotEvents = function () {
        var t = this;
        t.options.dots === !0 &&
          t.slideCount > t.options.slidesToShow &&
          e("li", t.$dots).on(
            "click.slick",
            { message: "index" },
            t.changeSlide
          ),
          t.options.dots === !0 &&
            t.options.pauseOnDotsHover === !0 &&
            e("li", t.$dots)
              .on("mouseenter.slick", e.proxy(t.interrupt, t, !0))
              .on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.initSlideEvents = function () {
        var t = this;
        t.options.pauseOnHover &&
          (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
      }),
      (t.prototype.initializeEvents = function () {
        var t = this;
        t.initArrowEvents(),
          t.initDotEvents(),
          t.initSlideEvents(),
          t.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on("click.slick", t.clickHandler),
          e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
          t.options.accessibility === !0 &&
            t.$list.on("keydown.slick", t.keyHandler),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          e(window).on(
            "orientationchange.slick.slick-" + t.instanceUid,
            e.proxy(t.orientationChange, t)
          ),
          e(window).on(
            "resize.slick.slick-" + t.instanceUid,
            e.proxy(t.resize, t)
          ),
          e("[draggable!=true]", t.$slideTrack).on(
            "dragstart",
            t.preventDefault
          ),
          e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.initUI = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.show(), e.$nextArrow.show()),
          e.options.dots === !0 &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.show();
      }),
      (t.prototype.keyHandler = function (e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && t.options.accessibility === !0
            ? t.changeSlide({
                data: { message: t.options.rtl === !0 ? "next" : "previous" },
              })
            : 39 === e.keyCode &&
              t.options.accessibility === !0 &&
              t.changeSlide({
                data: { message: t.options.rtl === !0 ? "previous" : "next" },
              }));
      }),
      (t.prototype.loadSlider = function () {
        var e = this;
        e.setPosition(),
          e.$slideTrack.css({ opacity: 1 }),
          e.$slider.removeClass("slick-loading"),
          e.initUI();
      }),
      (t.prototype.next = t.prototype.slickNext =
        function () {
          var e = this;
          e.changeSlide({ data: { message: "next" } });
        }),
      (t.prototype.orientationChange = function () {
        var e = this;
        e.checkResponsive(), e.setPosition();
      }),
      (t.prototype.pause = t.prototype.slickPause =
        function () {
          var e = this;
          e.autoPlayClear(), (e.paused = !0);
        }),
      (t.prototype.play = t.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (t.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked ||
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          t.options.accessibility === !0 && t.initADA());
      }),
      (t.prototype.prev = t.prototype.slickPrev =
        function () {
          var e = this;
          e.changeSlide({ data: { message: "previous" } });
        }),
      (t.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (t.prototype.refresh = function (t) {
        var n,
          i,
          o = this;
        (i = o.slideCount - o.options.slidesToShow),
          !o.options.infinite && o.currentSlide > i && (o.currentSlide = i),
          o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
          (n = o.currentSlide),
          o.destroy(!0),
          e.extend(o, o.initials, { currentSlide: n }),
          o.init(),
          t || o.changeSlide({ data: { message: "index", index: n } }, !1);
      }),
      (t.prototype.registerBreakpoints = function () {
        var t,
          n,
          i,
          o = this,
          r = o.options.responsive || null;
        if ("array" === e.type(r) && r.length) {
          o.respondTo = o.options.respondTo || "window";
          for (t in r)
            if (
              ((i = o.breakpoints.length - 1),
              (n = r[t].breakpoint),
              r.hasOwnProperty(t))
            ) {
              for (; i >= 0; )
                o.breakpoints[i] &&
                  o.breakpoints[i] === n &&
                  o.breakpoints.splice(i, 1),
                  i--;
              o.breakpoints.push(n), (o.breakpointSettings[n] = r[t].settings);
            }
          o.breakpoints.sort(function (e, t) {
            return o.options.mobileFirst ? e - t : t - e;
          });
        }
      }),
      (t.prototype.reinit = function () {
        var t = this;
        (t.$slides = t.$slideTrack
          .children(t.options.slide)
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.currentSlide >= t.slideCount &&
            0 !== t.currentSlide &&
            (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          t.registerBreakpoints(),
          t.setProps(),
          t.setupInfinite(),
          t.buildArrows(),
          t.updateArrows(),
          t.initArrowEvents(),
          t.buildDots(),
          t.updateDots(),
          t.initDotEvents(),
          t.cleanUpSlideEvents(),
          t.initSlideEvents(),
          t.checkResponsive(!1, !0),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.setPosition(),
          t.focusHandler(),
          (t.paused = !t.options.autoplay),
          t.autoPlay(),
          t.$slider.trigger("reInit", [t]);
      }),
      (t.prototype.resize = function () {
        var t = this;
        e(window).width() !== t.windowWidth &&
          (clearTimeout(t.windowDelay),
          (t.windowDelay = window.setTimeout(function () {
            (t.windowWidth = e(window).width()),
              t.checkResponsive(),
              t.unslicked || t.setPosition();
          }, 50)));
      }),
      (t.prototype.removeSlide = t.prototype.slickRemove =
        function (e, t, n) {
          var i = this;
          return (
            "boolean" == typeof e
              ? ((t = e), (e = t === !0 ? 0 : i.slideCount - 1))
              : (e = t === !0 ? --e : e),
            !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) &&
              (i.unload(),
              n === !0
                ? i.$slideTrack.children().remove()
                : i.$slideTrack.children(this.options.slide).eq(e).remove(),
              (i.$slides = i.$slideTrack.children(this.options.slide)),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.append(i.$slides),
              (i.$slidesCache = i.$slides),
              void i.reinit())
          );
        }),
      (t.prototype.setCSS = function (e) {
        var t,
          n,
          i = this,
          o = {};
        i.options.rtl === !0 && (e = -e),
          (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
          (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
          (o[i.positionProp] = e),
          i.transformsEnabled === !1
            ? i.$slideTrack.css(o)
            : ((o = {}),
              i.cssTransitions === !1
                ? ((o[i.animType] = "translate(" + t + ", " + n + ")"),
                  i.$slideTrack.css(o))
                : (i.options.customSlideAdvancement !== !0 &&
                    (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"),
                  i.$slideTrack.css(o)));
      }),
      (t.prototype.setDimensions = function () {
        var e,
          t = this,
          n = t.options.customHeightMatching && t.options.asNavFor;
        n && (e = t.getNavTarget().height()),
          (!n || e < 50) &&
            (e = t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
          t.options.vertical === !1
            ? t.options.centerMode === !0 &&
              t.$list.css({ padding: "0px " + t.options.centerPadding })
            : (t.$list.height(e),
              t.options.centerMode === !0 &&
                t.$list.css({ padding: t.options.centerPadding + " 0px" })),
          (t.listWidth = t.$list.width()),
          (t.listHeight = t.$list.height()),
          t.options.vertical === !1 && t.options.variableWidth === !1
            ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)),
              t.$slideTrack.width(
                Math.ceil(
                  t.slideWidth * t.$slideTrack.children(".slick-slide").length
                )
              ))
            : t.options.variableWidth === !0
            ? t.$slideTrack.width(5e3 * t.slideCount)
            : ((t.slideWidth = Math.ceil(t.listWidth)),
              t.$slideTrack.height(
                Math.ceil(
                  t.$slides.first().outerHeight(!0) *
                    t.$slideTrack.children(".slick-slide").length
                )
              ));
        var i = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        t.options.variableWidth === !1 &&
          t.$slideTrack.children(".slick-slide").width(t.slideWidth - i);
      }),
      (t.prototype.setFade = function () {
        var t,
          n = this;
        n.$slides.each(function (i, o) {
          (t = n.slideWidth * i * -1),
            n.options.rtl === !0
              ? e(o).css({
                  position: "relative",
                  right: t,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 1,
                })
              : e(o).css({
                  position: "relative",
                  left: t,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 1,
                });
        }),
          n.$slides
            .eq(n.currentSlide)
            .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
      }),
      (t.prototype.setHeight = function () {
        var e = this;
        if (
          1 === e.options.slidesToShow &&
          e.options.adaptiveHeight === !0 &&
          e.options.vertical === !1
        ) {
          var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
          e.$list.css("height", t);
        }
      }),
      (t.prototype.setOption = t.prototype.slickSetOption =
        function () {
          var t,
            n,
            i,
            o,
            r,
            s = this,
            a = !1;
          if (
            ("object" === e.type(arguments[0])
              ? ((i = arguments[0]), (a = arguments[1]), (r = "multiple"))
              : "string" === e.type(arguments[0]) &&
                ((i = arguments[0]),
                (o = arguments[1]),
                (a = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === e.type(arguments[1])
                  ? (r = "responsive")
                  : "undefined" != typeof arguments[1] && (r = "single")),
            "single" === r)
          )
            s.options[i] = o;
          else if ("multiple" === r)
            e.each(i, function (e, t) {
              s.options[e] = t;
            });
          else if ("responsive" === r)
            for (n in o)
              if ("array" !== e.type(s.options.responsive))
                s.options.responsive = [o[n]];
              else {
                for (t = s.options.responsive.length - 1; t >= 0; )
                  s.options.responsive[t].breakpoint === o[n].breakpoint &&
                    s.options.responsive.splice(t, 1),
                    t--;
                s.options.responsive.push(o[n]);
              }
          a && (s.unload(), s.reinit());
        }),
      (t.prototype.setPosition = function () {
        var e = this;
        e.setDimensions(),
          e.setHeight(),
          e.options.fade === !1
            ? e.setCSS(e.getLeft(e.currentSlide))
            : e.setFade(),
          e.$slider.trigger("setPosition", [e]);
      }),
      (t.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = e.options.vertical === !0 ? "top" : "left"),
          "top" === e.positionProp
            ? e.$slider.addClass("slick-vertical")
            : e.$slider.removeClass("slick-vertical"),
          (void 0 === t.WebkitTransition &&
            void 0 === t.MozTransition &&
            void 0 === t.msTransition) ||
            (e.options.useCSS === !0 && (e.cssTransitions = !0)),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            e.animType !== !1 &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && e.animType !== !1);
      }),
      (t.prototype.setSlideClasses = function (e) {
        var t,
          n,
          i,
          o,
          r = this;
        (n = r.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
          r.$slides.eq(e).addClass("slick-current"),
          r.options.centerMode === !0
            ? ((t = Math.floor(r.options.slidesToShow / 2)),
              r.options.infinite === !0 &&
                (e >= t && e <= r.slideCount - 1 - t
                  ? r.$slides
                      .slice(e - t, e + t + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((i = r.options.slidesToShow + e),
                    n
                      .slice(i - t + 1, i + t + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === e
                  ? n
                      .eq(n.length - 1 - r.options.slidesToShow)
                      .addClass("slick-center")
                  : e === r.slideCount - 1 &&
                    n.eq(r.options.slidesToShow).addClass("slick-center")),
              r.$slides.eq(e).addClass("slick-center"))
            : e >= 0 && e <= r.slideCount - r.options.slidesToShow
            ? r.$slides
                .slice(e, e + r.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : n.length <= r.options.slidesToShow
            ? n.addClass("slick-active").attr("aria-hidden", "false")
            : ((o = r.slideCount % r.options.slidesToShow),
              (i = r.options.infinite === !0 ? r.options.slidesToShow + e : e),
              r.options.slidesToShow == r.options.slidesToScroll &&
              r.slideCount - e < r.options.slidesToShow
                ? n
                    .slice(i - (r.options.slidesToShow - o), i + o)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : n
                    .slice(i, i + r.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false"));
      }),
      (t.prototype.setupInfinite = function () {
        var t,
          n,
          i,
          o = this;
        if (
          (o.options.fade === !0 && (o.options.centerMode = !1),
          o.options.infinite === !0 &&
            o.options.fade === !1 &&
            ((n = null), o.slideCount > o.options.slidesToShow))
        ) {
          for (
            i =
              o.options.centerMode === !0
                ? o.options.slidesToShow + 1
                : o.options.slidesToShow,
              t = o.slideCount;
            t > o.slideCount - i;
            t -= 1
          )
            (n = t - 1),
              e(o.$slides[n])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", n - o.slideCount)
                .prependTo(o.$slideTrack)
                .addClass("slick-cloned");
          for (t = 0; t < i; t += 1)
            (n = t),
              e(o.$slides[n])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", n + o.slideCount)
                .appendTo(o.$slideTrack)
                .addClass("slick-cloned");
          o.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              e(this).attr("id", "");
            });
        }
      }),
      (t.prototype.interrupt = function (e) {
        var t = this;
        e || t.autoPlay(), (t.interrupted = e);
      }),
      (t.prototype.selectHandler = function (t) {
        var n = this,
          i = e(t.target).is(".slick-slide")
            ? e(t.target)
            : e(t.target).parents(".slick-slide"),
          o = parseInt(i.attr("data-slick-index"));
        return (
          o || (o = 0),
          n.slideCount <= n.options.slidesToShow
            ? (n.setSlideClasses(o), void n.asNavFor(o))
            : void n.slideHandler(o)
        );
      }),
      (t.prototype.slideHandler = function (t, n, i) {
        var o,
          r,
          s,
          a,
          l = null,
          c = this;
        if (
          ((n = n || !1),
          !(
            (c.animating === !0 && c.options.waitForAnimate === !0) ||
            (c.options.fade === !0 && c.currentSlide === t)
          ))
        ) {
          n === !1 && c.asNavFor(t), (o = t), (l = c.getLeft(o));
          var u = !1;
          if (
            (c.slideCount <= c.options.slidesToShow && (u = !0),
            c.options.customSlideAdvancement)
          ) {
            var p = "beside" === c.$slider.data("position"),
              d = c.$slider.find(".slick-slide[data-slick-index=" + o + "]"),
              f = d.length,
              h = c.$slider.find(".slick-track"),
              m = 0,
              v = p ? c.$list.height() : c.$list.width();
            h.find(".slick-slide").each(function () {
              m += p ? e(this).outerHeight(!0) : e(this).outerWidth(!0);
            });
            var g = (p ? h.position().top * -1 : h.position().left * -1, m > v);
            if (g) {
              var y,
                b,
                w,
                x = m - v;
              p
                ? ((w = f ? d.outerHeight(!0) : 0),
                  (y = f ? d.position().top : 0),
                  (b = y - w))
                : ((w = f ? d.outerWidth(!0) : 0),
                  (y = f ? d.position().left : 0),
                  (b = y - w)),
                b >= 0 && (y = b),
                (1 !== t && 0 !== t) || (y = 0),
                y > x && (y = x);
            }
            (l = y * -1), m <= v && (u = !0);
          }
          if (
            ((a = c.getLeft(c.currentSlide)),
            (c.currentLeft = null === c.swipeLeft ? a : c.swipeLeft),
            c.options.infinite === !1 &&
              c.options.centerMode === !1 &&
              (t < 0 || t > c.getDotCount() * c.options.slidesToScroll))
          ) {
            if (u) return;
            return void (
              c.options.fade === !1 &&
              ((o = c.currentSlide),
              i !== !0
                ? c.animateSlide(a, function () {
                    c.postSlide(o);
                  })
                : c.postSlide(o))
            );
          }
          return c.options.infinite === !1 &&
            c.options.centerMode === !0 &&
            (t < 0 || t > c.slideCount - c.options.slidesToScroll)
            ? void (
                c.options.fade === !1 &&
                ((o = c.currentSlide),
                i !== !0
                  ? c.animateSlide(a, function () {
                      c.postSlide(o);
                    })
                  : c.postSlide(o))
              )
            : (c.options.autoplay && clearInterval(c.autoPlayTimer),
              (r =
                o < 0
                  ? c.slideCount % c.options.slidesToScroll !== 0
                    ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                    : c.slideCount + o
                  : o >= c.slideCount
                  ? c.slideCount % c.options.slidesToScroll !== 0
                    ? 0
                    : o - c.slideCount
                  : o),
              (c.animating = !0),
              c.$slider.trigger("beforeChange", [c, c.currentSlide, r]),
              (s = c.currentSlide),
              (c.currentSlide = r),
              c.setSlideClasses(c.currentSlide),
              c.options.vertical && u && (i = !0),
              c.updateDots(),
              c.updateArrows(),
              c.options.fade === !0
                ? (i !== !0
                    ? (c.fadeSlideOut(s),
                      c.fadeSlide(r, function () {
                        c.postSlide(r);
                      }))
                    : c.postSlide(r),
                  void c.animateHeight())
                : void (i !== !0
                    ? (0 === r && c.options.vertical && (l = 0),
                      c.animateSlide(l, function () {
                        c.postSlide(r);
                      }))
                    : c.postSlide(r)));
        }
      }),
      (t.prototype.startLoad = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.hide(), e.$nextArrow.hide()),
          e.options.dots === !0 &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.hide(),
          e.$slider.addClass("slick-loading");
      }),
      (t.prototype.swipeDirection = function () {
        var e,
          t,
          n,
          i,
          o = this;
        return (
          (e = o.touchObject.startX - o.touchObject.curX),
          (t = o.touchObject.startY - o.touchObject.curY),
          (n = Math.atan2(t, e)),
          (i = Math.round((180 * n) / Math.PI)),
          i < 0 && (i = 360 - Math.abs(i)),
          i <= 45 && i >= 0
            ? o.options.rtl === !1
              ? "left"
              : "right"
            : i <= 360 && i >= 315
            ? o.options.rtl === !1
              ? "left"
              : "right"
            : i >= 135 && i <= 225
            ? o.options.rtl === !1
              ? "right"
              : "left"
            : o.options.verticalSwiping === !0
            ? i >= 35 && i <= 135
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (t.prototype.swipeEnd = function (e) {
        var t,
          n,
          i = this;
        if (
          ((i.dragging = !1),
          (i.interrupted = !1),
          (i.shouldClick = !(i.touchObject.swipeLength > 10)),
          void 0 === i.touchObject.curX)
        )
          return !1;
        if (
          (i.touchObject.edgeHit === !0 &&
            i.$slider.trigger("edge", [i, i.swipeDirection()]),
          i.touchObject.swipeLength >= i.touchObject.minSwipe)
        ) {
          switch ((n = i.swipeDirection())) {
            case "left":
            case "down":
              (t = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                : i.currentSlide + i.getSlideCount()),
                (i.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                : i.currentSlide - i.getSlideCount()),
                (i.currentDirection = 1);
          }
          "vertical" != n &&
            (i.slideHandler(t),
            (i.touchObject = {}),
            i.$slider.trigger("swipe", [i, n]));
        } else
          i.touchObject.startX !== i.touchObject.curX &&
            (i.slideHandler(i.currentSlide), (i.touchObject = {}));
      }),
      (t.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            t.options.swipe === !1 ||
            ("ontouchend" in document && t.options.swipe === !1) ||
            (t.options.draggable === !1 && e.type.indexOf("mouse") !== -1)
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            t.options.verticalSwiping === !0 &&
              (t.touchObject.minSwipe =
                t.listHeight / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (t.prototype.swipeMove = function (e) {
        var t,
          n,
          i,
          o,
          r,
          s = this;
        return (
          (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
          !(!s.dragging || (r && 1 !== r.length)) &&
            ((t = s.getLeft(s.currentSlide)),
            (s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
            (s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
            (s.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))
            )),
            s.options.verticalSwiping === !0 &&
              (s.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(s.touchObject.curY - s.touchObject.startY, 2)
                )
              )),
            (n = s.swipeDirection()),
            "vertical" !== n
              ? (void 0 !== e.originalEvent &&
                  s.touchObject.swipeLength > 4 &&
                  e.preventDefault(),
                (o =
                  (s.options.rtl === !1 ? 1 : -1) *
                  (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                s.options.verticalSwiping === !0 &&
                  (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                (i = s.touchObject.swipeLength),
                (s.touchObject.edgeHit = !1),
                s.options.infinite === !1 &&
                  ((0 === s.currentSlide && "right" === n) ||
                    (s.currentSlide >= s.getDotCount() && "left" === n)) &&
                  ((i = s.touchObject.swipeLength * s.options.edgeFriction),
                  (s.touchObject.edgeHit = !0)),
                s.options.vertical === !1
                  ? (s.swipeLeft = t + i * o)
                  : (s.swipeLeft =
                      t + i * (s.$list.height() / s.listWidth) * o),
                s.options.verticalSwiping === !0 && (s.swipeLeft = t + i * o),
                s.options.fade !== !0 &&
                  s.options.touchMove !== !1 &&
                  (s.animating === !0
                    ? ((s.swipeLeft = null), !1)
                    : void s.setCSS(s.swipeLeft)))
              : void 0)
        );
      }),
      (t.prototype.swipeStart = function (e) {
        var t,
          n = this;
        return (
          (n.interrupted = !0),
          1 !== n.touchObject.fingerCount ||
          n.slideCount <= n.options.slidesToShow
            ? ((n.touchObject = {}), !1)
            : (void 0 !== e.originalEvent &&
                void 0 !== e.originalEvent.touches &&
                (t = e.originalEvent.touches[0]),
              (n.touchObject.startX = n.touchObject.curX =
                void 0 !== t ? t.pageX : e.clientX),
              (n.touchObject.startY = n.touchObject.curY =
                void 0 !== t ? t.pageY : e.clientY),
              void (n.dragging = !0))
        );
      }),
      (t.prototype.unfilterSlides = t.prototype.slickUnfilter =
        function () {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
      (t.prototype.unload = function () {
        var t = this;
        e(".slick-cloned", t.$slider).remove(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.htmlExpr.test(t.options.prevArrow) &&
            t.$prevArrow.remove(),
          t.$nextArrow &&
            t.htmlExpr.test(t.options.nextArrow) &&
            t.$nextArrow.remove(),
          t.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (t.prototype.unslick = function (e) {
        var t = this;
        t.$slider.trigger("unslick", [t, e]), t.destroy();
      }),
      (t.prototype.updateArrows = function () {
        var e,
          t = this;
        (e = Math.floor(t.options.slidesToShow / 2)),
          t.options.arrows === !0 &&
            t.slideCount > t.options.slidesToShow &&
            !t.options.infinite &&
            (t.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            t.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === t.currentSlide
              ? (t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                t.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : t.currentSlide >= t.slideCount - t.options.slidesToShow &&
                t.options.centerMode === !1
              ? (t.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                t.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : t.currentSlide >= t.slideCount - 1 &&
                t.options.centerMode === !0 &&
                (t.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                t.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (t.prototype.updateDots = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots
            .find("li")
            .removeClass("slick-active")
            .attr("aria-hidden", "true"),
          e.$dots
            .find("li")
            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
            .addClass("slick-active")
            .attr("aria-hidden", "false"));
      }),
      (t.prototype.visibility = function () {
        var e = this;
        e.options.autoplay &&
          (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
      }),
      (e.fn.slick = function () {
        var e,
          n,
          i = this,
          o = arguments[0],
          r = Array.prototype.slice.call(arguments, 1),
          s = i.length;
        for (e = 0; e < s; e++)
          if (
            ("object" == typeof o || "undefined" == typeof o
              ? (i[e].slick = new t(i[e], o))
              : (n = i[e].slick[o].apply(i[e].slick, r)),
            "undefined" != typeof n)
          )
            return n;
        return i;
      });
  }) /*! lazysizes respimg - v4.0.1 */,
  !(function (e, t) {
    var n = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
    };
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
        : e.lazySizes
        ? n()
        : e.addEventListener("lazyunveilread", n, !0);
  })(window, function (e, t, n) {
    "use strict";
    var i,
      o = (n && n.cfg) || e.lazySizesConfig,
      r = t.createElement("img"),
      s = "sizes" in r && "srcset" in r,
      a = /\s+\d+h/g,
      l = (function () {
        var e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
          n = Array.prototype.forEach;
        return function (i) {
          var o = t.createElement("img"),
            r = function (t) {
              var n,
                i = t.getAttribute(lazySizesConfig.srcsetAttr);
              i &&
                (i.match(e) &&
                  ((n =
                    "w" == RegExp.$2
                      ? RegExp.$1 / RegExp.$3
                      : RegExp.$3 / RegExp.$1),
                  n && t.setAttribute("data-aspectratio", n)),
                t.setAttribute(lazySizesConfig.srcsetAttr, i.replace(a, "")));
            },
            s = function (e) {
              var t = e.target.parentNode;
              t &&
                "PICTURE" == t.nodeName &&
                n.call(t.getElementsByTagName("source"), r),
                r(e.target);
            },
            l = function () {
              o.currentSrc && t.removeEventListener("lazybeforeunveil", s);
            };
          i[1] &&
            (t.addEventListener("lazybeforeunveil", s),
            (o.onload = l),
            (o.onerror = l),
            (o.srcset = "data:,a 1w 1h"),
            o.complete && l());
        };
      })();
    if (
      (o || ((o = {}), (e.lazySizesConfig = o)),
      o.supportsType ||
        (o.supportsType = function (e) {
          return !e;
        }),
      !e.picturefill && !o.pf)
    ) {
      if (e.HTMLPictureElement && s)
        return (
          t.msElementsFromPoint && l(navigator.userAgent.match(/Edge\/(\d+)/)),
          void (o.pf = function () {})
        );
      (o.pf = function (t) {
        var n, o;
        if (!e.picturefill)
          for (n = 0, o = t.elements.length; o > n; n++) i(t.elements[n]);
      }),
        (i = (function () {
          var r = function (e, t) {
              return e.w - t.w;
            },
            l = /^\s*\d+\.*\d*px\s*$/,
            c = function (e) {
              var t,
                n,
                i = e.length,
                o = e[i - 1],
                r = 0;
              for (r; i > r; r++)
                if (((o = e[r]), (o.d = o.w / e.w), o.d >= e.d)) {
                  !o.cached &&
                    (t = e[r - 1]) &&
                    t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                    ((n = Math.pow(t.d - 0.6, 1.6)),
                    t.cached && (t.d += 0.15 * n),
                    t.d + (o.d - e.d) * n > e.d && (o = t));
                  break;
                }
              return o;
            },
            u = (function () {
              var e,
                t = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                n = /\s/,
                i = function (t, n, i, o) {
                  e.push({ c: n, u: i, w: 1 * o });
                };
              return function (o) {
                return (
                  (e = []),
                  (o = o.trim()),
                  o.replace(a, "").replace(t, i),
                  e.length || !o || n.test(o) || e.push({ c: o, u: o, w: 99 }),
                  e
                );
              };
            })(),
            p = function () {
              p.init ||
                ((p.init = !0),
                addEventListener(
                  "resize",
                  (function () {
                    var e,
                      n = t.getElementsByClassName("lazymatchmedia"),
                      o = function () {
                        var e, t;
                        for (e = 0, t = n.length; t > e; e++) i(n[e]);
                      };
                    return function () {
                      clearTimeout(e), (e = setTimeout(o, 66));
                    };
                  })()
                ));
            },
            d = function (t, i) {
              var r,
                s = t.getAttribute("srcset") || t.getAttribute(o.srcsetAttr);
              !s &&
                i &&
                (s = t._lazypolyfill
                  ? t._lazypolyfill._set
                  : t.getAttribute(o.srcAttr) || t.getAttribute("src")),
                (t._lazypolyfill && t._lazypolyfill._set == s) ||
                  ((r = u(s || "")),
                  i &&
                    t.parentNode &&
                    ((r.isPicture =
                      "PICTURE" == t.parentNode.nodeName.toUpperCase()),
                    r.isPicture &&
                      e.matchMedia &&
                      (n.aC(t, "lazymatchmedia"), p())),
                  (r._set = s),
                  Object.defineProperty(t, "_lazypolyfill", {
                    value: r,
                    writable: !0,
                  }));
            },
            f = function (t) {
              var i = e.devicePixelRatio || 1,
                o = n.getX && n.getX(t);
              return Math.min(o || i, 2.5, i);
            },
            h = function (t) {
              return e.matchMedia
                ? (h = function (e) {
                    return !e || (matchMedia(e) || {}).matches;
                  })(t)
                : !t;
            },
            m = function (e) {
              var t, i, s, a, u, p, m;
              if (((a = e), d(a, !0), (u = a._lazypolyfill), u.isPicture))
                for (
                  i = 0,
                    t = e.parentNode.getElementsByTagName("source"),
                    s = t.length;
                  s > i;
                  i++
                )
                  if (
                    o.supportsType(t[i].getAttribute("type"), e) &&
                    h(t[i].getAttribute("media"))
                  ) {
                    (a = t[i]), d(a), (u = a._lazypolyfill);
                    break;
                  }
              return (
                u.length > 1
                  ? ((m = a.getAttribute("sizes") || ""),
                    (m =
                      (l.test(m) && parseInt(m, 10)) || n.gW(e, e.parentNode)),
                    (u.d = f(e)),
                    !u.src || !u.w || u.w < m
                      ? ((u.w = m), (p = c(u.sort(r))), (u.src = p))
                      : (p = u.src))
                  : (p = u[0]),
                p
              );
            },
            v = function (e) {
              if (
                !s ||
                !e.parentNode ||
                "PICTURE" == e.parentNode.nodeName.toUpperCase()
              ) {
                var t = m(e);
                t &&
                  t.u &&
                  e._lazypolyfill.cur != t.u &&
                  ((e._lazypolyfill.cur = t.u),
                  (t.cached = !0),
                  e.setAttribute(o.srcAttr, t.u),
                  e.setAttribute("src", t.u));
              }
            };
          return (v.parse = u), v;
        })()),
        o.loadedClass &&
          o.loadingClass &&
          !(function () {
            var e = [];
            [
              'img[sizes$="px"][srcset].',
              "picture > img:not([srcset]).",
            ].forEach(function (t) {
              e.push(t + o.loadedClass), e.push(t + o.loadingClass);
            }),
              o.pf({ elements: t.querySelectorAll(e.join(", ")) });
          })();
    }
  }) /*! lazysizes rias - v4.0.1 */,
  !(function (e, t) {
    var n = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
    };
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : e.lazySizes
        ? n()
        : e.addEventListener("lazyunveilread", n, !0);
  })(window, function (e, t, n) {
    "use strict";
    function i(t, n) {
      var i,
        o,
        r,
        s,
        a = e.getComputedStyle(t);
      (o = t.parentNode),
        (s = { isPicture: !(!o || !d.test(o.nodeName || "")) }),
        (r = function (e, n) {
          var i = t.getAttribute("data-" + e);
          if (!i) {
            var o = a.getPropertyValue("--ls-" + e);
            o && (i = o.trim());
          }
          if (i) {
            if ("true" == i) i = !0;
            else if ("false" == i) i = !1;
            else if (p.test(i)) i = parseFloat(i);
            else if ("function" == typeof c[e]) i = c[e](t, i);
            else if (v.test(i))
              try {
                i = JSON.parse(i);
              } catch (e) {}
            s[e] = i;
          } else
            e in c && "function" != typeof c[e]
              ? (s[e] = c[e])
              : n && "function" == typeof c[e] && (s[e] = c[e](t, i));
        });
      for (i in c) r(i);
      return (
        n.replace(m, function (e, t) {
          t in s || r(t, !0);
        }),
        s
      );
    }
    function o(e, t) {
      var n = [],
        i = function (e, n) {
          return u[typeof t[n]] ? t[n] : e;
        };
      return (
        (n.srcset = []),
        t.absUrl && (y.setAttribute("href", e), (e = y.href)),
        (e = ((t.prefix || "") + e + (t.postfix || "")).replace(m, i)),
        t.widths.forEach(function (i) {
          var o = t.widthmap[i] || i,
            r = {
              u: e
                .replace(f, o)
                .replace(h, t.ratio ? Math.round(i * t.ratio) : ""),
              w: i,
            };
          n.push(r), n.srcset.push((r.c = r.u + " " + i + "w"));
        }),
        n
      );
    }
    function r(e, n, i) {
      var r = 0,
        s = 0,
        a = i;
      if (e) {
        if ("container" === n.ratio) {
          for (r = a.scrollWidth, s = a.scrollHeight; !((r && s) || a === t); )
            (a = a.parentNode), (r = a.scrollWidth), (s = a.scrollHeight);
          r && s && (n.ratio = s / r);
        }
        (e = o(e, n)),
          (e.isPicture = n.isPicture),
          w && "IMG" == i.nodeName.toUpperCase()
            ? i.removeAttribute(l.srcsetAttr)
            : i.setAttribute(l.srcsetAttr, e.srcset.join(", ")),
          Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
      }
    }
    function s(e, t) {
      var o = i(e, t);
      return (
        c.modifyOptions.call(e, { target: e, details: o, detail: o }),
        n.fire(e, "lazyriasmodifyoptions", o),
        o
      );
    }
    function a(e) {
      return (
        e.getAttribute(e.getAttribute("data-srcattr") || c.srcAttr) ||
        e.getAttribute(l.srcsetAttr) ||
        e.getAttribute(l.srcAttr) ||
        e.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    var l,
      c,
      u = { string: 1, number: 1 },
      p = /^\-*\+*\d+\.*\d*$/,
      d = /^picture$/i,
      f = /\s*\{\s*width\s*\}\s*/i,
      h = /\s*\{\s*height\s*\}\s*/i,
      m = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      v = /^\[.*\]|\{.*\}$/,
      g = /^(?:auto|\d+(px)?)$/,
      y = t.createElement("a"),
      b = t.createElement("img"),
      w = "srcset" in b && !("sizes" in b),
      x = !!e.HTMLPictureElement && !w;
    !(function () {
      var t,
        i = function () {},
        o = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: i,
          widthmap: {},
          ratio: !1,
        };
      (l = (n && n.cfg) || e.lazySizesConfig),
        l || ((l = {}), (e.lazySizesConfig = l)),
        l.supportsType ||
          (l.supportsType = function (e) {
            return !e;
          }),
        l.rias || (l.rias = {}),
        (c = l.rias),
        "widths" in c ||
          ((c.widths = []),
          (function (e) {
            for (var t, n = 0; !t || 3e3 > t; )
              (n += 5), n > 30 && (n += 1), (t = 36 * n), e.push(t);
          })(c.widths));
      for (t in o) t in c || (c[t] = o[t]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance == n) {
            var t, i, o, u, p, d, h, m, v, y, b, w, S;
            if (
              ((t = e.target),
              e.detail.dataAttr &&
                !e.defaultPrevented &&
                !c.disabled &&
                (v = t.getAttribute(l.sizesAttr) || t.getAttribute("sizes")) &&
                g.test(v))
            ) {
              if (
                ((i = a(t)),
                (o = s(t, i)),
                (b = f.test(o.prefix) || f.test(o.postfix)),
                o.isPicture && (u = t.parentNode))
              )
                for (
                  p = u.getElementsByTagName("source"), d = 0, h = p.length;
                  h > d;
                  d++
                )
                  (b || f.test((m = a(p[d])))) && (r(m, o, p[d]), (w = !0));
              b || f.test(i)
                ? (r(i, o, t), (w = !0))
                : w &&
                  ((S = []),
                  (S.srcset = []),
                  (S.isPicture = !0),
                  Object.defineProperty(t, "_lazyrias", {
                    value: S,
                    writable: !0,
                  })),
                w &&
                  (x
                    ? t.removeAttribute(l.srcAttr)
                    : "auto" != v &&
                      ((y = { width: parseInt(v, 10) }),
                      k({ target: t, detail: y })));
            }
          }
        },
        !0
      );
    var k = (function () {
      var i = function (e, t) {
          return e.w - t.w;
        },
        o = function (e) {
          var t,
            n,
            i = e.length,
            o = e[i - 1],
            r = 0;
          for (r; i > r; r++)
            if (((o = e[r]), (o.d = o.w / e.w), o.d >= e.d)) {
              !o.cached &&
                (t = e[r - 1]) &&
                t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                ((n = Math.pow(t.d - 0.6, 1.6)),
                t.cached && (t.d += 0.15 * n),
                t.d + (o.d - e.d) * n > e.d && (o = t));
              break;
            }
          return o;
        },
        r = function (e, t) {
          var i;
          return (
            !e._lazyrias &&
              n.pWS &&
              (i = n.pWS(e.getAttribute(l.srcsetAttr || ""))).length &&
              (Object.defineProperty(e, "_lazyrias", {
                value: i,
                writable: !0,
              }),
              t &&
                e.parentNode &&
                (i.isPicture =
                  "PICTURE" == e.parentNode.nodeName.toUpperCase())),
            e._lazyrias
          );
        },
        s = function (t) {
          var i = e.devicePixelRatio || 1,
            o = n.getX && n.getX(t);
          return Math.min(o || i, 2.4, i);
        },
        a = function (t, n) {
          var a, l, c, u, p, d;
          if (((p = t._lazyrias), p.isPicture && e.matchMedia))
            for (
              l = 0,
                a = t.parentNode.getElementsByTagName("source"),
                c = a.length;
              c > l;
              l++
            )
              if (
                r(a[l]) &&
                !a[l].getAttribute("type") &&
                (!(u = a[l].getAttribute("media")) ||
                  (matchMedia(u) || {}).matches)
              ) {
                p = a[l]._lazyrias;
                break;
              }
          return (
            (!p.w || p.w < n) && ((p.w = n), (p.d = s(t)), (d = o(p.sort(i)))),
            d
          );
        },
        c = function (i) {
          if (i.detail.instance == n) {
            var o,
              s = i.target;
            return !w && (e.respimage || e.picturefill || lazySizesConfig.pf)
              ? void t.removeEventListener("lazybeforesizes", c)
              : void (
                  ("_lazyrias" in s || (i.detail.dataAttr && r(s, !0))) &&
                  ((o = a(s, i.detail.width)),
                  o &&
                    o.u &&
                    s._lazyrias.cur != o.u &&
                    ((s._lazyrias.cur = o.u),
                    (o.cached = !0),
                    n.rAF(function () {
                      s.setAttribute(l.srcAttr, o.u),
                        s.setAttribute("src", o.u);
                    })))
                );
          }
        };
      return (
        x ? (c = function () {}) : addEventListener("lazybeforesizes", c), c
      );
    })();
  }) /*! lazysizes bgset - v4.0.1 */,
  !(function (e, t) {
    var n = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
    };
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : e.lazySizes
        ? n()
        : e.addEventListener("lazyunveilread", n, !0);
  })(window, function (e, t, n) {
    "use strict";
    if (e.addEventListener) {
      var i = /\s+/g,
        o = /\s*\|\s+|\s+\|\s*/g,
        r = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
        s = /\(|\)|'/,
        a = { contain: 1, cover: 1 },
        l = function (e) {
          var t = n.gW(e, e.parentNode);
          return (
            (!e._lazysizesWidth || t > e._lazysizesWidth) &&
              (e._lazysizesWidth = t),
            e._lazysizesWidth
          );
        },
        c = function (e) {
          var t;
          return (
            (t = (
              getComputedStyle(e) || { getPropertyValue: function () {} }
            ).getPropertyValue("background-size")),
            !a[t] && a[e.style.backgroundSize] && (t = e.style.backgroundSize),
            t
          );
        },
        u = function (e, n, s) {
          var a = t.createElement("picture"),
            l = n.getAttribute(lazySizesConfig.sizesAttr),
            c = n.getAttribute("data-ratio"),
            u = n.getAttribute("data-optimumx");
          n._lazybgset &&
            n._lazybgset.parentNode == n &&
            n.removeChild(n._lazybgset),
            Object.defineProperty(s, "_lazybgset", { value: n, writable: !0 }),
            Object.defineProperty(n, "_lazybgset", { value: a, writable: !0 }),
            (e = e.replace(i, " ").split(o)),
            (a.style.display = "none"),
            (s.className = lazySizesConfig.lazyClass),
            1 != e.length || l || (l = "auto"),
            e.forEach(function (e) {
              var n = t.createElement("source");
              l && "auto" != l && n.setAttribute("sizes", l),
                e.match(r) &&
                  (n.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                  RegExp.$2 &&
                    n.setAttribute(
                      "media",
                      lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2
                    )),
                a.appendChild(n);
            }),
            l &&
              (s.setAttribute(lazySizesConfig.sizesAttr, l),
              n.removeAttribute(lazySizesConfig.sizesAttr),
              n.removeAttribute("sizes")),
            u && s.setAttribute("data-optimumx", u),
            c && s.setAttribute("data-ratio", c),
            a.appendChild(s),
            n.appendChild(a);
        },
        p = function (e) {
          if (e.target._lazybgset) {
            var t = e.target,
              i = t._lazybgset,
              o = t.currentSrc || t.src;
            o &&
              (i.style.backgroundImage =
                "url(" + (s.test(o) ? JSON.stringify(o) : o) + ")"),
              t._lazybgsetLoading &&
                (n.fire(i, "_lazyloaded", {}, !1, !0),
                delete t._lazybgsetLoading);
          }
        };
      addEventListener("lazybeforeunveil", function (e) {
        var i, o, r;
        !e.defaultPrevented &&
          (i = e.target.getAttribute("data-bgset")) &&
          ((r = e.target),
          (o = t.createElement("img")),
          (o.alt = ""),
          (o._lazybgsetLoading = !0),
          (e.detail.firesLoad = !0),
          u(i, r, o),
          setTimeout(function () {
            n.loader.unveil(o),
              n.rAF(function () {
                n.fire(o, "_lazyloaded", {}, !0, !0),
                  o.complete && p({ target: o });
              });
          }));
      }),
        t.addEventListener("load", p, !0),
        e.addEventListener(
          "lazybeforesizes",
          function (e) {
            if (
              e.detail.instance == n &&
              e.target._lazybgset &&
              e.detail.dataAttr
            ) {
              var t = e.target._lazybgset,
                i = c(t);
              a[i] &&
                ((e.target._lazysizesParentFit = i),
                n.rAF(function () {
                  e.target.setAttribute("data-parent-fit", i),
                    e.target._lazysizesParentFit &&
                      delete e.target._lazysizesParentFit;
                }));
            }
          },
          !0
        ),
        t.documentElement.addEventListener("lazybeforesizes", function (e) {
          !e.defaultPrevented &&
            e.target._lazybgset &&
            e.detail.instance == n &&
            (e.detail.width = l(e.target._lazybgset));
        });
    }
  }) /*! lazysizes object-fit - v4.1.2 */,
  !(function (e, t) {
    var n = function (i) {
      t(e.lazySizes, i), e.removeEventListener("lazyunveilread", n, !0);
    };
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : e.lazySizes
        ? n()
        : e.addEventListener("lazyunveilread", n, !0);
  })(window, function (e, t, n, i) {
    "use strict";
    function o(e) {
      var t = getComputedStyle(e, null) || {},
        n = t.fontFamily || "",
        i = n.match(c) || "",
        o = (i && n.match(u)) || "";
      return (
        o && (o = o[1]),
        { fit: (i && i[1]) || "", position: f[o] || o || "center" }
      );
    }
    function r(e, t) {
      var i,
        o,
        r = n.cfg,
        s = e.cloneNode(!1),
        a = s.style,
        l = function () {
          var t = e.currentSrc || e.src;
          t &&
            o !== t &&
            ((o = t),
            (a.backgroundImage =
              "url(" + (d.test(t) ? JSON.stringify(t) : t) + ")"),
            i || ((i = !0), n.rC(s, r.loadingClass), n.aC(s, r.loadedClass)));
        },
        c = function () {
          n.rAF(l);
        };
      (e._lazysizesParentFit = t.fit),
        e.addEventListener("lazyloaded", c, !0),
        e.addEventListener("load", c, !0),
        s.addEventListener("load", function () {
          var e = s.currentSrc || s.src;
          e && e != p && ((s.src = p), (s.srcset = ""));
        }),
        n.rAF(function () {
          var i = e,
            o = e.parentNode;
          "PICTURE" == o.nodeName.toUpperCase() &&
            ((i = o), (o = o.parentNode)),
            n.rC(s, r.loadedClass),
            n.rC(s, r.lazyClass),
            n.aC(s, r.loadingClass),
            n.aC(s, r.objectFitClass || "lazysizes-display-clone"),
            s.getAttribute(r.srcsetAttr) && s.setAttribute(r.srcsetAttr, ""),
            s.getAttribute(r.srcAttr) && s.setAttribute(r.srcAttr, ""),
            (s.src = p),
            (s.srcset = ""),
            (a.backgroundRepeat = "no-repeat"),
            (a.backgroundPosition = t.position),
            (a.backgroundSize = t.fit),
            (i.style.display = "none"),
            e.setAttribute("data-parent-fit", t.fit),
            e.setAttribute("data-parent-container", "prev"),
            o.insertBefore(s, i),
            e._lazysizesParentFit && delete e._lazysizesParentFit,
            e.complete && l();
        });
    }
    var s = t.createElement("a").style,
      a = "objectFit" in s,
      l = a && "objectPosition" in s,
      c = /object-fit["']*\s*:\s*["']*(contain|cover)/,
      u = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
      p =
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      d = /\(|\)|'/,
      f = { center: "center", "50% 50%": "center" };
    if (!a || !l) {
      var h = function (e) {
        if (e.detail.instance == n) {
          var t = e.target,
            i = o(t);
          !i.fit || (a && "center" == i.position) || r(t, i);
        }
      };
      e.addEventListener("lazyunveilread", h, !0), i && i.detail && h(i);
    }
  }) /*! lazysizes parent-fit - v4.1.2 */,
  !(function (e, t) {
    var n = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
    };
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : e.lazySizes
        ? n()
        : e.addEventListener("lazyunveilread", n, !0);
  })(window, function (e, t, n) {
    "use strict";
    if (e.addEventListener) {
      var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
        r = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
        s = /^picture$/i,
        a = function (e) {
          return getComputedStyle(e, null) || {};
        },
        l = {
          getParent: function (t, n) {
            var i = t,
              o = t.parentNode;
            return (
              (n && "prev" != n) ||
                !o ||
                !s.test(o.nodeName || "") ||
                (o = o.parentNode),
              "self" != n &&
                (i =
                  "prev" == n
                    ? t.previousElementSibling
                    : n && (o.closest || e.jQuery)
                    ? (o.closest ? o.closest(n) : jQuery(o).closest(n)[0]) || o
                    : o),
              i
            );
          },
          getFit: function (e) {
            var t,
              n,
              i = a(e),
              s = i.content || i.fontFamily,
              c = {
                fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit"),
              };
            return (
              !c.fit && s && (t = s.match(o)) && (c.fit = t[1]),
              c.fit
                ? ((n =
                    e._lazysizesParentContainer ||
                    e.getAttribute("data-parent-container")),
                  !n && s && (t = s.match(r)) && (n = t[1]),
                  (c.parent = l.getParent(e, n)))
                : (c.fit = i.objectFit),
              c
            );
          },
          getImageRatio: function (t) {
            var n,
              o,
              r,
              a,
              l,
              c = t.parentNode,
              u =
                c && s.test(c.nodeName || "")
                  ? c.querySelectorAll("source, img")
                  : [t];
            for (n = 0; n < u.length; n++)
              if (
                ((t = u[n]),
                (o =
                  t.getAttribute(lazySizesConfig.srcsetAttr) ||
                  t.getAttribute("srcset") ||
                  t.getAttribute("data-pfsrcset") ||
                  t.getAttribute("data-risrcset") ||
                  ""),
                (r = t._lsMedia || t.getAttribute("media")),
                (r =
                  lazySizesConfig.customMedia[
                    t.getAttribute("data-media") || r
                  ] || r),
                o && (!r || ((e.matchMedia && matchMedia(r)) || {}).matches))
              ) {
                (a = parseFloat(t.getAttribute("data-aspectratio"))),
                  !a &&
                    (l = o.match(i)) &&
                    (a = "w" == l[2] ? l[1] / l[3] : l[3] / l[1]);
                break;
              }
            return a;
          },
          calculateSize: function (e, t) {
            var n,
              i,
              o,
              r,
              s = this.getFit(e),
              a = s.fit,
              l = s.parent;
            return "width" == a ||
              (("contain" == a || "cover" == a) && (o = this.getImageRatio(e)))
              ? (l ? (t = l.clientWidth) : (l = e),
                (r = t),
                "width" == a
                  ? (r = t)
                  : ((i = l.clientHeight),
                    i > 40 &&
                      (n = t / i) &&
                      (("cover" == a && o > n) || ("contain" == a && n > o)) &&
                      (r = t * (o / n))),
                r)
              : t;
          },
        };
      (n.parentFit = l),
        t.addEventListener("lazybeforesizes", function (e) {
          if (!e.defaultPrevented && e.detail.instance == n) {
            var t = e.target;
            e.detail.width = l.calculateSize(t, e.detail.width);
          }
        });
    }
  }) /*! lazysizes - v4.0.2 */,
  !(function (e, t) {
    var n = t(e, e.document);
    (e.lazySizes = n),
      "object" == typeof module && module.exports && (module.exports = n);
  })(window, function (e, t) {
    "use strict";
    if (t.getElementsByClassName) {
      var n,
        i,
        o = t.documentElement,
        r = e.Date,
        s = e.HTMLPictureElement,
        a = "addEventListener",
        l = "getAttribute",
        c = e[a],
        u = e.setTimeout,
        p = e.requestAnimationFrame || u,
        d = e.requestIdleCallback,
        f = /^picture$/i,
        h = ["load", "error", "lazyincluded", "_lazyloaded"],
        m = {},
        v = Array.prototype.forEach,
        g = function (e, t) {
          return (
            m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
            m[t].test(e[l]("class") || "") && m[t]
          );
        },
        y = function (e, t) {
          g(e, t) ||
            e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
        },
        b = function (e, t) {
          var n;
          (n = g(e, t)) &&
            e.setAttribute("class", (e[l]("class") || "").replace(n, " "));
        },
        w = function (e, t, n) {
          var i = n ? a : "removeEventListener";
          n && w(e, t),
            h.forEach(function (n) {
              e[i](n, t);
            });
        },
        x = function (e, i, o, r, s) {
          var a = t.createEvent("CustomEvent");
          return (
            o || (o = {}),
            (o.instance = n),
            a.initCustomEvent(i, !r, !s, o),
            e.dispatchEvent(a),
            a
          );
        },
        k = function (t, n) {
          var o;
          !s && (o = e.picturefill || i.pf)
            ? o({ reevaluate: !0, elements: [t] })
            : n && n.src && (t.src = n.src);
        },
        S = function (e, t) {
          return (getComputedStyle(e, null) || {})[t];
        },
        C = function (e, t, n) {
          for (
            n = n || e.offsetWidth;
            n < i.minSize && t && !e._lazysizesWidth;

          )
            (n = t.offsetWidth), (t = t.parentNode);
          return n;
        },
        T = (function () {
          var e,
            n,
            i = [],
            o = [],
            r = i,
            s = function () {
              var t = r;
              for (r = i.length ? o : i, e = !0, n = !1; t.length; )
                t.shift()();
              e = !1;
            },
            a = function (i, o) {
              e && !o
                ? i.apply(this, arguments)
                : (r.push(i), n || ((n = !0), (t.hidden ? u : p)(s)));
            };
          return (a._lsFlush = s), a;
        })(),
        E = function (e, t) {
          return t
            ? function () {
                T(e);
              }
            : function () {
                var t = this,
                  n = arguments;
                T(function () {
                  e.apply(t, n);
                });
              };
        },
        A = function (e) {
          var t,
            n = 0,
            o = i.throttleDelay,
            s = i.ricTimeout,
            a = function () {
              (t = !1), (n = r.now()), e();
            },
            l =
              d && s > 49
                ? function () {
                    d(a, { timeout: s }),
                      s !== i.ricTimeout && (s = i.ricTimeout);
                  }
                : E(function () {
                    u(a);
                  }, !0);
          return function (e) {
            var i;
            (e = !0 === e) && (s = 33),
              t ||
                ((t = !0),
                (i = o - (r.now() - n)),
                i < 0 && (i = 0),
                e || i < 9 ? l() : u(l, i));
          };
        },
        P = function (e) {
          var t,
            n,
            i = 99,
            o = function () {
              (t = null), e();
            },
            s = function () {
              var e = r.now() - n;
              e < i ? u(s, i - e) : (d || o)(o);
            };
          return function () {
            (n = r.now()), t || (t = u(s, i));
          };
        };
      !(function () {
        var t,
          n = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 0,
            throttleDelay: 125,
          };
        i = e.lazySizesConfig || e.lazysizesConfig || {};
        for (t in n) t in i || (i[t] = n[t]);
        (e.lazySizesConfig = i),
          u(function () {
            i.init && $();
          });
      })();
      var _ = (function () {
          var s,
            p,
            d,
            h,
            m,
            C,
            _,
            $,
            I,
            L,
            N,
            D,
            M,
            z,
            j = /^img$/i,
            H = /^iframe$/i,
            R = "onscroll" in e && !/glebot/.test(navigator.userAgent),
            F = 0,
            q = 0,
            B = 0,
            W = -1,
            U = function (e) {
              B--,
                e && e.target && w(e.target, U),
                (!e || B < 0 || !e.target) && (B = 0);
            },
            V = function (e, n) {
              var i,
                r = e,
                s =
                  "hidden" == S(t.body, "visibility") ||
                  "hidden" != S(e, "visibility");
              for (
                $ -= n, N += n, I -= n, L += n;
                s && (r = r.offsetParent) && r != t.body && r != o;

              )
                (s = (S(r, "opacity") || 1) > 0) &&
                  "visible" != S(r, "overflow") &&
                  ((i = r.getBoundingClientRect()),
                  (s =
                    L > i.left &&
                    I < i.right &&
                    N > i.top - 1 &&
                    $ < i.bottom + 1));
              return s;
            },
            Z = function () {
              var e,
                r,
                a,
                c,
                u,
                d,
                f,
                m,
                v,
                g = n.elements;
              if ((h = i.loadMode) && B < 8 && (e = g.length)) {
                (r = 0),
                  W++,
                  null == M &&
                    ("expand" in i ||
                      (i.expand =
                        o.clientHeight > 500 && o.clientWidth > 500
                          ? 500
                          : 370),
                    (D = i.expand),
                    (M = D * i.expFactor)),
                  q < M && B < 1 && W > 2 && h > 2 && !t.hidden
                    ? ((q = M), (W = 0))
                    : (q = h > 1 && W > 1 && B < 6 ? D : F);
                for (; r < e; r++)
                  if (g[r] && !g[r]._lazyRace)
                    if (R)
                      if (
                        (((m = g[r][l]("data-expand")) && (d = 1 * m)) ||
                          (d = q),
                        v !== d &&
                          ((C = innerWidth + d * z),
                          (_ = innerHeight + d),
                          (f = -1 * d),
                          (v = d)),
                        (a = g[r].getBoundingClientRect()),
                        (N = a.bottom) >= f &&
                          ($ = a.top) <= _ &&
                          (L = a.right) >= f * z &&
                          (I = a.left) <= C &&
                          (N || L || I || $) &&
                          (i.loadHidden || "hidden" != S(g[r], "visibility")) &&
                          ((p && B < 3 && !m && (h < 3 || W < 4)) ||
                            V(g[r], d)))
                      ) {
                        if ((te(g[r]), (u = !0), B > 9)) break;
                      } else
                        !u &&
                          p &&
                          !c &&
                          B < 4 &&
                          W < 4 &&
                          h > 2 &&
                          (s[0] || i.preloadAfterLoad) &&
                          (s[0] ||
                            (!m &&
                              (N ||
                                L ||
                                I ||
                                $ ||
                                "auto" != g[r][l](i.sizesAttr)))) &&
                          (c = s[0] || g[r]);
                    else te(g[r]);
                c && !u && te(c);
              }
            },
            K = A(Z),
            X = function (e) {
              y(e.target, i.loadedClass),
                b(e.target, i.loadingClass),
                w(e.target, G),
                x(e.target, "lazyloaded");
            },
            Y = E(X),
            G = function (e) {
              Y({ target: e.target });
            },
            J = function (e, t) {
              try {
                e.contentWindow.location.replace(t);
              } catch (n) {
                e.src = t;
              }
            },
            Q = function (e) {
              var t,
                n = e[l](i.srcsetAttr);
              (t = i.customMedia[e[l]("data-media") || e[l]("media")]) &&
                e.setAttribute("media", t),
                n && e.setAttribute("srcset", n);
            },
            ee = E(function (e, t, n, o, r) {
              var s, a, c, p, h, m;
              (h = x(e, "lazybeforeunveil", t)).defaultPrevented ||
                (o && (n ? y(e, i.autosizesClass) : e.setAttribute("sizes", o)),
                (a = e[l](i.srcsetAttr)),
                (s = e[l](i.srcAttr)),
                r && ((c = e.parentNode), (p = c && f.test(c.nodeName || ""))),
                (m = t.firesLoad || ("src" in e && (a || s || p))),
                (h = { target: e }),
                m &&
                  (w(e, U, !0),
                  clearTimeout(d),
                  (d = u(U, 2500)),
                  y(e, i.loadingClass),
                  w(e, G, !0)),
                p && v.call(c.getElementsByTagName("source"), Q),
                a
                  ? e.setAttribute("srcset", a)
                  : s && !p && (H.test(e.nodeName) ? J(e, s) : (e.src = s)),
                r && (a || p) && k(e, { src: s })),
                e._lazyRace && delete e._lazyRace,
                b(e, i.lazyClass),
                T(function () {
                  (!m || (e.complete && e.naturalWidth > 1)) &&
                    (m ? U(h) : B--, X(h));
                }, !0);
            }),
            te = function (e) {
              var t,
                n = j.test(e.nodeName),
                o = n && (e[l](i.sizesAttr) || e[l]("sizes")),
                r = "auto" == o;
              ((!r && p) ||
                !n ||
                (!e[l]("src") && !e.srcset) ||
                e.complete ||
                g(e, i.errorClass) ||
                !g(e, i.lazyClass)) &&
                ((t = x(e, "lazyunveilread").detail),
                r && O.updateElem(e, !0, e.offsetWidth),
                (e._lazyRace = !0),
                B++,
                ee(e, t, r, o, n));
            },
            ne = function () {
              if (!p) {
                if (r.now() - m < 999) return void u(ne, 999);
                var e = P(function () {
                  (i.loadMode = 3), K();
                });
                (p = !0),
                  (i.loadMode = 3),
                  K(),
                  c(
                    "scroll",
                    function () {
                      3 == i.loadMode && (i.loadMode = 2), e();
                    },
                    !0
                  );
              }
            };
          return {
            _: function () {
              (m = r.now()),
                (n.elements = t.getElementsByClassName(i.lazyClass)),
                (s = t.getElementsByClassName(
                  i.lazyClass + " " + i.preloadClass
                )),
                (z = i.hFac),
                c("scroll", K, !0),
                c("resize", K, !0),
                e.MutationObserver
                  ? new MutationObserver(K).observe(o, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (o[a]("DOMNodeInserted", K, !0),
                    o[a]("DOMAttrModified", K, !0),
                    setInterval(K, 999)),
                c("hashchange", K, !0),
                [
                  "focus",
                  "mouseover",
                  "click",
                  "load",
                  "transitionend",
                  "animationend",
                  "webkitAnimationEnd",
                ].forEach(function (e) {
                  t[a](e, K, !0);
                }),
                /d$|^c/.test(t.readyState)
                  ? ne()
                  : (c("load", ne), t[a]("DOMContentLoaded", K), u(ne, 2e4)),
                n.elements.length ? (Z(), T._lsFlush()) : K();
            },
            checkElems: K,
            unveil: te,
          };
        })(),
        O = (function () {
          var e,
            n = E(function (e, t, n, i) {
              var o, r, s;
              if (
                ((e._lazysizesWidth = i),
                (i += "px"),
                e.setAttribute("sizes", i),
                f.test(t.nodeName || ""))
              )
                for (
                  o = t.getElementsByTagName("source"), r = 0, s = o.length;
                  r < s;
                  r++
                )
                  o[r].setAttribute("sizes", i);
              n.detail.dataAttr || k(e, n.detail);
            }),
            o = function (e, t, i) {
              var o,
                r = e.parentNode;
              r &&
                ((i = C(e, r, i)),
                (o = x(e, "lazybeforesizes", { width: i, dataAttr: !!t })),
                o.defaultPrevented ||
                  ((i = o.detail.width) &&
                    i !== e._lazysizesWidth &&
                    n(e, r, o, i)));
            },
            r = function () {
              var t,
                n = e.length;
              if (n) for (t = 0; t < n; t++) o(e[t]);
            },
            s = P(r);
          return {
            _: function () {
              (e = t.getElementsByClassName(i.autosizesClass)), c("resize", s);
            },
            checkElems: s,
            updateElem: o,
          };
        })(),
        $ = function () {
          $.i || (($.i = !0), O._(), _._());
        };
      return (n = {
        cfg: i,
        autoSizer: O,
        loader: _,
        init: $,
        uP: k,
        aC: y,
        rC: b,
        hC: g,
        fire: x,
        gW: C,
        rAF: T,
      });
    }
  }),
  !(function (e, t) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define([], t)
      : "object" == typeof exports
      ? (exports.Handlebars = t())
      : (e.Handlebars = t());
  })(this, function () {
    return (function (e) {
      function t(i) {
        if (n[i]) return n[i].exports;
        var o = (n[i] = { exports: {}, id: i, loaded: !1 });
        return (
          e[i].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports
        );
      }
      var n = {};
      return (t.m = e), (t.c = n), (t.p = ""), t(0);
    })([
      function (e, t, n) {
        "use strict";
        function i() {
          var e = g();
          return (
            (e.compile = function (t, n) {
              return u.compile(t, n, e);
            }),
            (e.precompile = function (t, n) {
              return u.precompile(t, n, e);
            }),
            (e.AST = l.default),
            (e.Compiler = u.Compiler),
            (e.JavaScriptCompiler = d.default),
            (e.Parser = c.parser),
            (e.parse = c.parse),
            (e.parseWithoutProcessing = c.parseWithoutProcessing),
            e
          );
        }
        var o = n(1).default;
        t.__esModule = !0;
        var r = n(2),
          s = o(r),
          a = n(45),
          l = o(a),
          c = n(46),
          u = n(51),
          p = n(52),
          d = o(p),
          f = n(49),
          h = o(f),
          m = n(44),
          v = o(m),
          g = s.default.create,
          y = i();
        (y.create = i),
          v.default(y),
          (y.Visitor = h.default),
          (y.default = y),
          (t.default = y),
          (e.exports = t.default);
      },
      function (e, t) {
        "use strict";
        (t.default = function (e) {
          return e && e.__esModule ? e : { default: e };
        }),
          (t.__esModule = !0);
      },
      function (e, t, n) {
        "use strict";
        function i() {
          var e = new a.HandlebarsEnvironment();
          return (
            f.extend(e, a),
            (e.SafeString = c.default),
            (e.Exception = p.default),
            (e.Utils = f),
            (e.escapeExpression = f.escapeExpression),
            (e.VM = m),
            (e.template = function (t) {
              return m.template(t, e);
            }),
            e
          );
        }
        var o = n(3).default,
          r = n(1).default;
        t.__esModule = !0;
        var s = n(4),
          a = o(s),
          l = n(37),
          c = r(l),
          u = n(6),
          p = r(u),
          d = n(5),
          f = o(d),
          h = n(38),
          m = o(h),
          v = n(44),
          g = r(v),
          y = i();
        (y.create = i),
          g.default(y),
          (y.default = y),
          (t.default = y),
          (e.exports = t.default);
      },
      function (e, t) {
        "use strict";
        (t.default = function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e)
            for (var n in e)
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return (t.default = e), t;
        }),
          (t.__esModule = !0);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t, n) {
          (this.helpers = e || {}),
            (this.partials = t || {}),
            (this.decorators = n || {}),
            l.registerDefaultHelpers(this),
            c.registerDefaultDecorators(this);
        }
        var o = n(1).default;
        (t.__esModule = !0), (t.HandlebarsEnvironment = i);
        var r = n(5),
          s = n(6),
          a = o(s),
          l = n(10),
          c = n(30),
          u = n(32),
          p = o(u),
          d = n(33),
          f = "4.7.2";
        t.VERSION = f;
        var h = 8;
        t.COMPILER_REVISION = h;
        var m = 7;
        t.LAST_COMPATIBLE_COMPILER_REVISION = m;
        var v = {
          1: "<= 1.0.rc.2",
          2: "== 1.0.0-rc.3",
          3: "== 1.0.0-rc.4",
          4: "== 1.x.x",
          5: "== 2.0.0-alpha.x",
          6: ">= 2.0.0-beta.1",
          7: ">= 4.0.0 <4.3.0",
          8: ">= 4.3.0",
        };
        t.REVISION_CHANGES = v;
        var g = "[object Object]";
        i.prototype = {
          constructor: i,
          logger: p.default,
          log: p.default.log,
          registerHelper: function (e, t) {
            if (r.toString.call(e) === g) {
              if (t)
                throw new a.default("Arg not supported with multiple helpers");
              r.extend(this.helpers, e);
            } else this.helpers[e] = t;
          },
          unregisterHelper: function (e) {
            delete this.helpers[e];
          },
          registerPartial: function (e, t) {
            if (r.toString.call(e) === g) r.extend(this.partials, e);
            else {
              if ("undefined" == typeof t)
                throw new a.default(
                  'Attempting to register a partial called "' +
                    e +
                    '" as undefined'
                );
              this.partials[e] = t;
            }
          },
          unregisterPartial: function (e) {
            delete this.partials[e];
          },
          registerDecorator: function (e, t) {
            if (r.toString.call(e) === g) {
              if (t)
                throw new a.default(
                  "Arg not supported with multiple decorators"
                );
              r.extend(this.decorators, e);
            } else this.decorators[e] = t;
          },
          unregisterDecorator: function (e) {
            delete this.decorators[e];
          },
          resetLoggedPropertyAccesses: function () {
            d.resetLoggedProperties();
          },
        };
        var y = p.default.log;
        (t.log = y), (t.createFrame = r.createFrame), (t.logger = p.default);
      },
      function (e, t) {
        "use strict";
        function n(e) {
          return u[e];
        }
        function i(e) {
          for (var t = 1; t < arguments.length; t++)
            for (var n in arguments[t])
              Object.prototype.hasOwnProperty.call(arguments[t], n) &&
                (e[n] = arguments[t][n]);
          return e;
        }
        function o(e, t) {
          for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
          return -1;
        }
        function r(e) {
          if ("string" != typeof e) {
            if (e && e.toHTML) return e.toHTML();
            if (null == e) return "";
            if (!e) return e + "";
            e = "" + e;
          }
          return d.test(e) ? e.replace(p, n) : e;
        }
        function s(e) {
          return (!e && 0 !== e) || !(!m(e) || 0 !== e.length);
        }
        function a(e) {
          var t = i({}, e);
          return (t._parent = e), t;
        }
        function l(e, t) {
          return (e.path = t), e;
        }
        function c(e, t) {
          return (e ? e + "." : "") + t;
        }
        (t.__esModule = !0),
          (t.extend = i),
          (t.indexOf = o),
          (t.escapeExpression = r),
          (t.isEmpty = s),
          (t.createFrame = a),
          (t.blockParams = l),
          (t.appendContextPath = c);
        var u = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;",
            "=": "&#x3D;",
          },
          p = /[&<>"'`=]/g,
          d = /[&<>"'`=]/,
          f = Object.prototype.toString;
        t.toString = f;
        var h = function (e) {
          return "function" == typeof e;
        };
        h(/x/) &&
          (t.isFunction = h =
            function (e) {
              return (
                "function" == typeof e && "[object Function]" === f.call(e)
              );
            }),
          (t.isFunction = h);
        var m =
          Array.isArray ||
          function (e) {
            return (
              !(!e || "object" != typeof e) && "[object Array]" === f.call(e)
            );
          };
        t.isArray = m;
      },
      function (e, t, n) {
        "use strict";
        function i(e, t) {
          var n = t && t.loc,
            s = void 0,
            a = void 0,
            l = void 0,
            c = void 0;
          n &&
            ((s = n.start.line),
            (a = n.end.line),
            (l = n.start.column),
            (c = n.end.column),
            (e += " - " + s + ":" + l));
          for (
            var u = Error.prototype.constructor.call(this, e), p = 0;
            p < r.length;
            p++
          )
            this[r[p]] = u[r[p]];
          Error.captureStackTrace && Error.captureStackTrace(this, i);
          try {
            n &&
              ((this.lineNumber = s),
              (this.endLineNumber = a),
              o
                ? (Object.defineProperty(this, "column", {
                    value: l,
                    enumerable: !0,
                  }),
                  Object.defineProperty(this, "endColumn", {
                    value: c,
                    enumerable: !0,
                  }))
                : ((this.column = l), (this.endColumn = c)));
          } catch (e) {}
        }
        var o = n(7).default;
        t.__esModule = !0;
        var r = [
          "description",
          "fileName",
          "lineNumber",
          "endLineNumber",
          "message",
          "name",
          "number",
          "stack",
        ];
        (i.prototype = new Error()), (t.default = i), (e.exports = t.default);
      },
      function (e, t, n) {
        e.exports = { default: n(8), __esModule: !0 };
      },
      function (e, t, n) {
        var i = n(9);
        e.exports = function (e, t, n) {
          return i.setDesc(e, t, n);
        };
      },
      function (e, t) {
        var n = Object;
        e.exports = {
          create: n.create,
          getProto: n.getPrototypeOf,
          isEnum: {}.propertyIsEnumerable,
          getDesc: n.getOwnPropertyDescriptor,
          setDesc: n.defineProperty,
          setDescs: n.defineProperties,
          getKeys: n.keys,
          getNames: n.getOwnPropertyNames,
          getSymbols: n.getOwnPropertySymbols,
          each: [].forEach,
        };
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          a.default(e),
            c.default(e),
            p.default(e),
            f.default(e),
            m.default(e),
            g.default(e),
            b.default(e);
        }
        function o(e, t, n) {
          e.helpers[t] &&
            ((e.hooks[t] = e.helpers[t]), n || delete e.helpers[t]);
        }
        var r = n(1).default;
        (t.__esModule = !0),
          (t.registerDefaultHelpers = i),
          (t.moveHelperToHooks = o);
        var s = n(11),
          a = r(s),
          l = n(12),
          c = r(l),
          u = n(25),
          p = r(u),
          d = n(26),
          f = r(d),
          h = n(27),
          m = r(h),
          v = n(28),
          g = r(v),
          y = n(29),
          b = r(y);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(5);
        (t.default = function (e) {
          e.registerHelper("blockHelperMissing", function (t, n) {
            var o = n.inverse,
              r = n.fn;
            if (t === !0) return r(this);
            if (t === !1 || null == t) return o(this);
            if (i.isArray(t))
              return t.length > 0
                ? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n))
                : o(this);
            if (n.data && n.ids) {
              var s = i.createFrame(n.data);
              (s.contextPath = i.appendContextPath(n.data.contextPath, n.name)),
                (n = { data: s });
            }
            return r(t, n);
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        (function (i) {
          "use strict";
          var o = n(13).default,
            r = n(1).default;
          t.__esModule = !0;
          var s = n(5),
            a = n(6),
            l = r(a);
          (t.default = function (e) {
            e.registerHelper("each", function (e, t) {
              function n(t, n, i) {
                p &&
                  ((p.key = t),
                  (p.index = n),
                  (p.first = 0 === n),
                  (p.last = !!i),
                  d && (p.contextPath = d + t)),
                  (u += r(e[t], {
                    data: p,
                    blockParams: s.blockParams([e[t], t], [d + t, null]),
                  }));
              }
              if (!t) throw new l.default("Must pass iterator to #each");
              var r = t.fn,
                a = t.inverse,
                c = 0,
                u = "",
                p = void 0,
                d = void 0;
              if (
                (t.data &&
                  t.ids &&
                  (d = s.appendContextPath(t.data.contextPath, t.ids[0]) + "."),
                s.isFunction(e) && (e = e.call(this)),
                t.data && (p = s.createFrame(t.data)),
                e && "object" == typeof e)
              )
                if (s.isArray(e))
                  for (var f = e.length; c < f; c++)
                    c in e && n(c, c, c === e.length - 1);
                else if (i.Symbol && e[i.Symbol.iterator]) {
                  for (
                    var h = [], m = e[i.Symbol.iterator](), v = m.next();
                    !v.done;
                    v = m.next()
                  )
                    h.push(v.value);
                  e = h;
                  for (var f = e.length; c < f; c++)
                    n(c, c, c === e.length - 1);
                } else
                  !(function () {
                    var t = void 0;
                    o(e).forEach(function (e) {
                      void 0 !== t && n(t, c - 1), (t = e), c++;
                    }),
                      void 0 !== t && n(t, c - 1, !0);
                  })();
              return 0 === c && (u = a(this)), u;
            });
          }),
            (e.exports = t.default);
        }).call(
          t,
          (function () {
            return this;
          })()
        );
      },
      function (e, t, n) {
        e.exports = { default: n(14), __esModule: !0 };
      },
      function (e, t, n) {
        n(15), (e.exports = n(21).Object.keys);
      },
      function (e, t, n) {
        var i = n(16);
        n(18)("keys", function (e) {
          return function (t) {
            return e(i(t));
          };
        });
      },
      function (e, t, n) {
        var i = n(17);
        e.exports = function (e) {
          return Object(i(e));
        };
      },
      function (e, t) {
        e.exports = function (e) {
          if (void 0 == e) throw TypeError("Can't call method on  " + e);
          return e;
        };
      },
      function (e, t, n) {
        var i = n(19),
          o = n(21),
          r = n(24);
        e.exports = function (e, t) {
          var n = (o.Object || {})[e] || Object[e],
            s = {};
          (s[e] = t(n)),
            i(
              i.S +
                i.F *
                  r(function () {
                    n(1);
                  }),
              "Object",
              s
            );
        };
      },
      function (e, t, n) {
        var i = n(20),
          o = n(21),
          r = n(22),
          s = "prototype",
          a = function (e, t, n) {
            var l,
              c,
              u,
              p = e & a.F,
              d = e & a.G,
              f = e & a.S,
              h = e & a.P,
              m = e & a.B,
              v = e & a.W,
              g = d ? o : o[t] || (o[t] = {}),
              y = d ? i : f ? i[t] : (i[t] || {})[s];
            d && (n = t);
            for (l in n)
              (c = !p && y && l in y),
                (c && l in g) ||
                  ((u = c ? y[l] : n[l]),
                  (g[l] =
                    d && "function" != typeof y[l]
                      ? n[l]
                      : m && c
                      ? r(u, i)
                      : v && y[l] == u
                      ? (function (e) {
                          var t = function (t) {
                            return this instanceof e ? new e(t) : e(t);
                          };
                          return (t[s] = e[s]), t;
                        })(u)
                      : h && "function" == typeof u
                      ? r(Function.call, u)
                      : u),
                  h && ((g[s] || (g[s] = {}))[l] = u));
          };
        (a.F = 1),
          (a.G = 2),
          (a.S = 4),
          (a.P = 8),
          (a.B = 16),
          (a.W = 32),
          (e.exports = a);
      },
      function (e, t) {
        var n = (e.exports =
          "undefined" != typeof window && window.Math == Math
            ? window
            : "undefined" != typeof self && self.Math == Math
            ? self
            : Function("return this")());
        "number" == typeof __g && (__g = n);
      },
      function (e, t) {
        var n = (e.exports = { version: "1.2.6" });
        "number" == typeof __e && (__e = n);
      },
      function (e, t, n) {
        var i = n(23);
        e.exports = function (e, t, n) {
          if ((i(e), void 0 === t)) return e;
          switch (n) {
            case 1:
              return function (n) {
                return e.call(t, n);
              };
            case 2:
              return function (n, i) {
                return e.call(t, n, i);
              };
            case 3:
              return function (n, i, o) {
                return e.call(t, n, i, o);
              };
          }
          return function () {
            return e.apply(t, arguments);
          };
        };
      },
      function (e, t) {
        e.exports = function (e) {
          if ("function" != typeof e)
            throw TypeError(e + " is not a function!");
          return e;
        };
      },
      function (e, t) {
        e.exports = function (e) {
          try {
            return !!e();
          } catch (e) {
            return !0;
          }
        };
      },
      function (e, t, n) {
        "use strict";
        var i = n(1).default;
        t.__esModule = !0;
        var o = n(6),
          r = i(o);
        (t.default = function (e) {
          e.registerHelper("helperMissing", function () {
            if (1 !== arguments.length)
              throw new r.default(
                'Missing helper: "' + arguments[arguments.length - 1].name + '"'
              );
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        var i = n(1).default;
        t.__esModule = !0;
        var o = n(5),
          r = n(6),
          s = i(r);
        (t.default = function (e) {
          e.registerHelper("if", function (e, t) {
            if (2 != arguments.length)
              throw new s.default("#if requires exactly one argument");
            return (
              o.isFunction(e) && (e = e.call(this)),
              (!t.hash.includeZero && !e) || o.isEmpty(e)
                ? t.inverse(this)
                : t.fn(this)
            );
          }),
            e.registerHelper("unless", function (t, n) {
              if (2 != arguments.length)
                throw new s.default("#unless requires exactly one argument");
              return e.helpers.if.call(this, t, {
                fn: n.inverse,
                inverse: n.fn,
                hash: n.hash,
              });
            });
        }),
          (e.exports = t.default);
      },
      function (e, t) {
        "use strict";
        (t.__esModule = !0),
          (t.default = function (e) {
            e.registerHelper("log", function () {
              for (
                var t = [void 0], n = arguments[arguments.length - 1], i = 0;
                i < arguments.length - 1;
                i++
              )
                t.push(arguments[i]);
              var o = 1;
              null != n.hash.level
                ? (o = n.hash.level)
                : n.data && null != n.data.level && (o = n.data.level),
                (t[0] = o),
                e.log.apply(e, t);
            });
          }),
          (e.exports = t.default);
      },
      function (e, t) {
        "use strict";
        (t.__esModule = !0),
          (t.default = function (e) {
            e.registerHelper("lookup", function (e, t, n) {
              return e ? n.lookupProperty(e, t) : e;
            });
          }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        var i = n(1).default;
        t.__esModule = !0;
        var o = n(5),
          r = n(6),
          s = i(r);
        (t.default = function (e) {
          e.registerHelper("with", function (e, t) {
            if (2 != arguments.length)
              throw new s.default("#with requires exactly one argument");
            o.isFunction(e) && (e = e.call(this));
            var n = t.fn;
            if (o.isEmpty(e)) return t.inverse(this);
            var i = t.data;
            return (
              t.data &&
                t.ids &&
                ((i = o.createFrame(t.data)),
                (i.contextPath = o.appendContextPath(
                  t.data.contextPath,
                  t.ids[0]
                ))),
              n(e, {
                data: i,
                blockParams: o.blockParams([e], [i && i.contextPath]),
              })
            );
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          s.default(e);
        }
        var o = n(1).default;
        (t.__esModule = !0), (t.registerDefaultDecorators = i);
        var r = n(31),
          s = o(r);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(5);
        (t.default = function (e) {
          e.registerDecorator("inline", function (e, t, n, o) {
            var r = e;
            return (
              t.partials ||
                ((t.partials = {}),
                (r = function (o, r) {
                  var s = n.partials;
                  n.partials = i.extend({}, s, t.partials);
                  var a = e(o, r);
                  return (n.partials = s), a;
                })),
              (t.partials[o.args[0]] = o.fn),
              r
            );
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(5),
          o = {
            methodMap: ["debug", "info", "warn", "error"],
            level: "info",
            lookupLevel: function (e) {
              if ("string" == typeof e) {
                var t = i.indexOf(o.methodMap, e.toLowerCase());
                e = t >= 0 ? t : parseInt(e, 10);
              }
              return e;
            },
            log: function (e) {
              if (
                ((e = o.lookupLevel(e)),
                "undefined" != typeof console && o.lookupLevel(o.level) <= e)
              ) {
                var t = o.methodMap[e];
                console[t] || (t = "log");
                for (
                  var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), r = 1;
                  r < n;
                  r++
                )
                  i[r - 1] = arguments[r];
                console[t].apply(console, i);
              }
            },
          };
        (t.default = o), (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          var t = l(null);
          (t.constructor = !1),
            (t.__defineGetter__ = !1),
            (t.__defineSetter__ = !1),
            (t.__lookupGetter__ = !1);
          var n = l(null);
          return (
            (n.__proto__ = !1),
            {
              properties: {
                whitelist: p.createNewLookupObject(n, e.allowedProtoProperties),
                defaultValue: e.allowProtoPropertiesByDefault,
              },
              methods: {
                whitelist: p.createNewLookupObject(t, e.allowedProtoMethods),
                defaultValue: e.allowProtoMethodsByDefault,
              },
            }
          );
        }
        function o(e, t, n) {
          return "function" == typeof e ? r(t.methods, n) : r(t.properties, n);
        }
        function r(e, t) {
          return void 0 !== e.whitelist[t]
            ? e.whitelist[t] === !0
            : void 0 !== e.defaultValue
            ? e.defaultValue
            : (s(t), !1);
        }
        function s(e) {
          h[e] !== !0 &&
            ((h[e] = !0),
            f.log(
              "error",
              'Handlebars: Access has been denied to resolve the property "' +
                e +
                '" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'
            ));
        }
        function a() {
          c(h).forEach(function (e) {
            delete h[e];
          });
        }
        var l = n(34).default,
          c = n(13).default,
          u = n(3).default;
        (t.__esModule = !0),
          (t.createProtoAccessControl = i),
          (t.resultIsAllowed = o),
          (t.resetLoggedProperties = a);
        var p = n(36),
          d = n(32),
          f = u(d),
          h = l(null);
      },
      function (e, t, n) {
        e.exports = { default: n(35), __esModule: !0 };
      },
      function (e, t, n) {
        var i = n(9);
        e.exports = function (e, t) {
          return i.create(e, t);
        };
      },
      function (e, t, n) {
        "use strict";
        function i() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          return r.extend.apply(void 0, [o(null)].concat(t));
        }
        var o = n(34).default;
        (t.__esModule = !0), (t.createNewLookupObject = i);
        var r = n(5);
      },
      function (e, t) {
        "use strict";
        function n(e) {
          this.string = e;
        }
        (t.__esModule = !0),
          (n.prototype.toString = n.prototype.toHTML =
            function () {
              return "" + this.string;
            }),
          (t.default = n),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          var t = (e && e[0]) || 1,
            n = x.COMPILER_REVISION;
          if (
            !(
              t >= x.LAST_COMPATIBLE_COMPILER_REVISION &&
              t <= x.COMPILER_REVISION
            )
          ) {
            if (t < x.LAST_COMPATIBLE_COMPILER_REVISION) {
              var i = x.REVISION_CHANGES[n],
                o = x.REVISION_CHANGES[t];
              throw new w.default(
                "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                  i +
                  ") or downgrade your runtime to an older version (" +
                  o +
                  ")."
              );
            }
            throw new w.default(
              "Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
                e[1] +
                ")."
            );
          }
        }
        function o(e, t) {
          function n(n, i, o) {
            o.hash && ((i = y.extend({}, i, o.hash)), o.ids && (o.ids[0] = !0)),
              (n = t.VM.resolvePartial.call(this, n, i, o));
            var r = y.extend({}, o, {
                hooks: this.hooks,
                protoAccessControl: this.protoAccessControl,
              }),
              s = t.VM.invokePartial.call(this, n, i, r);
            if (
              (null == s &&
                t.compile &&
                ((o.partials[o.name] = t.compile(n, e.compilerOptions, t)),
                (s = o.partials[o.name](i, r))),
              null != s)
            ) {
              if (o.indent) {
                for (
                  var a = s.split("\n"), l = 0, c = a.length;
                  l < c && (a[l] || l + 1 !== c);
                  l++
                )
                  a[l] = o.indent + a[l];
                s = a.join("\n");
              }
              return s;
            }
            throw new w.default(
              "The partial " +
                o.name +
                " could not be compiled when running in runtime-only mode"
            );
          }
          function i(t) {
            function n(t) {
              return "" + e.main(s, t, s.helpers, s.partials, r, l, a);
            }
            var o =
                arguments.length <= 1 || void 0 === arguments[1]
                  ? {}
                  : arguments[1],
              r = o.data;
            i._setup(o), !o.partial && e.useData && (r = c(t, r));
            var a = void 0,
              l = e.useBlockParams ? [] : void 0;
            return (
              e.useDepths &&
                (a = o.depths
                  ? t != o.depths[0]
                    ? [t].concat(o.depths)
                    : o.depths
                  : [t]),
              (n = u(e.main, n, s, o.depths || [], r, l))(t, o)
            );
          }
          if (!t) throw new w.default("No environment passed to template");
          if (!e || !e.main)
            throw new w.default("Unknown template object: " + typeof e);
          (e.main.decorator = e.main_d), t.VM.checkRevision(e.compiler);
          var o = e.compiler && 7 === e.compiler[0],
            s = {
              strict: function (e, t, n) {
                if (!(e && t in e))
                  throw new w.default('"' + t + '" not defined in ' + e, {
                    loc: n,
                  });
                return e[t];
              },
              lookupProperty: function (e, t) {
                var n = e[t];
                return null == n
                  ? n
                  : Object.prototype.hasOwnProperty.call(e, t)
                  ? n
                  : C.resultIsAllowed(n, s.protoAccessControl, t)
                  ? n
                  : void 0;
              },
              lookup: function (e, t) {
                for (var n = e.length, i = 0; i < n; i++) {
                  var o = e[i] && s.lookupProperty(e[i], t);
                  if (null != o) return e[i][t];
                }
              },
              lambda: function (e, t) {
                return "function" == typeof e ? e.call(t) : e;
              },
              escapeExpression: y.escapeExpression,
              invokePartial: n,
              fn: function (t) {
                var n = e[t];
                return (n.decorator = e[t + "_d"]), n;
              },
              programs: [],
              program: function (e, t, n, i, o) {
                var s = this.programs[e],
                  a = this.fn(e);
                return (
                  t || o || i || n
                    ? (s = r(this, e, a, t, n, i, o))
                    : s || (s = this.programs[e] = r(this, e, a)),
                  s
                );
              },
              data: function (e, t) {
                for (; e && t--; ) e = e._parent;
                return e;
              },
              mergeIfNeeded: function (e, t) {
                var n = e || t;
                return e && t && e !== t && (n = y.extend({}, t, e)), n;
              },
              nullContext: f({}),
              noop: t.VM.noop,
              compilerInfo: e.compiler,
            };
          return (
            (i.isTop = !0),
            (i._setup = function (n) {
              if (n.partial)
                (s.protoAccessControl = n.protoAccessControl),
                  (s.helpers = n.helpers),
                  (s.partials = n.partials),
                  (s.decorators = n.decorators),
                  (s.hooks = n.hooks);
              else {
                var i = y.extend({}, t.helpers, n.helpers);
                p(i, s),
                  (s.helpers = i),
                  e.usePartial &&
                    (s.partials = s.mergeIfNeeded(n.partials, t.partials)),
                  (e.usePartial || e.useDecorators) &&
                    (s.decorators = y.extend({}, t.decorators, n.decorators)),
                  (s.hooks = {}),
                  (s.protoAccessControl = C.createProtoAccessControl(n));
                var r = n.allowCallsToHelperMissing || o;
                k.moveHelperToHooks(s, "helperMissing", r),
                  k.moveHelperToHooks(s, "blockHelperMissing", r);
              }
            }),
            (i._child = function (t, n, i, o) {
              if (e.useBlockParams && !i)
                throw new w.default("must pass block params");
              if (e.useDepths && !o)
                throw new w.default("must pass parent depths");
              return r(s, t, e[t], n, 0, i, o);
            }),
            i
          );
        }
        function r(e, t, n, i, o, r, s) {
          function a(t) {
            var o =
                arguments.length <= 1 || void 0 === arguments[1]
                  ? {}
                  : arguments[1],
              a = s;
            return (
              !s ||
                t == s[0] ||
                (t === e.nullContext && null === s[0]) ||
                (a = [t].concat(s)),
              n(
                e,
                t,
                e.helpers,
                e.partials,
                o.data || i,
                r && [o.blockParams].concat(r),
                a
              )
            );
          }
          return (
            (a = u(n, a, e, s, i, r)),
            (a.program = t),
            (a.depth = s ? s.length : 0),
            (a.blockParams = o || 0),
            a
          );
        }
        function s(e, t, n) {
          return (
            e
              ? e.call || n.name || ((n.name = e), (e = n.partials[e]))
              : (e =
                  "@partial-block" === n.name
                    ? n.data["partial-block"]
                    : n.partials[n.name]),
            e
          );
        }
        function a(e, t, n) {
          var i = n.data && n.data["partial-block"];
          (n.partial = !0),
            n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
          var o = void 0;
          if (
            (n.fn &&
              n.fn !== l &&
              !(function () {
                n.data = x.createFrame(n.data);
                var e = n.fn;
                (o = n.data["partial-block"] =
                  function (t) {
                    var n =
                      arguments.length <= 1 || void 0 === arguments[1]
                        ? {}
                        : arguments[1];
                    return (
                      (n.data = x.createFrame(n.data)),
                      (n.data["partial-block"] = i),
                      e(t, n)
                    );
                  }),
                  e.partials &&
                    (n.partials = y.extend({}, n.partials, e.partials));
              })(),
            void 0 === e && o && (e = o),
            void 0 === e)
          )
            throw new w.default(
              "The partial " + n.name + " could not be found"
            );
          if (e instanceof Function) return e(t, n);
        }
        function l() {
          return "";
        }
        function c(e, t) {
          return (
            (t && "root" in t) ||
              ((t = t ? x.createFrame(t) : {}), (t.root = e)),
            t
          );
        }
        function u(e, t, n, i, o, r) {
          if (e.decorator) {
            var s = {};
            (t = e.decorator(t, s, n, i && i[0], o, r, i)), y.extend(t, s);
          }
          return t;
        }
        function p(e, t) {
          h(e).forEach(function (n) {
            var i = e[n];
            e[n] = d(i, t);
          });
        }
        function d(e, t) {
          var n = t.lookupProperty;
          return S.wrapHelper(e, function (e) {
            return y.extend({ lookupProperty: n }, e);
          });
        }
        var f = n(39).default,
          h = n(13).default,
          m = n(3).default,
          v = n(1).default;
        (t.__esModule = !0),
          (t.checkRevision = i),
          (t.template = o),
          (t.wrapProgram = r),
          (t.resolvePartial = s),
          (t.invokePartial = a),
          (t.noop = l);
        var g = n(5),
          y = m(g),
          b = n(6),
          w = v(b),
          x = n(4),
          k = n(10),
          S = n(43),
          C = n(33);
      },
      function (e, t, n) {
        e.exports = { default: n(40), __esModule: !0 };
      },
      function (e, t, n) {
        n(41), (e.exports = n(21).Object.seal);
      },
      function (e, t, n) {
        var i = n(42);
        n(18)("seal", function (e) {
          return function (t) {
            return e && i(t) ? e(t) : t;
          };
        });
      },
      function (e, t) {
        e.exports = function (e) {
          return "object" == typeof e ? null !== e : "function" == typeof e;
        };
      },
      function (e, t) {
        "use strict";
        function n(e, t) {
          if ("function" != typeof e) return e;
          var n = function () {
            var n = arguments[arguments.length - 1];
            return (
              (arguments[arguments.length - 1] = t(n)), e.apply(this, arguments)
            );
          };
          return n;
        }
        (t.__esModule = !0), (t.wrapHelper = n);
      },
      function (e, t) {
        (function (n) {
          "use strict";
          (t.__esModule = !0),
            (t.default = function (e) {
              var t = "undefined" != typeof n ? n : window,
                i = t.Handlebars;
              e.noConflict = function () {
                return t.Handlebars === e && (t.Handlebars = i), e;
              };
            }),
            (e.exports = t.default);
        }).call(
          t,
          (function () {
            return this;
          })()
        );
      },
      function (e, t) {
        "use strict";
        t.__esModule = !0;
        var n = {
          helpers: {
            helperExpression: function (e) {
              return (
                "SubExpression" === e.type ||
                (("MustacheStatement" === e.type ||
                  "BlockStatement" === e.type) &&
                  !!((e.params && e.params.length) || e.hash))
              );
            },
            scopedId: function (e) {
              return /^\.|this\b/.test(e.original);
            },
            simpleId: function (e) {
              return 1 === e.parts.length && !n.helpers.scopedId(e) && !e.depth;
            },
          },
        };
        (t.default = n), (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t) {
          if ("Program" === e.type) return e;
          (l.default.yy = h),
            (h.locInfo = function (e) {
              return new h.SourceLocation(t && t.srcName, e);
            });
          var n = l.default.parse(e);
          return n;
        }
        function o(e, t) {
          var n = i(e, t),
            o = new u.default(t);
          return o.accept(n);
        }
        var r = n(1).default,
          s = n(3).default;
        (t.__esModule = !0), (t.parseWithoutProcessing = i), (t.parse = o);
        var a = n(47),
          l = r(a),
          c = n(48),
          u = r(c),
          p = n(50),
          d = s(p),
          f = n(5);
        t.parser = l.default;
        var h = {};
        f.extend(h, d);
      },
      function (e, t) {
        "use strict";
        t.__esModule = !0;
        var n = (function () {
          function e() {
            this.yy = {};
          }
          var t = {
              trace: function () {},
              yy: {},
              symbols_: {
                error: 2,
                root: 3,
                program: 4,
                EOF: 5,
                program_repetition0: 6,
                statement: 7,
                mustache: 8,
                block: 9,
                rawBlock: 10,
                partial: 11,
                partialBlock: 12,
                content: 13,
                COMMENT: 14,
                CONTENT: 15,
                openRawBlock: 16,
                rawBlock_repetition0: 17,
                END_RAW_BLOCK: 18,
                OPEN_RAW_BLOCK: 19,
                helperName: 20,
                openRawBlock_repetition0: 21,
                openRawBlock_option0: 22,
                CLOSE_RAW_BLOCK: 23,
                openBlock: 24,
                block_option0: 25,
                closeBlock: 26,
                openInverse: 27,
                block_option1: 28,
                OPEN_BLOCK: 29,
                openBlock_repetition0: 30,
                openBlock_option0: 31,
                openBlock_option1: 32,
                CLOSE: 33,
                OPEN_INVERSE: 34,
                openInverse_repetition0: 35,
                openInverse_option0: 36,
                openInverse_option1: 37,
                openInverseChain: 38,
                OPEN_INVERSE_CHAIN: 39,
                openInverseChain_repetition0: 40,
                openInverseChain_option0: 41,
                openInverseChain_option1: 42,
                inverseAndProgram: 43,
                INVERSE: 44,
                inverseChain: 45,
                inverseChain_option0: 46,
                OPEN_ENDBLOCK: 47,
                OPEN: 48,
                mustache_repetition0: 49,
                mustache_option0: 50,
                OPEN_UNESCAPED: 51,
                mustache_repetition1: 52,
                mustache_option1: 53,
                CLOSE_UNESCAPED: 54,
                OPEN_PARTIAL: 55,
                partialName: 56,
                partial_repetition0: 57,
                partial_option0: 58,
                openPartialBlock: 59,
                OPEN_PARTIAL_BLOCK: 60,
                openPartialBlock_repetition0: 61,
                openPartialBlock_option0: 62,
                param: 63,
                sexpr: 64,
                OPEN_SEXPR: 65,
                sexpr_repetition0: 66,
                sexpr_option0: 67,
                CLOSE_SEXPR: 68,
                hash: 69,
                hash_repetition_plus0: 70,
                hashSegment: 71,
                ID: 72,
                EQUALS: 73,
                blockParams: 74,
                OPEN_BLOCK_PARAMS: 75,
                blockParams_repetition_plus0: 76,
                CLOSE_BLOCK_PARAMS: 77,
                path: 78,
                dataName: 79,
                STRING: 80,
                NUMBER: 81,
                BOOLEAN: 82,
                UNDEFINED: 83,
                NULL: 84,
                DATA: 85,
                pathSegments: 86,
                SEP: 87,
                $accept: 0,
                $end: 1,
              },
              terminals_: {
                2: "error",
                5: "EOF",
                14: "COMMENT",
                15: "CONTENT",
                18: "END_RAW_BLOCK",
                19: "OPEN_RAW_BLOCK",
                23: "CLOSE_RAW_BLOCK",
                29: "OPEN_BLOCK",
                33: "CLOSE",
                34: "OPEN_INVERSE",
                39: "OPEN_INVERSE_CHAIN",
                44: "INVERSE",
                47: "OPEN_ENDBLOCK",
                48: "OPEN",
                51: "OPEN_UNESCAPED",
                54: "CLOSE_UNESCAPED",
                55: "OPEN_PARTIAL",
                60: "OPEN_PARTIAL_BLOCK",
                65: "OPEN_SEXPR",
                68: "CLOSE_SEXPR",
                72: "ID",
                73: "EQUALS",
                75: "OPEN_BLOCK_PARAMS",
                77: "CLOSE_BLOCK_PARAMS",
                80: "STRING",
                81: "NUMBER",
                82: "BOOLEAN",
                83: "UNDEFINED",
                84: "NULL",
                85: "DATA",
                87: "SEP",
              },
              productions_: [
                0,
                [3, 2],
                [4, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [13, 1],
                [10, 3],
                [16, 5],
                [9, 4],
                [9, 4],
                [24, 6],
                [27, 6],
                [38, 6],
                [43, 2],
                [45, 3],
                [45, 1],
                [26, 3],
                [8, 5],
                [8, 5],
                [11, 5],
                [12, 3],
                [59, 5],
                [63, 1],
                [63, 1],
                [64, 5],
                [69, 1],
                [71, 3],
                [74, 3],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [56, 1],
                [56, 1],
                [79, 2],
                [78, 1],
                [86, 3],
                [86, 1],
                [6, 0],
                [6, 2],
                [17, 0],
                [17, 2],
                [21, 0],
                [21, 2],
                [22, 0],
                [22, 1],
                [25, 0],
                [25, 1],
                [28, 0],
                [28, 1],
                [30, 0],
                [30, 2],
                [31, 0],
                [31, 1],
                [32, 0],
                [32, 1],
                [35, 0],
                [35, 2],
                [36, 0],
                [36, 1],
                [37, 0],
                [37, 1],
                [40, 0],
                [40, 2],
                [41, 0],
                [41, 1],
                [42, 0],
                [42, 1],
                [46, 0],
                [46, 1],
                [49, 0],
                [49, 2],
                [50, 0],
                [50, 1],
                [52, 0],
                [52, 2],
                [53, 0],
                [53, 1],
                [57, 0],
                [57, 2],
                [58, 0],
                [58, 1],
                [61, 0],
                [61, 2],
                [62, 0],
                [62, 1],
                [66, 0],
                [66, 2],
                [67, 0],
                [67, 1],
                [70, 1],
                [70, 2],
                [76, 1],
                [76, 2],
              ],
              performAction: function (e, t, n, i, o, r, s) {
                var a = r.length - 1;
                switch (o) {
                  case 1:
                    return r[a - 1];
                  case 2:
                    this.$ = i.prepareProgram(r[a]);
                    break;
                  case 3:
                    this.$ = r[a];
                    break;
                  case 4:
                    this.$ = r[a];
                    break;
                  case 5:
                    this.$ = r[a];
                    break;
                  case 6:
                    this.$ = r[a];
                    break;
                  case 7:
                    this.$ = r[a];
                    break;
                  case 8:
                    this.$ = r[a];
                    break;
                  case 9:
                    this.$ = {
                      type: "CommentStatement",
                      value: i.stripComment(r[a]),
                      strip: i.stripFlags(r[a], r[a]),
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 10:
                    this.$ = {
                      type: "ContentStatement",
                      original: r[a],
                      value: r[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 11:
                    this.$ = i.prepareRawBlock(
                      r[a - 2],
                      r[a - 1],
                      r[a],
                      this._$
                    );
                    break;
                  case 12:
                    this.$ = {
                      path: r[a - 3],
                      params: r[a - 2],
                      hash: r[a - 1],
                    };
                    break;
                  case 13:
                    this.$ = i.prepareBlock(
                      r[a - 3],
                      r[a - 2],
                      r[a - 1],
                      r[a],
                      !1,
                      this._$
                    );
                    break;
                  case 14:
                    this.$ = i.prepareBlock(
                      r[a - 3],
                      r[a - 2],
                      r[a - 1],
                      r[a],
                      !0,
                      this._$
                    );
                    break;
                  case 15:
                    this.$ = {
                      open: r[a - 5],
                      path: r[a - 4],
                      params: r[a - 3],
                      hash: r[a - 2],
                      blockParams: r[a - 1],
                      strip: i.stripFlags(r[a - 5], r[a]),
                    };
                    break;
                  case 16:
                    this.$ = {
                      path: r[a - 4],
                      params: r[a - 3],
                      hash: r[a - 2],
                      blockParams: r[a - 1],
                      strip: i.stripFlags(r[a - 5], r[a]),
                    };
                    break;
                  case 17:
                    this.$ = {
                      path: r[a - 4],
                      params: r[a - 3],
                      hash: r[a - 2],
                      blockParams: r[a - 1],
                      strip: i.stripFlags(r[a - 5], r[a]),
                    };
                    break;
                  case 18:
                    this.$ = {
                      strip: i.stripFlags(r[a - 1], r[a - 1]),
                      program: r[a],
                    };
                    break;
                  case 19:
                    var l = i.prepareBlock(
                        r[a - 2],
                        r[a - 1],
                        r[a],
                        r[a],
                        !1,
                        this._$
                      ),
                      c = i.prepareProgram([l], r[a - 1].loc);
                    (c.chained = !0),
                      (this.$ = {
                        strip: r[a - 2].strip,
                        program: c,
                        chain: !0,
                      });
                    break;
                  case 20:
                    this.$ = r[a];
                    break;
                  case 21:
                    this.$ = {
                      path: r[a - 1],
                      strip: i.stripFlags(r[a - 2], r[a]),
                    };
                    break;
                  case 22:
                    this.$ = i.prepareMustache(
                      r[a - 3],
                      r[a - 2],
                      r[a - 1],
                      r[a - 4],
                      i.stripFlags(r[a - 4], r[a]),
                      this._$
                    );
                    break;
                  case 23:
                    this.$ = i.prepareMustache(
                      r[a - 3],
                      r[a - 2],
                      r[a - 1],
                      r[a - 4],
                      i.stripFlags(r[a - 4], r[a]),
                      this._$
                    );
                    break;
                  case 24:
                    this.$ = {
                      type: "PartialStatement",
                      name: r[a - 3],
                      params: r[a - 2],
                      hash: r[a - 1],
                      indent: "",
                      strip: i.stripFlags(r[a - 4], r[a]),
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 25:
                    this.$ = i.preparePartialBlock(
                      r[a - 2],
                      r[a - 1],
                      r[a],
                      this._$
                    );
                    break;
                  case 26:
                    this.$ = {
                      path: r[a - 3],
                      params: r[a - 2],
                      hash: r[a - 1],
                      strip: i.stripFlags(r[a - 4], r[a]),
                    };
                    break;
                  case 27:
                    this.$ = r[a];
                    break;
                  case 28:
                    this.$ = r[a];
                    break;
                  case 29:
                    this.$ = {
                      type: "SubExpression",
                      path: r[a - 3],
                      params: r[a - 2],
                      hash: r[a - 1],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 30:
                    this.$ = {
                      type: "Hash",
                      pairs: r[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 31:
                    this.$ = {
                      type: "HashPair",
                      key: i.id(r[a - 2]),
                      value: r[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 32:
                    this.$ = i.id(r[a - 1]);
                    break;
                  case 33:
                    this.$ = r[a];
                    break;
                  case 34:
                    this.$ = r[a];
                    break;
                  case 35:
                    this.$ = {
                      type: "StringLiteral",
                      value: r[a],
                      original: r[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 36:
                    this.$ = {
                      type: "NumberLiteral",
                      value: Number(r[a]),
                      original: Number(r[a]),
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 37:
                    this.$ = {
                      type: "BooleanLiteral",
                      value: "true" === r[a],
                      original: "true" === r[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 38:
                    this.$ = {
                      type: "UndefinedLiteral",
                      original: void 0,
                      value: void 0,
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 39:
                    this.$ = {
                      type: "NullLiteral",
                      original: null,
                      value: null,
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 40:
                    this.$ = r[a];
                    break;
                  case 41:
                    this.$ = r[a];
                    break;
                  case 42:
                    this.$ = i.preparePath(!0, r[a], this._$);
                    break;
                  case 43:
                    this.$ = i.preparePath(!1, r[a], this._$);
                    break;
                  case 44:
                    r[a - 2].push({
                      part: i.id(r[a]),
                      original: r[a],
                      separator: r[a - 1],
                    }),
                      (this.$ = r[a - 2]);
                    break;
                  case 45:
                    this.$ = [{ part: i.id(r[a]), original: r[a] }];
                    break;
                  case 46:
                    this.$ = [];
                    break;
                  case 47:
                    r[a - 1].push(r[a]);
                    break;
                  case 48:
                    this.$ = [];
                    break;
                  case 49:
                    r[a - 1].push(r[a]);
                    break;
                  case 50:
                    this.$ = [];
                    break;
                  case 51:
                    r[a - 1].push(r[a]);
                    break;
                  case 58:
                    this.$ = [];
                    break;
                  case 59:
                    r[a - 1].push(r[a]);
                    break;
                  case 64:
                    this.$ = [];
                    break;
                  case 65:
                    r[a - 1].push(r[a]);
                    break;
                  case 70:
                    this.$ = [];
                    break;
                  case 71:
                    r[a - 1].push(r[a]);
                    break;
                  case 78:
                    this.$ = [];
                    break;
                  case 79:
                    r[a - 1].push(r[a]);
                    break;
                  case 82:
                    this.$ = [];
                    break;
                  case 83:
                    r[a - 1].push(r[a]);
                    break;
                  case 86:
                    this.$ = [];
                    break;
                  case 87:
                    r[a - 1].push(r[a]);
                    break;
                  case 90:
                    this.$ = [];
                    break;
                  case 91:
                    r[a - 1].push(r[a]);
                    break;
                  case 94:
                    this.$ = [];
                    break;
                  case 95:
                    r[a - 1].push(r[a]);
                    break;
                  case 98:
                    this.$ = [r[a]];
                    break;
                  case 99:
                    r[a - 1].push(r[a]);
                    break;
                  case 100:
                    this.$ = [r[a]];
                    break;
                  case 101:
                    r[a - 1].push(r[a]);
                }
              },
              table: [
                {
                  3: 1,
                  4: 2,
                  5: [2, 46],
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 1: [3] },
                { 5: [1, 4] },
                {
                  5: [2, 2],
                  7: 5,
                  8: 6,
                  9: 7,
                  10: 8,
                  11: 9,
                  12: 10,
                  13: 11,
                  14: [1, 12],
                  15: [1, 20],
                  16: 17,
                  19: [1, 23],
                  24: 15,
                  27: 16,
                  29: [1, 21],
                  34: [1, 22],
                  39: [2, 2],
                  44: [2, 2],
                  47: [2, 2],
                  48: [1, 13],
                  51: [1, 14],
                  55: [1, 18],
                  59: 19,
                  60: [1, 24],
                },
                { 1: [2, 1] },
                {
                  5: [2, 47],
                  14: [2, 47],
                  15: [2, 47],
                  19: [2, 47],
                  29: [2, 47],
                  34: [2, 47],
                  39: [2, 47],
                  44: [2, 47],
                  47: [2, 47],
                  48: [2, 47],
                  51: [2, 47],
                  55: [2, 47],
                  60: [2, 47],
                },
                {
                  5: [2, 3],
                  14: [2, 3],
                  15: [2, 3],
                  19: [2, 3],
                  29: [2, 3],
                  34: [2, 3],
                  39: [2, 3],
                  44: [2, 3],
                  47: [2, 3],
                  48: [2, 3],
                  51: [2, 3],
                  55: [2, 3],
                  60: [2, 3],
                },
                {
                  5: [2, 4],
                  14: [2, 4],
                  15: [2, 4],
                  19: [2, 4],
                  29: [2, 4],
                  34: [2, 4],
                  39: [2, 4],
                  44: [2, 4],
                  47: [2, 4],
                  48: [2, 4],
                  51: [2, 4],
                  55: [2, 4],
                  60: [2, 4],
                },
                {
                  5: [2, 5],
                  14: [2, 5],
                  15: [2, 5],
                  19: [2, 5],
                  29: [2, 5],
                  34: [2, 5],
                  39: [2, 5],
                  44: [2, 5],
                  47: [2, 5],
                  48: [2, 5],
                  51: [2, 5],
                  55: [2, 5],
                  60: [2, 5],
                },
                {
                  5: [2, 6],
                  14: [2, 6],
                  15: [2, 6],
                  19: [2, 6],
                  29: [2, 6],
                  34: [2, 6],
                  39: [2, 6],
                  44: [2, 6],
                  47: [2, 6],
                  48: [2, 6],
                  51: [2, 6],
                  55: [2, 6],
                  60: [2, 6],
                },
                {
                  5: [2, 7],
                  14: [2, 7],
                  15: [2, 7],
                  19: [2, 7],
                  29: [2, 7],
                  34: [2, 7],
                  39: [2, 7],
                  44: [2, 7],
                  47: [2, 7],
                  48: [2, 7],
                  51: [2, 7],
                  55: [2, 7],
                  60: [2, 7],
                },
                {
                  5: [2, 8],
                  14: [2, 8],
                  15: [2, 8],
                  19: [2, 8],
                  29: [2, 8],
                  34: [2, 8],
                  39: [2, 8],
                  44: [2, 8],
                  47: [2, 8],
                  48: [2, 8],
                  51: [2, 8],
                  55: [2, 8],
                  60: [2, 8],
                },
                {
                  5: [2, 9],
                  14: [2, 9],
                  15: [2, 9],
                  19: [2, 9],
                  29: [2, 9],
                  34: [2, 9],
                  39: [2, 9],
                  44: [2, 9],
                  47: [2, 9],
                  48: [2, 9],
                  51: [2, 9],
                  55: [2, 9],
                  60: [2, 9],
                },
                {
                  20: 25,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 36,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  4: 37,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  39: [2, 46],
                  44: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                {
                  4: 38,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  44: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 15: [2, 48], 17: 39, 18: [2, 48] },
                {
                  20: 41,
                  56: 40,
                  64: 42,
                  65: [1, 43],
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  4: 44,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                {
                  5: [2, 10],
                  14: [2, 10],
                  15: [2, 10],
                  18: [2, 10],
                  19: [2, 10],
                  29: [2, 10],
                  34: [2, 10],
                  39: [2, 10],
                  44: [2, 10],
                  47: [2, 10],
                  48: [2, 10],
                  51: [2, 10],
                  55: [2, 10],
                  60: [2, 10],
                },
                {
                  20: 45,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 46,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 47,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 41,
                  56: 48,
                  64: 42,
                  65: [1, 43],
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  33: [2, 78],
                  49: 49,
                  65: [2, 78],
                  72: [2, 78],
                  80: [2, 78],
                  81: [2, 78],
                  82: [2, 78],
                  83: [2, 78],
                  84: [2, 78],
                  85: [2, 78],
                },
                {
                  23: [2, 33],
                  33: [2, 33],
                  54: [2, 33],
                  65: [2, 33],
                  68: [2, 33],
                  72: [2, 33],
                  75: [2, 33],
                  80: [2, 33],
                  81: [2, 33],
                  82: [2, 33],
                  83: [2, 33],
                  84: [2, 33],
                  85: [2, 33],
                },
                {
                  23: [2, 34],
                  33: [2, 34],
                  54: [2, 34],
                  65: [2, 34],
                  68: [2, 34],
                  72: [2, 34],
                  75: [2, 34],
                  80: [2, 34],
                  81: [2, 34],
                  82: [2, 34],
                  83: [2, 34],
                  84: [2, 34],
                  85: [2, 34],
                },
                {
                  23: [2, 35],
                  33: [2, 35],
                  54: [2, 35],
                  65: [2, 35],
                  68: [2, 35],
                  72: [2, 35],
                  75: [2, 35],
                  80: [2, 35],
                  81: [2, 35],
                  82: [2, 35],
                  83: [2, 35],
                  84: [2, 35],
                  85: [2, 35],
                },
                {
                  23: [2, 36],
                  33: [2, 36],
                  54: [2, 36],
                  65: [2, 36],
                  68: [2, 36],
                  72: [2, 36],
                  75: [2, 36],
                  80: [2, 36],
                  81: [2, 36],
                  82: [2, 36],
                  83: [2, 36],
                  84: [2, 36],
                  85: [2, 36],
                },
                {
                  23: [2, 37],
                  33: [2, 37],
                  54: [2, 37],
                  65: [2, 37],
                  68: [2, 37],
                  72: [2, 37],
                  75: [2, 37],
                  80: [2, 37],
                  81: [2, 37],
                  82: [2, 37],
                  83: [2, 37],
                  84: [2, 37],
                  85: [2, 37],
                },
                {
                  23: [2, 38],
                  33: [2, 38],
                  54: [2, 38],
                  65: [2, 38],
                  68: [2, 38],
                  72: [2, 38],
                  75: [2, 38],
                  80: [2, 38],
                  81: [2, 38],
                  82: [2, 38],
                  83: [2, 38],
                  84: [2, 38],
                  85: [2, 38],
                },
                {
                  23: [2, 39],
                  33: [2, 39],
                  54: [2, 39],
                  65: [2, 39],
                  68: [2, 39],
                  72: [2, 39],
                  75: [2, 39],
                  80: [2, 39],
                  81: [2, 39],
                  82: [2, 39],
                  83: [2, 39],
                  84: [2, 39],
                  85: [2, 39],
                },
                {
                  23: [2, 43],
                  33: [2, 43],
                  54: [2, 43],
                  65: [2, 43],
                  68: [2, 43],
                  72: [2, 43],
                  75: [2, 43],
                  80: [2, 43],
                  81: [2, 43],
                  82: [2, 43],
                  83: [2, 43],
                  84: [2, 43],
                  85: [2, 43],
                  87: [1, 50],
                },
                { 72: [1, 35], 86: 51 },
                {
                  23: [2, 45],
                  33: [2, 45],
                  54: [2, 45],
                  65: [2, 45],
                  68: [2, 45],
                  72: [2, 45],
                  75: [2, 45],
                  80: [2, 45],
                  81: [2, 45],
                  82: [2, 45],
                  83: [2, 45],
                  84: [2, 45],
                  85: [2, 45],
                  87: [2, 45],
                },
                {
                  52: 52,
                  54: [2, 82],
                  65: [2, 82],
                  72: [2, 82],
                  80: [2, 82],
                  81: [2, 82],
                  82: [2, 82],
                  83: [2, 82],
                  84: [2, 82],
                  85: [2, 82],
                },
                {
                  25: 53,
                  38: 55,
                  39: [1, 57],
                  43: 56,
                  44: [1, 58],
                  45: 54,
                  47: [2, 54],
                },
                { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] },
                { 13: 62, 15: [1, 20], 18: [1, 61] },
                {
                  33: [2, 86],
                  57: 63,
                  65: [2, 86],
                  72: [2, 86],
                  80: [2, 86],
                  81: [2, 86],
                  82: [2, 86],
                  83: [2, 86],
                  84: [2, 86],
                  85: [2, 86],
                },
                {
                  33: [2, 40],
                  65: [2, 40],
                  72: [2, 40],
                  80: [2, 40],
                  81: [2, 40],
                  82: [2, 40],
                  83: [2, 40],
                  84: [2, 40],
                  85: [2, 40],
                },
                {
                  33: [2, 41],
                  65: [2, 41],
                  72: [2, 41],
                  80: [2, 41],
                  81: [2, 41],
                  82: [2, 41],
                  83: [2, 41],
                  84: [2, 41],
                  85: [2, 41],
                },
                {
                  20: 64,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 26: 65, 47: [1, 66] },
                {
                  30: 67,
                  33: [2, 58],
                  65: [2, 58],
                  72: [2, 58],
                  75: [2, 58],
                  80: [2, 58],
                  81: [2, 58],
                  82: [2, 58],
                  83: [2, 58],
                  84: [2, 58],
                  85: [2, 58],
                },
                {
                  33: [2, 64],
                  35: 68,
                  65: [2, 64],
                  72: [2, 64],
                  75: [2, 64],
                  80: [2, 64],
                  81: [2, 64],
                  82: [2, 64],
                  83: [2, 64],
                  84: [2, 64],
                  85: [2, 64],
                },
                {
                  21: 69,
                  23: [2, 50],
                  65: [2, 50],
                  72: [2, 50],
                  80: [2, 50],
                  81: [2, 50],
                  82: [2, 50],
                  83: [2, 50],
                  84: [2, 50],
                  85: [2, 50],
                },
                {
                  33: [2, 90],
                  61: 70,
                  65: [2, 90],
                  72: [2, 90],
                  80: [2, 90],
                  81: [2, 90],
                  82: [2, 90],
                  83: [2, 90],
                  84: [2, 90],
                  85: [2, 90],
                },
                {
                  20: 74,
                  33: [2, 80],
                  50: 71,
                  63: 72,
                  64: 75,
                  65: [1, 43],
                  69: 73,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 72: [1, 79] },
                {
                  23: [2, 42],
                  33: [2, 42],
                  54: [2, 42],
                  65: [2, 42],
                  68: [2, 42],
                  72: [2, 42],
                  75: [2, 42],
                  80: [2, 42],
                  81: [2, 42],
                  82: [2, 42],
                  83: [2, 42],
                  84: [2, 42],
                  85: [2, 42],
                  87: [1, 50],
                },
                {
                  20: 74,
                  53: 80,
                  54: [2, 84],
                  63: 81,
                  64: 75,
                  65: [1, 43],
                  69: 82,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 26: 83, 47: [1, 66] },
                { 47: [2, 55] },
                {
                  4: 84,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  39: [2, 46],
                  44: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 47: [2, 20] },
                {
                  20: 85,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  4: 86,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 26: 87, 47: [1, 66] },
                { 47: [2, 57] },
                {
                  5: [2, 11],
                  14: [2, 11],
                  15: [2, 11],
                  19: [2, 11],
                  29: [2, 11],
                  34: [2, 11],
                  39: [2, 11],
                  44: [2, 11],
                  47: [2, 11],
                  48: [2, 11],
                  51: [2, 11],
                  55: [2, 11],
                  60: [2, 11],
                },
                { 15: [2, 49], 18: [2, 49] },
                {
                  20: 74,
                  33: [2, 88],
                  58: 88,
                  63: 89,
                  64: 75,
                  65: [1, 43],
                  69: 90,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  65: [2, 94],
                  66: 91,
                  68: [2, 94],
                  72: [2, 94],
                  80: [2, 94],
                  81: [2, 94],
                  82: [2, 94],
                  83: [2, 94],
                  84: [2, 94],
                  85: [2, 94],
                },
                {
                  5: [2, 25],
                  14: [2, 25],
                  15: [2, 25],
                  19: [2, 25],
                  29: [2, 25],
                  34: [2, 25],
                  39: [2, 25],
                  44: [2, 25],
                  47: [2, 25],
                  48: [2, 25],
                  51: [2, 25],
                  55: [2, 25],
                  60: [2, 25],
                },
                {
                  20: 92,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 74,
                  31: 93,
                  33: [2, 60],
                  63: 94,
                  64: 75,
                  65: [1, 43],
                  69: 95,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  75: [2, 60],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 74,
                  33: [2, 66],
                  36: 96,
                  63: 97,
                  64: 75,
                  65: [1, 43],
                  69: 98,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  75: [2, 66],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 74,
                  22: 99,
                  23: [2, 52],
                  63: 100,
                  64: 75,
                  65: [1, 43],
                  69: 101,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 74,
                  33: [2, 92],
                  62: 102,
                  63: 103,
                  64: 75,
                  65: [1, 43],
                  69: 104,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 33: [1, 105] },
                {
                  33: [2, 79],
                  65: [2, 79],
                  72: [2, 79],
                  80: [2, 79],
                  81: [2, 79],
                  82: [2, 79],
                  83: [2, 79],
                  84: [2, 79],
                  85: [2, 79],
                },
                { 33: [2, 81] },
                {
                  23: [2, 27],
                  33: [2, 27],
                  54: [2, 27],
                  65: [2, 27],
                  68: [2, 27],
                  72: [2, 27],
                  75: [2, 27],
                  80: [2, 27],
                  81: [2, 27],
                  82: [2, 27],
                  83: [2, 27],
                  84: [2, 27],
                  85: [2, 27],
                },
                {
                  23: [2, 28],
                  33: [2, 28],
                  54: [2, 28],
                  65: [2, 28],
                  68: [2, 28],
                  72: [2, 28],
                  75: [2, 28],
                  80: [2, 28],
                  81: [2, 28],
                  82: [2, 28],
                  83: [2, 28],
                  84: [2, 28],
                  85: [2, 28],
                },
                {
                  23: [2, 30],
                  33: [2, 30],
                  54: [2, 30],
                  68: [2, 30],
                  71: 106,
                  72: [1, 107],
                  75: [2, 30],
                },
                {
                  23: [2, 98],
                  33: [2, 98],
                  54: [2, 98],
                  68: [2, 98],
                  72: [2, 98],
                  75: [2, 98],
                },
                {
                  23: [2, 45],
                  33: [2, 45],
                  54: [2, 45],
                  65: [2, 45],
                  68: [2, 45],
                  72: [2, 45],
                  73: [1, 108],
                  75: [2, 45],
                  80: [2, 45],
                  81: [2, 45],
                  82: [2, 45],
                  83: [2, 45],
                  84: [2, 45],
                  85: [2, 45],
                  87: [2, 45],
                },
                {
                  23: [2, 44],
                  33: [2, 44],
                  54: [2, 44],
                  65: [2, 44],
                  68: [2, 44],
                  72: [2, 44],
                  75: [2, 44],
                  80: [2, 44],
                  81: [2, 44],
                  82: [2, 44],
                  83: [2, 44],
                  84: [2, 44],
                  85: [2, 44],
                  87: [2, 44],
                },
                { 54: [1, 109] },
                {
                  54: [2, 83],
                  65: [2, 83],
                  72: [2, 83],
                  80: [2, 83],
                  81: [2, 83],
                  82: [2, 83],
                  83: [2, 83],
                  84: [2, 83],
                  85: [2, 83],
                },
                { 54: [2, 85] },
                {
                  5: [2, 13],
                  14: [2, 13],
                  15: [2, 13],
                  19: [2, 13],
                  29: [2, 13],
                  34: [2, 13],
                  39: [2, 13],
                  44: [2, 13],
                  47: [2, 13],
                  48: [2, 13],
                  51: [2, 13],
                  55: [2, 13],
                  60: [2, 13],
                },
                {
                  38: 55,
                  39: [1, 57],
                  43: 56,
                  44: [1, 58],
                  45: 111,
                  46: 110,
                  47: [2, 76],
                },
                {
                  33: [2, 70],
                  40: 112,
                  65: [2, 70],
                  72: [2, 70],
                  75: [2, 70],
                  80: [2, 70],
                  81: [2, 70],
                  82: [2, 70],
                  83: [2, 70],
                  84: [2, 70],
                  85: [2, 70],
                },
                { 47: [2, 18] },
                {
                  5: [2, 14],
                  14: [2, 14],
                  15: [2, 14],
                  19: [2, 14],
                  29: [2, 14],
                  34: [2, 14],
                  39: [2, 14],
                  44: [2, 14],
                  47: [2, 14],
                  48: [2, 14],
                  51: [2, 14],
                  55: [2, 14],
                  60: [2, 14],
                },
                { 33: [1, 113] },
                {
                  33: [2, 87],
                  65: [2, 87],
                  72: [2, 87],
                  80: [2, 87],
                  81: [2, 87],
                  82: [2, 87],
                  83: [2, 87],
                  84: [2, 87],
                  85: [2, 87],
                },
                { 33: [2, 89] },
                {
                  20: 74,
                  63: 115,
                  64: 75,
                  65: [1, 43],
                  67: 114,
                  68: [2, 96],
                  69: 116,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 33: [1, 117] },
                { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] },
                {
                  33: [2, 59],
                  65: [2, 59],
                  72: [2, 59],
                  75: [2, 59],
                  80: [2, 59],
                  81: [2, 59],
                  82: [2, 59],
                  83: [2, 59],
                  84: [2, 59],
                  85: [2, 59],
                },
                { 33: [2, 61], 75: [2, 61] },
                { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] },
                {
                  33: [2, 65],
                  65: [2, 65],
                  72: [2, 65],
                  75: [2, 65],
                  80: [2, 65],
                  81: [2, 65],
                  82: [2, 65],
                  83: [2, 65],
                  84: [2, 65],
                  85: [2, 65],
                },
                { 33: [2, 67], 75: [2, 67] },
                { 23: [1, 123] },
                {
                  23: [2, 51],
                  65: [2, 51],
                  72: [2, 51],
                  80: [2, 51],
                  81: [2, 51],
                  82: [2, 51],
                  83: [2, 51],
                  84: [2, 51],
                  85: [2, 51],
                },
                { 23: [2, 53] },
                { 33: [1, 124] },
                {
                  33: [2, 91],
                  65: [2, 91],
                  72: [2, 91],
                  80: [2, 91],
                  81: [2, 91],
                  82: [2, 91],
                  83: [2, 91],
                  84: [2, 91],
                  85: [2, 91],
                },
                { 33: [2, 93] },
                {
                  5: [2, 22],
                  14: [2, 22],
                  15: [2, 22],
                  19: [2, 22],
                  29: [2, 22],
                  34: [2, 22],
                  39: [2, 22],
                  44: [2, 22],
                  47: [2, 22],
                  48: [2, 22],
                  51: [2, 22],
                  55: [2, 22],
                  60: [2, 22],
                },
                {
                  23: [2, 99],
                  33: [2, 99],
                  54: [2, 99],
                  68: [2, 99],
                  72: [2, 99],
                  75: [2, 99],
                },
                { 73: [1, 108] },
                {
                  20: 74,
                  63: 125,
                  64: 75,
                  65: [1, 43],
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  5: [2, 23],
                  14: [2, 23],
                  15: [2, 23],
                  19: [2, 23],
                  29: [2, 23],
                  34: [2, 23],
                  39: [2, 23],
                  44: [2, 23],
                  47: [2, 23],
                  48: [2, 23],
                  51: [2, 23],
                  55: [2, 23],
                  60: [2, 23],
                },
                { 47: [2, 19] },
                { 47: [2, 77] },
                {
                  20: 74,
                  33: [2, 72],
                  41: 126,
                  63: 127,
                  64: 75,
                  65: [1, 43],
                  69: 128,
                  70: 76,
                  71: 77,
                  72: [1, 78],
                  75: [2, 72],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  5: [2, 24],
                  14: [2, 24],
                  15: [2, 24],
                  19: [2, 24],
                  29: [2, 24],
                  34: [2, 24],
                  39: [2, 24],
                  44: [2, 24],
                  47: [2, 24],
                  48: [2, 24],
                  51: [2, 24],
                  55: [2, 24],
                  60: [2, 24],
                },
                { 68: [1, 129] },
                {
                  65: [2, 95],
                  68: [2, 95],
                  72: [2, 95],
                  80: [2, 95],
                  81: [2, 95],
                  82: [2, 95],
                  83: [2, 95],
                  84: [2, 95],
                  85: [2, 95],
                },
                { 68: [2, 97] },
                {
                  5: [2, 21],
                  14: [2, 21],
                  15: [2, 21],
                  19: [2, 21],
                  29: [2, 21],
                  34: [2, 21],
                  39: [2, 21],
                  44: [2, 21],
                  47: [2, 21],
                  48: [2, 21],
                  51: [2, 21],
                  55: [2, 21],
                  60: [2, 21],
                },
                { 33: [1, 130] },
                { 33: [2, 63] },
                { 72: [1, 132], 76: 131 },
                { 33: [1, 133] },
                { 33: [2, 69] },
                { 15: [2, 12], 18: [2, 12] },
                {
                  14: [2, 26],
                  15: [2, 26],
                  19: [2, 26],
                  29: [2, 26],
                  34: [2, 26],
                  47: [2, 26],
                  48: [2, 26],
                  51: [2, 26],
                  55: [2, 26],
                  60: [2, 26],
                },
                {
                  23: [2, 31],
                  33: [2, 31],
                  54: [2, 31],
                  68: [2, 31],
                  72: [2, 31],
                  75: [2, 31],
                },
                { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] },
                {
                  33: [2, 71],
                  65: [2, 71],
                  72: [2, 71],
                  75: [2, 71],
                  80: [2, 71],
                  81: [2, 71],
                  82: [2, 71],
                  83: [2, 71],
                  84: [2, 71],
                  85: [2, 71],
                },
                { 33: [2, 73], 75: [2, 73] },
                {
                  23: [2, 29],
                  33: [2, 29],
                  54: [2, 29],
                  65: [2, 29],
                  68: [2, 29],
                  72: [2, 29],
                  75: [2, 29],
                  80: [2, 29],
                  81: [2, 29],
                  82: [2, 29],
                  83: [2, 29],
                  84: [2, 29],
                  85: [2, 29],
                },
                {
                  14: [2, 15],
                  15: [2, 15],
                  19: [2, 15],
                  29: [2, 15],
                  34: [2, 15],
                  39: [2, 15],
                  44: [2, 15],
                  47: [2, 15],
                  48: [2, 15],
                  51: [2, 15],
                  55: [2, 15],
                  60: [2, 15],
                },
                { 72: [1, 137], 77: [1, 136] },
                { 72: [2, 100], 77: [2, 100] },
                {
                  14: [2, 16],
                  15: [2, 16],
                  19: [2, 16],
                  29: [2, 16],
                  34: [2, 16],
                  44: [2, 16],
                  47: [2, 16],
                  48: [2, 16],
                  51: [2, 16],
                  55: [2, 16],
                  60: [2, 16],
                },
                { 33: [1, 138] },
                { 33: [2, 75] },
                { 33: [2, 32] },
                { 72: [2, 101], 77: [2, 101] },
                {
                  14: [2, 17],
                  15: [2, 17],
                  19: [2, 17],
                  29: [2, 17],
                  34: [2, 17],
                  39: [2, 17],
                  44: [2, 17],
                  47: [2, 17],
                  48: [2, 17],
                  51: [2, 17],
                  55: [2, 17],
                  60: [2, 17],
                },
              ],
              defaultActions: {
                4: [2, 1],
                54: [2, 55],
                56: [2, 20],
                60: [2, 57],
                73: [2, 81],
                82: [2, 85],
                86: [2, 18],
                90: [2, 89],
                101: [2, 53],
                104: [2, 93],
                110: [2, 19],
                111: [2, 77],
                116: [2, 97],
                119: [2, 63],
                122: [2, 69],
                135: [2, 75],
                136: [2, 32],
              },
              parseError: function (e, t) {
                throw new Error(e);
              },
              parse: function (e) {
                function t() {
                  var e;
                  return (
                    (e = n.lexer.lex() || 1),
                    "number" != typeof e && (e = n.symbols_[e] || e),
                    e
                  );
                }
                var n = this,
                  i = [0],
                  o = [null],
                  r = [],
                  s = this.table,
                  a = "",
                  l = 0,
                  c = 0,
                  u = 0;
                this.lexer.setInput(e),
                  (this.lexer.yy = this.yy),
                  (this.yy.lexer = this.lexer),
                  (this.yy.parser = this),
                  "undefined" == typeof this.lexer.yylloc &&
                    (this.lexer.yylloc = {});
                var p = this.lexer.yylloc;
                r.push(p);
                var d = this.lexer.options && this.lexer.options.ranges;
                "function" == typeof this.yy.parseError &&
                  (this.parseError = this.yy.parseError);
                for (var f, h, m, v, g, y, b, w, x, k = {}; ; ) {
                  if (
                    ((m = i[i.length - 1]),
                    this.defaultActions[m]
                      ? (v = this.defaultActions[m])
                      : ((null !== f && "undefined" != typeof f) || (f = t()),
                        (v = s[m] && s[m][f])),
                    "undefined" == typeof v || !v.length || !v[0])
                  ) {
                    var S = "";
                    if (!u) {
                      x = [];
                      for (y in s[m])
                        this.terminals_[y] &&
                          y > 2 &&
                          x.push("'" + this.terminals_[y] + "'");
                      (S = this.lexer.showPosition
                        ? "Parse error on line " +
                          (l + 1) +
                          ":\n" +
                          this.lexer.showPosition() +
                          "\nExpecting " +
                          x.join(", ") +
                          ", got '" +
                          (this.terminals_[f] || f) +
                          "'"
                        : "Parse error on line " +
                          (l + 1) +
                          ": Unexpected " +
                          (1 == f
                            ? "end of input"
                            : "'" + (this.terminals_[f] || f) + "'")),
                        this.parseError(S, {
                          text: this.lexer.match,
                          token: this.terminals_[f] || f,
                          line: this.lexer.yylineno,
                          loc: p,
                          expected: x,
                        });
                    }
                  }
                  if (v[0] instanceof Array && v.length > 1)
                    throw new Error(
                      "Parse Error: multiple actions possible at state: " +
                        m +
                        ", token: " +
                        f
                    );
                  switch (v[0]) {
                    case 1:
                      i.push(f),
                        o.push(this.lexer.yytext),
                        r.push(this.lexer.yylloc),
                        i.push(v[1]),
                        (f = null),
                        h
                          ? ((f = h), (h = null))
                          : ((c = this.lexer.yyleng),
                            (a = this.lexer.yytext),
                            (l = this.lexer.yylineno),
                            (p = this.lexer.yylloc),
                            u > 0 && u--);
                      break;
                    case 2:
                      if (
                        ((b = this.productions_[v[1]][1]),
                        (k.$ = o[o.length - b]),
                        (k._$ = {
                          first_line: r[r.length - (b || 1)].first_line,
                          last_line: r[r.length - 1].last_line,
                          first_column: r[r.length - (b || 1)].first_column,
                          last_column: r[r.length - 1].last_column,
                        }),
                        d &&
                          (k._$.range = [
                            r[r.length - (b || 1)].range[0],
                            r[r.length - 1].range[1],
                          ]),
                        (g = this.performAction.call(
                          k,
                          a,
                          c,
                          l,
                          this.yy,
                          v[1],
                          o,
                          r
                        )),
                        "undefined" != typeof g)
                      )
                        return g;
                      b &&
                        ((i = i.slice(0, -1 * b * 2)),
                        (o = o.slice(0, -1 * b)),
                        (r = r.slice(0, -1 * b))),
                        i.push(this.productions_[v[1]][0]),
                        o.push(k.$),
                        r.push(k._$),
                        (w = s[i[i.length - 2]][i[i.length - 1]]),
                        i.push(w);
                      break;
                    case 3:
                      return !0;
                  }
                }
                return !0;
              },
            },
            n = (function () {
              var e = {
                EOF: 1,
                parseError: function (e, t) {
                  if (!this.yy.parser) throw new Error(e);
                  this.yy.parser.parseError(e, t);
                },
                setInput: function (e) {
                  return (
                    (this._input = e),
                    (this._more = this._less = this.done = !1),
                    (this.yylineno = this.yyleng = 0),
                    (this.yytext = this.matched = this.match = ""),
                    (this.conditionStack = ["INITIAL"]),
                    (this.yylloc = {
                      first_line: 1,
                      first_column: 0,
                      last_line: 1,
                      last_column: 0,
                    }),
                    this.options.ranges && (this.yylloc.range = [0, 0]),
                    (this.offset = 0),
                    this
                  );
                },
                input: function () {
                  var e = this._input[0];
                  (this.yytext += e),
                    this.yyleng++,
                    this.offset++,
                    (this.match += e),
                    (this.matched += e);
                  var t = e.match(/(?:\r\n?|\n).*/g);
                  return (
                    t
                      ? (this.yylineno++, this.yylloc.last_line++)
                      : this.yylloc.last_column++,
                    this.options.ranges && this.yylloc.range[1]++,
                    (this._input = this._input.slice(1)),
                    e
                  );
                },
                unput: function (e) {
                  var t = e.length,
                    n = e.split(/(?:\r\n?|\n)/g);
                  (this._input = e + this._input),
                    (this.yytext = this.yytext.substr(
                      0,
                      this.yytext.length - t - 1
                    )),
                    (this.offset -= t);
                  var i = this.match.split(/(?:\r\n?|\n)/g);
                  (this.match = this.match.substr(0, this.match.length - 1)),
                    (this.matched = this.matched.substr(
                      0,
                      this.matched.length - 1
                    )),
                    n.length - 1 && (this.yylineno -= n.length - 1);
                  var o = this.yylloc.range;
                  return (
                    (this.yylloc = {
                      first_line: this.yylloc.first_line,
                      last_line: this.yylineno + 1,
                      first_column: this.yylloc.first_column,
                      last_column: n
                        ? (n.length === i.length
                            ? this.yylloc.first_column
                            : 0) +
                          i[i.length - n.length].length -
                          n[0].length
                        : this.yylloc.first_column - t,
                    }),
                    this.options.ranges &&
                      (this.yylloc.range = [o[0], o[0] + this.yyleng - t]),
                    this
                  );
                },
                more: function () {
                  return (this._more = !0), this;
                },
                less: function (e) {
                  this.unput(this.match.slice(e));
                },
                pastInput: function () {
                  var e = this.matched.substr(
                    0,
                    this.matched.length - this.match.length
                  );
                  return (
                    (e.length > 20 ? "..." : "") +
                    e.substr(-20).replace(/\n/g, "")
                  );
                },
                upcomingInput: function () {
                  var e = this.match;
                  return (
                    e.length < 20 &&
                      (e += this._input.substr(0, 20 - e.length)),
                    (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(
                      /\n/g,
                      ""
                    )
                  );
                },
                showPosition: function () {
                  var e = this.pastInput(),
                    t = new Array(e.length + 1).join("-");
                  return e + this.upcomingInput() + "\n" + t + "^";
                },
                next: function () {
                  if (this.done) return this.EOF;
                  this._input || (this.done = !0);
                  var e, t, n, i, o;
                  this._more || ((this.yytext = ""), (this.match = ""));
                  for (
                    var r = this._currentRules(), s = 0;
                    s < r.length &&
                    ((n = this._input.match(this.rules[r[s]])),
                    !n ||
                      (t && !(n[0].length > t[0].length)) ||
                      ((t = n), (i = s), this.options.flex));
                    s++
                  );
                  return t
                    ? ((o = t[0].match(/(?:\r\n?|\n).*/g)),
                      o && (this.yylineno += o.length),
                      (this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: o
                          ? o[o.length - 1].length -
                            o[o.length - 1].match(/\r?\n?/)[0].length
                          : this.yylloc.last_column + t[0].length,
                      }),
                      (this.yytext += t[0]),
                      (this.match += t[0]),
                      (this.matches = t),
                      (this.yyleng = this.yytext.length),
                      this.options.ranges &&
                        (this.yylloc.range = [
                          this.offset,
                          (this.offset += this.yyleng),
                        ]),
                      (this._more = !1),
                      (this._input = this._input.slice(t[0].length)),
                      (this.matched += t[0]),
                      (e = this.performAction.call(
                        this,
                        this.yy,
                        this,
                        r[i],
                        this.conditionStack[this.conditionStack.length - 1]
                      )),
                      this.done && this._input && (this.done = !1),
                      e ? e : void 0)
                    : "" === this._input
                    ? this.EOF
                    : this.parseError(
                        "Lexical error on line " +
                          (this.yylineno + 1) +
                          ". Unrecognized text.\n" +
                          this.showPosition(),
                        { text: "", token: null, line: this.yylineno }
                      );
                },
                lex: function () {
                  var e = this.next();
                  return "undefined" != typeof e ? e : this.lex();
                },
                begin: function (e) {
                  this.conditionStack.push(e);
                },
                popState: function () {
                  return this.conditionStack.pop();
                },
                _currentRules: function () {
                  return this.conditions[
                    this.conditionStack[this.conditionStack.length - 1]
                  ].rules;
                },
                topState: function () {
                  return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function (e) {
                  this.begin(e);
                },
              };
              return (
                (e.options = {}),
                (e.performAction = function (e, t, n, i) {
                  function o(e, n) {
                    return (t.yytext = t.yytext.substring(e, t.yyleng - n + e));
                  }
                  switch (n) {
                    case 0:
                      if (
                        ("\\\\" === t.yytext.slice(-2)
                          ? (o(0, 1), this.begin("mu"))
                          : "\\" === t.yytext.slice(-1)
                          ? (o(0, 1), this.begin("emu"))
                          : this.begin("mu"),
                        t.yytext)
                      )
                        return 15;
                      break;
                    case 1:
                      return 15;
                    case 2:
                      return this.popState(), 15;
                    case 3:
                      return this.begin("raw"), 15;
                    case 4:
                      return (
                        this.popState(),
                        "raw" ===
                        this.conditionStack[this.conditionStack.length - 1]
                          ? 15
                          : (o(5, 9), "END_RAW_BLOCK")
                      );
                    case 5:
                      return 15;
                    case 6:
                      return this.popState(), 14;
                    case 7:
                      return 65;
                    case 8:
                      return 68;
                    case 9:
                      return 19;
                    case 10:
                      return this.popState(), this.begin("raw"), 23;
                    case 11:
                      return 55;
                    case 12:
                      return 60;
                    case 13:
                      return 29;
                    case 14:
                      return 47;
                    case 15:
                      return this.popState(), 44;
                    case 16:
                      return this.popState(), 44;
                    case 17:
                      return 34;
                    case 18:
                      return 39;
                    case 19:
                      return 51;
                    case 20:
                      return 48;
                    case 21:
                      this.unput(t.yytext), this.popState(), this.begin("com");
                      break;
                    case 22:
                      return this.popState(), 14;
                    case 23:
                      return 48;
                    case 24:
                      return 73;
                    case 25:
                      return 72;
                    case 26:
                      return 72;
                    case 27:
                      return 87;
                    case 28:
                      break;
                    case 29:
                      return this.popState(), 54;
                    case 30:
                      return this.popState(), 33;
                    case 31:
                      return (t.yytext = o(1, 2).replace(/\\"/g, '"')), 80;
                    case 32:
                      return (t.yytext = o(1, 2).replace(/\\'/g, "'")), 80;
                    case 33:
                      return 85;
                    case 34:
                      return 82;
                    case 35:
                      return 82;
                    case 36:
                      return 83;
                    case 37:
                      return 84;
                    case 38:
                      return 81;
                    case 39:
                      return 75;
                    case 40:
                      return 77;
                    case 41:
                      return 72;
                    case 42:
                      return (
                        (t.yytext = t.yytext.replace(/\\([\\\]])/g, "$1")), 72
                      );
                    case 43:
                      return "INVALID";
                    case 44:
                      return 5;
                  }
                }),
                (e.rules = [
                  /^(?:[^\x00]*?(?=(\{\{)))/,
                  /^(?:[^\x00]+)/,
                  /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                  /^(?:\{\{\{\{(?=[^\/]))/,
                  /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                  /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
                  /^(?:[\s\S]*?--(~)?\}\})/,
                  /^(?:\()/,
                  /^(?:\))/,
                  /^(?:\{\{\{\{)/,
                  /^(?:\}\}\}\})/,
                  /^(?:\{\{(~)?>)/,
                  /^(?:\{\{(~)?#>)/,
                  /^(?:\{\{(~)?#\*?)/,
                  /^(?:\{\{(~)?\/)/,
                  /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                  /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                  /^(?:\{\{(~)?\^)/,
                  /^(?:\{\{(~)?\s*else\b)/,
                  /^(?:\{\{(~)?\{)/,
                  /^(?:\{\{(~)?&)/,
                  /^(?:\{\{(~)?!--)/,
                  /^(?:\{\{(~)?![\s\S]*?\}\})/,
                  /^(?:\{\{(~)?\*?)/,
                  /^(?:=)/,
                  /^(?:\.\.)/,
                  /^(?:\.(?=([=~}\s\/.)|])))/,
                  /^(?:[\/.])/,
                  /^(?:\s+)/,
                  /^(?:\}(~)?\}\})/,
                  /^(?:(~)?\}\})/,
                  /^(?:"(\\["]|[^"])*")/,
                  /^(?:'(\\[']|[^'])*')/,
                  /^(?:@)/,
                  /^(?:true(?=([~}\s)])))/,
                  /^(?:false(?=([~}\s)])))/,
                  /^(?:undefined(?=([~}\s)])))/,
                  /^(?:null(?=([~}\s)])))/,
                  /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                  /^(?:as\s+\|)/,
                  /^(?:\|)/,
                  /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                  /^(?:\[(\\\]|[^\]])*\])/,
                  /^(?:.)/,
                  /^(?:$)/,
                ]),
                (e.conditions = {
                  mu: {
                    rules: [
                      7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
                      36, 37, 38, 39, 40, 41, 42, 43, 44,
                    ],
                    inclusive: !1,
                  },
                  emu: { rules: [2], inclusive: !1 },
                  com: { rules: [6], inclusive: !1 },
                  raw: { rules: [3, 4, 5], inclusive: !1 },
                  INITIAL: { rules: [0, 1, 44], inclusive: !0 },
                }),
                e
              );
            })();
          return (t.lexer = n), (e.prototype = t), (t.Parser = e), new e();
        })();
        (t.default = n), (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i() {
          var e =
            arguments.length <= 0 || void 0 === arguments[0]
              ? {}
              : arguments[0];
          this.options = e;
        }
        function o(e, t, n) {
          void 0 === t && (t = e.length);
          var i = e[t - 1],
            o = e[t - 2];
          return i
            ? "ContentStatement" === i.type
              ? (o || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(i.original)
              : void 0
            : n;
        }
        function r(e, t, n) {
          void 0 === t && (t = -1);
          var i = e[t + 1],
            o = e[t + 2];
          return i
            ? "ContentStatement" === i.type
              ? (o || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(i.original)
              : void 0
            : n;
        }
        function s(e, t, n) {
          var i = e[null == t ? 0 : t + 1];
          if (i && "ContentStatement" === i.type && (n || !i.rightStripped)) {
            var o = i.value;
            (i.value = i.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, "")),
              (i.rightStripped = i.value !== o);
          }
        }
        function a(e, t, n) {
          var i = e[null == t ? e.length - 1 : t - 1];
          if (i && "ContentStatement" === i.type && (n || !i.leftStripped)) {
            var o = i.value;
            return (
              (i.value = i.value.replace(n ? /\s+$/ : /[ \t]+$/, "")),
              (i.leftStripped = i.value !== o),
              i.leftStripped
            );
          }
        }
        var l = n(1).default;
        t.__esModule = !0;
        var c = n(49),
          u = l(c);
        (i.prototype = new u.default()),
          (i.prototype.Program = function (e) {
            var t = !this.options.ignoreStandalone,
              n = !this.isRootSeen;
            this.isRootSeen = !0;
            for (var i = e.body, l = 0, c = i.length; l < c; l++) {
              var u = i[l],
                p = this.accept(u);
              if (p) {
                var d = o(i, l, n),
                  f = r(i, l, n),
                  h = p.openStandalone && d,
                  m = p.closeStandalone && f,
                  v = p.inlineStandalone && d && f;
                p.close && s(i, l, !0),
                  p.open && a(i, l, !0),
                  t &&
                    v &&
                    (s(i, l),
                    a(i, l) &&
                      "PartialStatement" === u.type &&
                      (u.indent = /([ \t]+$)/.exec(i[l - 1].original)[1])),
                  t && h && (s((u.program || u.inverse).body), a(i, l)),
                  t && m && (s(i, l), a((u.inverse || u.program).body));
              }
            }
            return e;
          }),
          (i.prototype.BlockStatement =
            i.prototype.DecoratorBlock =
            i.prototype.PartialBlockStatement =
              function (e) {
                this.accept(e.program), this.accept(e.inverse);
                var t = e.program || e.inverse,
                  n = e.program && e.inverse,
                  i = n,
                  l = n;
                if (n && n.chained)
                  for (i = n.body[0].program; l.chained; )
                    l = l.body[l.body.length - 1].program;
                var c = {
                  open: e.openStrip.open,
                  close: e.closeStrip.close,
                  openStandalone: r(t.body),
                  closeStandalone: o((i || t).body),
                };
                if ((e.openStrip.close && s(t.body, null, !0), n)) {
                  var u = e.inverseStrip;
                  u.open && a(t.body, null, !0),
                    u.close && s(i.body, null, !0),
                    e.closeStrip.open && a(l.body, null, !0),
                    !this.options.ignoreStandalone &&
                      o(t.body) &&
                      r(i.body) &&
                      (a(t.body), s(i.body));
                } else e.closeStrip.open && a(t.body, null, !0);
                return c;
              }),
          (i.prototype.Decorator = i.prototype.MustacheStatement =
            function (e) {
              return e.strip;
            }),
          (i.prototype.PartialStatement = i.prototype.CommentStatement =
            function (e) {
              var t = e.strip || {};
              return { inlineStandalone: !0, open: t.open, close: t.close };
            }),
          (t.default = i),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i() {
          this.parents = [];
        }
        function o(e) {
          this.acceptRequired(e, "path"),
            this.acceptArray(e.params),
            this.acceptKey(e, "hash");
        }
        function r(e) {
          o.call(this, e),
            this.acceptKey(e, "program"),
            this.acceptKey(e, "inverse");
        }
        function s(e) {
          this.acceptRequired(e, "name"),
            this.acceptArray(e.params),
            this.acceptKey(e, "hash");
        }
        var a = n(1).default;
        t.__esModule = !0;
        var l = n(6),
          c = a(l);
        (i.prototype = {
          constructor: i,
          mutating: !1,
          acceptKey: function (e, t) {
            var n = this.accept(e[t]);
            if (this.mutating) {
              if (n && !i.prototype[n.type])
                throw new c.default(
                  'Unexpected node type "' +
                    n.type +
                    '" found when accepting ' +
                    t +
                    " on " +
                    e.type
                );
              e[t] = n;
            }
          },
          acceptRequired: function (e, t) {
            if ((this.acceptKey(e, t), !e[t]))
              throw new c.default(e.type + " requires " + t);
          },
          acceptArray: function (e) {
            for (var t = 0, n = e.length; t < n; t++)
              this.acceptKey(e, t), e[t] || (e.splice(t, 1), t--, n--);
          },
          accept: function (e) {
            if (e) {
              if (!this[e.type])
                throw new c.default("Unknown type: " + e.type, e);
              this.current && this.parents.unshift(this.current),
                (this.current = e);
              var t = this[e.type](e);
              return (
                (this.current = this.parents.shift()),
                !this.mutating || t ? t : t !== !1 ? e : void 0
              );
            }
          },
          Program: function (e) {
            this.acceptArray(e.body);
          },
          MustacheStatement: o,
          Decorator: o,
          BlockStatement: r,
          DecoratorBlock: r,
          PartialStatement: s,
          PartialBlockStatement: function (e) {
            s.call(this, e), this.acceptKey(e, "program");
          },
          ContentStatement: function () {},
          CommentStatement: function () {},
          SubExpression: o,
          PathExpression: function () {},
          StringLiteral: function () {},
          NumberLiteral: function () {},
          BooleanLiteral: function () {},
          UndefinedLiteral: function () {},
          NullLiteral: function () {},
          Hash: function (e) {
            this.acceptArray(e.pairs);
          },
          HashPair: function (e) {
            this.acceptRequired(e, "value");
          },
        }),
          (t.default = i),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t) {
          if (((t = t.path ? t.path.original : t), e.path.original !== t)) {
            var n = { loc: e.path.loc };
            throw new v.default(e.path.original + " doesn't match " + t, n);
          }
        }
        function o(e, t) {
          (this.source = e),
            (this.start = { line: t.first_line, column: t.first_column }),
            (this.end = { line: t.last_line, column: t.last_column });
        }
        function r(e) {
          return /^\[.*\]$/.test(e) ? e.substring(1, e.length - 1) : e;
        }
        function s(e, t) {
          return {
            open: "~" === e.charAt(2),
            close: "~" === t.charAt(t.length - 3),
          };
        }
        function a(e) {
          return e.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
        }
        function l(e, t, n) {
          n = this.locInfo(n);
          for (
            var i = e ? "@" : "", o = [], r = 0, s = 0, a = t.length;
            s < a;
            s++
          ) {
            var l = t[s].part,
              c = t[s].original !== l;
            if (
              ((i += (t[s].separator || "") + l),
              c || (".." !== l && "." !== l && "this" !== l))
            )
              o.push(l);
            else {
              if (o.length > 0)
                throw new v.default("Invalid path: " + i, { loc: n });
              ".." === l && r++;
            }
          }
          return {
            type: "PathExpression",
            data: e,
            depth: r,
            parts: o,
            original: i,
            loc: n,
          };
        }
        function c(e, t, n, i, o, r) {
          var s = i.charAt(3) || i.charAt(2),
            a = "{" !== s && "&" !== s,
            l = /\*/.test(i);
          return {
            type: l ? "Decorator" : "MustacheStatement",
            path: e,
            params: t,
            hash: n,
            escaped: a,
            strip: o,
            loc: this.locInfo(r),
          };
        }
        function u(e, t, n, o) {
          i(e, n), (o = this.locInfo(o));
          var r = { type: "Program", body: t, strip: {}, loc: o };
          return {
            type: "BlockStatement",
            path: e.path,
            params: e.params,
            hash: e.hash,
            program: r,
            openStrip: {},
            inverseStrip: {},
            closeStrip: {},
            loc: o,
          };
        }
        function p(e, t, n, o, r, s) {
          o && o.path && i(e, o);
          var a = /\*/.test(e.open);
          t.blockParams = e.blockParams;
          var l = void 0,
            c = void 0;
          if (n) {
            if (a)
              throw new v.default("Unexpected inverse block on decorator", n);
            n.chain && (n.program.body[0].closeStrip = o.strip),
              (c = n.strip),
              (l = n.program);
          }
          return (
            r && ((r = l), (l = t), (t = r)),
            {
              type: a ? "DecoratorBlock" : "BlockStatement",
              path: e.path,
              params: e.params,
              hash: e.hash,
              program: t,
              inverse: l,
              openStrip: e.strip,
              inverseStrip: c,
              closeStrip: o && o.strip,
              loc: this.locInfo(s),
            }
          );
        }
        function d(e, t) {
          if (!t && e.length) {
            var n = e[0].loc,
              i = e[e.length - 1].loc;
            n &&
              i &&
              (t = {
                source: n.source,
                start: { line: n.start.line, column: n.start.column },
                end: { line: i.end.line, column: i.end.column },
              });
          }
          return { type: "Program", body: e, strip: {}, loc: t };
        }
        function f(e, t, n, o) {
          return (
            i(e, n),
            {
              type: "PartialBlockStatement",
              name: e.path,
              params: e.params,
              hash: e.hash,
              program: t,
              openStrip: e.strip,
              closeStrip: n && n.strip,
              loc: this.locInfo(o),
            }
          );
        }
        var h = n(1).default;
        (t.__esModule = !0),
          (t.SourceLocation = o),
          (t.id = r),
          (t.stripFlags = s),
          (t.stripComment = a),
          (t.preparePath = l),
          (t.prepareMustache = c),
          (t.prepareRawBlock = u),
          (t.prepareBlock = p),
          (t.prepareProgram = d),
          (t.preparePartialBlock = f);
        var m = n(6),
          v = h(m);
      },
      function (e, t, n) {
        "use strict";
        function i() {}
        function o(e, t, n) {
          if (null == e || ("string" != typeof e && "Program" !== e.type))
            throw new p.default(
              "You must pass a string or Handlebars AST to Handlebars.precompile. You passed " +
                e
            );
          (t = t || {}),
            "data" in t || (t.data = !0),
            t.compat && (t.useDepths = !0);
          var i = n.parse(e, t),
            o = new n.Compiler().compile(i, t);
          return new n.JavaScriptCompiler().compile(o, t);
        }
        function r(e, t, n) {
          function i() {
            var i = n.parse(e, t),
              o = new n.Compiler().compile(i, t),
              r = new n.JavaScriptCompiler().compile(o, t, void 0, !0);
            return n.template(r);
          }
          function o(e, t) {
            return r || (r = i()), r.call(this, e, t);
          }
          if (
            (void 0 === t && (t = {}),
            null == e || ("string" != typeof e && "Program" !== e.type))
          )
            throw new p.default(
              "You must pass a string or Handlebars AST to Handlebars.compile. You passed " +
                e
            );
          (t = d.extend({}, t)),
            "data" in t || (t.data = !0),
            t.compat && (t.useDepths = !0);
          var r = void 0;
          return (
            (o._setup = function (e) {
              return r || (r = i()), r._setup(e);
            }),
            (o._child = function (e, t, n, o) {
              return r || (r = i()), r._child(e, t, n, o);
            }),
            o
          );
        }
        function s(e, t) {
          if (e === t) return !0;
          if (d.isArray(e) && d.isArray(t) && e.length === t.length) {
            for (var n = 0; n < e.length; n++) if (!s(e[n], t[n])) return !1;
            return !0;
          }
        }
        function a(e) {
          if (!e.path.parts) {
            var t = e.path;
            e.path = {
              type: "PathExpression",
              data: !1,
              depth: 0,
              parts: [t.original + ""],
              original: t.original + "",
              loc: t.loc,
            };
          }
        }
        var l = n(34).default,
          c = n(1).default;
        (t.__esModule = !0),
          (t.Compiler = i),
          (t.precompile = o),
          (t.compile = r);
        var u = n(6),
          p = c(u),
          d = n(5),
          f = n(45),
          h = c(f),
          m = [].slice;
        i.prototype = {
          compiler: i,
          equals: function (e) {
            var t = this.opcodes.length;
            if (e.opcodes.length !== t) return !1;
            for (var n = 0; n < t; n++) {
              var i = this.opcodes[n],
                o = e.opcodes[n];
              if (i.opcode !== o.opcode || !s(i.args, o.args)) return !1;
            }
            t = this.children.length;
            for (var n = 0; n < t; n++)
              if (!this.children[n].equals(e.children[n])) return !1;
            return !0;
          },
          guid: 0,
          compile: function (e, t) {
            return (
              (this.sourceNode = []),
              (this.opcodes = []),
              (this.children = []),
              (this.options = t),
              (this.stringParams = t.stringParams),
              (this.trackIds = t.trackIds),
              (t.blockParams = t.blockParams || []),
              (t.knownHelpers = d.extend(
                l(null),
                {
                  helperMissing: !0,
                  blockHelperMissing: !0,
                  each: !0,
                  if: !0,
                  unless: !0,
                  with: !0,
                  log: !0,
                  lookup: !0,
                },
                t.knownHelpers
              )),
              this.accept(e)
            );
          },
          compileProgram: function (e) {
            var t = new this.compiler(),
              n = t.compile(e, this.options),
              i = this.guid++;
            return (
              (this.usePartial = this.usePartial || n.usePartial),
              (this.children[i] = n),
              (this.useDepths = this.useDepths || n.useDepths),
              i
            );
          },
          accept: function (e) {
            if (!this[e.type])
              throw new p.default("Unknown type: " + e.type, e);
            this.sourceNode.unshift(e);
            var t = this[e.type](e);
            return this.sourceNode.shift(), t;
          },
          Program: function (e) {
            this.options.blockParams.unshift(e.blockParams);
            for (var t = e.body, n = t.length, i = 0; i < n; i++)
              this.accept(t[i]);
            return (
              this.options.blockParams.shift(),
              (this.isSimple = 1 === n),
              (this.blockParams = e.blockParams ? e.blockParams.length : 0),
              this
            );
          },
          BlockStatement: function (e) {
            a(e);
            var t = e.program,
              n = e.inverse;
            (t = t && this.compileProgram(t)),
              (n = n && this.compileProgram(n));
            var i = this.classifySexpr(e);
            "helper" === i
              ? this.helperSexpr(e, t, n)
              : "simple" === i
              ? (this.simpleSexpr(e),
                this.opcode("pushProgram", t),
                this.opcode("pushProgram", n),
                this.opcode("emptyHash"),
                this.opcode("blockValue", e.path.original))
              : (this.ambiguousSexpr(e, t, n),
                this.opcode("pushProgram", t),
                this.opcode("pushProgram", n),
                this.opcode("emptyHash"),
                this.opcode("ambiguousBlockValue")),
              this.opcode("append");
          },
          DecoratorBlock: function (e) {
            var t = e.program && this.compileProgram(e.program),
              n = this.setupFullMustacheParams(e, t, void 0),
              i = e.path;
            (this.useDecorators = !0),
              this.opcode("registerDecorator", n.length, i.original);
          },
          PartialStatement: function (e) {
            this.usePartial = !0;
            var t = e.program;
            t && (t = this.compileProgram(e.program));
            var n = e.params;
            if (n.length > 1)
              throw new p.default(
                "Unsupported number of partial arguments: " + n.length,
                e
              );
            n.length ||
              (this.options.explicitPartialContext
                ? this.opcode("pushLiteral", "undefined")
                : n.push({ type: "PathExpression", parts: [], depth: 0 }));
            var i = e.name.original,
              o = "SubExpression" === e.name.type;
            o && this.accept(e.name),
              this.setupFullMustacheParams(e, t, void 0, !0);
            var r = e.indent || "";
            this.options.preventIndent &&
              r &&
              (this.opcode("appendContent", r), (r = "")),
              this.opcode("invokePartial", o, i, r),
              this.opcode("append");
          },
          PartialBlockStatement: function (e) {
            this.PartialStatement(e);
          },
          MustacheStatement: function (e) {
            this.SubExpression(e),
              e.escaped && !this.options.noEscape
                ? this.opcode("appendEscaped")
                : this.opcode("append");
          },
          Decorator: function (e) {
            this.DecoratorBlock(e);
          },
          ContentStatement: function (e) {
            e.value && this.opcode("appendContent", e.value);
          },
          CommentStatement: function () {},
          SubExpression: function (e) {
            a(e);
            var t = this.classifySexpr(e);
            "simple" === t
              ? this.simpleSexpr(e)
              : "helper" === t
              ? this.helperSexpr(e)
              : this.ambiguousSexpr(e);
          },
          ambiguousSexpr: function (e, t, n) {
            var i = e.path,
              o = i.parts[0],
              r = null != t || null != n;
            this.opcode("getContext", i.depth),
              this.opcode("pushProgram", t),
              this.opcode("pushProgram", n),
              (i.strict = !0),
              this.accept(i),
              this.opcode("invokeAmbiguous", o, r);
          },
          simpleSexpr: function (e) {
            var t = e.path;
            (t.strict = !0),
              this.accept(t),
              this.opcode("resolvePossibleLambda");
          },
          helperSexpr: function (e, t, n) {
            var i = this.setupFullMustacheParams(e, t, n),
              o = e.path,
              r = o.parts[0];
            if (this.options.knownHelpers[r])
              this.opcode("invokeKnownHelper", i.length, r);
            else {
              if (this.options.knownHelpersOnly)
                throw new p.default(
                  "You specified knownHelpersOnly, but used the unknown helper " +
                    r,
                  e
                );
              (o.strict = !0),
                (o.falsy = !0),
                this.accept(o),
                this.opcode(
                  "invokeHelper",
                  i.length,
                  o.original,
                  h.default.helpers.simpleId(o)
                );
            }
          },
          PathExpression: function (e) {
            this.addDepth(e.depth), this.opcode("getContext", e.depth);
            var t = e.parts[0],
              n = h.default.helpers.scopedId(e),
              i = !e.depth && !n && this.blockParamIndex(t);
            i
              ? this.opcode("lookupBlockParam", i, e.parts)
              : t
              ? e.data
                ? ((this.options.data = !0),
                  this.opcode("lookupData", e.depth, e.parts, e.strict))
                : this.opcode("lookupOnContext", e.parts, e.falsy, e.strict, n)
              : this.opcode("pushContext");
          },
          StringLiteral: function (e) {
            this.opcode("pushString", e.value);
          },
          NumberLiteral: function (e) {
            this.opcode("pushLiteral", e.value);
          },
          BooleanLiteral: function (e) {
            this.opcode("pushLiteral", e.value);
          },
          UndefinedLiteral: function () {
            this.opcode("pushLiteral", "undefined");
          },
          NullLiteral: function () {
            this.opcode("pushLiteral", "null");
          },
          Hash: function (e) {
            var t = e.pairs,
              n = 0,
              i = t.length;
            for (this.opcode("pushHash"); n < i; n++)
              this.pushParam(t[n].value);
            for (; n--; ) this.opcode("assignToHash", t[n].key);
            this.opcode("popHash");
          },
          opcode: function (e) {
            this.opcodes.push({
              opcode: e,
              args: m.call(arguments, 1),
              loc: this.sourceNode[0].loc,
            });
          },
          addDepth: function (e) {
            e && (this.useDepths = !0);
          },
          classifySexpr: function (e) {
            var t = h.default.helpers.simpleId(e.path),
              n = t && !!this.blockParamIndex(e.path.parts[0]),
              i = !n && h.default.helpers.helperExpression(e),
              o = !n && (i || t);
            if (o && !i) {
              var r = e.path.parts[0],
                s = this.options;
              s.knownHelpers[r] ? (i = !0) : s.knownHelpersOnly && (o = !1);
            }
            return i ? "helper" : o ? "ambiguous" : "simple";
          },
          pushParams: function (e) {
            for (var t = 0, n = e.length; t < n; t++) this.pushParam(e[t]);
          },
          pushParam: function (e) {
            var t = null != e.value ? e.value : e.original || "";
            if (this.stringParams)
              t.replace &&
                (t = t.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
                e.depth && this.addDepth(e.depth),
                this.opcode("getContext", e.depth || 0),
                this.opcode("pushStringParam", t, e.type),
                "SubExpression" === e.type && this.accept(e);
            else {
              if (this.trackIds) {
                var n = void 0;
                if (
                  (!e.parts ||
                    h.default.helpers.scopedId(e) ||
                    e.depth ||
                    (n = this.blockParamIndex(e.parts[0])),
                  n)
                ) {
                  var i = e.parts.slice(1).join(".");
                  this.opcode("pushId", "BlockParam", n, i);
                } else
                  (t = e.original || t),
                    t.replace &&
                      (t = t
                        .replace(/^this(?:\.|$)/, "")
                        .replace(/^\.\//, "")
                        .replace(/^\.$/, "")),
                    this.opcode("pushId", e.type, t);
              }
              this.accept(e);
            }
          },
          setupFullMustacheParams: function (e, t, n, i) {
            var o = e.params;
            return (
              this.pushParams(o),
              this.opcode("pushProgram", t),
              this.opcode("pushProgram", n),
              e.hash ? this.accept(e.hash) : this.opcode("emptyHash", i),
              o
            );
          },
          blockParamIndex: function (e) {
            for (var t = 0, n = this.options.blockParams.length; t < n; t++) {
              var i = this.options.blockParams[t],
                o = i && d.indexOf(i, e);
              if (i && o >= 0) return [t, o];
            }
          },
        };
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          this.value = e;
        }
        function o() {}
        function r(e, t, n, i) {
          var o = t.popStack(),
            r = 0,
            s = n.length;
          for (e && s--; r < s; r++) o = t.nameLookup(o, n[r], i);
          return e
            ? [
                t.aliasable("container.strict"),
                "(",
                o,
                ", ",
                t.quotedString(n[r]),
                ", ",
                JSON.stringify(t.source.currentLocation),
                " )",
              ]
            : o;
        }
        var s = n(13).default,
          a = n(1).default;
        t.__esModule = !0;
        var l = n(4),
          c = n(6),
          u = a(c),
          p = n(5),
          d = n(53),
          f = a(d);
        (o.prototype = {
          nameLookup: function (e, t) {
            return this.internalNameLookup(e, t);
          },
          depthedLookup: function (e) {
            return [this.aliasable("container.lookup"), '(depths, "', e, '")'];
          },
          compilerInfo: function () {
            var e = l.COMPILER_REVISION,
              t = l.REVISION_CHANGES[e];
            return [e, t];
          },
          appendToBuffer: function (e, t, n) {
            return (
              p.isArray(e) || (e = [e]),
              (e = this.source.wrap(e, t)),
              this.environment.isSimple
                ? ["return ", e, ";"]
                : n
                ? ["buffer += ", e, ";"]
                : ((e.appendToBuffer = !0), e)
            );
          },
          initializeBuffer: function () {
            return this.quotedString("");
          },
          internalNameLookup: function (e, t) {
            return (
              (this.lookupPropertyFunctionIsUsed = !0),
              ["lookupProperty(", e, ",", JSON.stringify(t), ")"]
            );
          },
          lookupPropertyFunctionIsUsed: !1,
          compile: function (e, t, n, i) {
            (this.environment = e),
              (this.options = t),
              (this.stringParams = this.options.stringParams),
              (this.trackIds = this.options.trackIds),
              (this.precompile = !i),
              (this.name = this.environment.name),
              (this.isChild = !!n),
              (this.context = n || {
                decorators: [],
                programs: [],
                environments: [],
              }),
              this.preamble(),
              (this.stackSlot = 0),
              (this.stackVars = []),
              (this.aliases = {}),
              (this.registers = { list: [] }),
              (this.hashes = []),
              (this.compileStack = []),
              (this.inlineStack = []),
              (this.blockParams = []),
              this.compileChildren(e, t),
              (this.useDepths =
                this.useDepths ||
                e.useDepths ||
                e.useDecorators ||
                this.options.compat),
              (this.useBlockParams = this.useBlockParams || e.useBlockParams);
            var o = e.opcodes,
              r = void 0,
              s = void 0,
              a = void 0,
              l = void 0;
            for (a = 0, l = o.length; a < l; a++)
              (r = o[a]),
                (this.source.currentLocation = r.loc),
                (s = s || r.loc),
                this[r.opcode].apply(this, r.args);
            if (
              ((this.source.currentLocation = s),
              this.pushSource(""),
              this.stackSlot ||
                this.inlineStack.length ||
                this.compileStack.length)
            )
              throw new u.default(
                "Compile completed with content left on stack"
              );
            this.decorators.isEmpty()
              ? (this.decorators = void 0)
              : ((this.useDecorators = !0),
                this.decorators.prepend([
                  "var decorators = container.decorators, ",
                  this.lookupPropertyFunctionVarDeclaration(),
                  ";\n",
                ]),
                this.decorators.push("return fn;"),
                i
                  ? (this.decorators = Function.apply(this, [
                      "fn",
                      "props",
                      "container",
                      "depth0",
                      "data",
                      "blockParams",
                      "depths",
                      this.decorators.merge(),
                    ]))
                  : (this.decorators.prepend(
                      "function(fn, props, container, depth0, data, blockParams, depths) {\n"
                    ),
                    this.decorators.push("}\n"),
                    (this.decorators = this.decorators.merge())));
            var c = this.createFunctionContext(i);
            if (this.isChild) return c;
            var p = { compiler: this.compilerInfo(), main: c };
            this.decorators &&
              ((p.main_d = this.decorators), (p.useDecorators = !0));
            var d = this.context,
              f = d.programs,
              h = d.decorators;
            for (a = 0, l = f.length; a < l; a++)
              f[a] &&
                ((p[a] = f[a]),
                h[a] && ((p[a + "_d"] = h[a]), (p.useDecorators = !0)));
            return (
              this.environment.usePartial && (p.usePartial = !0),
              this.options.data && (p.useData = !0),
              this.useDepths && (p.useDepths = !0),
              this.useBlockParams && (p.useBlockParams = !0),
              this.options.compat && (p.compat = !0),
              i
                ? (p.compilerOptions = this.options)
                : ((p.compiler = JSON.stringify(p.compiler)),
                  (this.source.currentLocation = {
                    start: { line: 1, column: 0 },
                  }),
                  (p = this.objectLiteral(p)),
                  t.srcName
                    ? ((p = p.toStringWithSourceMap({ file: t.destName })),
                      (p.map = p.map && p.map.toString()))
                    : (p = p.toString())),
              p
            );
          },
          preamble: function () {
            (this.lastContext = 0),
              (this.source = new f.default(this.options.srcName)),
              (this.decorators = new f.default(this.options.srcName));
          },
          createFunctionContext: function (e) {
            var t = this,
              n = "",
              i = this.stackVars.concat(this.registers.list);
            i.length > 0 && (n += ", " + i.join(", "));
            var o = 0;
            s(this.aliases).forEach(function (e) {
              var i = t.aliases[e];
              i.children &&
                i.referenceCount > 1 &&
                ((n += ", alias" + ++o + "=" + e),
                (i.children[0] = "alias" + o));
            }),
              this.lookupPropertyFunctionIsUsed &&
                (n += ", " + this.lookupPropertyFunctionVarDeclaration());
            var r = ["container", "depth0", "helpers", "partials", "data"];
            (this.useBlockParams || this.useDepths) && r.push("blockParams"),
              this.useDepths && r.push("depths");
            var a = this.mergeSource(n);
            return e
              ? (r.push(a), Function.apply(this, r))
              : this.source.wrap(["function(", r.join(","), ") {\n  ", a, "}"]);
          },
          mergeSource: function (e) {
            var t = this.environment.isSimple,
              n = !this.forceBuffer,
              i = void 0,
              o = void 0,
              r = void 0,
              s = void 0;
            return (
              this.source.each(function (e) {
                e.appendToBuffer
                  ? (r ? e.prepend("  + ") : (r = e), (s = e))
                  : (r &&
                      (o ? r.prepend("buffer += ") : (i = !0),
                      s.add(";"),
                      (r = s = void 0)),
                    (o = !0),
                    t || (n = !1));
              }),
              n
                ? r
                  ? (r.prepend("return "), s.add(";"))
                  : o || this.source.push('return "";')
                : ((e += ", buffer = " + (i ? "" : this.initializeBuffer())),
                  r
                    ? (r.prepend("return buffer + "), s.add(";"))
                    : this.source.push("return buffer;")),
              e &&
                this.source.prepend("var " + e.substring(2) + (i ? "" : ";\n")),
              this.source.merge()
            );
          },
          lookupPropertyFunctionVarDeclaration: function () {
            return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
          },
          blockValue: function (e) {
            var t = this.aliasable("container.hooks.blockHelperMissing"),
              n = [this.contextName(0)];
            this.setupHelperArgs(e, 0, n);
            var i = this.popStack();
            n.splice(1, 0, i),
              this.push(this.source.functionCall(t, "call", n));
          },
          ambiguousBlockValue: function () {
            var e = this.aliasable("container.hooks.blockHelperMissing"),
              t = [this.contextName(0)];
            this.setupHelperArgs("", 0, t, !0), this.flushInline();
            var n = this.topStack();
            t.splice(1, 0, n),
              this.pushSource([
                "if (!",
                this.lastHelper,
                ") { ",
                n,
                " = ",
                this.source.functionCall(e, "call", t),
                "}",
              ]);
          },
          appendContent: function (e) {
            this.pendingContent
              ? (e = this.pendingContent + e)
              : (this.pendingLocation = this.source.currentLocation),
              (this.pendingContent = e);
          },
          append: function () {
            if (this.isInline())
              this.replaceStack(function (e) {
                return [" != null ? ", e, ' : ""'];
              }),
                this.pushSource(this.appendToBuffer(this.popStack()));
            else {
              var e = this.popStack();
              this.pushSource([
                "if (",
                e,
                " != null) { ",
                this.appendToBuffer(e, void 0, !0),
                " }",
              ]),
                this.environment.isSimple &&
                  this.pushSource([
                    "else { ",
                    this.appendToBuffer("''", void 0, !0),
                    " }",
                  ]);
            }
          },
          appendEscaped: function () {
            this.pushSource(
              this.appendToBuffer([
                this.aliasable("container.escapeExpression"),
                "(",
                this.popStack(),
                ")",
              ])
            );
          },
          getContext: function (e) {
            this.lastContext = e;
          },
          pushContext: function () {
            this.pushStackLiteral(this.contextName(this.lastContext));
          },
          lookupOnContext: function (e, t, n, i) {
            var o = 0;
            i || !this.options.compat || this.lastContext
              ? this.pushContext()
              : this.push(this.depthedLookup(e[o++])),
              this.resolvePath("context", e, o, t, n);
          },
          lookupBlockParam: function (e, t) {
            (this.useBlockParams = !0),
              this.push(["blockParams[", e[0], "][", e[1], "]"]),
              this.resolvePath("context", t, 1);
          },
          lookupData: function (e, t, n) {
            e
              ? this.pushStackLiteral("container.data(data, " + e + ")")
              : this.pushStackLiteral("data"),
              this.resolvePath("data", t, 0, !0, n);
          },
          resolvePath: function (e, t, n, i, o) {
            var s = this;
            if (this.options.strict || this.options.assumeObjects)
              return void this.push(r(this.options.strict && o, this, t, e));
            for (var a = t.length; n < a; n++)
              this.replaceStack(function (o) {
                var r = s.nameLookup(o, t[n], e);
                return i ? [" && ", r] : [" != null ? ", r, " : ", o];
              });
          },
          resolvePossibleLambda: function () {
            this.push([
              this.aliasable("container.lambda"),
              "(",
              this.popStack(),
              ", ",
              this.contextName(0),
              ")",
            ]);
          },
          pushStringParam: function (e, t) {
            this.pushContext(),
              this.pushString(t),
              "SubExpression" !== t &&
                ("string" == typeof e
                  ? this.pushString(e)
                  : this.pushStackLiteral(e));
          },
          emptyHash: function (e) {
            this.trackIds && this.push("{}"),
              this.stringParams && (this.push("{}"), this.push("{}")),
              this.pushStackLiteral(e ? "undefined" : "{}");
          },
          pushHash: function () {
            this.hash && this.hashes.push(this.hash),
              (this.hash = { values: {}, types: [], contexts: [], ids: [] });
          },
          popHash: function () {
            var e = this.hash;
            (this.hash = this.hashes.pop()),
              this.trackIds && this.push(this.objectLiteral(e.ids)),
              this.stringParams &&
                (this.push(this.objectLiteral(e.contexts)),
                this.push(this.objectLiteral(e.types))),
              this.push(this.objectLiteral(e.values));
          },
          pushString: function (e) {
            this.pushStackLiteral(this.quotedString(e));
          },
          pushLiteral: function (e) {
            this.pushStackLiteral(e);
          },
          pushProgram: function (e) {
            null != e
              ? this.pushStackLiteral(this.programExpression(e))
              : this.pushStackLiteral(null);
          },
          registerDecorator: function (e, t) {
            var n = this.nameLookup("decorators", t, "decorator"),
              i = this.setupHelperArgs(t, e);
            this.decorators.push([
              "fn = ",
              this.decorators.functionCall(n, "", [
                "fn",
                "props",
                "container",
                i,
              ]),
              " || fn;",
            ]);
          },
          invokeHelper: function (e, t, n) {
            var i = this.popStack(),
              o = this.setupHelper(e, t),
              r = [];
            n && r.push(o.name),
              r.push(i),
              this.options.strict ||
                r.push(this.aliasable("container.hooks.helperMissing"));
            var s = ["(", this.itemsSeparatedBy(r, "||"), ")"],
              a = this.source.functionCall(s, "call", o.callParams);
            this.push(a);
          },
          itemsSeparatedBy: function (e, t) {
            var n = [];
            n.push(e[0]);
            for (var i = 1; i < e.length; i++) n.push(t, e[i]);
            return n;
          },
          invokeKnownHelper: function (e, t) {
            var n = this.setupHelper(e, t);
            this.push(this.source.functionCall(n.name, "call", n.callParams));
          },
          invokeAmbiguous: function (e, t) {
            this.useRegister("helper");
            var n = this.popStack();
            this.emptyHash();
            var i = this.setupHelper(0, e, t),
              o = (this.lastHelper = this.nameLookup("helpers", e, "helper")),
              r = ["(", "(helper = ", o, " || ", n, ")"];
            this.options.strict ||
              ((r[0] = "(helper = "),
              r.push(
                " != null ? helper : ",
                this.aliasable("container.hooks.helperMissing")
              )),
              this.push([
                "(",
                r,
                i.paramsInit ? ["),(", i.paramsInit] : [],
                "),",
                "(typeof helper === ",
                this.aliasable('"function"'),
                " ? ",
                this.source.functionCall("helper", "call", i.callParams),
                " : helper))",
              ]);
          },
          invokePartial: function (e, t, n) {
            var i = [],
              o = this.setupParams(t, 1, i);
            e && ((t = this.popStack()), delete o.name),
              n && (o.indent = JSON.stringify(n)),
              (o.helpers = "helpers"),
              (o.partials = "partials"),
              (o.decorators = "container.decorators"),
              e
                ? i.unshift(t)
                : i.unshift(this.nameLookup("partials", t, "partial")),
              this.options.compat && (o.depths = "depths"),
              (o = this.objectLiteral(o)),
              i.push(o),
              this.push(
                this.source.functionCall("container.invokePartial", "", i)
              );
          },
          assignToHash: function (e) {
            var t = this.popStack(),
              n = void 0,
              i = void 0,
              o = void 0;
            this.trackIds && (o = this.popStack()),
              this.stringParams &&
                ((i = this.popStack()), (n = this.popStack()));
            var r = this.hash;
            n && (r.contexts[e] = n),
              i && (r.types[e] = i),
              o && (r.ids[e] = o),
              (r.values[e] = t);
          },
          pushId: function (e, t, n) {
            "BlockParam" === e
              ? this.pushStackLiteral(
                  "blockParams[" +
                    t[0] +
                    "].path[" +
                    t[1] +
                    "]" +
                    (n ? " + " + JSON.stringify("." + n) : "")
                )
              : "PathExpression" === e
              ? this.pushString(t)
              : "SubExpression" === e
              ? this.pushStackLiteral("true")
              : this.pushStackLiteral("null");
          },
          compiler: o,
          compileChildren: function (e, t) {
            for (
              var n = e.children, i = void 0, o = void 0, r = 0, s = n.length;
              r < s;
              r++
            ) {
              (i = n[r]), (o = new this.compiler());
              var a = this.matchExistingProgram(i);
              if (null == a) {
                this.context.programs.push("");
                var l = this.context.programs.length;
                (i.index = l),
                  (i.name = "program" + l),
                  (this.context.programs[l] = o.compile(
                    i,
                    t,
                    this.context,
                    !this.precompile
                  )),
                  (this.context.decorators[l] = o.decorators),
                  (this.context.environments[l] = i),
                  (this.useDepths = this.useDepths || o.useDepths),
                  (this.useBlockParams =
                    this.useBlockParams || o.useBlockParams),
                  (i.useDepths = this.useDepths),
                  (i.useBlockParams = this.useBlockParams);
              } else
                (i.index = a.index),
                  (i.name = "program" + a.index),
                  (this.useDepths = this.useDepths || a.useDepths),
                  (this.useBlockParams =
                    this.useBlockParams || a.useBlockParams);
            }
          },
          matchExistingProgram: function (e) {
            for (var t = 0, n = this.context.environments.length; t < n; t++) {
              var i = this.context.environments[t];
              if (i && i.equals(e)) return i;
            }
          },
          programExpression: function (e) {
            var t = this.environment.children[e],
              n = [t.index, "data", t.blockParams];
            return (
              (this.useBlockParams || this.useDepths) && n.push("blockParams"),
              this.useDepths && n.push("depths"),
              "container.program(" + n.join(", ") + ")"
            );
          },
          useRegister: function (e) {
            this.registers[e] ||
              ((this.registers[e] = !0), this.registers.list.push(e));
          },
          push: function (e) {
            return (
              e instanceof i || (e = this.source.wrap(e)),
              this.inlineStack.push(e),
              e
            );
          },
          pushStackLiteral: function (e) {
            this.push(new i(e));
          },
          pushSource: function (e) {
            this.pendingContent &&
              (this.source.push(
                this.appendToBuffer(
                  this.source.quotedString(this.pendingContent),
                  this.pendingLocation
                )
              ),
              (this.pendingContent = void 0)),
              e && this.source.push(e);
          },
          replaceStack: function (e) {
            var t = ["("],
              n = void 0,
              o = void 0,
              r = void 0;
            if (!this.isInline())
              throw new u.default("replaceStack on non-inline");
            var s = this.popStack(!0);
            if (s instanceof i) (n = [s.value]), (t = ["(", n]), (r = !0);
            else {
              o = !0;
              var a = this.incrStack();
              (t = ["((", this.push(a), " = ", s, ")"]), (n = this.topStack());
            }
            var l = e.call(this, n);
            r || this.popStack(),
              o && this.stackSlot--,
              this.push(t.concat(l, ")"));
          },
          incrStack: function () {
            return (
              this.stackSlot++,
              this.stackSlot > this.stackVars.length &&
                this.stackVars.push("stack" + this.stackSlot),
              this.topStackName()
            );
          },
          topStackName: function () {
            return "stack" + this.stackSlot;
          },
          flushInline: function () {
            var e = this.inlineStack;
            this.inlineStack = [];
            for (var t = 0, n = e.length; t < n; t++) {
              var o = e[t];
              if (o instanceof i) this.compileStack.push(o);
              else {
                var r = this.incrStack();
                this.pushSource([r, " = ", o, ";"]), this.compileStack.push(r);
              }
            }
          },
          isInline: function () {
            return this.inlineStack.length;
          },
          popStack: function (e) {
            var t = this.isInline(),
              n = (t ? this.inlineStack : this.compileStack).pop();
            if (!e && n instanceof i) return n.value;
            if (!t) {
              if (!this.stackSlot) throw new u.default("Invalid stack pop");
              this.stackSlot--;
            }
            return n;
          },
          topStack: function () {
            var e = this.isInline() ? this.inlineStack : this.compileStack,
              t = e[e.length - 1];
            return t instanceof i ? t.value : t;
          },
          contextName: function (e) {
            return this.useDepths && e ? "depths[" + e + "]" : "depth" + e;
          },
          quotedString: function (e) {
            return this.source.quotedString(e);
          },
          objectLiteral: function (e) {
            return this.source.objectLiteral(e);
          },
          aliasable: function (e) {
            var t = this.aliases[e];
            return t
              ? (t.referenceCount++, t)
              : ((t = this.aliases[e] = this.source.wrap(e)),
                (t.aliasable = !0),
                (t.referenceCount = 1),
                t);
          },
          setupHelper: function (e, t, n) {
            var i = [],
              o = this.setupHelperArgs(t, e, i, n),
              r = this.nameLookup("helpers", t, "helper"),
              s = this.aliasable(
                this.contextName(0) +
                  " != null ? " +
                  this.contextName(0) +
                  " : (container.nullContext || {})"
              );
            return {
              params: i,
              paramsInit: o,
              name: r,
              callParams: [s].concat(i),
            };
          },
          setupParams: function (e, t, n) {
            var i = {},
              o = [],
              r = [],
              s = [],
              a = !n,
              l = void 0;
            a && (n = []),
              (i.name = this.quotedString(e)),
              (i.hash = this.popStack()),
              this.trackIds && (i.hashIds = this.popStack()),
              this.stringParams &&
                ((i.hashTypes = this.popStack()),
                (i.hashContexts = this.popStack()));
            var c = this.popStack(),
              u = this.popStack();
            (u || c) &&
              ((i.fn = u || "container.noop"),
              (i.inverse = c || "container.noop"));
            for (var p = t; p--; )
              (l = this.popStack()),
                (n[p] = l),
                this.trackIds && (s[p] = this.popStack()),
                this.stringParams &&
                  ((r[p] = this.popStack()), (o[p] = this.popStack()));
            return (
              a && (i.args = this.source.generateArray(n)),
              this.trackIds && (i.ids = this.source.generateArray(s)),
              this.stringParams &&
                ((i.types = this.source.generateArray(r)),
                (i.contexts = this.source.generateArray(o))),
              this.options.data && (i.data = "data"),
              this.useBlockParams && (i.blockParams = "blockParams"),
              i
            );
          },
          setupHelperArgs: function (e, t, n, i) {
            var o = this.setupParams(e, t, n);
            return (
              (o.loc = JSON.stringify(this.source.currentLocation)),
              (o = this.objectLiteral(o)),
              i
                ? (this.useRegister("options"),
                  n.push("options"),
                  ["options=", o])
                : n
                ? (n.push(o), "")
                : o
            );
          },
        }),
          (function () {
            for (
              var e =
                  "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                    " "
                  ),
                t = (o.RESERVED_WORDS = {}),
                n = 0,
                i = e.length;
              n < i;
              n++
            )
              t[e[n]] = !0;
          })(),
          (o.isValidJavaScriptVariableName = function (e) {
            return !o.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
          }),
          (t.default = o),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t, n) {
          if (s.isArray(e)) {
            for (var i = [], o = 0, r = e.length; o < r; o++)
              i.push(t.wrap(e[o], n));
            return i;
          }
          return "boolean" == typeof e || "number" == typeof e ? e + "" : e;
        }
        function o(e) {
          (this.srcFile = e), (this.source = []);
        }
        var r = n(13).default;
        t.__esModule = !0;
        var s = n(5),
          a = void 0;
        try {
        } catch (e) {}
        a ||
          ((a = function (e, t, n, i) {
            (this.src = ""), i && this.add(i);
          }),
          (a.prototype = {
            add: function (e) {
              s.isArray(e) && (e = e.join("")), (this.src += e);
            },
            prepend: function (e) {
              s.isArray(e) && (e = e.join("")), (this.src = e + this.src);
            },
            toStringWithSourceMap: function () {
              return { code: this.toString() };
            },
            toString: function () {
              return this.src;
            },
          })),
          (o.prototype = {
            isEmpty: function () {
              return !this.source.length;
            },
            prepend: function (e, t) {
              this.source.unshift(this.wrap(e, t));
            },
            push: function (e, t) {
              this.source.push(this.wrap(e, t));
            },
            merge: function () {
              var e = this.empty();
              return (
                this.each(function (t) {
                  e.add(["  ", t, "\n"]);
                }),
                e
              );
            },
            each: function (e) {
              for (var t = 0, n = this.source.length; t < n; t++)
                e(this.source[t]);
            },
            empty: function () {
              var e = this.currentLocation || { start: {} };
              return new a(e.start.line, e.start.column, this.srcFile);
            },
            wrap: function (e) {
              var t =
                arguments.length <= 1 || void 0 === arguments[1]
                  ? this.currentLocation || { start: {} }
                  : arguments[1];
              return e instanceof a
                ? e
                : ((e = i(e, this, t)),
                  new a(t.start.line, t.start.column, this.srcFile, e));
            },
            functionCall: function (e, t, n) {
              return (
                (n = this.generateList(n)),
                this.wrap([e, t ? "." + t + "(" : "(", n, ")"])
              );
            },
            quotedString: function (e) {
              return (
                '"' +
                (e + "")
                  .replace(/\\/g, "\\\\")
                  .replace(/"/g, '\\"')
                  .replace(/\n/g, "\\n")
                  .replace(/\r/g, "\\r")
                  .replace(/\u2028/g, "\\u2028")
                  .replace(/\u2029/g, "\\u2029") +
                '"'
              );
            },
            objectLiteral: function (e) {
              var t = this,
                n = [];
              r(e).forEach(function (o) {
                var r = i(e[o], t);
                "undefined" !== r && n.push([t.quotedString(o), ":", r]);
              });
              var o = this.generateList(n);
              return o.prepend("{"), o.add("}"), o;
            },
            generateList: function (e) {
              for (var t = this.empty(), n = 0, o = e.length; n < o; n++)
                n && t.add(","), t.add(i(e[n], this));
              return t;
            },
            generateArray: function (e) {
              var t = this.generateList(e);
              return t.prepend("["), t.add("]"), t;
            },
          }),
          (t.default = o),
          (e.exports = t.default);
      },
    ]);
  }),
  !(function (e) {
    e.fn.prepareTransition = function () {
      return this.each(function () {
        var t = e(this);
        t.one(
          "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
          function () {
            t.removeClass("is-transitioning");
          }
        );
        var n = [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ],
          i = 0;
        e.each(n, function (e, n) {
          i = parseFloat(t.css(n)) || i;
        }),
          0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
      });
    };
  })(jQuery)
  /*
   * jQuery throttle / debounce - v1.1 - 3/7/2010
   * http://benalman.com/projects/jquery-throttle-debounce-plugin/
   *
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */,
  (function (e, t) {
    var n,
      i = e.jQuery || e.Cowboy || (e.Cowboy = {});
    (i.throttle = n =
      function (e, n, o, r) {
        function s() {
          function i() {
            (l = +new Date()), o.apply(c, p);
          }
          function s() {
            a = t;
          }
          var c = this,
            u = +new Date() - l,
            p = arguments;
          r && !a && i(),
            a && clearTimeout(a),
            r === t && u > e
              ? i()
              : n !== !0 && (a = setTimeout(r ? s : i, r === t ? e - u : e));
        }
        var a,
          l = 0;
        return (
          "boolean" != typeof n && ((r = o), (o = n), (n = t)),
          i.guid && (s.guid = o.guid = o.guid || i.guid++),
          s
        );
      }),
      (i.debounce = function (e, i, o) {
        return o === t ? n(e, i, !1) : n(e, o, i !== !1);
      });
  })(this),
  !(function (e, t) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define([], t)
      : "object" == typeof exports
      ? (exports.AOS = t())
      : (e.AOS = t());
  })(this, function () {
    return (function (e) {
      function t(i) {
        if (n[i]) return n[i].exports;
        var o = (n[i] = { exports: {}, id: i, loaded: !1 });
        return (
          e[i].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports
        );
      }
      var n = {};
      return (t.m = e), (t.c = n), (t.p = "dist/"), t(0);
    })([
      function (e, t, n) {
        "use strict";
        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }
        var o =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var i in n)
                  Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
              }
              return e;
            },
          r = n(1),
          s = (i(r), n(6)),
          a = i(s),
          l = n(7),
          c = i(l),
          u = n(8),
          p = i(u),
          d = n(9),
          f = i(d),
          h = n(10),
          m = i(h),
          v = n(11),
          g = i(v),
          y = n(14),
          b = i(y),
          w = [],
          x = !1,
          k = document.all && !window.atob,
          S = {
            offset: 120,
            delay: 0,
            easing: "ease",
            duration: 400,
            disable: !1,
            once: !1,
            startEvent: "DOMContentLoaded",
            disableMutationObserver: !1,
          },
          C = function () {
            var e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            if ((e && (x = !0), x))
              return (w = (0, g.default)(w, S)), (0, m.default)(w, S.once), w;
          },
          T = function () {
            (w = (0, b.default)()), C();
          },
          E = function () {
            w.forEach(function (e, t) {
              e.node.removeAttribute("data-aos"),
                e.node.removeAttribute("data-aos-easing"),
                e.node.removeAttribute("data-aos-duration"),
                e.node.removeAttribute("data-aos-delay");
            });
          },
          A = function (e) {
            return (
              e === !0 ||
              ("mobile" === e && f.default.mobile()) ||
              ("phone" === e && f.default.phone()) ||
              ("tablet" === e && f.default.tablet()) ||
              ("function" == typeof e && e() === !0)
            );
          },
          P = function (e) {
            return (
              (S = o(S, e)),
              (w = (0, b.default)()),
              A(S.disable) || k
                ? E()
                : (document
                    .querySelector("body")
                    .setAttribute("data-aos-easing", S.easing),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-duration", S.duration),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-delay", S.delay),
                  "DOMContentLoaded" === S.startEvent &&
                  ["complete", "interactive"].indexOf(document.readyState) > -1
                    ? C(!0)
                    : "load" === S.startEvent
                    ? window.addEventListener(S.startEvent, function () {
                        C(!0);
                      })
                    : document.addEventListener(S.startEvent, function () {
                        C(!0);
                      }),
                  window.addEventListener("resize", (0, c.default)(C, 50, !0)),
                  window.addEventListener(
                    "orientationchange",
                    (0, c.default)(C, 50, !0)
                  ),
                  window.addEventListener(
                    "scroll",
                    (0, a.default)(function () {
                      (0, m.default)(w, S.once);
                    }, 99)
                  ),
                  S.disableMutationObserver || (0, p.default)("[data-aos]", T),
                  w)
            );
          };
        e.exports = { init: P, refresh: C, refreshHard: T };
      },
      function (e, t) {},
      ,
      ,
      ,
      ,
      function (e, t) {
        (function (t) {
          "use strict";
          function n(e, t, n) {
            function i(t) {
              var n = m,
                i = v;
              return (m = v = void 0), (x = t), (y = e.apply(i, n));
            }
            function r(e) {
              return (x = e), (b = setTimeout(u, t)), T ? i(e) : y;
            }
            function s(e) {
              var n = e - w,
                i = e - x,
                o = t - n;
              return E ? S(o, g - i) : o;
            }
            function l(e) {
              var n = e - w,
                i = e - x;
              return void 0 === w || n >= t || n < 0 || (E && i >= g);
            }
            function u() {
              var e = C();
              return l(e) ? p(e) : void (b = setTimeout(u, s(e)));
            }
            function p(e) {
              return (b = void 0), A && m ? i(e) : ((m = v = void 0), y);
            }
            function d() {
              void 0 !== b && clearTimeout(b),
                (x = 0),
                (m = w = v = b = void 0);
            }
            function f() {
              return void 0 === b ? y : p(C());
            }
            function h() {
              var e = C(),
                n = l(e);
              if (((m = arguments), (v = this), (w = e), n)) {
                if (void 0 === b) return r(w);
                if (E) return (b = setTimeout(u, t)), i(w);
              }
              return void 0 === b && (b = setTimeout(u, t)), y;
            }
            var m,
              v,
              g,
              y,
              b,
              w,
              x = 0,
              T = !1,
              E = !1,
              A = !0;
            if ("function" != typeof e) throw new TypeError(c);
            return (
              (t = a(t) || 0),
              o(n) &&
                ((T = !!n.leading),
                (E = "maxWait" in n),
                (g = E ? k(a(n.maxWait) || 0, t) : g),
                (A = "trailing" in n ? !!n.trailing : A)),
              (h.cancel = d),
              (h.flush = f),
              h
            );
          }
          function i(e, t, i) {
            var r = !0,
              s = !0;
            if ("function" != typeof e) throw new TypeError(c);
            return (
              o(i) &&
                ((r = "leading" in i ? !!i.leading : r),
                (s = "trailing" in i ? !!i.trailing : s)),
              n(e, t, { leading: r, maxWait: t, trailing: s })
            );
          }
          function o(e) {
            var t = "undefined" == typeof e ? "undefined" : l(e);
            return !!e && ("object" == t || "function" == t);
          }
          function r(e) {
            return (
              !!e && "object" == ("undefined" == typeof e ? "undefined" : l(e))
            );
          }
          function s(e) {
            return (
              "symbol" == ("undefined" == typeof e ? "undefined" : l(e)) ||
              (r(e) && x.call(e) == p)
            );
          }
          function a(e) {
            if ("number" == typeof e) return e;
            if (s(e)) return u;
            if (o(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = o(t) ? t + "" : t;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(d, "");
            var n = h.test(e);
            return n || m.test(e)
              ? v(e.slice(2), n ? 2 : 8)
              : f.test(e)
              ? u
              : +e;
          }
          var l =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  },
            c = "Expected a function",
            u = NaN,
            p = "[object Symbol]",
            d = /^\s+|\s+$/g,
            f = /^[-+]0x[0-9a-f]+$/i,
            h = /^0b[01]+$/i,
            m = /^0o[0-7]+$/i,
            v = parseInt,
            g =
              "object" == ("undefined" == typeof t ? "undefined" : l(t)) &&
              t &&
              t.Object === Object &&
              t,
            y =
              "object" ==
                ("undefined" == typeof self ? "undefined" : l(self)) &&
              self &&
              self.Object === Object &&
              self,
            b = g || y || Function("return this")(),
            w = Object.prototype,
            x = w.toString,
            k = Math.max,
            S = Math.min,
            C = function () {
              return b.Date.now();
            };
          e.exports = i;
        }).call(
          t,
          (function () {
            return this;
          })()
        );
      },
      function (e, t) {
        (function (t) {
          "use strict";
          function n(e, t, n) {
            function o(t) {
              var n = m,
                i = v;
              return (m = v = void 0), (C = t), (y = e.apply(i, n));
            }
            function r(e) {
              return (C = e), (b = setTimeout(u, t)), T ? o(e) : y;
            }
            function a(e) {
              var n = e - w,
                i = e - C,
                o = t - n;
              return E ? k(o, g - i) : o;
            }
            function c(e) {
              var n = e - w,
                i = e - C;
              return void 0 === w || n >= t || n < 0 || (E && i >= g);
            }
            function u() {
              var e = S();
              return c(e) ? p(e) : void (b = setTimeout(u, a(e)));
            }
            function p(e) {
              return (b = void 0), A && m ? o(e) : ((m = v = void 0), y);
            }
            function d() {
              void 0 !== b && clearTimeout(b),
                (C = 0),
                (m = w = v = b = void 0);
            }
            function f() {
              return void 0 === b ? y : p(S());
            }
            function h() {
              var e = S(),
                n = c(e);
              if (((m = arguments), (v = this), (w = e), n)) {
                if (void 0 === b) return r(w);
                if (E) return (b = setTimeout(u, t)), o(w);
              }
              return void 0 === b && (b = setTimeout(u, t)), y;
            }
            var m,
              v,
              g,
              y,
              b,
              w,
              C = 0,
              T = !1,
              E = !1,
              A = !0;
            if ("function" != typeof e) throw new TypeError(l);
            return (
              (t = s(t) || 0),
              i(n) &&
                ((T = !!n.leading),
                (E = "maxWait" in n),
                (g = E ? x(s(n.maxWait) || 0, t) : g),
                (A = "trailing" in n ? !!n.trailing : A)),
              (h.cancel = d),
              (h.flush = f),
              h
            );
          }
          function i(e) {
            var t = "undefined" == typeof e ? "undefined" : a(e);
            return !!e && ("object" == t || "function" == t);
          }
          function o(e) {
            return (
              !!e && "object" == ("undefined" == typeof e ? "undefined" : a(e))
            );
          }
          function r(e) {
            return (
              "symbol" == ("undefined" == typeof e ? "undefined" : a(e)) ||
              (o(e) && w.call(e) == u)
            );
          }
          function s(e) {
            if ("number" == typeof e) return e;
            if (r(e)) return c;
            if (i(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = i(t) ? t + "" : t;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(p, "");
            var n = f.test(e);
            return n || h.test(e)
              ? m(e.slice(2), n ? 2 : 8)
              : d.test(e)
              ? c
              : +e;
          }
          var a =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  },
            l = "Expected a function",
            c = NaN,
            u = "[object Symbol]",
            p = /^\s+|\s+$/g,
            d = /^[-+]0x[0-9a-f]+$/i,
            f = /^0b[01]+$/i,
            h = /^0o[0-7]+$/i,
            m = parseInt,
            v =
              "object" == ("undefined" == typeof t ? "undefined" : a(t)) &&
              t &&
              t.Object === Object &&
              t,
            g =
              "object" ==
                ("undefined" == typeof self ? "undefined" : a(self)) &&
              self &&
              self.Object === Object &&
              self,
            y = v || g || Function("return this")(),
            b = Object.prototype,
            w = b.toString,
            x = Math.max,
            k = Math.min,
            S = function () {
              return y.Date.now();
            };
          e.exports = n;
        }).call(
          t,
          (function () {
            return this;
          })()
        );
      },
      function (e, t) {
        "use strict";
        function n(e, t) {
          var n = new r(i);
          (s = t),
            n.observe(o.documentElement, {
              childList: !0,
              subtree: !0,
              removedNodes: !0,
            });
        }
        function i(e) {
          e &&
            e.forEach(function (e) {
              var t = Array.prototype.slice.call(e.addedNodes),
                n = Array.prototype.slice.call(e.removedNodes),
                i = t.concat(n).filter(function (e) {
                  return e.hasAttribute && e.hasAttribute("data-aos");
                }).length;
              i && s();
            });
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var o = window.document,
          r = window.MutationObserver || window.WebKitMutationObserver,
          s = function () {};
        t.default = n;
      },
      function (e, t) {
        "use strict";
        function n(e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        }
        function i() {
          return navigator.userAgent || navigator.vendor || window.opera || "";
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var o = (function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  "value" in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }
            return function (t, n, i) {
              return n && e(t.prototype, n), i && e(t, i), t;
            };
          })(),
          r =
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
          s =
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
          a =
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
          l =
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
          c = (function () {
            function e() {
              n(this, e);
            }
            return (
              o(e, [
                {
                  key: "phone",
                  value: function () {
                    var e = i();
                    return !(!r.test(e) && !s.test(e.substr(0, 4)));
                  },
                },
                {
                  key: "mobile",
                  value: function () {
                    var e = i();
                    return !(!a.test(e) && !l.test(e.substr(0, 4)));
                  },
                },
                {
                  key: "tablet",
                  value: function () {
                    return this.mobile() && !this.phone();
                  },
                },
              ]),
              e
            );
          })();
        t.default = new c();
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n = function (e, t, n) {
            var i = e.node.getAttribute("data-aos-once");
            t > e.position
              ? e.node.classList.add("aos-animate")
              : "undefined" != typeof i &&
                ("false" === i || (!n && "true" !== i)) &&
                e.node.classList.remove("aos-animate");
          },
          i = function (e, t) {
            var i = window.pageYOffset,
              o = window.innerHeight;
            e.forEach(function (e, r) {
              n(e, o + i, t);
            });
          };
        t.default = i;
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var o = n(12),
          r = i(o),
          s = function (e, t) {
            return (
              e.forEach(function (e, n) {
                e.node.classList.add("aos-init"),
                  (e.position = (0, r.default)(e.node, t.offset));
              }),
              e
            );
          };
        t.default = s;
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var o = n(13),
          r = i(o),
          s = function (e, t) {
            var n = 0,
              i = 0,
              o = window.innerHeight,
              s = {
                offset: e.getAttribute("data-aos-offset"),
                anchor: e.getAttribute("data-aos-anchor"),
                anchorPlacement: e.getAttribute("data-aos-anchor-placement"),
              };
            switch (
              (s.offset && !isNaN(s.offset) && (i = parseInt(s.offset)),
              s.anchor &&
                document.querySelectorAll(s.anchor) &&
                (e = document.querySelectorAll(s.anchor)[0]),
              (n = (0, r.default)(e).top),
              s.anchorPlacement)
            ) {
              case "top-bottom":
                break;
              case "center-bottom":
                n += e.offsetHeight / 2;
                break;
              case "bottom-bottom":
                n += e.offsetHeight;
                break;
              case "top-center":
                n += o / 2;
                break;
              case "bottom-center":
                n += o / 2 + e.offsetHeight;
                break;
              case "center-center":
                n += o / 2 + e.offsetHeight / 2;
                break;
              case "top-top":
                n += o;
                break;
              case "bottom-top":
                n += e.offsetHeight + o;
                break;
              case "center-top":
                n += e.offsetHeight / 2 + o;
            }
            return s.anchorPlacement || s.offset || isNaN(t) || (i = t), n + i;
          };
        t.default = s;
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n = function (e) {
          for (
            var t = 0, n = 0;
            e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);

          )
            (t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0)),
              (n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0)),
              (e = e.offsetParent);
          return { top: n, left: t };
        };
        t.default = n;
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n = function (e) {
          e = e || document.querySelectorAll("[data-aos]");
          var t = [];
          return (
            [].forEach.call(e, function (e, n) {
              t.push({ node: e });
            }),
            t
          );
        };
        t.default = n;
      },
    ]);
  }),
  (function (e) {
    var t = !1;
    if (
      ("function" == typeof define && define.amd && (define(e), (t = !0)),
      "object" == typeof exports && ((module.exports = e()), (t = !0)),
      !t)
    ) {
      var n = window.Cookies,
        i = (window.Cookies = e());
      i.noConflict = function () {
        return (window.Cookies = n), i;
      };
    }
  })(function () {
    function e() {
      for (var e = 0, t = {}; e < arguments.length; e++) {
        var n = arguments[e];
        for (var i in n) t[i] = n[i];
      }
      return t;
    }
    function t(n) {
      function i(t, o, r) {
        var s;
        if ("undefined" != typeof document) {
          if (arguments.length > 1) {
            if (
              ((r = e({ path: "/" }, i.defaults, r)),
              "number" == typeof r.expires)
            ) {
              var a = new Date();
              a.setMilliseconds(a.getMilliseconds() + 864e5 * r.expires),
                (r.expires = a);
            }
            r.expires = r.expires ? r.expires.toUTCString() : "";
            try {
              (s = JSON.stringify(o)), /^[\{\[]/.test(s) && (o = s);
            } catch (e) {}
            (o = n.write
              ? n.write(o, t)
              : encodeURIComponent(String(o)).replace(
                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                  decodeURIComponent
                )),
              (t = encodeURIComponent(String(t))),
              (t = t.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
              (t = t.replace(/[\(\)]/g, escape));
            var l = "";
            for (var c in r)
              r[c] && ((l += "; " + c), r[c] !== !0 && (l += "=" + r[c]));
            return (document.cookie = t + "=" + o + l);
          }
          t || (s = {});
          for (
            var u = document.cookie ? document.cookie.split("; ") : [],
              p = /(%[0-9A-Z]{2})+/g,
              d = 0;
            d < u.length;
            d++
          ) {
            var f = u[d].split("="),
              h = f.slice(1).join("=");
            this.json || '"' !== h.charAt(0) || (h = h.slice(1, -1));
            try {
              var m = f[0].replace(p, decodeURIComponent);
              if (
                ((h = n.read
                  ? n.read(h, m)
                  : n(h, m) || h.replace(p, decodeURIComponent)),
                this.json)
              )
                try {
                  h = JSON.parse(h);
                } catch (e) {}
              if (t === m) {
                s = h;
                break;
              }
              t || (s[m] = h);
            } catch (e) {}
          }
          return s;
        }
      }
      return (
        (i.set = i),
        (i.get = function (e) {
          return i.call(i, e);
        }),
        (i.getJSON = function () {
          return i.apply({ json: !0 }, [].slice.call(arguments));
        }),
        (i.defaults = {}),
        (i.remove = function (t, n) {
          i(t, "", e(n, { expires: -1 }));
        }),
        (i.withConverter = t),
        i
      );
    }
    return t(function () {});
  })
  /*! PhotoSwipe - v4.1.3 - 2019-01-08
   * http://photoswipe.com
   * Copyright (c) 2019 Dmitry Semenov; */,
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(t)
      : "object" == typeof exports
      ? (module.exports = t())
      : (e.PhotoSwipe = t());
  })(this, function () {
    "use strict";
    var e = function (e, t, n, i) {
      var o = {
        features: null,
        bind: function (e, t, n, i) {
          var o = (i ? "remove" : "add") + "EventListener";
          t = t.split(" ");
          for (var r = 0; r < t.length; r++) t[r] && e[o](t[r], n, !1);
        },
        isArray: function (e) {
          return e instanceof Array;
        },
        createEl: function (e, t) {
          var n = document.createElement(t || "div");
          return e && (n.className = e), n;
        },
        getScrollY: function () {
          var e = window.pageYOffset;
          return void 0 !== e ? e : document.documentElement.scrollTop;
        },
        unbind: function (e, t, n) {
          o.bind(e, t, n, !0);
        },
        removeClass: function (e, t) {
          var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
          e.className = e.className
            .replace(n, " ")
            .replace(/^\s\s*/, "")
            .replace(/\s\s*$/, "");
        },
        addClass: function (e, t) {
          o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
        },
        hasClass: function (e, t) {
          return (
            e.className &&
            new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
          );
        },
        getChildByClass: function (e, t) {
          for (var n = e.firstChild; n; ) {
            if (o.hasClass(n, t)) return n;
            n = n.nextSibling;
          }
        },
        arraySearch: function (e, t, n) {
          for (var i = e.length; i--; ) if (e[i][n] === t) return i;
          return -1;
        },
        extend: function (e, t, n) {
          for (var i in t)
            if (t.hasOwnProperty(i)) {
              if (n && e.hasOwnProperty(i)) continue;
              e[i] = t[i];
            }
        },
        easing: {
          sine: {
            out: function (e) {
              return Math.sin(e * (Math.PI / 2));
            },
            inOut: function (e) {
              return -(Math.cos(Math.PI * e) - 1) / 2;
            },
          },
          cubic: {
            out: function (e) {
              return --e * e * e + 1;
            },
          },
        },
        detectFeatures: function () {
          if (o.features) return o.features;
          var e = o.createEl(),
            t = e.style,
            n = "",
            i = {};
          if (
            ((i.oldIE = document.all && !document.addEventListener),
            (i.touch = "ontouchstart" in window),
            window.requestAnimationFrame &&
              ((i.raf = window.requestAnimationFrame),
              (i.caf = window.cancelAnimationFrame)),
            (i.pointerEvent =
              !!window.PointerEvent || navigator.msPointerEnabled),
            !i.pointerEvent)
          ) {
            var r = navigator.userAgent;
            if (/iP(hone|od)/.test(navigator.platform)) {
              var s = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
              s &&
                s.length > 0 &&
                ((s = parseInt(s[1], 10)),
                s >= 1 && s < 8 && (i.isOldIOSPhone = !0));
            }
            var a = r.match(/Android\s([0-9\.]*)/),
              l = a ? a[1] : 0;
            (l = parseFloat(l)),
              l >= 1 &&
                (l < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = l)),
              (i.isMobileOpera = /opera mini|opera mobi/i.test(r));
          }
          for (
            var c,
              u,
              p = ["transform", "perspective", "animationName"],
              d = ["", "webkit", "Moz", "ms", "O"],
              f = 0;
            f < 4;
            f++
          ) {
            n = d[f];
            for (var h = 0; h < 3; h++)
              (c = p[h]),
                (u = n + (n ? c.charAt(0).toUpperCase() + c.slice(1) : c)),
                !i[c] && u in t && (i[c] = u);
            n &&
              !i.raf &&
              ((n = n.toLowerCase()),
              (i.raf = window[n + "RequestAnimationFrame"]),
              i.raf &&
                (i.caf =
                  window[n + "CancelAnimationFrame"] ||
                  window[n + "CancelRequestAnimationFrame"]));
          }
          if (!i.raf) {
            var m = 0;
            (i.raf = function (e) {
              var t = new Date().getTime(),
                n = Math.max(0, 16 - (t - m)),
                i = window.setTimeout(function () {
                  e(t + n);
                }, n);
              return (m = t + n), i;
            }),
              (i.caf = function (e) {
                clearTimeout(e);
              });
          }
          return (
            (i.svg =
              !!document.createElementNS &&
              !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
                .createSVGRect),
            (o.features = i),
            i
          );
        },
      };
      o.detectFeatures(),
        o.features.oldIE &&
          (o.bind = function (e, t, n, i) {
            t = t.split(" ");
            for (
              var o,
                r = (i ? "detach" : "attach") + "Event",
                s = function () {
                  n.handleEvent.call(n);
                },
                a = 0;
              a < t.length;
              a++
            )
              if ((o = t[a]))
                if ("object" == typeof n && n.handleEvent) {
                  if (i) {
                    if (!n["oldIE" + o]) return !1;
                  } else n["oldIE" + o] = s;
                  e[r]("on" + o, n["oldIE" + o]);
                } else e[r]("on" + o, n);
          });
      var r = this,
        s = 25,
        a = 3,
        l = {
          allowPanToNext: !0,
          spacing: 0.12,
          bgOpacity: 1,
          mouseUsed: !1,
          loop: !0,
          pinchToClose: !0,
          closeOnScroll: !0,
          closeOnVerticalDrag: !0,
          verticalDragRange: 0.75,
          hideAnimationDuration: 333,
          showAnimationDuration: 333,
          showHideOpacity: !1,
          focus: !0,
          escKey: !0,
          arrowKeys: !0,
          mainScrollEndFriction: 0.35,
          panEndFriction: 0.35,
          isClickableElement: function (e) {
            return "A" === e.tagName;
          },
          getDoubleTapZoom: function (e, t) {
            return e ? 1 : t.initialZoomLevel < 0.7 ? 1 : 1.33;
          },
          maxSpreadZoom: 1.33,
          modal: !0,
          scaleMode: "fit",
        };
      o.extend(l, i);
      var c,
        u,
        p,
        d,
        f,
        h,
        m,
        v,
        g,
        y,
        b,
        w,
        x,
        k,
        S,
        C,
        T,
        E,
        A,
        P,
        _,
        O,
        $,
        I,
        L,
        N,
        D,
        M,
        z,
        j,
        H,
        R,
        F,
        q,
        B,
        W,
        U,
        V,
        Z,
        K,
        X,
        Y,
        G,
        J,
        Q,
        ee,
        te,
        ne,
        ie,
        oe,
        re,
        se,
        ae,
        le,
        ce,
        ue,
        pe,
        de = function () {
          return { x: 0, y: 0 };
        },
        fe = de(),
        he = de(),
        me = de(),
        ve = {},
        ge = 0,
        ye = {},
        be = de(),
        we = 0,
        xe = !0,
        ke = [],
        Se = {},
        Ce = !1,
        Te = function (e, t) {
          o.extend(r, t.publicMethods), ke.push(e);
        },
        Ee = function (e) {
          var t = en();
          return e > t - 1 ? e - t : e < 0 ? t + e : e;
        },
        Ae = {},
        Pe = function (e, t) {
          return Ae[e] || (Ae[e] = []), Ae[e].push(t);
        },
        _e = function (e) {
          var t = Ae[e];
          if (t) {
            var n = Array.prototype.slice.call(arguments);
            n.shift();
            for (var i = 0; i < t.length; i++) t[i].apply(r, n);
          }
        },
        Oe = function () {
          return new Date().getTime();
        },
        $e = function (e) {
          (ce = e), (r.bg.style.opacity = e * l.bgOpacity);
        },
        Ie = function (e, t, n, i, o) {
          (!Ce || (o && o !== r.currItem)) &&
            (i /= o ? o.fitRatio : r.currItem.fitRatio),
            (e[O] = w + t + "px, " + n + "px" + x + " scale(" + i + ")");
        },
        Le = function (e) {
          oe &&
            (e &&
              (y > r.currItem.fitRatio
                ? Ce || (fn(r.currItem, !1, !0), (Ce = !0))
                : Ce && (fn(r.currItem), (Ce = !1))),
            Ie(oe, me.x, me.y, y));
        },
        Ne = function (e) {
          e.container &&
            Ie(
              e.container.style,
              e.initialPosition.x,
              e.initialPosition.y,
              e.initialZoomLevel,
              e
            );
        },
        De = function (e, t) {
          t[O] = w + e + "px, 0px" + x;
        },
        Me = function (e, t) {
          if (!l.loop && t) {
            var n = d + (be.x * ge - e) / be.x,
              i = Math.round(e - bt.x);
            ((n < 0 && i > 0) || (n >= en() - 1 && i < 0)) &&
              (e = bt.x + i * l.mainScrollEndFriction);
          }
          (bt.x = e), De(e, f);
        },
        ze = function (e, t) {
          var n = wt[e] - ye[e];
          return he[e] + fe[e] + n - n * (t / b);
        },
        je = function (e, t) {
          (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
        },
        He = function (e) {
          (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
        },
        Re = null,
        Fe = function () {
          Re &&
            (o.unbind(document, "mousemove", Fe),
            o.addClass(e, "pswp--has_mouse"),
            (l.mouseUsed = !0),
            _e("mouseUsed")),
            (Re = setTimeout(function () {
              Re = null;
            }, 100));
        },
        qe = function () {
          o.bind(document, "keydown", r),
            H.transform && o.bind(r.scrollWrap, "click", r),
            l.mouseUsed || o.bind(document, "mousemove", Fe),
            o.bind(window, "resize scroll orientationchange", r),
            _e("bindEvents");
        },
        Be = function () {
          o.unbind(window, "resize scroll orientationchange", r),
            o.unbind(window, "scroll", g.scroll),
            o.unbind(document, "keydown", r),
            o.unbind(document, "mousemove", Fe),
            H.transform && o.unbind(r.scrollWrap, "click", r),
            Z && o.unbind(window, m, r),
            clearTimeout(R),
            _e("unbindEvents");
        },
        We = function (e, t) {
          var n = cn(r.currItem, ve, e);
          return t && (ie = n), n;
        },
        Ue = function (e) {
          return e || (e = r.currItem), e.initialZoomLevel;
        },
        Ve = function (e) {
          return e || (e = r.currItem), e.w > 0 ? l.maxSpreadZoom : 1;
        },
        Ze = function (e, t, n, i) {
          return i === r.currItem.initialZoomLevel
            ? ((n[e] = r.currItem.initialPosition[e]), !0)
            : ((n[e] = ze(e, i)),
              n[e] > t.min[e]
                ? ((n[e] = t.min[e]), !0)
                : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
        },
        Ke = function () {
          if (O) {
            var t = H.perspective && !I;
            return (
              (w = "translate" + (t ? "3d(" : "(")),
              void (x = H.perspective ? ", 0px)" : ")")
            );
          }
          (O = "left"),
            o.addClass(e, "pswp--ie"),
            (De = function (e, t) {
              t.left = e + "px";
            }),
            (Ne = function (e) {
              var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                n = e.container.style,
                i = t * e.w,
                o = t * e.h;
              (n.width = i + "px"),
                (n.height = o + "px"),
                (n.left = e.initialPosition.x + "px"),
                (n.top = e.initialPosition.y + "px");
            }),
            (Le = function () {
              if (oe) {
                var e = oe,
                  t = r.currItem,
                  n = t.fitRatio > 1 ? 1 : t.fitRatio,
                  i = n * t.w,
                  o = n * t.h;
                (e.width = i + "px"),
                  (e.height = o + "px"),
                  (e.left = me.x + "px"),
                  (e.top = me.y + "px");
              }
            });
        },
        Xe = function (e) {
          var t = "";
          l.escKey && 27 === e.keyCode
            ? (t = "close")
            : l.arrowKeys &&
              (37 === e.keyCode
                ? (t = "prev")
                : 39 === e.keyCode && (t = "next")),
            t &&
              (e.ctrlKey ||
                e.altKey ||
                e.shiftKey ||
                e.metaKey ||
                (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
                r[t]()));
        },
        Ye = function (e) {
          e && (Y || X || re || U) && (e.preventDefault(), e.stopPropagation());
        },
        Ge = function () {
          r.setScrollOffset(0, o.getScrollY());
        },
        Je = {},
        Qe = 0,
        et = function (e) {
          Je[e] && (Je[e].raf && N(Je[e].raf), Qe--, delete Je[e]);
        },
        tt = function (e) {
          Je[e] && et(e), Je[e] || (Qe++, (Je[e] = {}));
        },
        nt = function () {
          for (var e in Je) Je.hasOwnProperty(e) && et(e);
        },
        it = function (e, t, n, i, o, r, s) {
          var a,
            l = Oe();
          tt(e);
          var c = function () {
            if (Je[e]) {
              if (((a = Oe() - l), a >= i)) return et(e), r(n), void (s && s());
              r((n - t) * o(a / i) + t), (Je[e].raf = L(c));
            }
          };
          c();
        },
        ot = {
          shout: _e,
          listen: Pe,
          viewportSize: ve,
          options: l,
          isMainScrollAnimating: function () {
            return re;
          },
          getZoomLevel: function () {
            return y;
          },
          getCurrentIndex: function () {
            return d;
          },
          isDragging: function () {
            return Z;
          },
          isZooming: function () {
            return ee;
          },
          setScrollOffset: function (e, t) {
            (ye.x = e), (j = ye.y = t), _e("updateScrollOffset", ye);
          },
          applyZoomPan: function (e, t, n, i) {
            (me.x = t), (me.y = n), (y = e), Le(i);
          },
          init: function () {
            if (!c && !u) {
              var n;
              (r.framework = o),
                (r.template = e),
                (r.bg = o.getChildByClass(e, "pswp__bg")),
                (D = e.className),
                (c = !0),
                (H = o.detectFeatures()),
                (L = H.raf),
                (N = H.caf),
                (O = H.transform),
                (z = H.oldIE),
                (r.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap")),
                (r.container = o.getChildByClass(
                  r.scrollWrap,
                  "pswp__container"
                )),
                (f = r.container.style),
                (r.itemHolders = C =
                  [
                    { el: r.container.children[0], wrap: 0, index: -1 },
                    { el: r.container.children[1], wrap: 0, index: -1 },
                    { el: r.container.children[2], wrap: 0, index: -1 },
                  ]),
                (C[0].el.style.display = C[2].el.style.display = "none"),
                Ke(),
                (g = {
                  resize: r.updateSize,
                  orientationchange: function () {
                    clearTimeout(R),
                      (R = setTimeout(function () {
                        ve.x !== r.scrollWrap.clientWidth && r.updateSize();
                      }, 500));
                  },
                  scroll: Ge,
                  keydown: Xe,
                  click: Ye,
                });
              var i = H.isOldIOSPhone || H.isOldAndroid || H.isMobileOpera;
              for (
                (H.animationName && H.transform && !i) ||
                  (l.showAnimationDuration = l.hideAnimationDuration = 0),
                  n = 0;
                n < ke.length;
                n++
              )
                r["init" + ke[n]]();
              if (t) {
                var s = (r.ui = new t(r, o));
                s.init();
              }
              _e("firstUpdate"),
                (d = d || l.index || 0),
                (isNaN(d) || d < 0 || d >= en()) && (d = 0),
                (r.currItem = Qt(d)),
                (H.isOldIOSPhone || H.isOldAndroid) && (xe = !1),
                e.setAttribute("aria-hidden", "false"),
                l.modal &&
                  (xe
                    ? (e.style.position = "fixed")
                    : ((e.style.position = "absolute"),
                      (e.style.top = o.getScrollY() + "px"))),
                void 0 === j && (_e("initialLayout"), (j = M = o.getScrollY()));
              var p = "pswp--open ";
              for (
                l.mainClass && (p += l.mainClass + " "),
                  l.showHideOpacity && (p += "pswp--animate_opacity "),
                  p += I ? "pswp--touch" : "pswp--notouch",
                  p += H.animationName ? " pswp--css_animation" : "",
                  p += H.svg ? " pswp--svg" : "",
                  o.addClass(e, p),
                  r.updateSize(),
                  h = -1,
                  we = null,
                  n = 0;
                n < a;
                n++
              )
                De((n + h) * be.x, C[n].el.style);
              z || o.bind(r.scrollWrap, v, r),
                Pe("initialZoomInEnd", function () {
                  r.setContent(C[0], d - 1),
                    r.setContent(C[2], d + 1),
                    (C[0].el.style.display = C[2].el.style.display = "block"),
                    l.focus && e.focus(),
                    qe();
                }),
                r.setContent(C[1], d),
                r.updateCurrItem(),
                _e("afterInit"),
                xe ||
                  (k = setInterval(function () {
                    Qe ||
                      Z ||
                      ee ||
                      y !== r.currItem.initialZoomLevel ||
                      r.updateSize();
                  }, 1e3)),
                o.addClass(e, "pswp--visible");
            }
          },
          close: function () {
            c &&
              ((c = !1),
              (u = !0),
              _e("close"),
              Be(),
              nn(r.currItem, null, !0, r.destroy));
          },
          destroy: function () {
            _e("destroy"),
              Xt && clearTimeout(Xt),
              e.setAttribute("aria-hidden", "true"),
              (e.className = D),
              k && clearInterval(k),
              o.unbind(r.scrollWrap, v, r),
              o.unbind(window, "scroll", r),
              Tt(),
              nt(),
              (Ae = null);
          },
          panTo: function (e, t, n) {
            n ||
              (e > ie.min.x ? (e = ie.min.x) : e < ie.max.x && (e = ie.max.x),
              t > ie.min.y ? (t = ie.min.y) : t < ie.max.y && (t = ie.max.y)),
              (me.x = e),
              (me.y = t),
              Le();
          },
          handleEvent: function (e) {
            (e = e || window.event), g[e.type] && g[e.type](e);
          },
          goTo: function (e) {
            e = Ee(e);
            var t = e - d;
            (we = t),
              (d = e),
              (r.currItem = Qt(d)),
              (ge -= t),
              Me(be.x * ge),
              nt(),
              (re = !1),
              r.updateCurrItem();
          },
          next: function () {
            r.goTo(d + 1);
          },
          prev: function () {
            r.goTo(d - 1);
          },
          updateCurrZoomItem: function (e) {
            if ((e && _e("beforeChange", 0), C[1].el.children.length)) {
              var t = C[1].el.children[0];
              oe = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
            } else oe = null;
            (ie = r.currItem.bounds),
              (b = y = r.currItem.initialZoomLevel),
              (me.x = ie.center.x),
              (me.y = ie.center.y),
              e && _e("afterChange");
          },
          invalidateCurrItems: function () {
            S = !0;
            for (var e = 0; e < a; e++)
              C[e].item && (C[e].item.needsUpdate = !0);
          },
          updateCurrItem: function (e) {
            if (0 !== we) {
              var t,
                n = Math.abs(we);
              if (!(e && n < 2)) {
                (r.currItem = Qt(d)),
                  (Ce = !1),
                  _e("beforeChange", we),
                  n >= a && ((h += we + (we > 0 ? -a : a)), (n = a));
                for (var i = 0; i < n; i++)
                  we > 0
                    ? ((t = C.shift()),
                      (C[a - 1] = t),
                      h++,
                      De((h + 2) * be.x, t.el.style),
                      r.setContent(t, d - n + i + 1 + 1))
                    : ((t = C.pop()),
                      C.unshift(t),
                      h--,
                      De(h * be.x, t.el.style),
                      r.setContent(t, d + n - i - 1 - 1));
                if (oe && 1 === Math.abs(we)) {
                  var o = Qt(T);
                  o.initialZoomLevel !== y && (cn(o, ve), fn(o), Ne(o));
                }
                (we = 0), r.updateCurrZoomItem(), (T = d), _e("afterChange");
              }
            }
          },
          updateSize: function (t) {
            if (!xe && l.modal) {
              var n = o.getScrollY();
              if (
                (j !== n && ((e.style.top = n + "px"), (j = n)),
                !t && Se.x === window.innerWidth && Se.y === window.innerHeight)
              )
                return;
              (Se.x = window.innerWidth),
                (Se.y = window.innerHeight),
                (e.style.height = Se.y + "px");
            }
            if (
              ((ve.x = r.scrollWrap.clientWidth),
              (ve.y = r.scrollWrap.clientHeight),
              Ge(),
              (be.x = ve.x + Math.round(ve.x * l.spacing)),
              (be.y = ve.y),
              Me(be.x * ge),
              _e("beforeResize"),
              void 0 !== h)
            ) {
              for (var i, s, c, u = 0; u < a; u++)
                (i = C[u]),
                  De((u + h) * be.x, i.el.style),
                  (c = d + u - 1),
                  l.loop && en() > 2 && (c = Ee(c)),
                  (s = Qt(c)),
                  s && (S || s.needsUpdate || !s.bounds)
                    ? (r.cleanSlide(s),
                      r.setContent(i, c),
                      1 === u && ((r.currItem = s), r.updateCurrZoomItem(!0)),
                      (s.needsUpdate = !1))
                    : i.index === -1 && c >= 0 && r.setContent(i, c),
                  s && s.container && (cn(s, ve), fn(s), Ne(s));
              S = !1;
            }
            (b = y = r.currItem.initialZoomLevel),
              (ie = r.currItem.bounds),
              ie && ((me.x = ie.center.x), (me.y = ie.center.y), Le(!0)),
              _e("resize");
          },
          zoomTo: function (e, t, n, i, r) {
            t &&
              ((b = y),
              (wt.x = Math.abs(t.x) - me.x),
              (wt.y = Math.abs(t.y) - me.y),
              je(he, me));
            var s = We(e, !1),
              a = {};
            Ze("x", s, a, e), Ze("y", s, a, e);
            var l = y,
              c = { x: me.x, y: me.y };
            He(a);
            var u = function (t) {
              1 === t
                ? ((y = e), (me.x = a.x), (me.y = a.y))
                : ((y = (e - l) * t + l),
                  (me.x = (a.x - c.x) * t + c.x),
                  (me.y = (a.y - c.y) * t + c.y)),
                r && r(t),
                Le(1 === t);
            };
            n ? it("customZoomTo", 0, 1, n, i || o.easing.sine.inOut, u) : u(1);
          },
        },
        rt = 30,
        st = 10,
        at = {},
        lt = {},
        ct = {},
        ut = {},
        pt = {},
        dt = [],
        ft = {},
        ht = [],
        mt = {},
        vt = 0,
        gt = de(),
        yt = 0,
        bt = de(),
        wt = de(),
        xt = de(),
        kt = function (e, t) {
          return e.x === t.x && e.y === t.y;
        },
        St = function (e, t) {
          return Math.abs(e.x - t.x) < s && Math.abs(e.y - t.y) < s;
        },
        Ct = function (e, t) {
          return (
            (mt.x = Math.abs(e.x - t.x)),
            (mt.y = Math.abs(e.y - t.y)),
            Math.sqrt(mt.x * mt.x + mt.y * mt.y)
          );
        },
        Tt = function () {
          G && (N(G), (G = null));
        },
        Et = function () {
          Z && ((G = L(Et)), qt());
        },
        At = function () {
          return !("fit" === l.scaleMode && y === r.currItem.initialZoomLevel);
        },
        Pt = function (e, t) {
          return (
            !(!e || e === document) &&
            !(
              e.getAttribute("class") &&
              e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1
            ) &&
            (t(e) ? e : Pt(e.parentNode, t))
          );
        },
        _t = {},
        Ot = function (e, t) {
          return (
            (_t.prevent = !Pt(e.target, l.isClickableElement)),
            _e("preventDragEvent", e, t, _t),
            _t.prevent
          );
        },
        $t = function (e, t) {
          return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
        },
        It = function (e, t, n) {
          (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
        },
        Lt = function (e, t, n) {
          if (e - q > 50) {
            var i = ht.length > 2 ? ht.shift() : {};
            (i.x = t), (i.y = n), ht.push(i), (q = e);
          }
        },
        Nt = function () {
          var e = me.y - r.currItem.initialPosition.y;
          return 1 - Math.abs(e / (ve.y / 2));
        },
        Dt = {},
        Mt = {},
        zt = [],
        jt = function (e) {
          for (; zt.length > 0; ) zt.pop();
          return (
            $
              ? ((pe = 0),
                dt.forEach(function (e) {
                  0 === pe ? (zt[0] = e) : 1 === pe && (zt[1] = e), pe++;
                }))
              : e.type.indexOf("touch") > -1
              ? e.touches &&
                e.touches.length > 0 &&
                ((zt[0] = $t(e.touches[0], Dt)),
                e.touches.length > 1 && (zt[1] = $t(e.touches[1], Mt)))
              : ((Dt.x = e.pageX),
                (Dt.y = e.pageY),
                (Dt.id = ""),
                (zt[0] = Dt)),
            zt
          );
        },
        Ht = function (e, t) {
          var n,
            i,
            o,
            s,
            a = 0,
            c = me[e] + t[e],
            u = t[e] > 0,
            p = bt.x + t.x,
            d = bt.x - ft.x;
          return (
            (n = c > ie.min[e] || c < ie.max[e] ? l.panEndFriction : 1),
            (c = me[e] + t[e] * n),
            (!l.allowPanToNext && y !== r.currItem.initialZoomLevel) ||
            (oe
              ? "h" !== se ||
                "x" !== e ||
                X ||
                (u
                  ? (c > ie.min[e] &&
                      ((n = l.panEndFriction),
                      (a = ie.min[e] - c),
                      (i = ie.min[e] - he[e])),
                    (i <= 0 || d < 0) && en() > 1
                      ? ((s = p), d < 0 && p > ft.x && (s = ft.x))
                      : ie.min.x !== ie.max.x && (o = c))
                  : (c < ie.max[e] &&
                      ((n = l.panEndFriction),
                      (a = c - ie.max[e]),
                      (i = he[e] - ie.max[e])),
                    (i <= 0 || d > 0) && en() > 1
                      ? ((s = p), d > 0 && p < ft.x && (s = ft.x))
                      : ie.min.x !== ie.max.x && (o = c)))
              : (s = p),
            "x" !== e)
              ? void (
                  re ||
                  J ||
                  (y > r.currItem.fitRatio && (me[e] += t[e] * n))
                )
              : (void 0 !== s && (Me(s, !0), (J = s !== ft.x)),
                ie.min.x !== ie.max.x &&
                  (void 0 !== o ? (me.x = o) : J || (me.x += t.x * n)),
                void 0 !== s)
          );
        },
        Rt = function (e) {
          if (!("mousedown" === e.type && e.button > 0)) {
            if (Jt) return void e.preventDefault();
            if (!V || "mousedown" !== e.type) {
              if ((Ot(e, !0) && e.preventDefault(), _e("pointerDown"), $)) {
                var t = o.arraySearch(dt, e.pointerId, "id");
                t < 0 && (t = dt.length),
                  (dt[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
              }
              var n = jt(e),
                i = n.length;
              (Q = null),
                nt(),
                (Z && 1 !== i) ||
                  ((Z = ae = !0),
                  o.bind(window, m, r),
                  (W = ue = le = U = J = Y = K = X = !1),
                  (se = null),
                  _e("firstTouchStart", n),
                  je(he, me),
                  (fe.x = fe.y = 0),
                  je(ut, n[0]),
                  je(pt, ut),
                  (ft.x = be.x * ge),
                  (ht = [{ x: ut.x, y: ut.y }]),
                  (q = F = Oe()),
                  We(y, !0),
                  Tt(),
                  Et()),
                !ee &&
                  i > 1 &&
                  !re &&
                  !J &&
                  ((b = y),
                  (X = !1),
                  (ee = K = !0),
                  (fe.y = fe.x = 0),
                  je(he, me),
                  je(at, n[0]),
                  je(lt, n[1]),
                  It(at, lt, xt),
                  (wt.x = Math.abs(xt.x) - me.x),
                  (wt.y = Math.abs(xt.y) - me.y),
                  (te = ne = Ct(at, lt)));
            }
          }
        },
        Ft = function (e) {
          if ((e.preventDefault(), $)) {
            var t = o.arraySearch(dt, e.pointerId, "id");
            if (t > -1) {
              var n = dt[t];
              (n.x = e.pageX), (n.y = e.pageY);
            }
          }
          if (Z) {
            var i = jt(e);
            if (se || Y || ee) Q = i;
            else if (bt.x !== be.x * ge) se = "h";
            else {
              var r = Math.abs(i[0].x - ut.x) - Math.abs(i[0].y - ut.y);
              Math.abs(r) >= st && ((se = r > 0 ? "h" : "v"), (Q = i));
            }
          }
        },
        qt = function () {
          if (Q) {
            var e = Q.length;
            if (0 !== e)
              if (
                (je(at, Q[0]),
                (ct.x = at.x - ut.x),
                (ct.y = at.y - ut.y),
                ee && e > 1)
              ) {
                if (
                  ((ut.x = at.x), (ut.y = at.y), !ct.x && !ct.y && kt(Q[1], lt))
                )
                  return;
                je(lt, Q[1]), X || ((X = !0), _e("zoomGestureStarted"));
                var t = Ct(at, lt),
                  n = Zt(t);
                n >
                  r.currItem.initialZoomLevel +
                    r.currItem.initialZoomLevel / 15 && (ue = !0);
                var i = 1,
                  o = Ue(),
                  s = Ve();
                if (n < o)
                  if (
                    l.pinchToClose &&
                    !ue &&
                    b <= r.currItem.initialZoomLevel
                  ) {
                    var a = o - n,
                      c = 1 - a / (o / 1.2);
                    $e(c), _e("onPinchClose", c), (le = !0);
                  } else
                    (i = (o - n) / o), i > 1 && (i = 1), (n = o - i * (o / 3));
                else
                  n > s &&
                    ((i = (n - s) / (6 * o)),
                    i > 1 && (i = 1),
                    (n = s + i * o));
                i < 0 && (i = 0),
                  (te = t),
                  It(at, lt, gt),
                  (fe.x += gt.x - xt.x),
                  (fe.y += gt.y - xt.y),
                  je(xt, gt),
                  (me.x = ze("x", n)),
                  (me.y = ze("y", n)),
                  (W = n > y),
                  (y = n),
                  Le();
              } else {
                if (!se) return;
                if (
                  (ae &&
                    ((ae = !1),
                    Math.abs(ct.x) >= st && (ct.x -= Q[0].x - pt.x),
                    Math.abs(ct.y) >= st && (ct.y -= Q[0].y - pt.y)),
                  (ut.x = at.x),
                  (ut.y = at.y),
                  0 === ct.x && 0 === ct.y)
                )
                  return;
                if ("v" === se && l.closeOnVerticalDrag && !At()) {
                  (fe.y += ct.y), (me.y += ct.y);
                  var u = Nt();
                  return (U = !0), _e("onVerticalDrag", u), $e(u), void Le();
                }
                Lt(Oe(), at.x, at.y), (Y = !0), (ie = r.currItem.bounds);
                var p = Ht("x", ct);
                p || (Ht("y", ct), He(me), Le());
              }
          }
        },
        Bt = function (e) {
          if (H.isOldAndroid) {
            if (V && "mouseup" === e.type) return;
            e.type.indexOf("touch") > -1 &&
              (clearTimeout(V),
              (V = setTimeout(function () {
                V = 0;
              }, 600)));
          }
          _e("pointerUp"), Ot(e, !1) && e.preventDefault();
          var t;
          if ($) {
            var n = o.arraySearch(dt, e.pointerId, "id");
            if (n > -1)
              if (((t = dt.splice(n, 1)[0]), navigator.msPointerEnabled)) {
                var i = { 4: "mouse", 2: "touch", 3: "pen" };
                (t.type = i[e.pointerType]),
                  t.type || (t.type = e.pointerType || "mouse");
              } else t.type = e.pointerType || "mouse";
          }
          var s,
            a = jt(e),
            c = a.length;
          if (("mouseup" === e.type && (c = 0), 2 === c)) return (Q = null), !0;
          1 === c && je(pt, a[0]),
            0 !== c ||
              se ||
              re ||
              (t ||
                ("mouseup" === e.type
                  ? (t = { x: e.pageX, y: e.pageY, type: "mouse" })
                  : e.changedTouches &&
                    e.changedTouches[0] &&
                    (t = {
                      x: e.changedTouches[0].pageX,
                      y: e.changedTouches[0].pageY,
                      type: "touch",
                    })),
              _e("touchRelease", e, t));
          var u = -1;
          if (
            (0 === c &&
              ((Z = !1),
              o.unbind(window, m, r),
              Tt(),
              ee ? (u = 0) : yt !== -1 && (u = Oe() - yt)),
            (yt = 1 === c ? Oe() : -1),
            (s = u !== -1 && u < 150 ? "zoom" : "swipe"),
            ee &&
              c < 2 &&
              ((ee = !1),
              1 === c && (s = "zoomPointerUp"),
              _e("zoomGestureEnded")),
            (Q = null),
            Y || X || re || U)
          )
            if ((nt(), B || (B = Wt()), B.calculateSwipeSpeed("x"), U)) {
              var p = Nt();
              if (p < l.verticalDragRange) r.close();
              else {
                var d = me.y,
                  f = ce;
                it("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
                  (me.y = (r.currItem.initialPosition.y - d) * e + d),
                    $e((1 - f) * e + f),
                    Le();
                }),
                  _e("onVerticalDrag", 1);
              }
            } else {
              if ((J || re) && 0 === c) {
                var h = Vt(s, B);
                if (h) return;
                s = "zoomPointerUp";
              }
              if (!re)
                return "swipe" !== s
                  ? void Kt()
                  : void (!J && y > r.currItem.fitRatio && Ut(B));
            }
        },
        Wt = function () {
          var e,
            t,
            n = {
              lastFlickOffset: {},
              lastFlickDist: {},
              lastFlickSpeed: {},
              slowDownRatio: {},
              slowDownRatioReverse: {},
              speedDecelerationRatio: {},
              speedDecelerationRatioAbs: {},
              distanceOffset: {},
              backAnimDestination: {},
              backAnimStarted: {},
              calculateSwipeSpeed: function (i) {
                ht.length > 1
                  ? ((e = Oe() - q + 50), (t = ht[ht.length - 2][i]))
                  : ((e = Oe() - F), (t = pt[i])),
                  (n.lastFlickOffset[i] = ut[i] - t),
                  (n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i])),
                  n.lastFlickDist[i] > 20
                    ? (n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e)
                    : (n.lastFlickSpeed[i] = 0),
                  Math.abs(n.lastFlickSpeed[i]) < 0.1 &&
                    (n.lastFlickSpeed[i] = 0),
                  (n.slowDownRatio[i] = 0.95),
                  (n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i]),
                  (n.speedDecelerationRatio[i] = 1);
              },
              calculateOverBoundsAnimOffset: function (e, t) {
                n.backAnimStarted[e] ||
                  (me[e] > ie.min[e]
                    ? (n.backAnimDestination[e] = ie.min[e])
                    : me[e] < ie.max[e] &&
                      (n.backAnimDestination[e] = ie.max[e]),
                  void 0 !== n.backAnimDestination[e] &&
                    ((n.slowDownRatio[e] = 0.7),
                    (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                    n.speedDecelerationRatioAbs[e] < 0.05 &&
                      ((n.lastFlickSpeed[e] = 0),
                      (n.backAnimStarted[e] = !0),
                      it(
                        "bounceZoomPan" + e,
                        me[e],
                        n.backAnimDestination[e],
                        t || 300,
                        o.easing.sine.out,
                        function (t) {
                          (me[e] = t), Le();
                        }
                      ))));
              },
              calculateAnimOffset: function (e) {
                n.backAnimStarted[e] ||
                  ((n.speedDecelerationRatio[e] =
                    n.speedDecelerationRatio[e] *
                    (n.slowDownRatio[e] +
                      n.slowDownRatioReverse[e] -
                      (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                  (n.speedDecelerationRatioAbs[e] = Math.abs(
                    n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]
                  )),
                  (n.distanceOffset[e] =
                    n.lastFlickSpeed[e] *
                    n.speedDecelerationRatio[e] *
                    n.timeDiff),
                  (me[e] += n.distanceOffset[e]));
              },
              panAnimLoop: function () {
                if (
                  Je.zoomPan &&
                  ((Je.zoomPan.raf = L(n.panAnimLoop)),
                  (n.now = Oe()),
                  (n.timeDiff = n.now - n.lastNow),
                  (n.lastNow = n.now),
                  n.calculateAnimOffset("x"),
                  n.calculateAnimOffset("y"),
                  Le(),
                  n.calculateOverBoundsAnimOffset("x"),
                  n.calculateOverBoundsAnimOffset("y"),
                  n.speedDecelerationRatioAbs.x < 0.05 &&
                    n.speedDecelerationRatioAbs.y < 0.05)
                )
                  return (
                    (me.x = Math.round(me.x)),
                    (me.y = Math.round(me.y)),
                    Le(),
                    void et("zoomPan")
                  );
              },
            };
          return n;
        },
        Ut = function (e) {
          return (
            e.calculateSwipeSpeed("y"),
            (ie = r.currItem.bounds),
            (e.backAnimDestination = {}),
            (e.backAnimStarted = {}),
            Math.abs(e.lastFlickSpeed.x) <= 0.05 &&
            Math.abs(e.lastFlickSpeed.y) <= 0.05
              ? ((e.speedDecelerationRatioAbs.x =
                  e.speedDecelerationRatioAbs.y =
                    0),
                e.calculateOverBoundsAnimOffset("x"),
                e.calculateOverBoundsAnimOffset("y"),
                !0)
              : (tt("zoomPan"), (e.lastNow = Oe()), void e.panAnimLoop())
          );
        },
        Vt = function (e, t) {
          var n;
          re || (vt = d);
          var i;
          if ("swipe" === e) {
            var s = ut.x - pt.x,
              a = t.lastFlickDist.x < 10;
            s > rt && (a || t.lastFlickOffset.x > 20)
              ? (i = -1)
              : s < -rt && (a || t.lastFlickOffset.x < -20) && (i = 1);
          }
          var c;
          i &&
            ((d += i),
            d < 0
              ? ((d = l.loop ? en() - 1 : 0), (c = !0))
              : d >= en() && ((d = l.loop ? 0 : en() - 1), (c = !0)),
            (c && !l.loop) || ((we += i), (ge -= i), (n = !0)));
          var u,
            p = be.x * ge,
            f = Math.abs(p - bt.x);
          return (
            n || p > bt.x == t.lastFlickSpeed.x > 0
              ? ((u =
                  Math.abs(t.lastFlickSpeed.x) > 0
                    ? f / Math.abs(t.lastFlickSpeed.x)
                    : 333),
                (u = Math.min(u, 400)),
                (u = Math.max(u, 250)))
              : (u = 333),
            vt === d && (n = !1),
            (re = !0),
            _e("mainScrollAnimStart"),
            it("mainScroll", bt.x, p, u, o.easing.cubic.out, Me, function () {
              nt(),
                (re = !1),
                (vt = -1),
                (n || vt !== d) && r.updateCurrItem(),
                _e("mainScrollAnimComplete");
            }),
            n && r.updateCurrItem(!0),
            n
          );
        },
        Zt = function (e) {
          return (1 / ne) * e * b;
        },
        Kt = function () {
          var e = y,
            t = Ue(),
            n = Ve();
          y < t ? (e = t) : y > n && (e = n);
          var i,
            s = 1,
            a = ce;
          return le && !W && !ue && y < t
            ? (r.close(), !0)
            : (le &&
                (i = function (e) {
                  $e((s - a) * e + a);
                }),
              r.zoomTo(e, 0, 200, o.easing.cubic.out, i),
              !0);
        };
      Te("Gestures", {
        publicMethods: {
          initGestures: function () {
            var e = function (e, t, n, i, o) {
              (E = e + t), (A = e + n), (P = e + i), (_ = o ? e + o : "");
            };
            ($ = H.pointerEvent),
              $ && H.touch && (H.touch = !1),
              $
                ? navigator.msPointerEnabled
                  ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                  : e("pointer", "down", "move", "up", "cancel")
                : H.touch
                ? (e("touch", "start", "move", "end", "cancel"), (I = !0))
                : e("mouse", "down", "move", "up"),
              (m = A + " " + P + " " + _),
              (v = E),
              $ &&
                !I &&
                (I =
                  navigator.maxTouchPoints > 1 ||
                  navigator.msMaxTouchPoints > 1),
              (r.likelyTouchDevice = I),
              (g[E] = Rt),
              (g[A] = Ft),
              (g[P] = Bt),
              _ && (g[_] = g[P]),
              H.touch &&
                ((v += " mousedown"),
                (m += " mousemove mouseup"),
                (g.mousedown = g[E]),
                (g.mousemove = g[A]),
                (g.mouseup = g[P])),
              I || (l.allowPanToNext = !1);
          },
        },
      });
      var Xt,
        Yt,
        Gt,
        Jt,
        Qt,
        en,
        tn,
        nn = function (t, n, i, s) {
          Xt && clearTimeout(Xt), (Jt = !0), (Gt = !0);
          var a;
          t.initialLayout
            ? ((a = t.initialLayout), (t.initialLayout = null))
            : (a = l.getThumbBoundsFn && l.getThumbBoundsFn(d));
          var c = i ? l.hideAnimationDuration : l.showAnimationDuration,
            u = function () {
              et("initialZoom"),
                i
                  ? (r.template.removeAttribute("style"),
                    r.bg.removeAttribute("style"))
                  : ($e(1),
                    n && (n.style.display = "block"),
                    o.addClass(e, "pswp--animated-in"),
                    _e("initialZoom" + (i ? "OutEnd" : "InEnd"))),
                s && s(),
                (Jt = !1);
            };
          if (!c || !a || void 0 === a.x)
            return (
              _e("initialZoom" + (i ? "Out" : "In")),
              (y = t.initialZoomLevel),
              je(me, t.initialPosition),
              Le(),
              (e.style.opacity = i ? 0 : 1),
              $e(1),
              void (c
                ? setTimeout(function () {
                    u();
                  }, c)
                : u())
            );
          var f = function () {
            var n = p,
              s = !r.currItem.src || r.currItem.loadError || l.showHideOpacity;
            t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
              i ||
                ((y = a.w / t.w),
                (me.x = a.x),
                (me.y = a.y - M),
                (r[s ? "template" : "bg"].style.opacity = 0.001),
                Le()),
              tt("initialZoom"),
              i && !n && o.removeClass(e, "pswp--animated-in"),
              s &&
                (i
                  ? o[(n ? "remove" : "add") + "Class"](
                      e,
                      "pswp--animate_opacity"
                    )
                  : setTimeout(function () {
                      o.addClass(e, "pswp--animate_opacity");
                    }, 30)),
              (Xt = setTimeout(
                function () {
                  if ((_e("initialZoom" + (i ? "Out" : "In")), i)) {
                    var r = a.w / t.w,
                      l = { x: me.x, y: me.y },
                      p = y,
                      d = ce,
                      f = function (t) {
                        1 === t
                          ? ((y = r), (me.x = a.x), (me.y = a.y - j))
                          : ((y = (r - p) * t + p),
                            (me.x = (a.x - l.x) * t + l.x),
                            (me.y = (a.y - j - l.y) * t + l.y)),
                          Le(),
                          s ? (e.style.opacity = 1 - t) : $e(d - t * d);
                      };
                    n
                      ? it("initialZoom", 0, 1, c, o.easing.cubic.out, f, u)
                      : (f(1), (Xt = setTimeout(u, c + 20)));
                  } else
                    (y = t.initialZoomLevel),
                      je(me, t.initialPosition),
                      Le(),
                      $e(1),
                      s ? (e.style.opacity = 1) : $e(1),
                      (Xt = setTimeout(u, c + 20));
                },
                i ? 25 : 90
              ));
          };
          f();
        },
        on = {},
        rn = [],
        sn = {
          index: 0,
          errorMsg:
            '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
          forceProgressiveLoading: !1,
          preload: [1, 1],
          getNumItemsFn: function () {
            return Yt.length;
          },
        },
        an = function () {
          return {
            center: { x: 0, y: 0 },
            max: { x: 0, y: 0 },
            min: { x: 0, y: 0 },
          };
        },
        ln = function (e, t, n) {
          var i = e.bounds;
          (i.center.x = Math.round((on.x - t) / 2)),
            (i.center.y = Math.round((on.y - n) / 2) + e.vGap.top),
            (i.max.x = t > on.x ? Math.round(on.x - t) : i.center.x),
            (i.max.y =
              n > on.y ? Math.round(on.y - n) + e.vGap.top : i.center.y),
            (i.min.x = t > on.x ? 0 : i.center.x),
            (i.min.y = n > on.y ? e.vGap.top : i.center.y);
        },
        cn = function (e, t, n) {
          if (e.src && !e.loadError) {
            var i = !n;
            if (
              (i &&
                (e.vGap || (e.vGap = { top: 0, bottom: 0 }),
                _e("parseVerticalMargin", e)),
              (on.x = t.x),
              (on.y = t.y - e.vGap.top - e.vGap.bottom),
              i)
            ) {
              var o = on.x / e.w,
                r = on.y / e.h;
              e.fitRatio = o < r ? o : r;
              var s = l.scaleMode;
              "orig" === s
                ? (n = 1)
                : "fit" === s
                ? (n = e.fitRatio)
                : "zoom" === s &&
                  (n = Math.max(e.initialZoomLevel || 1, e.fitRatio)),
                n > 1 && (n = 1),
                (e.initialZoomLevel = n),
                e.bounds || (e.bounds = an());
            }
            if (!n) return;
            return (
              ln(e, e.w * n, e.h * n),
              i &&
                n === e.initialZoomLevel &&
                (e.initialPosition = e.bounds.center),
              e.bounds
            );
          }
          return (
            (e.w = e.h = 0),
            (e.initialZoomLevel = e.fitRatio = 1),
            (e.bounds = an()),
            (e.initialPosition = e.bounds.center),
            e.bounds
          );
        },
        un = function (e, t, n, i, o, s) {
          t.loadError ||
            (i &&
              ((t.imageAppended = !0),
              fn(t, i, t === r.currItem && Ce),
              n.appendChild(i),
              s &&
                setTimeout(function () {
                  t &&
                    t.loaded &&
                    t.placeholder &&
                    ((t.placeholder.style.display = "none"),
                    (t.placeholder = null));
                }, 500)));
        },
        pn = function (e) {
          (e.loading = !0), (e.loaded = !1);
          var t = (e.img = o.createEl("pswp__img", "img")),
            n = function () {
              (e.loading = !1),
                (e.loaded = !0),
                e.loadComplete ? e.loadComplete(e) : (e.img = null),
                (t.onload = t.onerror = null),
                (t = null);
            };
          return (
            (t.onload = n),
            (t.onerror = function () {
              (e.loadError = !0), n();
            }),
            (t.src = e.src),
            t
          );
        },
        dn = function (e, t) {
          if (e.src && e.loadError && e.container)
            return (
              t && (e.container.innerHTML = ""),
              (e.container.innerHTML = l.errorMsg.replace("%url%", e.src)),
              !0
            );
        },
        fn = function (e, t, n) {
          if (e.src) {
            t || (t = e.container.lastChild);
            var i = n ? e.w : Math.round(e.w * e.fitRatio),
              o = n ? e.h : Math.round(e.h * e.fitRatio);
            e.placeholder &&
              !e.loaded &&
              ((e.placeholder.style.width = i + "px"),
              (e.placeholder.style.height = o + "px")),
              (t.style.width = i + "px"),
              (t.style.height = o + "px");
          }
        },
        hn = function () {
          if (rn.length) {
            for (var e, t = 0; t < rn.length; t++)
              (e = rn[t]),
                e.holder.index === e.index &&
                  un(e.index, e.item, e.baseDiv, e.img, !1, e.clearPlaceholder);
            rn = [];
          }
        };
      Te("Controller", {
        publicMethods: {
          lazyLoadItem: function (e) {
            e = Ee(e);
            var t = Qt(e);
            t &&
              ((!t.loaded && !t.loading) || S) &&
              (_e("gettingData", e, t), t.src && pn(t));
          },
          initController: function () {
            o.extend(l, sn, !0),
              (r.items = Yt = n),
              (Qt = r.getItemAt),
              (en = l.getNumItemsFn),
              (tn = l.loop),
              en() < 3 && (l.loop = !1),
              Pe("beforeChange", function (e) {
                var t,
                  n = l.preload,
                  i = null === e || e >= 0,
                  o = Math.min(n[0], en()),
                  s = Math.min(n[1], en());
                for (t = 1; t <= (i ? s : o); t++) r.lazyLoadItem(d + t);
                for (t = 1; t <= (i ? o : s); t++) r.lazyLoadItem(d - t);
              }),
              Pe("initialLayout", function () {
                r.currItem.initialLayout =
                  l.getThumbBoundsFn && l.getThumbBoundsFn(d);
              }),
              Pe("mainScrollAnimComplete", hn),
              Pe("initialZoomInEnd", hn),
              Pe("destroy", function () {
                for (var e, t = 0; t < Yt.length; t++)
                  (e = Yt[t]),
                    e.container && (e.container = null),
                    e.placeholder && (e.placeholder = null),
                    e.img && (e.img = null),
                    e.preloader && (e.preloader = null),
                    e.loadError && (e.loaded = e.loadError = !1);
                rn = null;
              });
          },
          getItemAt: function (e) {
            return e >= 0 && void 0 !== Yt[e] && Yt[e];
          },
          allowProgressiveImg: function () {
            return (
              l.forceProgressiveLoading ||
              !I ||
              l.mouseUsed ||
              screen.width > 1200
            );
          },
          setContent: function (e, t) {
            l.loop && (t = Ee(t));
            var n = r.getItemAt(e.index);
            n && (n.container = null);
            var i,
              s = r.getItemAt(t);
            if (!s) return void (e.el.innerHTML = "");
            _e("gettingData", t, s), (e.index = t), (e.item = s);
            var a = (s.container = o.createEl("pswp__zoom-wrap"));
            if (
              (!s.src &&
                s.html &&
                (s.html.tagName
                  ? a.appendChild(s.html)
                  : (a.innerHTML = s.html)),
              dn(s),
              cn(s, ve),
              !s.src || s.loadError || s.loaded)
            )
              s.src &&
                !s.loadError &&
                ((i = o.createEl("pswp__img", "img")),
                (i.style.opacity = 1),
                (i.src = s.src),
                fn(s, i),
                un(t, s, a, i, !0));
            else {
              if (
                ((s.loadComplete = function (n) {
                  if (c) {
                    if (e && e.index === t) {
                      if (dn(n, !0))
                        return (
                          (n.loadComplete = n.img = null),
                          cn(n, ve),
                          Ne(n),
                          void (e.index === d && r.updateCurrZoomItem())
                        );
                      n.imageAppended
                        ? !Jt &&
                          n.placeholder &&
                          ((n.placeholder.style.display = "none"),
                          (n.placeholder = null))
                        : H.transform && (re || Jt)
                        ? rn.push({
                            item: n,
                            baseDiv: a,
                            img: n.img,
                            index: t,
                            holder: e,
                            clearPlaceholder: !0,
                          })
                        : un(t, n, a, n.img, re || Jt, !0);
                    }
                    (n.loadComplete = null),
                      (n.img = null),
                      _e("imageLoadComplete", t, n);
                  }
                }),
                o.features.transform)
              ) {
                var u = "pswp__img pswp__img--placeholder";
                u += s.msrc ? "" : " pswp__img--placeholder--blank";
                var p = o.createEl(u, s.msrc ? "img" : "");
                s.msrc && (p.src = s.msrc),
                  fn(s, p),
                  a.appendChild(p),
                  (s.placeholder = p);
              }
              s.loading || pn(s),
                r.allowProgressiveImg() &&
                  (!Gt && H.transform
                    ? rn.push({
                        item: s,
                        baseDiv: a,
                        img: s.img,
                        index: t,
                        holder: e,
                      })
                    : un(t, s, a, s.img, !0, !0));
            }
            Gt || t !== d ? Ne(s) : ((oe = a.style), nn(s, i || s.img)),
              (e.el.innerHTML = ""),
              e.el.appendChild(a);
          },
          cleanSlide: function (e) {
            e.img && (e.img.onload = e.img.onerror = null),
              (e.loaded = e.loading = e.img = e.imageAppended = !1);
          },
        },
      });
      var mn,
        vn = {},
        gn = function (e, t, n) {
          var i = document.createEvent("CustomEvent"),
            o = {
              origEvent: e,
              target: e.target,
              releasePoint: t,
              pointerType: n || "touch",
            };
          i.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(i);
        };
      Te("Tap", {
        publicMethods: {
          initTap: function () {
            Pe("firstTouchStart", r.onTapStart),
              Pe("touchRelease", r.onTapRelease),
              Pe("destroy", function () {
                (vn = {}), (mn = null);
              });
          },
          onTapStart: function (e) {
            e.length > 1 && (clearTimeout(mn), (mn = null));
          },
          onTapRelease: function (e, t) {
            if (t && !Y && !K && !Qe) {
              var n = t;
              if (mn && (clearTimeout(mn), (mn = null), St(n, vn)))
                return void _e("doubleTap", n);
              if ("mouse" === t.type) return void gn(e, t, "mouse");
              var i = e.target.tagName.toUpperCase();
              if ("BUTTON" === i || o.hasClass(e.target, "pswp__single-tap"))
                return void gn(e, t);
              je(vn, n),
                (mn = setTimeout(function () {
                  gn(e, t), (mn = null);
                }, 300));
            }
          },
        },
      });
      var yn;
      Te("DesktopZoom", {
        publicMethods: {
          initDesktopZoom: function () {
            z ||
              (I
                ? Pe("mouseUsed", function () {
                    r.setupDesktopZoom();
                  })
                : r.setupDesktopZoom(!0));
          },
          setupDesktopZoom: function (t) {
            yn = {};
            var n = "wheel mousewheel DOMMouseScroll";
            Pe("bindEvents", function () {
              o.bind(e, n, r.handleMouseWheel);
            }),
              Pe("unbindEvents", function () {
                yn && o.unbind(e, n, r.handleMouseWheel);
              }),
              (r.mouseZoomedIn = !1);
            var i,
              s = function () {
                r.mouseZoomedIn &&
                  (o.removeClass(e, "pswp--zoomed-in"), (r.mouseZoomedIn = !1)),
                  y < 1
                    ? o.addClass(e, "pswp--zoom-allowed")
                    : o.removeClass(e, "pswp--zoom-allowed"),
                  a();
              },
              a = function () {
                i && (o.removeClass(e, "pswp--dragging"), (i = !1));
              };
            Pe("resize", s),
              Pe("afterChange", s),
              Pe("pointerDown", function () {
                r.mouseZoomedIn && ((i = !0), o.addClass(e, "pswp--dragging"));
              }),
              Pe("pointerUp", a),
              t || s();
          },
          handleMouseWheel: function (e) {
            if (y <= r.currItem.fitRatio)
              return (
                l.modal &&
                  (!l.closeOnScroll || Qe || Z
                    ? e.preventDefault()
                    : O && Math.abs(e.deltaY) > 2 && ((p = !0), r.close())),
                !0
              );
            if ((e.stopPropagation(), (yn.x = 0), "deltaX" in e))
              1 === e.deltaMode
                ? ((yn.x = 18 * e.deltaX), (yn.y = 18 * e.deltaY))
                : ((yn.x = e.deltaX), (yn.y = e.deltaY));
            else if ("wheelDelta" in e)
              e.wheelDeltaX && (yn.x = -0.16 * e.wheelDeltaX),
                e.wheelDeltaY
                  ? (yn.y = -0.16 * e.wheelDeltaY)
                  : (yn.y = -0.16 * e.wheelDelta);
            else {
              if (!("detail" in e)) return;
              yn.y = e.detail;
            }
            We(y, !0);
            var t = me.x - yn.x,
              n = me.y - yn.y;
            (l.modal ||
              (t <= ie.min.x &&
                t >= ie.max.x &&
                n <= ie.min.y &&
                n >= ie.max.y)) &&
              e.preventDefault(),
              r.panTo(t, n);
          },
          toggleDesktopZoom: function (t) {
            t = t || { x: ve.x / 2 + ye.x, y: ve.y / 2 + ye.y };
            var n = l.getDoubleTapZoom(!0, r.currItem),
              i = y === n;
            (r.mouseZoomedIn = !i),
              r.zoomTo(i ? r.currItem.initialZoomLevel : n, t, 333),
              o[(i ? "remove" : "add") + "Class"](e, "pswp--zoomed-in");
          },
        },
      }),
        o.extend(r, ot);
    };
    return e;
  })
  /*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05
   * http://photoswipe.com
   * Copyright (c) 2017 Dmitry Semenov; */,
  !(function (e, t) {
    "function" == typeof define && define.amd
      ? define(t)
      : "object" == typeof exports
      ? (module.exports = t())
      : (e.PhotoSwipeUI_Default = t());
  })(this, function () {
    "use strict";
    var e = function (e, t) {
      var n,
        i,
        o,
        r,
        s,
        a,
        l,
        c,
        u,
        p,
        d,
        f,
        h,
        m,
        v,
        g,
        y,
        b,
        w,
        x = this,
        k = !1,
        S = !0,
        C = !0,
        T = {
          barsSize: { top: 44, bottom: "auto" },
          closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
          timeToIdle: 4e3,
          timeToIdleOutside: 1e3,
          loadingIndicatorDelay: 1e3,
          addCaptionHTMLFn: function (e, t) {
            return e.title
              ? ((t.children[0].innerHTML = e.title), !0)
              : ((t.children[0].innerHTML = ""), !1);
          },
          closeEl: !0,
          captionEl: !0,
          fullscreenEl: !0,
          zoomEl: !0,
          shareEl: !0,
          counterEl: !0,
          arrowEl: !0,
          preloaderEl: !0,
          tapToClose: !1,
          tapToToggleControls: !0,
          clickToCloseNonZoomable: !0,
          shareButtons: [
            {
              id: "facebook",
              label: "Share on Facebook",
              url: "https://www.facebook.com/sharer/sharer.php?u={{url}}",
            },
            {
              id: "twitter",
              label: "Tweet",
              url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}",
            },
            {
              id: "pinterest",
              label: "Pin it",
              url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}",
            },
            {
              id: "download",
              label: "Download image",
              url: "{{raw_image_url}}",
              download: !0,
            },
          ],
          getImageURLForShare: function () {
            return e.currItem.src || "";
          },
          getPageURLForShare: function () {
            return window.location.href;
          },
          getTextForShare: function () {
            return e.currItem.title || "";
          },
          indexIndicatorSep: " / ",
          fitControlsWidth: 1200,
        },
        E = function (e) {
          if (g) return !0;
          (e = e || window.event), v.timeToIdle && v.mouseUsed && !u && M();
          for (
            var n,
              i,
              o = e.target || e.srcElement,
              r = o.getAttribute("class") || "",
              s = 0;
            s < W.length;
            s++
          )
            (n = W[s]),
              n.onTap &&
                r.indexOf("pswp__" + n.name) > -1 &&
                (n.onTap(), (i = !0));
          if (i) {
            e.stopPropagation && e.stopPropagation(), (g = !0);
            var a = t.features.isOldAndroid ? 600 : 30;
            y = setTimeout(function () {
              g = !1;
            }, a);
          }
        },
        A = function () {
          return (
            !e.likelyTouchDevice ||
            v.mouseUsed ||
            screen.width > v.fitControlsWidth
          );
        },
        P = function (e, n, i) {
          t[(i ? "add" : "remove") + "Class"](e, "pswp__" + n);
        },
        _ = function () {
          var e = 1 === v.getNumItemsFn();
          e !== m && (P(i, "ui--one-slide", e), (m = e));
        },
        O = function () {
          P(l, "share-modal--hidden", C);
        },
        $ = function () {
          return (
            (C = !C),
            C
              ? (t.removeClass(l, "pswp__share-modal--fade-in"),
                setTimeout(function () {
                  C && O();
                }, 300))
              : (O(),
                setTimeout(function () {
                  C || t.addClass(l, "pswp__share-modal--fade-in");
                }, 30)),
            C || L(),
            !1
          );
        },
        I = function (t) {
          t = t || window.event;
          var n = t.target || t.srcElement;
          return (
            e.shout("shareLinkClick", t, n),
            !(
              !n.href ||
              (!n.hasAttribute("download") &&
                (window.open(
                  n.href,
                  "pswp_share",
                  "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                    (window.screen ? Math.round(screen.width / 2 - 275) : 100)
                ),
                C || $(),
                1))
            )
          );
        },
        L = function () {
          for (var e, t, n, i, o, r = "", s = 0; s < v.shareButtons.length; s++)
            (e = v.shareButtons[s]),
              (n = v.getImageURLForShare(e)),
              (i = v.getPageURLForShare(e)),
              (o = v.getTextForShare(e)),
              (t = e.url
                .replace("{{url}}", encodeURIComponent(i))
                .replace("{{image_url}}", encodeURIComponent(n))
                .replace("{{raw_image_url}}", n)
                .replace("{{text}}", encodeURIComponent(o))),
              (r +=
                '<a href="' +
                t +
                '" target="_blank" class="pswp__share--' +
                e.id +
                '"' +
                (e.download ? "download" : "") +
                ">" +
                e.label +
                "</a>"),
              v.parseShareButtonOut && (r = v.parseShareButtonOut(e, r));
          (l.children[0].innerHTML = r), (l.children[0].onclick = I);
        },
        N = function (e) {
          for (var n = 0; n < v.closeElClasses.length; n++)
            if (t.hasClass(e, "pswp__" + v.closeElClasses[n])) return !0;
        },
        D = 0,
        M = function () {
          clearTimeout(w), (D = 0), u && x.setIdle(!1);
        },
        z = function (e) {
          e = e ? e : window.event;
          var t = e.relatedTarget || e.toElement;
          (t && "HTML" !== t.nodeName) ||
            (clearTimeout(w),
            (w = setTimeout(function () {
              x.setIdle(!0);
            }, v.timeToIdleOutside)));
        },
        j = function () {
          v.fullscreenEl &&
            !t.features.isOldAndroid &&
            (n || (n = x.getFullscreenAPI()),
            n
              ? (t.bind(document, n.eventK, x.updateFullscreen),
                x.updateFullscreen(),
                t.addClass(e.template, "pswp--supports-fs"))
              : t.removeClass(e.template, "pswp--supports-fs"));
        },
        H = function () {
          v.preloaderEl &&
            (R(!0),
            p("beforeChange", function () {
              clearTimeout(h),
                (h = setTimeout(function () {
                  e.currItem && e.currItem.loading
                    ? (!e.allowProgressiveImg() ||
                        (e.currItem.img && !e.currItem.img.naturalWidth)) &&
                      R(!1)
                    : R(!0);
                }, v.loadingIndicatorDelay));
            }),
            p("imageLoadComplete", function (t, n) {
              e.currItem === n && R(!0);
            }));
        },
        R = function (e) {
          f !== e && (P(d, "preloader--active", !e), (f = e));
        },
        F = function (e) {
          var n = e.vGap;
          if (A()) {
            var s = v.barsSize;
            if (v.captionEl && "auto" === s.bottom)
              if (
                (r ||
                  ((r = t.createEl("pswp__caption pswp__caption--fake")),
                  r.appendChild(t.createEl("pswp__caption__center")),
                  i.insertBefore(r, o),
                  t.addClass(i, "pswp__ui--fit")),
                v.addCaptionHTMLFn(e, r, !0))
              ) {
                var a = r.clientHeight;
                n.bottom = parseInt(a, 10) || 44;
              } else n.bottom = s.top;
            else n.bottom = "auto" === s.bottom ? 0 : s.bottom;
            n.top = s.top;
          } else n.top = n.bottom = 0;
        },
        q = function () {
          v.timeToIdle &&
            p("mouseUsed", function () {
              t.bind(document, "mousemove", M),
                t.bind(document, "mouseout", z),
                (b = setInterval(function () {
                  D++, 2 === D && x.setIdle(!0);
                }, v.timeToIdle / 2));
            });
        },
        B = function () {
          p("onVerticalDrag", function (e) {
            S && e < 0.95
              ? x.hideControls()
              : !S && e >= 0.95 && x.showControls();
          });
          var e;
          p("onPinchClose", function (t) {
            S && t < 0.9
              ? (x.hideControls(), (e = !0))
              : e && !S && t > 0.9 && x.showControls();
          }),
            p("zoomGestureEnded", function () {
              (e = !1), e && !S && x.showControls();
            });
        },
        W = [
          {
            name: "caption",
            option: "captionEl",
            onInit: function (e) {
              o = e;
            },
          },
          {
            name: "share-modal",
            option: "shareEl",
            onInit: function (e) {
              l = e;
            },
            onTap: function () {
              $();
            },
          },
          {
            name: "button--share",
            option: "shareEl",
            onInit: function (e) {
              a = e;
            },
            onTap: function () {
              $();
            },
          },
          {
            name: "button--zoom",
            option: "zoomEl",
            onTap: e.toggleDesktopZoom,
          },
          {
            name: "counter",
            option: "counterEl",
            onInit: function (e) {
              s = e;
            },
          },
          { name: "button--close", option: "closeEl", onTap: e.close },
          { name: "button--arrow--left", option: "arrowEl", onTap: e.prev },
          { name: "button--arrow--right", option: "arrowEl", onTap: e.next },
          {
            name: "button--fs",
            option: "fullscreenEl",
            onTap: function () {
              n.isFullscreen() ? n.exit() : n.enter();
            },
          },
          {
            name: "preloader",
            option: "preloaderEl",
            onInit: function (e) {
              d = e;
            },
          },
        ],
        U = function () {
          var e,
            n,
            o,
            r = function (i) {
              if (i)
                for (var r = i.length, s = 0; s < r; s++) {
                  (e = i[s]), (n = e.className);
                  for (var a = 0; a < W.length; a++)
                    (o = W[a]),
                      n.indexOf("pswp__" + o.name) > -1 &&
                        (v[o.option]
                          ? (t.removeClass(e, "pswp__element--disabled"),
                            o.onInit && o.onInit(e))
                          : t.addClass(e, "pswp__element--disabled"));
                }
            };
          r(i.children);
          var s = t.getChildByClass(i, "pswp__top-bar");
          s && r(s.children);
        };
      (x.init = function () {
        t.extend(e.options, T, !0),
          (v = e.options),
          (i = t.getChildByClass(e.scrollWrap, "pswp__ui")),
          (p = e.listen),
          B(),
          p("beforeChange", x.update),
          p("doubleTap", function (t) {
            var n = e.currItem.initialZoomLevel;
            e.getZoomLevel() !== n
              ? e.zoomTo(n, t, 333)
              : e.zoomTo(v.getDoubleTapZoom(!1, e.currItem), t, 333);
          }),
          p("preventDragEvent", function (e, t, n) {
            var i = e.target || e.srcElement;
            i &&
              i.getAttribute("class") &&
              e.type.indexOf("mouse") > -1 &&
              (i.getAttribute("class").indexOf("__caption") > 0 ||
                /(SMALL|STRONG|EM)/i.test(i.tagName)) &&
              (n.prevent = !1);
          }),
          p("bindEvents", function () {
            t.bind(i, "pswpTap click", E),
              t.bind(e.scrollWrap, "pswpTap", x.onGlobalTap),
              e.likelyTouchDevice ||
                t.bind(e.scrollWrap, "mouseover", x.onMouseOver);
          }),
          p("unbindEvents", function () {
            C || $(),
              b && clearInterval(b),
              t.unbind(document, "mouseout", z),
              t.unbind(document, "mousemove", M),
              t.unbind(i, "pswpTap click", E),
              t.unbind(e.scrollWrap, "pswpTap", x.onGlobalTap),
              t.unbind(e.scrollWrap, "mouseover", x.onMouseOver),
              n &&
                (t.unbind(document, n.eventK, x.updateFullscreen),
                n.isFullscreen() && ((v.hideAnimationDuration = 0), n.exit()),
                (n = null));
          }),
          p("destroy", function () {
            v.captionEl &&
              (r && i.removeChild(r), t.removeClass(o, "pswp__caption--empty")),
              l && (l.children[0].onclick = null),
              t.removeClass(i, "pswp__ui--over-close"),
              t.addClass(i, "pswp__ui--hidden"),
              x.setIdle(!1);
          }),
          v.showAnimationDuration || t.removeClass(i, "pswp__ui--hidden"),
          p("initialZoomIn", function () {
            v.showAnimationDuration && t.removeClass(i, "pswp__ui--hidden");
          }),
          p("initialZoomOut", function () {
            t.addClass(i, "pswp__ui--hidden");
          }),
          p("parseVerticalMargin", F),
          U(),
          v.shareEl && a && l && (C = !0),
          _(),
          q(),
          j(),
          H();
      }),
        (x.setIdle = function (e) {
          (u = e), P(i, "ui--idle", e);
        }),
        (x.update = function () {
          S && e.currItem
            ? (x.updateIndexIndicator(),
              v.captionEl &&
                (v.addCaptionHTMLFn(e.currItem, o),
                P(o, "caption--empty", !e.currItem.title)),
              (k = !0))
            : (k = !1),
            C || $(),
            _();
        }),
        (x.updateFullscreen = function (i) {
          i &&
            setTimeout(function () {
              e.setScrollOffset(0, t.getScrollY());
            }, 50),
            t[(n.isFullscreen() ? "add" : "remove") + "Class"](
              e.template,
              "pswp--fs"
            );
        }),
        (x.updateIndexIndicator = function () {
          v.counterEl &&
            (s.innerHTML =
              e.getCurrentIndex() +
              1 +
              v.indexIndicatorSep +
              v.getNumItemsFn());
        }),
        (x.onGlobalTap = function (n) {
          n = n || window.event;
          var i = n.target || n.srcElement;
          if (!g)
            if (n.detail && "mouse" === n.detail.pointerType) {
              if (N(i)) return void e.close();
              t.hasClass(i, "pswp__img") &&
                (1 === e.getZoomLevel() &&
                e.getZoomLevel() <= e.currItem.fitRatio
                  ? v.clickToCloseNonZoomable && e.close()
                  : e.toggleDesktopZoom(n.detail.releasePoint));
            } else if (
              (v.tapToToggleControls &&
                (S ? x.hideControls() : x.showControls()),
              v.tapToClose && (t.hasClass(i, "pswp__img") || N(i)))
            )
              return void e.close();
        }),
        (x.onMouseOver = function (e) {
          e = e || window.event;
          var t = e.target || e.srcElement;
          P(i, "ui--over-close", N(t));
        }),
        (x.hideControls = function () {
          t.addClass(i, "pswp__ui--hidden"), (S = !1);
        }),
        (x.showControls = function () {
          (S = !0), k || x.update(), t.removeClass(i, "pswp__ui--hidden");
        }),
        (x.supportsFullscreen = function () {
          var e = document;
          return !!(
            e.exitFullscreen ||
            e.mozCancelFullScreen ||
            e.webkitExitFullscreen ||
            e.msExitFullscreen
          );
        }),
        (x.getFullscreenAPI = function () {
          var t,
            n = document.documentElement,
            i = "fullscreenchange";
          return (
            n.requestFullscreen
              ? (t = {
                  enterK: "requestFullscreen",
                  exitK: "exitFullscreen",
                  elementK: "fullscreenElement",
                  eventK: i,
                })
              : n.mozRequestFullScreen
              ? (t = {
                  enterK: "mozRequestFullScreen",
                  exitK: "mozCancelFullScreen",
                  elementK: "mozFullScreenElement",
                  eventK: "moz" + i,
                })
              : n.webkitRequestFullscreen
              ? (t = {
                  enterK: "webkitRequestFullscreen",
                  exitK: "webkitExitFullscreen",
                  elementK: "webkitFullscreenElement",
                  eventK: "webkit" + i,
                })
              : n.msRequestFullscreen &&
                (t = {
                  enterK: "msRequestFullscreen",
                  exitK: "msExitFullscreen",
                  elementK: "msFullscreenElement",
                  eventK: "MSFullscreenChange",
                }),
            t &&
              ((t.enter = function () {
                return (
                  (c = v.closeOnScroll),
                  (v.closeOnScroll = !1),
                  "webkitRequestFullscreen" !== this.enterK
                    ? e.template[this.enterK]()
                    : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                );
              }),
              (t.exit = function () {
                return (v.closeOnScroll = c), document[this.exitK]();
              }),
              (t.isFullscreen = function () {
                return document[this.elementK];
              })),
            t
          );
        });
    };
    return e;
  });
